/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_590b8c0a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_590b8c0a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"36dd362c-fd48-494c-aa6c-ee79427799c7","title":"Információk a nyomtatóról","link":"finding-information-about-printer-topic.html","desc":"További információk a nyomtatóról Források","descFull":"További információk a nyomtatóról Források és elérési helyük Mit keres? Itt található Kezdeti üzembehelyezési utasítások Lásd a nyomtatóhoz mellékelt üzembe helyezési útmutatóban. Nyomtatószoftver Nyomtató- vagy faxillesztőprogram Nyomtatófirmware Segédprogram Látogasson el a  www.lexmark.com/downloads  webhelyre. Interaktív  használati útmutató Látogasson el a  https://support.lexmark.com  címre. Oktatóvideók Látogasson el a  https://infoserve.lexmark.com/idv/  címre. Súgó a nyomtatószoftver használatához. Súgó Microsoft Windows vagy Macintosh operációs rendszerhez – Nyissa meg a nyomtatószoftver programját vagy alkalmazását, majd kattintson a  Súgó  lehetőségre. A   ikonra kattintva tartalomtól függő tájékoztatást jeleníthet meg. A súgó automatikusan települ a nyomtatószoftverrel. Az operációs rendszertől függően a nyomtatószoftver a nyomtatóprogram mappájában vagy az asztalon található. Dokumentáció Azonnali segítségnyújtás csevegőprogramon Segítségnyújtás e-mailben Telefonos támogatás Látogasson el a  https://support.lexmark.com  címre. A megfelelő támogatási webhely megjelenítéséhez válassza ki az országot vagy régiót, majd a terméket. Az adott országban vagy régióban érvényes támogatási elérhetőségeket a támogatási webhelyen vagy a nyomtatóhoz kapott garancialapon találja. Az ügyféltámogatással való kapcsolatfelvétel előtt készítse elő a következő adatokat: Vásárlás helye és ideje A készülék típusa és sorozatszáma További információkért lásd:  . Biztonsági információk Jogszabályi információk Jótállási információk Környezetvédelmi információk A jótállási feltételek országonként, területenként változhatnak: Az Amerikai Egyesült Államokban  – lásd a nyomtatóhoz mellékelt „Korlátozott jótállási nyilatkozat” című dokumentumot vagy a  https://support.lexmark.com  webhelyet. Más országokban, illetve régiókban  – lásd a készülékhez mellékelt nyomtatott jótállási jegyet. Termékismertető  – további információkért tekintse meg a nyomtatóhoz kapott dokumentációt, vagy keresse fel a  https://support.lexmark.com  webhelyet. Információk a Lexmark digitális útlevéllel kapcsolatban Látogasson el a  https://csr.lexmark.com/digital-passport.php  címre. nyomtató adatainak megkeresése"},{"UUID":"42124d86-0645-494e-ad9e-a783bb396d8e","title":"Információk a nyomtatóról","link":"finding-printer-serial-number-topic.html","desc":"A nyomtató sorozatszámának megtalálása Nyissa","descFull":"A nyomtató sorozatszámának megtalálása Nyissa ki a tálcát. Keresse meg a nyomtató sorozatszámának helyét a nyomtató jobb oldalán. nyomtató sorozatszáma sorozatszám"},{"UUID":"bd3789a2-da96-4026-9a1a-692e6f1a7fb9","title":"Információk a nyomtatóról","link":"printer-configurations-topic.html","desc":"Nyomtatókonfigurációk Ügyeljen arra, hogy a","descFull":"Nyomtatókonfigurációk Ügyeljen arra, hogy a nyomtatót sík, szilárd és stabil felületen állítsa be. Alapmodell Nyomtató-alapmodell részei 1 Automatikus lapadagoló 2 Kezelőpanel 3 USB-port 4 Többcélú adagoló 5 Normál 550 lapos tálca 6 Normál rekesz Konfigurált modell A nyomtató vagy MFP egy vagy több opciójának telepítéséhez szükség lehet görgős talapra, bútorra vagy más funkcióra az esetlegesen sérülést okozó instabilitás elkerülése érdekében. A támogatott konfigurációkra vonatkozó további információért látogasson el a  www.lexmark.com/multifunctionprinters  webhelyre. A nyomtató vagy MFP egy vagy több opciójának telepítéséhez szükség lehet görgős talapra, bútorra vagy más funkcióra az esetlegesen sérülést okozó instabilitás elkerülése érdekében. A támogatott konfigurációkra vonatkozó további információért vegye fel a kapcsolatot az üzlettel, amelyben a nyomtatót vásárolta. A berendezés stabilitásvesztésének elkerülése érdekében minden egyes tálcába külön-külön töltse be a papírt. A többi tálcát tartsa csukva, amíg szüksége nincs rájuk. Konfigurált nyomtatómodell részei # Hardverkiegészítő Alternatív hardverkiegészítő 1  Nem telepíthető együtt füzetkészítő egységgel vagy kapcsozó-lyukasztó kiadóegységgel. 2  Mindig együtt kell telepíteni egy külön megvásárolható 550 lapos tálcával és a 2 x 550 lapos tálcával vagy a 2000 lapos kettős bemeneti egységgel. 3  Mindig a külön megvásárolható 550 lapos tálcával együtt kell telepíteni. 4  Mindig a külön megvásárolható 550 lapos tálcával és az alábbiak egyikével együtt kell telepíteni: 2 x 550 lapos tálca, 2000 lapos kettős bemeneti egység vagy szekrény. 1 Kapcsozó kiadóegység 1 Kötegelő rendezőtálca 1 Papírszállító egység Papírszállító egység hajtogatási lehetőséggel 2 1500 lapos fiók 2 Nincs 3 2000 lapos kettős bemeneti egység 3 2 x 550 lapos tálca 3 Szekrény 3 4 550 lapos kiegészítő tálca Nincs 5 Füzetkészítő egység 4 Kapcsozó-lyukasztó kiadóegység 4 Lehetséges, hogy egyes belső kiegészítők nem szerezhetők be. További információért fáradjon el oda, ahol a nyomtatót vásárolta. nyomtatóbeállítások"},{"UUID":"ef49ccc0-e0d5-4c03-8357-1f5a512c6da3","title":"Információk a nyomtatóról","link":"using-control-panel-topic.html","desc":"A kezelőpanel használata A nyomtató","descFull":"A kezelőpanel használata A nyomtató kezelőpaneljének részei, valamint ezek funkciói A kezelőpanel részei Funkció 1 Tápkapcsoló A nyomtató be- és kikapcsolása. A nyomtató kikapcsolásához tartsa nyomva öt másodpercig a tápkapcsolót. A nyomtató beállítása Alvó üzemmódba. Aktiválja a nyomtatót Alvó vagy Hibernált üzemmódból. 2 Megjelenítés A nyomtató üzeneteinek és a készletek állapotának megtekintése. A nyomtató beállítása és kezelése. 3 Jelzőfény A nyomtató állapotának ellenőrzése. kezelőpanel használata a kezelőpanel használata"},{"UUID":"6cf85dbb-6741-456d-a4a6-0ff4da093565","title":"Információk a nyomtatóról","link":"using-home-screen-topic.html","desc":"Kezdőoldal ikonjai A kezdőképernyő a","descFull":"Kezdőoldal ikonjai A kezdőképernyő a kezdőképernyő testre szabási beállításaitól, a rendszergazdai beállítástól és az aktív beépített megoldásoktól függően változhat. A főképernyő ikonjai és funkcióik # Ikon neve Funkció 1 Felhasználó  Megmutatja, hogy a felhasználó be van-e jelentkezve a nyomtatón. 2 Megjelenített adatok Testreszabott nyomtatóinformációk megjelenítése, például a nyomtató IP-címe vagy a dátum és az idő. 3 Kellék Kellékanyagok állapotának megtekintése. 4 Értesítés Figyelmeztető vagy hibaüzenet megjelenítése, amikor a feldolgozás folytatásához beavatkozás szükséges. További információkat tekinthet meg a nyomtató figyelmeztetéséről vagy üzenetéről, illetve azok törléséről. 5 Nyomtatás Fényképek és dokumentumok nyomtatása. 6 Másolás Fényképek és dokumentumok másolása. 7 Beolvasás Dokumentumok beolvasása. 8 Fax Faxüzenetek küldése. a kezdőképernyő használata kezdőoldal ikonjai"},{"UUID":"e6e3aee6-3f94-47cc-b29e-87cf2724bdcf","title":"Információk a nyomtatóról","link":"colors-of-indicator-light-topic.html","desc":"A jelzőfény színei A jelzőfény","descFull":"A jelzőfény színei A jelzőfény színe és a kapcsolódó nyomtatóállapot A jelzőfény színe A nyomtató állapota Ki A nyomtató ki van kapcsolva. Folyamatos kék A nyomtató készen áll. Villogó kék A nyomtató nyomtat vagy adatokat dolgoz fel. Villogó vörös A nyomtató felhasználói beavatkozást igényel. Folyamatos aranysárga fény A nyomtató alvó üzemmódban van. Villogó aranysárga A nyomtató mély alvás vagy hibernált üzemmódban van. jelzőfény nyomtató állapota nyomtató állapota"},{"UUID":"554e8a73-deab-4a85-b4dc-4e21761bd66e","title":"Információk a nyomtatóról","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Az automatikus lapadagoló és a","descFull":"Az automatikus lapadagoló és a lapolvasó üveglapjának használata Papír behelyezése az automatikus lapadagolóba és a lapolvasó üveglapjára Automatikus lapadagoló (ADF) Lapolvasó üveglapja Az automatikus lapadagolót egy- és többoldalas dokumentumok esetén használja. Töltse be az eredeti, felfelé néző dokumentumot. Többoldalas dokumentumok betöltésekor ellenőrizze, hogy a vezetők széle a lapokhoz vannak-e igazítva. Igazítsa úgy az ADF-papírvezetőket, hogy azok megegyezzenek a betöltött papír szélességével. Egyetlen oldalból álló dokumentumok, könyvoldalak, kisméretű anyagok (például képeslapok vagy fényképek), valamint fólia, fotópapír vagy vékony papír (például újságkivágások) beolvasásához használja a lapolvasó üveglapját. Tegye a dokumentumok nyomtatott oldalával lefelé a nyíllal jelölt sarokba. másolás az automatikus lapadagoló (ADF) használatával másolás lapolvasó üveglapja segítségével"},{"UUID":"6226e32a-bc54-4836-885a-5982ffbf88ca","title":"Információk a nyomtatóról","link":"locating-security-slot-topic.html","desc":"Biztonsági nyílás pozíciója A nyomtató","descFull":"Biztonsági nyílás pozíciója A nyomtató biztonsági zár funkcióval van ellátva. A nyomtató védelme érdekében szereljen be egy a legtöbb laptop számítógéppel kompatibilis biztonsági zárat a nyomtatón jelölt helyre. biztonsági nyílás keresés biztonsági nyílás pozíciója"},{"UUID":"17e6264f-2f89-4c7d-976c-fa5e606d0d62","title":"Papír kiválasztása","link":"paper-guidelines-topic.html","desc":"Útmutató a papírokhoz A megfelelő","descFull":"Útmutató a papírokhoz A megfelelő papír használata megakadályozza az elakadást, és segít a problémamentes nyomtatásban. Mindig új, sértetlen papírt használjon. A papír betöltése előtt legyen tisztában vele, melyik a papír javasolt nyomtatási oldala. Ez az információ általában fel van tüntetve a papír csomagolásán. Ne használjon vágott vagy kézzel tépett papírt. Ne keverje a papírméreteket, -típusokat és -súlyokat ugyanabban a tálcában; a keverés elakadást okoz. Ne használjon bevonatos papírt, hacsak azt nem kifejezetten elektro-fotografikus nyomtatáshoz tervezték. További információért lásd a  Papír és speciális hordozó útmutatót . papír kiválasztás útmutató a papírokhoz"},{"UUID":"fb03abd4-c886-420c-a068-32683a39bfa6","title":"Papír kiválasztása","link":"paper-guidelines-topic.html","desc":"Papírjellemzők A következő papírjellemzők hatással","descFull":"Papírjellemzők A következő papírjellemzők hatással vannak a nyomtatás minőségére és megbízhatóságára. Vegye figyelembe ezeket a tényezőket, mielőtt nyomtatna. Súly A tálcákkal különböző súlyú papírok adagolhatók. Előfordulhat, hogy a 60 g/m 2 -nél (16 fontnál) könnyebb papírok nem elég merevek a megfelelő adagoláshoz, így elakadást okozhatnak. További információkért tekintse át a „Támogatott papírsúlyok” című fejezetet. Meghajlás A meghajlás a papír szélein jelentkező elhajlást jelenti. Az intenzív meghajlás problémákat okozhat a papíradagolásban. Meghajlás akkor is történhet, amikor a papír végighalad a nyomtatón, ahol magas hőmérsékletnek van kitéve. Ha a papírt csomagolás nélkül forró, nedves, hideg vagy száraz környezetben tárolják, akkor ez a papír nyomtatás előtti meghajlásához vezethet, és adagolási problémákat okozhat. Simaság A papír simasága közvetlen hatással van a nyomtatás minőségére. Ha a papír durva, akkor a festék nem képes megfelelően beégni. Ha a papír túl sima, akkor az papíradagolási vagy nyomtatásminőségi problémákhoz vezethet. 50 Sheffield pontos papír használatát javasoljuk. Nedvességtartalom A papír nedvességtartalma hatással van a nyomtatás minőségére és a nyomtató adagolási képességére is. Tárolja a papírt az eredeti csomagolásban, amíg nem használja fel. A papír nedvességváltozásnak való kitettsége csökkentheti a teljesítményét. A nyomtatás előtt tárolja a papírokat az eredeti csomagolásukban 24–48 órán keresztül. A papírt ugyanolyan környezetben kell tárolni, mint amilyenben a nyomtató van. Nyújtsa meg az időszakot több nappal, ha a tárolási vagy szállítási környezet jelentősen eltér a nyomtató környezetétől. A vastag papírnak szintén hosszabb időre van szüksége az alkalmazkodáshoz. Szálirány A szálirány a papírlap rostjainak elrendeződését jelenti. A szálirány lehet  hosszanti , amely a papír hosszúságával párhuzamosan fut, vagy  keresztirányú , amely a papír szélességével párhuzamosan fut. Az ajánlott szálirányért tekintse át a „Támogatott papírsúlyok” című fejezetet. Rosttartalom A legtöbb jó minőségű másolópapír 100% kémiailag kezelt farostból áll. Ez a tartalom nagyfokú stabilitást biztosít a papírnak, amely kevesebb papíradagolási problémát és jobb nyomtatási minőséget okoz. A szálakat, például pamutot tartalmazó papír negatívan befolyásolhatja a papírkezelést. papírjellemzők"},{"UUID":"320e0e94-ed62-4599-bc6f-04b29ba5ab7e","title":"Papír kiválasztása","link":"paper-guidelines-topic.html","desc":"Nem támogatott papír Az alábbi","descFull":"Nem támogatott papír Az alábbi papírtípusok használata nem ajánlott a nyomtatóhoz: Karbonpapírok nélküli fénymásoláshoz használt, kémiailag kezelt papírok. Karbonmentes papíroknak, karbonmentes fénymásolópapíroknak (CCP) vagy karbon nélküli (NCR) papíroknak is nevezik őket. Olyan vegyi anyagokat tartalmazó előnyomott papírok, amelyek szennyeződést okozhatnak a nyomtatóban. Olyan előnyomott papírok, amelyekre hatással lehet a nyomtató bégető egységének belső hőmérséklete. Előnyomtatott papírok (a nyomtatás helyéhez a papíron), ahol a szükséges pozicionálás ±2,3 mm (±0,09 hüvelyk). Például az optikai karakterfelismerő (OCR) űrlapok. Egyes esetekben a regisztráció egy szoftveralkalmazással állítható be, hogy ezekre az űrlapokra is lehessen nyomtatni. Bevonatos (törölhető, finom) papírok, szintetikus papírok, hőpapírok. Durva szélű, durva vagy nehéz felületű papírok vagy hullámos papírok. Az EN12281:2002 (európai) szabványnak nem megfelelő papírok. 60 g/m 2 -nél (16 fontnál) kisebb tömegű papírok. Több részből álló űrlapok vagy dokumentumok. nem támogatott papír"},{"UUID":"269bc7d0-3c90-4a43-9719-5f61f0f3d426","title":"Papír kiválasztása","link":"paper-guidelines-topic.html","desc":"A papír tárolása A papírelakadás","descFull":"A papír tárolása A papírelakadás és a nem egyenletes nyomtatási minőség elkerüléséhez kövesse a következő papírtárolási ajánlásokat: Nyomtatás előtt 24–48 óráig tárolja a papírt a nyomtatóval azonos környezetben, hogy a papír alkalmazkodjon az adott környezethez. Nyújtsa meg az időszakot több nappal, ha a tárolási vagy szállítási környezet jelentősen eltér a nyomtató környezetétől. A vastag papírnak szintén hosszabb időre van szüksége az alkalmazkodáshoz. A legjobb eredmény érdekében a papírt 21 °C (70 °F) hőmérsékleten, 40%-os relatív páratartalom mellett tárolja. A legtöbb címkegyártó 18–24 °C (65–75 °F) közötti hőmérsékleten és 40–60%-os relatív páratartalom mellett ajánlja a nyomtatást. A papírt inkább kartonban, raklapon vagy polcon tárolja, és ne a földön. Az önálló csomagokat sima felületen tárolja. Ne helyezzen semmit az önálló papírcsomagok tetejére. A papírt csak akkor vegye ki a kartonból vagy a csomagolásból, amikor a nyomtatóba tölti. A karton és a csomagolás segít, hogy a papír tiszta, száraz és sima maradjon. a papír tárolása"},{"UUID":"e8a44b0e-9b70-4686-8390-75671d36fa55","title":"Papír kiválasztása","link":"paper-guidelines-topic.html","desc":"Előnyomott űrlapok és fejlécek kiválasztása","descFull":"Előnyomott űrlapok és fejlécek kiválasztása Hosszanti szálirányú papírt használjon. Csak ofszetnyomtatással vagy mélynyomtatással készült űrlapokat és fejléceket használjon. Ne használjon durva vagy érdes felületű papírokat. Használjon olyan festéket, amelyet nem befolyásol a festékkazettában található gyanta. Az oxidálódó vagy olaj alapú festékek általában megfelelők; a latex festékek nem feltétlenül. A használandó nyomatról nyomtasson mintát az előnyomott űrlapokra és fejléces papírokra, mielőtt nagyobb mennyiséget vásárolna. Ez meghatározza, hogy az előnyomott űrlapokon és fejléces papírokon levő tinta befolyásolja-e a nyomtatás minőségét. Ha kétségei vannak, forduljon a papír szállítójához. Fejléces papír nyomtatásakor a megfelelő tájolással helyezze a papírt a nyomtatóba. További információért lásd a  Papír és speciális hordozó útmutatót . Fejléces papír nyomtatásakor a megfelelő tájolással helyezze a papírt a nyomtatóba. papír előnyomott űrlapok előnyomott űrlapok kiválasztás papír fejléces papír fejléces papír kiválasztás"},{"UUID":"6aaa6b37-293e-4434-a418-fc41d00269d1","title":"Támogatott papírméretek","link":"paper-guidelines-topic.html","desc":"Az alapkonfiguráció által támogatott papírméretek","descFull":"Az alapkonfiguráció által támogatott papírméretek Az alapkonfiguráció által támogatott papírméretek Papírméret Tájolás Normál 550 lapos tálca Többcélú adagoló Kétoldalas nyomtatás Automatikus lapadagoló 1  Csak bizonyos nyomtatómodellek esetében támogatott. 2  Csak akkor támogatott, ha az Univerzális beállítás menüből konfigurálták. 3  Támogatja a 95 x 139,7 mm (3,74 x 5,5 hüvelyk) és 297 x 355,6 mm (11,69 x 14 hüvelyk) közötti papírméreteket. 4  Az univerzális papírméret maximális hossza szalagpapír esetén 1320,8 mm/52 hüvelyk. Egyszerre csak egy ív szalagpapírt töltsön be. 5  Támogatja a 95 x 139,7 mm (3,74 x 5,5 hüvelyk) és 320 x 457,2 mm (12,6 x 18 hüvelyk) közötti papírméreteket. 6  Támogatja a 105 x 139,7 mm (4,13 x 5,5 hüvelyk) és 320 x 457,2 mm (12,59 x 18 hüvelyk) közötti papírméreteket. 7  Támogatja a 76,2 x 128 mm (3 x 5,04 hüvelyk) és 297 x 432 mm (11,69 x 17,01 hüvelyk) közötti papírméreteket. 4x6-os kártya Rövid él mentén behelyezve X ✓ X X Hosszú él mentén behelyezve X X X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve X X X X 1/3 A4 Rövid él mentén behelyezve ✓ ✓ X ✓ Hosszú él mentén behelyezve X X X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve ✓ X ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ X ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve X ✓ ✓ 1 ✓ 1 JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ X ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve ✓ X ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve ✓ X ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ X ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve X ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12,0 x 18,0 hüvelyk) Rövid él mentén behelyezve X ✓ ✓ X SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve X ✓ ✓ X Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X ✓ 2 X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Univerzális N/A ✓ 3 ✓ 4, 5 ✓ 6 ✓ 7 támogatott papírméretek papírméretek támogatott"},{"UUID":"7d14c843-5ec7-4ce7-a665-fa00ba8a24a5","title":"Támogatott papírméretek","link":"paper-guidelines-topic.html","desc":"A külön megvásárolható tálcák által","descFull":"A külön megvásárolható tálcák által támogatott papírméretek Papírméret Tájolás 550 lapos kiegészítő tálca 2 x 550 lapos tálca 2000 lapos kettős bemeneti egység 1500 lapos tálca 1  Csak akkor támogatott, ha az Univerzális beállítás menüből konfigurálták. 2  Támogatja a 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) és 304,8 x 457,2 mm (12 x 18 hüvelyk) közötti papírméreteket. 4x6-os kártya Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Hosszú él mentén behelyezve X X X X 1/3 A4 Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ X X A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Hosszú él mentén behelyezve X X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ X X Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve ✓ 1 ✓ 1 X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve ✓ 1 ✓ 1 X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X X Univerzális N/A ✓ 2 ✓ 2 ✓ ✓ támogatott papírméretek papírméretek támogatott"},{"UUID":"a0c51bb7-ff2c-46c2-a609-59d15d98a1ec","title":"Támogatott papírméretek","link":"paper-guidelines-topic.html","desc":"A kimeneti rekeszek által támogatott","descFull":"A kimeneti rekeszek által támogatott papírméretek A papírszállító egység és vagy a kapcsozó-lyukasztó kiadóegység vagy a füzetkészítő egység be van szerelve a nyomtatóba. Papírméret Tájolás Papírszállító egység + kapcsozó-lyukasztó kiadóegység Papírszállító egység + füzetkészítő egység Normál rekesz (kiadóegység felső rekesze) 1. rekesz (kapcsozó-lyukasztó kiadóegység, kötegelőrekesz) 2. rekesz (papírszállító egység rekesze) Normál rekesz (kiadóegység felső rekesze) 1. rekesz (kapcsozó-lyukasztó kiadóegység, kötegelőrekesz) 2. rekesz (füzetkészítő egység rekesze) 3. rekesz (papírszállító egység rekesze) 1  Támogatja a 90 x 148 mm (3,55 x 5,83 hüvelyk) és 320 x 600 mm (12,59 x 23,62 hüvelyk) közötti papírméreteket. 2  Támogatja a 90 x 148 mm (3,55 x 5,83 hüvelyk) és 320 x 1260 mm (12,59 x 49,6 hüvelyk) közötti papírméreteket. 3  Támogatja a 182 x 257 mm (7,17 x 10,12 hüvelyk) és 304,8 x 457,2 mm (12 x 18 hüvelyk) közötti papírméreteket. 4x6-os kártya Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve X X X X X X ✓ A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve X X X X X X X 1/3 A4 Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve X X X X X X ✓ A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X ✓ ✓ X ✓ Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Univerzális N/A ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 A hajtogatási opcióval ellátott papírszállító egység és vagy a kapcsozó-lyukasztó kiadóegység vagy a füzetkészítő egység be van szerelve a nyomtatóba. Papírszállító egység hajtogatási lehetőséggel + kapcsozó-lyukasztó kiadóegység Papírszállító egység hajtogatási lehetőséggel + füzetkészítő egység Papírméret Tájolás Normál rekesz (kiadóegység felső rekesze) 1. rekesz (kapcsozó-lyukasztó kiadóegység, kötegelőrekesz) 2. rekesz (papírszállító egység rekesze) Normál rekesz (kiadóegység felső rekesze) 1. rekesz (kapcsozó-lyukasztó kiadóegység, kötegelőrekesz) 2. rekesz (füzetkészítő egység rekesze) 3. rekesz (papírszállító egység rekesze) 1  Támogatja a 90 x 148 mm (3,55 x 5,83 hüvelyk) és 320 x 600 mm (12,59 x 23,62 hüvelyk) közötti papírméreteket. 2  Támogatja a 90 x 148 mm (3,55 x 5,83 hüvelyk) és 297 x 1260 mm (11,69 x 49,6 hüvelyk) közötti papírméreteket. 3  Támogatja a 182 x 257 mm (7,17 x 10,12 hüvelyk) és 304,8 x 457,2 mm (12 x 18 hüvelyk) közötti papírméreteket. 4x6-os kártya Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve X X X X X X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve X X X X X X X 1/3 A4 Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve X X X X X X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ X ✓ Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X ✓ ✓ ✓ X SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X ✓ ✓ X X Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X ✓ X X X ✓ Univerzális N/A ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 támogatott papírméretek papírméretek támogatott"},{"UUID":"c65796af-49eb-4bd8-a64b-2ed53b1b9b2f","title":"Támogatott papírméretek","link":"paper-guidelines-topic.html","desc":"Kapcsozási és lyukasztási feladatokhoz támogatott","descFull":"Kapcsozási és lyukasztási feladatokhoz támogatott papírméretek A kapcsozó kiadó által támogatott papírméretek Papírméret Tájolás kapcsozás Egyszeres Kettős Kettős, bal oldalon 4x6-os kártya Rövid él mentén behelyezve X X X Hosszú él mentén behelyezve X X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X Hosszú él mentén behelyezve X X X 1/3 A4 Rövid él mentén behelyezve X X X Hosszú él mentén behelyezve X X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve X X X Hosszú él mentén behelyezve X X X A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve X X X Hosszú él mentén behelyezve X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve ✓ X X Hosszú él mentén behelyezve ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X Hosszú él mentén behelyezve ✓ ✓ X Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve X X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve X X X Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X X A kapcsozó-lyukasztó kiadóegység által támogatott papírméretek Papírméret Tájolás kapcsozás lyukasztás Egyszeres Kettős Kettős, bal oldalon Kétlyukas Háromlyukas Négylyukas 4x6-os kártya Rövid él mentén behelyezve X X X X X X Hosszú él mentén behelyezve X X X X X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X X X X Hosszú él mentén behelyezve X X X X X X 1/3 A4 Rövid él mentén behelyezve X X X X X X Hosszú él mentén behelyezve X X X X X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve X X X ✓ X X Hosszú él mentén behelyezve X X X ✓ X X A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve X X X ✓ X X Hosszú él mentén behelyezve X X X ✓ X X Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve X X X X X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X X X X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X X X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X X X X X A füzetkészítő egység által támogatott papírméretek Papírméret Tájolás kapcsozás lyukasztás Egyszeres Kettős Kettős, bal oldalon Kétlyukas Háromlyukas Négylyukas 4x6-os kártya Rövid él mentén behelyezve X X X X X X Hosszú él mentén behelyezve X X X X X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X X X X Hosszú él mentén behelyezve X X X X X X 1/3 A4 Rövid él mentén behelyezve X X X X X X Hosszú él mentén behelyezve X X X X X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve X X X ✓ X X Hosszú él mentén behelyezve X X X ✓ X X A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ X X X Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ X X JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve ✓ ✓ X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve X X X ✓ X X Hosszú él mentén behelyezve X X X ✓ X X Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Hosszú él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ X X Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve X X X X X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X X X X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X X X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X X X X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X X X X X támogatott papírméretek papírméretek támogatott"},{"UUID":"96d15618-5a13-46b0-b4f2-3cbc2c724416","title":"Támogatott papírméretek","link":"paper-guidelines-topic.html","desc":"A hajtogatási feladatokhoz támogatott papírméretek","descFull":"A hajtogatási feladatokhoz támogatott papírméretek A hajtogatási lehetőséggel ellátott papírszállító egység által támogatott papírméretek Papírméret Tájolás Papírszállító egység csak hajtogatási lehetőséggel C hajtású Z hajtású Z hajtású fél lap V hajtású Normál rekesz Normál rekesz Normál rekesz Normál rekesz 4x6-os kártya Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X 1/3 A4 Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve X X X X A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve X X ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve X X X X Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve X X X X Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve X X X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X X X A papírszállító egység és a füzetkészítő egység által támogatott papírméretek Papírméret Tájolás Papírszállító egység + füzetkészítő egység V hajtású többszörös V hajtású 2. rekesz Normál rekesz, 1. rekesz, 2. rekesz 4x6-os kártya Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X 1/3 A4 Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve X X A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve X X JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve X X Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X A hajtogatási opcióval ellátott papírszállító egység és a kapcsozó-lyukasztó kiadóegység által támogatott papírméretek Papírméret Tájolás Papírszállító egység hajtogatási lehetőséggel + kapcsozó-lyukasztó kiadóegység C hajtású Z hajtású Z hajtású fél lap V hajtású 2. rekesz 2. rekesz Normál rekesz, 2. rekesz Normál rekesz, 2. rekesz 4x6-os kártya Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X 1/3 A4 Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve X X X X A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve X X ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve X X X X Hosszú él mentén behelyezve X X X X Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve X X X X Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve X X X X Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve X X X ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve X X X ✓ Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X X X A hajtogatási opcióval ellátott papírszállító egység és a füzetkészítő egység által támogatott papírméretek Papírméret Tájolás Papírszállító egység hajtogatási lehetőséggel + füzetkészítő egység C hajtású Z hajtású Z hajtású fél lap V hajtású többszörös V hajtású 3. rekesz 3. rekesz Normál rekesz, 1. rekesz, 3, rekesz 2. rekesz Normál rekesz, 1. rekesz, 2, rekesz, 3. rekesz 4x6-os kártya Rövid él mentén behelyezve X X X X X Hosszú él mentén behelyezve X X X X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X X X Hosszú él mentén behelyezve X X X X X 1/3 A4 Rövid él mentén behelyezve X X X X X Hosszú él mentén behelyezve X X X X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve X X X X X Hosszú él mentén behelyezve X X X X X A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve X X X X X A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve X X X ✓ ✓ Hosszú él mentén behelyezve X X X X X JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve X X ✓ ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve X X X X X Hosszú él mentén behelyezve X X X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve X X X X X Hosszú él mentén behelyezve X X X X X Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ Hosszú él mentén behelyezve X X X X X Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve X X X ✓ ✓ Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ ✓ ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve X X X X ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve X X X X ✓ Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X X X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X X X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X X X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X X X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X X X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X X X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X X X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X X X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X X X X támogatott papírméretek papírméretek támogatott"},{"UUID":"97dc80e9-9ba5-43b9-92d2-66f8802f4247","title":"Támogatott papírméretek","link":"paper-guidelines-topic.html","desc":"A kötegelt rendezéshez támogatott papírméretek","descFull":"A kötegelt rendezéshez támogatott papírméretek A kötegelő rendezőtálca vagy a kapcsozó kiadó által támogatott papírméretek Papírméret Tájolás Kötegelő rendezőtálca Kapcsozó kiadó 1  Támogatja a 90 x 148 mm (3,55 x 5,83 hüvelyk) és 320 x 600 mm (12,59 x 23,62 hüvelyk) közötti papírméreteket. 2  Támogatja a 148 x 148 mm (5,83 x 5,83 hüvelyk) és 297 x 431,8 mm (11,69 x 17 hüvelyk) közötti papírméreteket. 4x6-os kártya Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X 1/3 A4 Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve ✓ X Hosszú él mentén behelyezve ✓ X Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve X X SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve X X Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve ✓ X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve ✓ X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve ✓ X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve ✓ X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve ✓ X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve ✓ X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve ✓ X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve ✓ X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve ✓ X Univerzális N/A ✓ 1 ✓ 2 A kimeneti rekeszek által támogatott papírméretek Papírméret Tájolás Papírszállító egység + kapcsozó-lyukasztó kiadóegység Papírszállító egység + füzetkészítő egység 1. rekesz 1. rekesz 1  Támogatja a 139,7 x 148 mm (5,5 x 5,83 hüvelyk) és 304,8 x 600 mm (12 x 23,62 hüvelyk) közötti papírméreteket. 2  Támogatja a 125 x 148 mm (4,93 x 5,83 hüvelyk) és 304,8 x 457,2 mm (12 x 18 hüvelyk) közötti papírméreteket. 4x6-os kártya Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X 1/3 A4 Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve X X Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X Univerzális N/A ✓ 1 ✓ 2 A kimeneti rekesz által támogatott papírméretek (hajtogatási opcióval ellátott papírszállító egységgel) Papírméret Tájolás Papírszállító egység hajtogatási lehetőséggel + kapcsozó-lyukasztó kiadóegység Papírszállító egység hajtogatási lehetőséggel + füzetkészítő egység 1. rekesz 1. rekesz 1  Támogatja a 139,7 x 148 mm (5,5 x 5,83 hüvelyk) és 304,8 x 600 mm (12 x 23,62 hüvelyk) közötti papírméreteket. 2  Támogatja a 125 x 148 mm (4,93 x 5,83 hüvelyk) és 304,8 x 457,2 mm (12 x 18 hüvelyk) közötti papírméreteket. 4x6-os kártya Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X A6 105 x 148 mm (4,13 x 5,83 hüvelyk) Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X 1/3 A4 Rövid él mentén behelyezve X X Hosszú él mentén behelyezve X X A5 148 x 210 mm (5,83 x 8,27 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ A4 210 x 297 mm (8,27 x 11,7 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ A3 297 x 420 mm (11,69 x 16,54 hüvelyk) Rövid él mentén behelyezve ✓ ✓ JIS B5 182 x 257 mm (7,17 x 10,1 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ JIS B4 257 x 364 mm (10,12 x 14,33 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Statement 139,7 x 215,9 mm (5,5 x 8,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ Executive 184,2 x 266,7 mm (7,25 x 10,5 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ Letter 215,9 x 279,4 mm (8,5 x 11 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Hosszú él mentén behelyezve ✓ ✓ Folio 215,9 x 330,2 mm (8,5 x 13 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Oficio (Mexikó) 215,9 x 340,4 mm (8,5 x 13,4 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Legal 215,9 x 355,6 mm (8,5 x 14 hüvelyk) Rövid él mentén behelyezve ✓ ✓ Ledger 279,4 x 431,8 mm (11 x 17 hüvelyk) Rövid él mentén behelyezve ✓ ✓ 12x18 304,8 x 457,2 mm (12 x 18 hüvelyk) Rövid él mentén behelyezve ✓ ✓ SRA3 320,04 x 449,58 mm (12,6 x 17,7 hüvelyk) Rövid él mentén behelyezve X X Boríték (Choukei #3) 120 x 235 mm (4,75 x 9,25 hüvelyk) Rövid él mentén behelyezve X X Hagaki 100 x 148 mm (3,94 x 5,83 hüvelyk) Rövid él mentén behelyezve X X B5 boríték 176 x 250 mm (6,93 x 9,84 hüvelyk) Rövid él mentén behelyezve X X Boríték (Commercial #9) 98,4 x 225,4 mm (3,875 x 8,9 hüvelyk) Rövid él mentén behelyezve X X Boríték (Commercial #10) 104,8 x 241,3 mm (4,12 x 9,5 hüvelyk) Rövid él mentén behelyezve X X Boríték (Monarch 7-3/4) 98,4 x 190,5 mm (3,875 x 7,5 hüvelyk) Rövid él mentén behelyezve X X Boríték (DL) 110 x 220 mm (4,33 x 8,66 hüvelyk) Rövid él mentén behelyezve X X Boríték (ISO C4) 229 x 324 mm (9 x 12,8 hüvelyk) Rövid él mentén behelyezve X X Boríték (ISO C5) 162 x 229 mm (6,38 x 9 hüvelyk) Rövid él mentén behelyezve X X Univerzális N/A ✓ 1 ✓ 2 támogatott papírméretek papírméretek támogatott"},{"UUID":"b8c32c4d-fd96-4331-89b2-3454d7973bf8","title":"Papír kiválasztása","link":"paper-guidelines-topic.html","desc":"Támogatott papírsúlyok Támogatott papírsúlyok A","descFull":"Támogatott papírsúlyok Támogatott papírsúlyok A nyomtató által támogatott papírsúlyok Standard vagy külön megvásárolható 550 lapos tálca, 2 x 550 lapos tálca, 1500 lapos fiók és 2000 lapos kettős bemeneti egység Többcélú adagoló Kétoldalas nyomtatás Automatikus lapadagoló 60–300 g/m 2 (16–80 fontos bankpostapapír) 60–300 g/m 2 (16–80 fontos bankpostapapír) 60–220 g/m 2 (16–59 fontos bankpostapapír) 50–150 g/m 2 (14–40 fontos bankpostapapír) támogatott papírsúlyok papírsúlyok támogatott"},{"UUID":"94fd7a4e-7773-4a30-9ef0-f2bf069b05fb","title":"Papír kiválasztása","link":"paper-guidelines-topic.html","desc":"Támogatott papírtípusok Támogatott papírtípusok Az","descFull":"Támogatott papírtípusok Támogatott papírtípusok Az alapkonfiguráció által támogatott papírtípusok Papírméret Normál 550 lapos tálca Többcélú adagoló Kétoldalas nyomtatás Automatikus lapadagoló Normál papír ✓ ✓ ✓ ✓ Kártya ✓ ✓ ✓ X Újrahasznosított ✓ ✓ ✓ ✓ Fényes ✓ ✓ ✓ X Nehéz fényes ✓ ✓ ✓ X Címkék ✓ ✓ X X Vinil címkék ✓ ✓ X X Bankpostapapír ✓ ✓ ✓ ✓ Boríték ✓ ✓ X X Boríték (durva papír) ✓ ✓ X X Fejléces papír ✓ ✓ ✓ ✓ Előnyomott ✓ ✓ ✓ ✓ Színes papír ✓ ✓ ✓ ✓ Könnyű papír ✓ ✓ ✓ ✓ Nehéz papír ✓ ✓ ✓ ✓ Durva pamuttartalmú ✓ ✓ ✓ X Egyedi típus ✓ ✓ ✓ ✓ A külön megvásárolható tálcák által támogatott papírtípusok Papírméret 550 lapos kiegészítő tálca 2 x 550 lapos tálca 2000 lapos kettős bemeneti egység 1500 lapos tálca Normál papír ✓ ✓ ✓ ✓ Kártya ✓ ✓ ✓ ✓ Fólia X X X X Újrahasznosított ✓ ✓ ✓ ✓ Fényes ✓ ✓ ✓ ✓ Nehéz fényes ✓ ✓ ✓ ✓ Címkék ✓ ✓ X X Vinil címkék ✓ ✓ X X Bankpostapapír ✓ ✓ ✓ ✓ Boríték ✓ ✓ X X Boríték (durva papír) ✓ ✓ X X Fejléces papír ✓ ✓ ✓ ✓ Előnyomott ✓ ✓ ✓ ✓ Színes papír ✓ ✓ ✓ ✓ Könnyű papír ✓ ✓ ✓ ✓ Nehéz papír ✓ ✓ ✓ ✓ Durva pamuttartalmú ✓ ✓ ✓ ✓ Egyedi típus ✓ ✓ ✓ ✓ A kimeneti rekesz által támogatott papírtípusok Papírméret Papírszállító egység + kapcsozó-lyukasztó kiadóegység Papírszállító egység + füzetkészítő egység Normál rekesz (kiadóegység felső rekesze) 1. rekesz (kapcsozó-lyukasztó kiadóegység, kötegelőrekesz) 2. rekesz (papírszállító egység rekesze) Normál rekesz (kiadóegység felső rekesze) 1. rekesz (kapcsozó-lyukasztó kiadóegység, kötegelőrekesz) 2. rekesz (füzetkészítő egység rekesze) 3. rekesz (papírszállító egység rekesze) *  Az univerzális papírméret maximális hossza szalagpapír esetén 1320,8 mm/52hüvelyk. Egyszerre csak egy ív szalagpapírt töltsön be. Normál papír ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Kártya ✓ ✓ ✓ ✓ ✓ X ✓ Újrahasznosított ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Fényes ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Nehéz fényes ✓ ✓ ✓ ✓ ✓ X ✓ Címkék ✓ ✓ ✓ ✓ ✓ X X Vinil címkék ✓ ✓ ✓ ✓ ✓ X X Bankpostapapír ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Boríték X X ✓ X X X ✓ Boríték (durva papír) X X ✓ X X X ✓ Fejléces papír ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Előnyomott ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Színes papír ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Könnyű papír ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Nehéz papír ✓ ✓ ✓ ✓ ✓ X X Durva pamuttartalmú ✓ ✓ ✓ ✓ ✓ X X Egyedi típus ✓ ✓ ✓ ✓ ✓ ✓ * ✓ A kimeneti rekesz által támogatott papírtípusok (hajtogatási opcióval ellátott papírszállító egységgel) Papírméret Papírszállító egység hajtogatási lehetőséggel + kapcsozó-lyukasztó kiadóegység Papírszállító egység hajtogatási lehetőséggel + füzetkészítő egység Normál rekesz (kiadóegység felső rekesze) 1. rekesz (kapcsozó-lyukasztó kiadóegység, kötegelőrekesz) 2. rekesz (papírszállító egység rekesze) Normál rekesz (kiadóegység felső rekesze) 1. rekesz (kapcsozó-lyukasztó kiadóegység, kötegelőrekesz) 2. rekesz (füzetkészítő egység rekesze) 3. rekesz (papírszállító egység rekesze) *  Az univerzális papírméret maximális hossza szalagpapír esetén 1320,8 mm/52hüvelyk. Egyszerre csak egy ív szalagpapírt töltsön be. Normál papír ✓ ✓ ✓ ✓ ✓ ✓ ✓ Kártya ✓ ✓ ✓ ✓ ✓ X ✓ Újrahasznosított ✓ ✓ ✓ ✓ ✓ ✓ ✓ Fényes ✓ ✓ ✓ ✓ ✓ ✓ ✓ Nehéz fényes ✓ ✓ ✓ ✓ ✓ X ✓ Címkék ✓ ✓ ✓ ✓ ✓ X ✓ Vinil címkék ✓ ✓ ✓ ✓ ✓ X ✓ Bankpostapapír ✓ ✓ ✓ ✓ ✓ ✓ ✓ Boríték X X ✓ X X X ✓ Boríték (durva papír) X X ✓ X X X ✓ Fejléces papír ✓ ✓ ✓ ✓ ✓ X ✓ Előnyomott ✓ ✓ ✓ ✓ ✓ X ✓ Színes papír ✓ ✓ ✓ ✓ ✓ ✓ ✓ Könnyű papír ✓ ✓ ✓ ✓ ✓ ✓ ✓ Nehéz papír ✓ ✓ ✓ ✓ ✓ X X Durva pamuttartalmú ✓ ✓ ✓ ✓ ✓ X X Egyedi típus ✓ ✓ ✓ ✓ ✓ ✓ * ✓ Hajtogatási opcióval ellátott papírszállító egység, a kötegelő rendezőtálca és a kapcsozó kiadó által támogatott papírtípusok Papírméret Papírszállító egység csak hajtogatási lehetőséggel Kötegelő rendezőtálca Kapcsozó kiadó Normál papír ✓ ✓ ✓ Kártya ✓ ✓ ✓ Újrahasznosított ✓ ✓ ✓ Fényes ✓ ✓ ✓ Nehéz fényes ✓ ✓ ✓ Címkék ✓ ✓ ✓ Vinil címkék ✓ ✓ ✓ Bankpostapapír ✓ ✓ ✓ Boríték ✓ ✓ ✓ Boríték (durva papír) ✓ ✓ ✓ Fejléces papír ✓ ✓ ✓ Előnyomott ✓ ✓ ✓ Színes papír ✓ ✓ ✓ Könnyű papír ✓ ✓ ✓ Nehéz papír ✓ ✓ ✓ Durva pamuttartalmú ✓ ✓ ✓ Egyedi típus ✓ ✓ ✓ A kapcsozó-lyukasztó kiadóegység és a füzetkészítő egység által támogatott papírtípusok Papírméret Kiadóegység felső rekesze (normál rekesz) Kiadóegység kapocsrekesze (1. rekesz) eltolás lyukasztás kapcsozás hajtogatás eltolás lyukasztás kapcsozás hajtogatás Normál papír X ✓ X ✓ ✓ ✓ ✓ ✓ Kártya X X X X ✓ X X X Újrahasznosított X ✓ X ✓ ✓ ✓ ✓ ✓ Fényes X ✓ X ✓ ✓ ✓ ✓ ✓ Nehéz fényes X X X X ✓ X X X Címkék X X X X ✓ X X X Vinil címkék X X X X ✓ X X X Bankpostapapír X ✓ X ✓ ✓ ✓ ✓ ✓ Fejléces papír X ✓ X ✓ ✓ ✓ ✓ ✓ Előnyomott X ✓ X ✓ ✓ ✓ ✓ ✓ Színes papír X ✓ X ✓ ✓ ✓ ✓ ✓ Könnyű papír X ✓ X ✓ ✓ ✓ ✓ ✓ Nehéz papír X X X X ✓ X X X Durva pamuttartalmú X ✓ X X ✓ ✓ X X Egyedi típus X ✓ X ✓ ✓ ✓ ✓ ✓ támogatott papírtípusok papírtípusok támogatott"},{"UUID":"aa5fa942-91b0-47fd-a4b7-6bbf64505268","title":"További nyomtatófunkciók és támogatás","link":"supported-applications-topic.html","desc":"Támogatott alkalmazások Alkalmazások és az","descFull":"Támogatott alkalmazások Alkalmazások és az általuk támogatott nyomtatómodellek Alkalmazás Nyomtatómodellek Beolvasási központ CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 Megjelenés testreszabása CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 Ügyféltámogatás XC8355, XC9635, XC9645, XC9655 Eszközkvóták XC8355, XC9635, XC9645, XC9655 nyomtatóalkalmazások előre telepített alkalmazások"},{"UUID":"942f7f41-8c5d-486c-bdff-0b6ceecfcc59","title":"További nyomtatófunkciók és támogatás","link":"supported-applications-topic.html","desc":"Támogatott flash meghajtók és fájltípusok","descFull":"Támogatott flash meghajtók és fájltípusok Flash meghajtók USB 2.0-t vagy alacsonyabb szintű USB-t támogató flash meghajtók. A New Technology File System (NFTS) vagy a File Allocation Table (FAT32) fájlrendszert támogató flash meghajtók. Fájltípusok Támogatott fájltípusok Dokumentumok Képek PDF (1.7-es vagy korábbi verziószámú) Microsoft-fájlformátumok (DOC, DOCX, XLS, XLSX, PPT, PPTX) JPEG vagy JPG TIFF vagy TIF GIF BMP PNG PCX DCX támogatott flash meghajtók támogatott fájltípusok"},{"UUID":"fb3578c7-dd19-4ac2-8a51-742160386ece","title":"További nyomtatófunkciók és támogatás","link":"supported-applications-topic.html","desc":"Megrendelhető belső kiegészítők Merevlemez Licencelt","descFull":"Megrendelhető belső kiegészítők Merevlemez Licencelt funkciók IPDS Vonalkód Lexmark  Internal solutions port (ISP) RS‑232C sorosport-kártya MarkNet  N8230 optikai Ethernet 100BASE-FX(LC), 1000BASE-SX(LC) Internal solutions port (ISP) belső kiegészítők firmware-kártya merevlemez"},{"UUID":"50962e67-3c0a-4d44-bd7b-4b7e8ea0b3b7","title":"Beállítás, telepítés és konfigurálás","link":"selecting-location-printer-topic.html","desc":"A nyomtató helyének kiválasztása Hagyjon","descFull":"A nyomtató helyének kiválasztása Hagyjon elég helyet a tálcák, fedelek és ajtók kinyitásához, illetve hardveropciók telepítéséhez. Elektromos aljzat közelébe helyezze a nyomtatót. A tűzveszély és az áramütés elkerülése érdekében a tápkábelt közvetlenül egy, a készülékhez közeli, könnyen hozzáférhető, megfelelő besorolású és megfelelően földelt konnektorba csatlakoztassa. Az áramütés kockázatának elkerülése érdekében ne helyezze a terméket víz közelébe vagy nedves helyekre. Győződjön meg róla, hogy a helyiségben a légmozgás megfelel az ASHRAE 62 szabvány vagy a CEN Technical Committee 156 szabvány legutolsó verziójának. A készüléket egy sima, szilárd és stabil felületre helyezze. A nyomtatót: Tartsa tisztán, szárazon és pormentesen. Tartsa távol tűzőkapcsoktól és gemkapcsoktól. Tartsa távol a légkondicionálók, fűtőtestek vagy ventillátorok közvetlen légmozgásától. Ne tegye ki közvetlen napfénynek vagy túlzott nedvességnek. Tartsa be az ajánlott hőmérsékleti értékeket, és kerülje az ingadozásokat: Ajánlott hőmérsékletek Környezeti hőmérséklet Tárolási hőmérséklet A megfelelő szellőzés érdekében tartsa be a következő javasolt távolságokat: Ajánlott üres tér a nyomtató körül 1 Felül 2 Hátul 3 Jobb oldalon 4 Elöl 5 Bal oldalon nyomtató hely kiválasztása a következőhöz: hely kiválasztása a nyomtató számára nyomtató minimális elakadások a nyomtató áthelyezése"},{"UUID":"83f1825c-16c3-49a2-9f1a-a3c64e363943","title":"Beállítás, telepítés és konfigurálás","link":"printer-ports-topic.html","desc":"Nyomtatóportok Az áramütés kockázatának elkerülése","descFull":"Nyomtatóportok Az áramütés kockázatának elkerülése érdekében zivataros időben ne végezze a készülék üzembe helyezését, illetve elektromos vagy kábelezési csatlakozásokat, például a fax, a tápkábel vagy a telefon csatlakoztatását. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. A tűz és áramütés kockázatának elkerülése érdekében csak a termékhez kapott vagy a gyártó által hitelesített tápkábelt használja. Ha a terméket a nyilvános telefonhálózathoz csatlakoztatja, a tűzveszély csökkentése érdekében csak 26 AWG vagy nagyobb keresztmetszetű telekommunikációs (RJ-11) kábelt használjon. Ausztráliai felhasználás: a tápkábelt a Australian Communications and Media Authority szervezetnek kell hitelesítenie. Az adatvesztés és a nyomtató meghibásodásának elkerülése érdekében nyomtatás közben ne érjen hozzá az USB-kábelhez, bármilyen vezeték nélküli hálózati adapterhez vagy a nyomtató ábrán jelzett részéhez. A nyomtatóportok és csatlakozók, és azok leírása Nyomtatóport Funkció 1 Kiadóegység vagy külön megvásárolható port Csatlakoztassa a nyomtatót egy kiadóegységhez vagy egy kiegészítőhöz. 2 USB-port Billentyűzetet vagy bármely más, kompatibilis kiegészítő csatlakoztatása. 3 LINE csatlakozó Csak akkor elérhető, ha van beszerelve faxkártya. A nyomtató csatlakoztatása aktív telefonvonalhoz normál fali csatlakozóval (RJ-11), DSL-szűrővel, VoIP-adapterrel vagy egyéb olyan adapterrel, amely lehetővé teszi a telefonvonalhoz való hozzáférést faxküldés és -fogadás céljából. 4 EXT csatlakozó Csak akkor elérhető, ha van beszerelve faxkártya. További eszközök (telefon vagy üzenetrögzítő) csatlakoztatása a nyomtatóhoz és a telefonvonalhoz. Akkor használja ezt a portot, ha a nyomtatóhoz nem tartozik dedikált faxvonal, és az országa, illetve régiója támogatja ezt a kapcsolati módot. 5 USB-nyomtatóport Csatlakoztassa a nyomtatót számítógéphez. 6 Ethernet-csatlakozó Csatlakoztassa a nyomtatót hálózathoz. 7 Tápcsatlakozó Csatlakoztassa a nyomtatót egy megfelelően földelt csatlakozóaljzathoz. nyomtatóportok USB-port Ethernet-csatlakozó tápcsatlakozó"},{"UUID":"d3ecbf74-d397-4cbe-9491-2695a24fcf6d","title":"Alkalmazások és megoldások konfigurálása","link":"setting-up-scan-center-topic.html","desc":"A Beolvasási központ beállítása A","descFull":"A Beolvasási központ beállítása A kezelőpanelen válassza a  Beolvasási központ  menüpontot. Válasszon ki és hozzon létre egy célhelyet, majd végezze el a beállítások konfigurálását. Csak az Embedded Web Server segítségével létrehozott célhelyek kerülnek mentésre. További tudnivalók a megoldás dokumentációjában találhatók. Olvassa be a dokumentumot. Beolvasási központ beállítás"},{"UUID":"dc9e1b16-695c-457a-8820-f074838c5cf8","title":"Alkalmazások és megoldások konfigurálása","link":"setting-up-scan-center-topic.html","desc":"A Megjelenés testreszabása funkció használata","descFull":"A Megjelenés testreszabása funkció használata A Megjelenés testreszabása funkció használata Győződjön meg róla, hogy a képernyővédő, a diavetítés és a háttérkép beállításai engedélyezve vannak az Embedded Web Serverben. Navigáljon az  Alkalmazások Megjelenés testreszabása Konfiguráció  menüpontra. A képernyővédő és a diavetítés képeinek kezelése A Képernyővédő és diavetítési képek résznél adjon hozzá, szerkesszen vagy töröljön egy képet. Legfeljebb 10 képet adhat hozzá. Bekapcsolt állapotban az állapotikonok csak akkor jelennek meg a képernyővédőn, ha hibák, figyelmeztetések vagy felhőalapú értesítések vannak a rendszerben. Alkalmazza a módosításokat. Háttérkép módosítása A kezelőpanelen válassza a  Háttérkép módosítása  lehetőséget. Válassza ki a használni kívánt képet. Alkalmazza a módosításokat. Diavetítés futtatása flash-meghajtóról Helyezzen be egy flash-meghajtót az USB-portba. A kezelőpanelen válassza a  Diavetítés  lehetőséget. A diavetítés indítását követően eltávolíthatja a flash-meghajtót, de a nyomtató nem fogja tárolni a képeket. Ha a diavetítés leáll, a képek megtekintéséhez helyezze vissza a flash-meghajtót. Megjelenés testreszabása használat kijelző testreszabása háttérkép módosítása diavetítés indítása képernyővédő kezelése"},{"UUID":"0605b2b5-e5d3-4ffb-9b1f-467d174c3753","title":"Alkalmazások és megoldások konfigurálása","link":"setting-up-scan-center-topic.html","desc":"Könyvjelzők konfigurálása Könyvjelzők létrehozása Nyisson","descFull":"Könyvjelzők konfigurálása Könyvjelzők létrehozása Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Könyvjelzők Könyvjelző hozzáadása  elemre, majd írjon be egy könyvjelzőnevet. Válasszon ki egy  cím  protokolltípust, majd tegye a következők egyikét: HTTP és HTTPS esetén írja be a könyvjelzőzni kívánt URL-címet. HTTPS esetében az állomásnevet használja az IP-cím helyett. Például gépelje be a  myWebsite.com/sample.pdf  szöveget a  123.﻿123.123.123/sample.pdf  helyett. Győződjön meg arról, hogy az állomásnév megegyezik a kiszolgálótanúsítvány CN (Common Name) értékével. Ha további információra van szüksége azzal kapcsolatban, hogyan juthat hozzá a kiszolgálótanúsítványban található CN-értékhez, tekintse meg böngészőjének súgóját. FTP esetén írja be az FTP-címet. Például  myServer/myDirectory . Írja be az FTP-port számát. A 21. port az alapértelmezett port a parancsküldéshez. Az SMB mezőbe írja be a hálózati mappa címét. Például  myServer/myShare/myFile.pdf . Írja be a hálózati tartomány nevét. Szükség esetén válassza ki a  hitelesítés  típusát az FTP-hez és az SMB-hez. A könyvjelzőhöz való hozzáférés korlátozása érdekében adjon meg egy PIN-kódot. Az alkalmazás a következő fájltípusokat támogatja: PDF, JPEG és TIFF. A DOCX-hez és az XLSX-hez hasonló egyéb fájltípusok támogatottak egyes nyomtatómodelleken. Kattintson a  Mentés  gombra. Mappák létrehozása Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Könyvjelzők Mappa hozzáadása  elemre, majd írjon be egy mappanevet. A mappához való hozzáférés korlátozása érdekében adjon meg egy PIN-kódot. Kattintson a  Mentés  gombra. könyvjelzők létrehozás könyvjelzők létrehozása"},{"UUID":"41eff52e-0d47-4e78-8436-1246047f44da","title":"Alkalmazások és megoldások konfigurálása","link":"setting-up-scan-center-topic.html","desc":"Címjegyzék konfigurálása Partnerek hozzáadása Nyisson","descFull":"Címjegyzék konfigurálása Partnerek hozzáadása Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Címjegyzék , majd a  Kapcsolat hozzáadása  gombra. Ha szükséges, adja meg a bejelentkezés módját, hogy lehetővé tegye az alkalmazások számára a hozzáférést. Kattintson a  Mentés  gombra. Csoportok hozzáadása Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Címjegyzék , majd a  Kapcsolat hozzáadása  gombra. Egy vagy több partnert rendelhet hozzá a csoporthoz. Kattintson a  Mentés  gombra. partnerek hozzáadása csoportok hozzáadása Címjegyzék"},{"UUID":"ac2d64b5-ba4f-4e57-86a7-b75ac1c33581","title":"A kisegítő funkciók telepítése és használata","link":"activating-voice-guidance-topic.html","desc":"Hangutasítások aktiválása A kezdőképernyőről Egy","descFull":"Hangutasítások aktiválása A kezdőképernyőről Egy mozdulattal húzza el balra, majd felfelé a képernyőn egy ujját, amíg hangüzenetet nem hall. Két ujjal érintse meg az  OK  gombot. Ha a mozdulat nem működik, fejtsen ki nagyobb nyomást. A billentyűzetről Tartsa nyomva az  5 -ös billentyűt, amíg egy hangüzenetet nem hall. Nyomja meg a  Tab  billentyűt, hogy az OK gombhoz navigálja a fókuszkurzort, majd nyomja meg az  Enter  billentyűt. Ha a hangutasítások aktiválva vannak, mindig két ujjal válassza ki a kijelzőn lévő elemeket. A hangutasítások korlátozott számú nyelvet támogatnak. Hangutasítások aktiválása hangutasítások aktiválása"},{"UUID":"b73a9dab-7d9a-4e10-b6e6-e46b2e846e67","title":"A kisegítő funkciók telepítése és használata","link":"activating-voice-guidance-topic.html","desc":"Hangutasítások inaktiválása Egy mozdulattal húzza","descFull":"Hangutasítások inaktiválása Egy mozdulattal húzza el balra, majd felfelé a képernyőn egy ujját, amíg hangüzenetet nem hall. Két ujjal végezze a következők egyikét: Válassza ki a  Hangutasítások  lehetőséget, majd válassza az  OK  lehetőséget. Válassza a  Mégse  lehetőséget. Ha a mozdulat nem működik, fejtsen ki nagyobb nyomást. A bekapcsológomb megnyomása vagy a nyomtató alvó vagy hibernált üzemmódba helyezése szintén kikapcsolja a hangutasításokat. Hangutasítások kikapcsolása hangutasítások inaktiválása"},{"UUID":"2799095f-3f8b-4234-85fa-a61c96bcbfc2","title":"A kisegítő funkciók telepítése és használata","link":"activating-voice-guidance-topic.html","desc":"Navigáció a képernyőn kézmozdulatok segítségével","descFull":"Navigáció a képernyőn kézmozdulatok segítségével A legtöbb kézmozdulatot csak akkor lehet használni, ha a hangutasítások aktiválva vannak. Karakterek begépeléséhez és bizonyos beállítások módosításához használjon fizikai billentyűzetet. A kézmozdulatok és funkcióik Kézmozdulat Funkció Balra, majd felfelé húzás egy ujjal Kisegítő lehetőségek mód elindítása vagy bezárása. Ugyanez a mozdulat használható a nyomtató normál üzemmódjában is. Dupla koppintás egy ujjal Egy beállítás vagy elem kiválasztása a képernyőn. Dupla koppintás a főképernyő ikonjára két ujjal A Kisegítő lehetőségek mód inaktiválása. Tripla koppintás egy ujjal Szövegek és képek nagyítása vagy kicsinyítése. A nagyítás funkció használatához engedélyezze a Nagyítás módot. Jobbra húzás vagy lefelé húzás egy ujjal Lépés a képernyő következő elemére. Balra húzás vagy felfelé húzás egy ujjal Lépés a képernyő előző elemére. Felfelé húzás, majd lefelé húzás egy ujjal Lépés a képernyő első elemére. Pásztázás A nagyított kép olyan részeihez férhet hozzá, melyek a képernyő keretén kívülre esnek. Két ujjal húzhat el egy kinagyított képet. Engedélyezze a Nagyítás módot a pásztázó kézmozdulat használatához. Felfelé húzás, majd jobbra húzás egy ujjal Hangerő növelése. Ugyanez a mozdulat használható a nyomtató normál üzemmódjában is. Lefelé húzás, majd jobbra húzás egy ujjal Hangerő csökkentése. Ugyanez a mozdulat használható a nyomtató normál üzemmódjában is. Felfelé húzás, majd balra húzás egy ujjal Kilépés az alkalmazásból, majd visszatérés a kezdőképernyőre. Lefelé húzás, majd balra húzás egy ujjal Visszalépés az előző beállításra. navigáció a képernyőn kézmozdulatok segítségével érintőkijelző kézmozdulatok képernyő kézmozdulatok"},{"UUID":"eea8b965-c69b-4ce6-8730-83a472503428","title":"A kisegítő funkciók telepítése és használata","link":"activating-voice-guidance-topic.html","desc":"A képernyőn megjelenő billentyűzet használata","descFull":"A képernyőn megjelenő billentyűzet használata A képernyőn megjelenő billentyűzet megjelenésekor tegye a következők egyikét: Érintsen meg egy gombot a bejelentéshez, és írja be a karaktert a mezőbe. Húzza végig az ujját különböző karaktereken a bejelentéshez, majd írja be a karaktert a mezőbe. Érintsen meg egy szövegdobozt két ujjával a mezőben lévő karakterek bejelentéséhez. Érintse meg a  Törlés  billentyűt a karakterek törléséhez. képernyőn megjelenő billentyűzet használata"},{"UUID":"a61abc0b-e3eb-4958-bb6f-28d2e0904b1a","title":"A kisegítő funkciók telepítése és használata","link":"activating-voice-guidance-topic.html","desc":"Nagyítás üzemmód engedélyezése Egy mozdulattal","descFull":"Nagyítás üzemmód engedélyezése Egy mozdulattal húzza el balra, majd felfelé a képernyőn egy ujját, amíg hangüzenetet nem hall. Beépített hangszórók nélküli nyomtatómodell esetén használjon fejhallgatót az üzenet meghallgatásához. Két ujjal végezze a következőket: Érintse meg a  Nagyítás üzemmód  lehetőséget. Érintse meg az  OK  gombot. Ha a mozdulat nem működik, fejtsen ki nagyobb nyomást. A nagyított képernyőn történő navigálással kapcsolatos további információért lásd:  . Nagyítás üzemmód engedélyezés nagyítás üzemmód engedélyezése"},{"UUID":"7f974aec-dd4e-414c-aeef-cdb6ba5ae543","title":"A kisegítő funkciók telepítése és használata","link":"activating-voice-guidance-topic.html","desc":"A hangutasítások beszédsebességének beállítása A","descFull":"A hangutasítások beszédsebességének beállítása A kezelőpanelen navigáljon a  Beállítások Eszköz Kisegítő lehetőségek Beszédsebesség  menüpontra. Válassza ki a beszédsebességet. Hangutasítások beszédsebesség beállítása beszédsebesség beállítása Hangutasítások beszédsebesség beállítása Hangutasítások"},{"UUID":"88f2d478-7b0c-4dfe-a5b4-eda3518cc9b9","title":"A kisegítő funkciók telepítése és használata","link":"activating-voice-guidance-topic.html","desc":"Az alapértelmezett fejhallgató-hangerő módosítása A","descFull":"Az alapértelmezett fejhallgató-hangerő módosítása A kezelőpanelen navigáljon a  Beállítások Eszköz Kisegítő lehetőségek  menüpontra. A fejhallgató hangerejének módosítása. A hangerő az alapértelmezett értékre áll vissza a Kisegítő lehetőségek üzemmódból való kilépést követően, amikor a nyomtató alvó vagy hibernált üzemmódból felébred. fejhallgató hangereje, beállítás fejhallgató hangerejének beállítása"},{"UUID":"b6684ede-7e51-418c-b163-d7afa588baaf","title":"A kisegítő funkciók telepítése és használata","link":"activating-voice-guidance-topic.html","desc":"Az alapértelmezett belső hangszóróhangerő módosítása","descFull":"Az alapértelmezett belső hangszóróhangerő módosítása A kezelőpanelen húzza jobbra az ujját a kezelőközpont eléréséhez. Állítsa be a hangerőt. Ha a csendes üzemmód engedélyezve van, akkor ki vannak kapcsolva a hallható riasztások. Ez a beállítás lassítja a nyomtató működését. A hangerő visszaáll az alapértelmezett értékre, miután a felhasználó kilép a Kisegítő üzemmódból, vagy amikor a nyomtató felébred alvó vagy hibernált módból. hangszóró hangereje beállítás a hangszóró hangerejének módosítása"},{"UUID":"d126720e-0a90-4455-9012-958aaf57a4be","title":"A kisegítő funkciók telepítése és használata","link":"activating-voice-guidance-topic.html","desc":"Hangos jelszavak vagy személyes azonosítószámok","descFull":"Hangos jelszavak vagy személyes azonosítószámok engedélyezése A kezelőpanelen navigáljon a  Beállítások Eszköz Kisegítő lehetőségek Jelszavak/PIN-kódok felolvasása  menüpontra. Engedélyezze a beállítást. hangos jelszavak engedélyezés személyes azonosítószámok engedélyezés"},{"UUID":"7dd9dee4-7a92-4d57-a7f5-b88f15162e24","title":"Nyomtató beállítása faxolásra","link":"setting-up-printer-to-fax-group.html","desc":"Az analóg faxot használó faxfunkció","descFull":"Az analóg faxot használó faxfunkció beállítása Az analóg faxot használó faxfunkció beállítása Egy faxkártyát kell beszerelni az analóg fax használatához. Néhány csatlakozási módszer csak bizonyos országokban vagy régiókban használható. Ha a faxolás funkció engedélyezve van, de nincs teljesen beállítva, a jelzőfény pirosan villoghat. Ha nem rendelkezik TCP/IP környezettel, a fax beállítási adatainak megadásához a nyomtató kezelőpanelét kell használnia. Az adatvesztés és a nyomtatóhibák elkerülése érdekében fax küldése vagy fogadása közben ne érjen hozzá a kábelekhez és a nyomtató ábrán jelzett részéhez. A kezelőpanel használata A kezelőpanelen navigáljon a  Beállítások Fax Faxbeállítás Általános faxbeállítások  menüpontra. Konfigurálja a beállításokat. Az Embedded Web Server használata Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a kezelőpanelen. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a következőre:  Beállítások Fax Fax beállítása Általános faxbeállítások . Konfigurálja a beállításokat. Alkalmazza a módosításokat. analóg fax beállítás analóg fax beállítása"},{"UUID":"61b8988e-451f-4be6-bc91-5811f6bc6458","title":"Nyomtató beállítása faxolásra","link":"setting-up-printer-to-fax-group.html","desc":"Az etherFAX-ot használó faxfunkció beállítása","descFull":"Az etherFAX-ot használó faxfunkció beállítása Az etherFAX-ot használó faxfunkció beállítása A nyomtató-firmware-t frissíteni kell a legújabb verzióra. További információkért lásd a „A firmware frissítése” című részt. A nyomtatóra megfelelő licenccsomagot kell telepíteni. További információkért vegye fel a kapcsolatot az etherFAX-szal. Győzödjön meg arról, hogy nyomtatóját regisztrálta az etherFAX portálon. További információért látogasson el a  https://www.etherfax.net/lexmark  weboldalra. A regisztrációkor szükség van a nyomtató sorozatszámára. További információkért lásd:  . Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a kezelőpanelen. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a következőre:  Beállítások Fax Fax beállítása Általános faxbeállítások . A  Fax beállítása  csak akkor jelenik meg, ha a  Fax mód Fax  értékre van állítva. A Faxnév mezőben adjon meg egy egyedi nevet. A Faxszám mezőben adja meg az etherFAX által megadott faxszámot. A  Faxtovábbítás  menüben válassza az  etherFAX  lehetőséget. Ez a menü csak akkor jelenik meg, ha egynél több faxtovábbítás érhető el. Ha a nyomtatóra csak etherFAX van telepítve, akkor az automatikusan konfigurálásra kerül. Alkalmazza a módosításokat. etherFAX fax funkció beállítása fax funkció beállítása etherFAX használata"},{"UUID":"b8050c33-a1f1-4dcd-9cb2-1ef30d113a69","title":"Nyomtató beállítása faxolásra","link":"setting-up-printer-to-fax-group.html","desc":"A faxfunkció beállítása a faxkiszolgáló","descFull":"A faxfunkció beállítása a faxkiszolgáló használatával Ezzel a funkcióval faxüzeneteket küldhet olyan faxszolgáltatónak, amely támogatja az e-mailes fogadást. Ez a funkció csak a kimenő faxüzeneteket támogatja. A faxfogadáshoz bizonyosodjon meg róla, hogy a nyomtatójához konfigurálva van egy eszközalapú faxmegoldás. Ilyen például az analóg fax, az etherFAX, vagy az IP-faxolás IP (FoIP). Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a kezelőpanelen. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Beállítások Fax  elemre. A  Fax mód  menüből válassza ki  Faxkiszolgáló  opciót, majd kattintson a  Mentés  gombra. Kattintson a  Faxkiszolgáló beállítása  opcióra. A  Címjegyzék formátuma  mezőbe írja be, hogy „ [#]@myfax.com ”, amelyben  [#]  a faxszám és  myfax.com  a faxszolgáltató tartománya. Ha szükséges, konfigurálja a Válaszcím, a Címzett, vagy az Üzenet mezőket. Ha szeretné, hogy a nyomtató faxüzeneteket fogadjon, engedélyezze az eszközalapú faxfogadás beállítást. Bizonyosodjon meg róla, hogy az eszközalapú fax be van állítva. Kattintson a  Mentés  gombra. Kattintson a  Faxkiszolgáló e-mail-beállításai  gombra, majd engedélyezze az  E-mail SMTP-kiszolgáló használata  lehetőséget. Ha a beállítások nincsenek konfigurálva, lásd:  . Alkalmazza a módosításokat. faxkiszolgáló, használat fax funkció beállítása faxfunkció beállítása faxkiszolgáló használatával"},{"UUID":"69abbc1a-e842-44bb-aa30-94abd9b87629","title":"Nyomtató beállítása faxolásra","link":"setting-up-printer-to-fax-group.html","desc":"Fax beállítása normál telefonvonal használatával","descFull":"Fax beállítása normál telefonvonal használatával Fax beállítása normál telefonvonal használatával Ezek az utasítások csak a faxkártyával felszerelt nyomtatókra vonatkoznak. Az áramütés kockázatának elkerülése érdekében zivataros időben ne végezze a készülék üzembe helyezését, illetve elektromos vagy kábelezési csatlakozásokat, például a fax, a tápkábel vagy a telefon csatlakoztatását. Az áramütés veszélyének elkerülése érdekében ne használja a faxfunkciót villámláskor. Ha a terméket a nyilvános telefonhálózathoz csatlakoztatja, a tűzveszély csökkentése érdekében csak 26 AWG vagy nagyobb keresztmetszetű telekommunikációs (RJ-11) kábelt használjon. Ausztráliai felhasználás: a tápkábelt a Australian Communications and Media Authority szervezetnek kell hitelesítenie. 1. konfiguráció: A nyomtató dedikált faxvonalhoz csatlakozik Csatlakoztassa a telefonkábel egyik végét a nyomtató telefonvonal-portjához. A kábel másik végét csatlakoztassa egy aktív analóg fali aljzathoz. Beállíthatja, hogy a nyomtató automatikusan ( Automatikus válasz Be ) vagy manuálisan ( Automatikus válasz Ki ) fogadja a faxokat. Ha azt szeretné, hogy a nyomtató automatikusan fogadja a faxokat, állítsa be a kívánt csengésszámot, amely után a nyomtató válaszol. 2. konfiguráció: A nyomtató egy üzenetrögzítővel közösen használja a telefonvonalat Ha előfizet a megkülönböztető csengetési minta szolgáltatásra, akkor győződjön meg róla, hogy a megfelelő csengetési mintát rendeli a nyomtatóhoz. Ellenkező esetben a nyomtató még akkor sem fogadja a faxokat, ha Ön az automatikus fogadást állította be. Ugyanahhoz a fali telefonaljzathoz csatlakoztatva Csatlakoztassa a telefonkábel egyik végét a nyomtató telefonvonal-portjához. A kábel másik végét csatlakoztassa egy aktív analóg fali telefonaljzathoz. Csatlakoztassa az üzenetrögzítőt a nyomtató telefonportjához. Különböző fali csatlakozókhoz csatlakoztatva Csatlakoztassa a telefonkábel egyik végét a nyomtató telefonvonal-portjához. A kábel másik végét csatlakoztassa egy aktív analóg fali telefonaljzathoz. Ha csak egy telefonszám tartozik a telefonfonalhoz, akkor állítsa automatikus faxfogadásra a nyomtatót. Állítsa be, hogy a nyomtató az üzenetrögzítő után két csengéssel válaszoljon a hívásra. Ha például az üzenetrögzítő négy csengés után veszi fel a hívást, állítsa a nyomtató  Csengések a válaszig  beállítását  6  csengésre. faxbeállítás szabványos telefonvonali csatlakozással fax beállítása szabványos telefonvonali csatlakozással üzenetrögzítő beállítás"},{"UUID":"f253a6d3-d7d9-4476-9faa-461a2a700f1f","title":"Nyomtató beállítása faxolásra","link":"setting-up-printer-to-fax-group.html","desc":"Fax beállítása olyan országokban vagy","descFull":"Fax beállítása olyan országokban vagy régiókban, amelyekben különböző fali telefonaljzat van használatban Fax beállítása olyan országokban vagy régiókban, amelyekben különböző fali telefonaljzat van használatban Ezek az utasítások csak a faxkártyával felszerelt nyomtatókra vonatkoznak. Az áramütés kockázatának elkerülése érdekében zivataros időben ne végezze a készülék üzembe helyezését, illetve elektromos vagy kábelezési csatlakozásokat, például a fax, a tápkábel vagy a telefon csatlakoztatását. Az áramütés veszélyének elkerülése érdekében ne használja a faxfunkciót villámláskor. Ha a terméket a nyilvános telefonhálózathoz csatlakoztatja, a tűzveszély csökkentése érdekében csak 26 AWG vagy nagyobb keresztmetszetű telekommunikációs (RJ-11) kábelt használjon. Ausztráliai felhasználás: a tápkábelt a Australian Communications and Media Authority szervezetnek kell hitelesítenie. A szabványos fali csatlakozó az RJ-11 a legtöbb országban, illetve régióban. Ha a fali telefonaljzat vagy az adott készülék nem használható ilyen típusú csatlakozással, akkor telefonadapterre lesz szüksége. Előfordulhat, hogy az Ön országának vagy régiójának megfelelő adapter nem jár a nyomtatóhoz, és azt külön kell megvásárolnia. Előfordulhat, hogy a nyomtató telefonportjában egy adaptercsatlakozó is található. Ne húzza ki az adaptercsatlakozót a nyomtató telefonportjából, ha a készüléket soros vagy kaszkád telefonrendszerhez csatlakoztatja. Adaptercsatlakozó cikkszáma Az alkatrész neve Cikkszám Lexmark adaptercsatlakozó 40X8519 A nyomtató csatlakoztatása nem RJ-11 típusú fali aljzathoz Csatlakoztassa a telefonkábel egyik végét a nyomtató telefonvonal-portjához. Csatlakoztassa a kábel másik végét az RJ-11 adapterhez, majd csatlakoztassa az adaptert a fali csatlakozóhoz. Ha egy másik, nem RJ-11 típusú csatlakozóval ellátott készüléket is szeretne ugyanahhoz a fali aljzathoz csatlakoztatni, csatlakoztassa közvetlenül a telefonadapterhez. fax beállítása faxbeállítás"},{"UUID":"758e0625-ccce-449d-880d-bcbdf698f306","title":"Nyomtató beállítása faxolásra","link":"setting-up-printer-to-fax-group.html","desc":"Csatlakozás megkülönböztető csengetési szolgáltatáshoz A","descFull":"Csatlakozás megkülönböztető csengetési szolgáltatáshoz A megkülönböztető csengési szolgáltatással több telefonszámmal rendelkezhet ugyanazon a telefonvonalon. Mindegyik telefonszámhoz különböző csengési minta van hozzárendelve. A kezelőpanelen navigáljon a  Beállítások Fax Faxbeállítás Faxfogadási beállítások Rendszergazdai beállítások Válasz be  menüpontra. Válasszon ki egy csengési mintát. megkülönböztető csengetési szolgáltatás a nyomtató csatlakoztatása megkülönböztető csengési szolgáltatáshoz csengőhang hozzárendelése a nyomtatóhoz"},{"UUID":"54240b6a-7c1b-46f3-8dc6-0d0a77aad0d2","title":"Nyomtató beállítása faxolásra","link":"setting-up-printer-to-fax-group.html","desc":"Faxdátum és -idő beállítása Faxdátum","descFull":"Faxdátum és -idő beállítása Faxdátum és -idő beállítása A kezelőpanelen navigáljon a  Beállítások Eszköz Beállítások Dátum és idő Konfigurálás  menüpontra. Konfigurálja a beállításokat. faxolás dátum és idő beállítása dátum és idő faxbeállítások"},{"UUID":"21823792-1617-452a-aebe-fe515154be52","title":"Nyomtató beállítása faxolásra","link":"setting-up-printer-to-fax-group.html","desc":"Nyári időszámítás konfigurálása A kezelőpanelen","descFull":"Nyári időszámítás konfigurálása A kezelőpanelen navigáljon a  Beállítások Eszköz Beállítások Dátum és idő Konfigurálás  menüpontra. Az  Időzóna  menüben válassza ki az  (UTC+felhasználó) Egyéni  elemet. A  Konfigurálás  menüben válassza a  UTC-eltolódás  lehetőséget. Konfigurálja a beállításokat. nyári időszámítás konfigurálása nyári időszámítás konfigurálás"},{"UUID":"2b1ab2f6-e41b-4671-9283-eef8c2512ffa","title":"Nyomtató beállítása faxolásra","link":"setting-up-printer-to-fax-group.html","desc":"Faxhangszóró beállításainak konfigurálása A kezelőpanelen","descFull":"Faxhangszóró beállításainak konfigurálása A kezelőpanelen navigáljon a  Beállítások Fax Faxbeállítás Hangszóróbeállítások  menüpontra. Tegye a következőt: Állítsa a  hangszóró üzemmódot Mindig be  értékre. Állítsa a  hangszóró hangerejét Nagy  értékre. Aktiválja a  Csengetés hangerejét . beállítások konfigurálása faxhangszóró faxhangszóró beállítások konfigurálása"},{"UUID":"0f2a87f4-6b40-4a63-8f3b-e6c63ee34a9f","title":"Papír és speciális adathordozó betöltése","link":"loading-trays-group.html","desc":"Speciális hordozó méretének és típusának","descFull":"Speciális hordozó méretének és típusának megadása Speciális hordozó méretének és típusának megadása Speciális hordozó, például címke, kártya vagy boríték alkalmazása esetén tegye a következőket: A kezelőpanelről kiindulva lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  elemre. Válasszon ki egy papírforrást, majd állítsa be a speciális hordozó méretét és típusát. papírméret beállítása papírtípus beállítása"},{"UUID":"e15676e9-86cc-4302-8435-504653451275","title":"Papír és speciális adathordozó betöltése","link":"loading-trays-group.html","desc":"Univerzális papírbeállítások konfigurálása Univerzális papírbeállítások","descFull":"Univerzális papírbeállítások konfigurálása Univerzális papírbeállítások konfigurálása Az  Univerzális beállítás  menü segítségével beállíthatja a nyomtatóban előre be nem állított papírméret szélességét és magasságát. A kezelőpanelen navigáljon a  Beállítások Papír Média konfigurációja Hordozókonfiguráció  menüpontra. Válassza a  Minden bemeneti tálca  lehetőséget, majd konfigurálja a testreszabni kívánt papírméret beállításait. papírméret beállítása papírméret testreszabása"},{"UUID":"d8ae1e9c-86e8-43f6-b271-448ab461b696","title":"Papír és speciális adathordozó betöltése","link":"loading-trays-group.html","desc":"Az 550 lapos tálca betöltése","descFull":"Az 550 lapos tálca betöltése A berendezés stabilitásvesztésének elkerülése érdekében minden egyes tálcába külön-külön töltse be a papírt. A többi tálcát tartsa csukva, amíg szüksége nincs rájuk. Nyissa ki a tálcát. Az elakadások elkerülése érdekében ne nyissa ki a tálcákat, amíg a nyomtató foglalt. Igazítsa úgy a papírvezetőket, hogy azok megegyezzenek a betöltött papír méretével. Használja a tálca alján lévő mutatókat a vezető beállításához. Az előre lyukasztott papír csak a normál 550 lapos tálcában támogatott. A3 méretű papír csak a külön megvásárolható 550 lapos tálcában támogatott. Mielőtt behelyezné a papírt, hajlítsa meg, pörgesse át, és igazítsa össze a köteget. Töltse be a papírköteget a nyomtatandó oldallal felfelé. Ne csúsztasson papírt a tálcába. Győződjön meg arról, hogy az oldalsó vezetők szorosan illeszkednek a papírhoz. Ügyeljen arra, a köteg magassága ne haladja meg a maximális papírmennyiséget mutató jelet. A tálca túltöltése papírelakadást okozhat. Szerelje fel a tálcát. Szükség esetén állítsa be a papírméretet és a papírtípust a tálcába töltött papírnak megfelelően. Ha telepített kiadóegységet, a lapok nyomtatáskor 180°-ban elfordulnak. Fejléces papír betöltésekor végezze el a következők egyikét: Kiadóegység nélkül Kiadóegységgel Egyoldalas, hosszú oldali nyomtatás Egyoldalas, hosszú oldali nyomtatás Egyoldalas, rövid oldali nyomtatás Egyoldalas, rövid oldali nyomtatás Kétoldalas, hosszú oldali nyomtatás Kétoldalas, hosszú oldali nyomtatás Kétoldalas, rövid oldali nyomtatás Kétoldalas, rövid oldali nyomtatás Előre lyukasztott papír betöltésekor végezze el a következők egyikét: Külön megvásárolható kiadóegység nélkül Külön megvásárolható kiadóegységgel Egyoldalas, hosszú oldali nyomtatás Egyoldalas, hosszú oldali nyomtatás Egyoldalas, rövid oldali nyomtatás Egyoldalas, rövid oldali nyomtatás Kétoldalas, hosszú oldali nyomtatás Kétoldalas, hosszú oldali nyomtatás Kétoldalas, rövid oldali nyomtatás Kétoldalas, rövid oldali nyomtatás 550 lapos tálca betöltés 550 lapos tálca betöltése tálcák betöltése"},{"UUID":"b4a51e87-c473-40de-8a9f-a7f5759a3ebf","title":"Papír és speciális adathordozó betöltése","link":"loading-trays-group.html","desc":"A 2000 lapos kettős bemeneti","descFull":"A 2000 lapos kettős bemeneti egység betöltése A berendezés stabilitásvesztésének elkerülése érdekében minden egyes tálcába külön-külön töltse be a papírt. A többi tálcát tartsa csukva, amíg szüksége nincs rájuk. Nyissa ki a tálcát. A papírelakadás elkerülése érdekében ne húzza ki a tálcákat, amíg a nyomtató elfoglalt. Mielőtt behelyezné a papírt, hajlítsa meg, pörgesse át, és igazítsa össze a köteget. Töltse be a papírköteget a jobb oldali tálca mozgatható részébe a nyomtatható oldallal felfelé. Ne csúsztasson papírt a tálcába. Ügyeljen arra, a köteg magassága ne haladja meg a maximális papírmennyiséget mutató jelet. A tálca túltöltése papírelakadást okozhat. Helyezze be a jobb oldali tálca mozgatható részét a nyomtatóba. Töltse be a papírköteget a bal oldali tálca mozgatható részébe a nyomtatható oldallal felfelé. Szerelje fel a tálcát. Ha szükséges, állítsa be a tálcákba betöltött papír paramétereivel megegyező papírméretet és -típust. Ha telepített kiadóegységet, a lapok nyomtatáskor 180°-ban elfordulnak. Egyoldalas nyomtatás esetén a fejléces papírt felfelé nézve, a fejléccel az adagoló elülső oldalán töltse be. Kétoldalas nyomtatás esetén a fejléces papírt lefelé nézve, a fejléccel az adagoló elülső oldalán töltse be. 2000 lapos kettős bemeneti egység betöltés 2000 lapos kettős bemeneti egység betöltése tálcák betöltése"},{"UUID":"107c119e-2255-494b-afbb-8deae9442269","title":"Papír és speciális adathordozó betöltése","link":"loading-trays-group.html","desc":"Az 1500 lapos fiók betöltése","descFull":"Az 1500 lapos fiók betöltése A berendezés stabilitásvesztésének elkerülése érdekében minden egyes tálcába külön-külön töltse be a papírt. A többi tálcát tartsa csukva, amíg szüksége nincs rájuk. Nyissa ki a K ajtót. Az elakadások elkerülése érdekében ne nyissa ki a tálcákat, amíg a nyomtató foglalt. Mielőtt behelyezné a papírt, hajlítsa meg, pörgesse át, és igazítsa össze a köteget. A papírköteget a nyomtatandó oldalával lefelé töltse be. Ne csúsztasson papírt a tálcába. Ügyeljen arra, a köteg magassága ne haladja meg a maximális papírmennyiséget mutató jelet. A tálca túltöltése papírelakadást okozhat. Csukja be a K ajtót. Ha szükséges, állítsa be a tálcákba betöltött papír paramétereivel megegyező papírméretet és -típust. Egyoldalas nyomtatás esetén a fejléces papírt lefelé nézve, a fejléccel a nyomtató hátulja felé töltse be. Kétoldalas nyomtatás esetén a fejléces papírt felfelé nézve, a fejléccel a nyomtató hátulja felé töltse be. Ha más papírméretet tölt be, győződjön meg róla, hogy a vezetőket beállította. Tegye a következőt: Egy lapos fejű csavarhúzóval távolítsa el a csavarokat a papírvezetőkből. Távolítsa el a papírvezetőket. Igazítsa úgy a papírvezetőket, hogy azok megegyezzenek a betöltött papír méretével. Szerelje be a csavarokat a papírvezetőkbe. 1500 lapos tálca betöltés tálca betöltése"},{"UUID":"7f96bf59-e66f-4289-ad39-6d4bfdf03132","title":"Papír és speciális adathordozó betöltése","link":"loading-trays-group.html","desc":"A többcélú adagoló betöltése Nyissa","descFull":"A többcélú adagoló betöltése Nyissa ki a többcélú adagolót. Igazítsa úgy az oldalsó vezetőket, hogy azok megegyezzenek a betöltött papír méretével. Mielőtt behelyezné a papírt, hajlítsa meg, pörgesse át, és igazítsa össze a köteget. Töltse be a papírt. Győződjön meg arról, hogy az oldalsó vezetők szorosan illeszkednek a papírhoz. Fejléces papír betöltésénél tegye a következők egyikét: Kiadóegység nélkül Kiadóegységgel Egyoldalas, hosszú oldali nyomtatás Egyoldalas, hosszú oldali nyomtatás Kétoldalas, hosszú oldali nyomtatás Kétoldalas, hosszú oldali nyomtatás Előre lyukasztott papír betöltésekor végezze el a következők egyikét: Kiadóegység nélkül Kiadóegységgel Egyoldalas, hosszú oldali nyomtatás Egyoldalas, hosszú oldali nyomtatás Kétoldalas, hosszú oldali nyomtatás Kétoldalas, hosszú oldali nyomtatás Borítékok esetén Töltse be a borítékot úgy, hogy a fedlapja felfelé mutasson, és a nyomtató hátulja felé helyezkedjen el. Az európai borítékot úgy töltse be, hogy a felfelé mutató fedlap lépjen be először a többcélú adagolóba. Ha telepített kiadóegységet, a nyomtató 180°-kal elfordítja az oldalakat. papír betöltése többcélú adagolóban fejléces papír betöltése Előlyukasztott papír betöltése"},{"UUID":"8e7cf5ae-a1e1-4f0e-b30d-95cb84d48656","title":"Papír és speciális adathordozó betöltése","link":"loading-trays-group.html","desc":"Tálcák összekapcsolása Nyisson meg egy","descFull":"Tálcák összekapcsolása Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a következőre:  Beállítások Papír Tálcakonfiguráció . Állítsa be ugyanazt a papírméretet és -típust az összekapcsolni kívánt tálcákhoz. Ügyeljen arra, hogy az összekapcsolt tálcákat azonos tájolással töltse be. Mentse a beállításokat. Kattintson a  Beállítások Eszköz Karbantartás Konfigurációs menü Tálca beállításai  opcióra. Állítsa a  Tálca-összekapcsolás  lehetőséget  Automatikus  beállításra. Mentse a beállításokat. A tálcák szétkapcsolásánál ügyeljen arra, hogy egyik tálcának se legyenek ugyanazok a papírméret- és papírtípus-beállításai. A beégető egység hőmérséklete a beállított papírtípustól függ. A nyomtatási problémák elkerülése érdekében egyeztesse össze a nyomtató papírtípus-beállításait a tálcába betöltött papírral. tálcacsatolás megszüntetése tálcák csatolása tálcák összekapcsolása tálca-összekapcsolás bontása"},{"UUID":"9b49bab1-6f6b-454a-8951-541f59380f60","title":"Szoftver, illesztőprogramok és firmware telepítése, illetve frissítése","link":"installing-printer-software-topic.html","desc":"Nyomtatószoftver telepítése A nyomtató illesztőprogramja","descFull":"Nyomtatószoftver telepítése A nyomtató illesztőprogramja a szoftvertelepítő csomagban található. A macOS 10.7 vagy újabb verziójú operációs rendszert használó Macintosh számítógépek esetén nem kell illesztőprogramot telepítenie az AirPrint-nyomtatókra történő nyomtatáshoz. Ha egyéni nyomtatási funkciókat szeretne, töltse le a nyomtató-illesztőprogramot. Szerezze be a szoftvertelepítő csomag egy példányát. A nyomtatóhoz kapott szoftvereket tartalmazó CD lemezről. Látogasson el a  www.lexmark.com/downloads  webhelyre. Keresse fel a  www.dell.com/support/printers  oldalt. Webhelyünkről vagy a nyomtató értékesítőjétől. Indítsa el a telepítőt, és kövesse a képernyőn megjelenő utasításokat. nyomtatószoftver telepítése nyomtatószoftver telepítés nyomtató-illesztőprogram telepítése nyomtató-illesztőprogram telepítés"},{"UUID":"0f086c20-c145-4a70-a29b-3598d797018c","title":"Szoftver, illesztőprogramok és firmware telepítése, illetve frissítése","link":"installing-printer-software-topic.html","desc":"Faxoláshoz használt illesztőprogram telepítése Lépjen","descFull":"Faxoláshoz használt illesztőprogram telepítése Lépjen a  www.lexmark.com/downloads  oldalra, keresse meg a nyomtatómodellt, majd töltse le a megfelelő telepítőcsomagot. Látogasson el webhelyünkre vagy arra a helyre, ahol a nyomtatót vásárolta, és szerezze be a telepítőcsomagot. Lépjen a  www.dell.com/support  oldalra, majd töltse le a megfelelő telepítőcsomagot. A számítógépén kattintson a  Nyomtató tulajdonságai  elemre, majd lépjen a  Konfiguráció  lapra. Indítsa el a telepítőt, és kövesse a képernyőn megjelenő utasításokat. Válassza ki a  Fax  elemet, majd kattintson az  Alkalmaz  gombra. faxoláshoz használt illesztőprogram telepítés faxoláshoz használt illesztőprogram telepítése"},{"UUID":"c66265ab-7e5b-49ce-820d-ad15c1e2bceb","title":"Szoftver, illesztőprogramok és firmware telepítése, illetve frissítése","link":"installing-printer-software-topic.html","desc":"Nyomtatók hozzáadása a számítógéphez Mielőtt","descFull":"Nyomtatók hozzáadása a számítógéphez Mielőtt elkezdené, tegye a következők egyikét: Csatlakoztassa a nyomtatót és a számítógépet ugyanahhoz a hálózathoz. A nyomtató hálózathoz való csatlakoztatásával kapcsolatos további információkat lásd:  . A számítógép csatlakoztatása a nyomtatóhoz. További információkért lásd:  . A nyomtató csatlakoztatása a számítógéphez USB-kábel használatával. További információkért lásd:  . Az USB-kábel külön vásárolható meg. Útmutatás Windows-felhasználók számára Telepítse a nyomtatóillesztő-programot a számítógépre. További információkért lásd:  . Nyissa meg a  Nyomtatók & lapolvasók  menüt, majd kattintson a  Nyomtató vagy lapolvasó hozzáadása  gombra. A nyomtató csatlakozásától függően tegye a következők egyikét: Válasszon ki egy nyomtatót a listából, majd kattintson az  Eszköz hozzáadása  lehetőségre. Kattintson a  Wi-Fi Direct nyomtatók megjelenítése  elemre, válasszon ki egy nyomtatót, majd kattintson az  Eszköz hozzáadása  lehetőségre. Kattintson  A kívánt nyomtató nem szerepel a listán  elemre, majd a  Nyomtató hozzáadása  ablakban tegye a következőket: Válassza ki a  Nyomtató hozzáadása IP-cím vagy állomásnév használatával  lehetőséget, majd kattintson a  Tovább  gombra. Az Eszköz típusa mezőben válassza a  TCP/IP eszköz  lehetőséget. Az Állomásnév vagy IP-cím mezőben adja meg a nyomtató IP-címét, majd kattintson a  Tovább  gombra. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Válasszon ki egy nyomtató-illesztőprogramot, majd kattintson a  Tovább  gombra. Válassza ki a  Jelenleg telepített illesztőprogram használata (ajánlott)  lehetőséget, majd kattintson a  Tovább  gombra. Gépelje be a nyomtató nevét, majd kattintson a  Tovább  gombra. Kattintson a  Befejezés  gombra. Macintosh-felhasználók számára Nyiss meg a  Nyomtatók & lapolvasók  menüt. Kattintson a  Nyomtató, szkenner vagy fax hozzáadása  gombra, majd válasszon ki egy nyomtatót. A  Nyomtató hozzáadása  menüből válasszon ki egy nyomtatóillesztő-programot. Macintosh nyomtató-illesztőprogram használatához válassza az  AirPrint  vagy a  Biztonságos AirPrint  lehetőséget. Ha egyéni nyomtatási funkciókat szeretne, válassza a Lexmark nyomtató-illesztőprogramot. Az illesztőprogram telepítésével kapcsolatban lásd:  . Ha egyéni nyomtatási funkciókat szeretne, válassza a gyártó nyomtató-illesztőprogramját. Az illesztőprogram telepítésével kapcsolatban lásd:  . Végezze el a nyomtató hozzáadását. nyomtatók hozzáadása a számítógéphez"},{"UUID":"1b911294-885a-406b-a289-6201cee07cd8","title":"Szoftver, illesztőprogramok és firmware telepítése, illetve frissítése","link":"installing-printer-software-topic.html","desc":"Konfigurációs fájl exportálása Nyisson meg","descFull":"Konfigurációs fájl exportálása Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Az Embedded Web Serveren kattintson a  Konfiguráció exportálása  elemre. Válassza ki az exportálandó konfigurációt. A kiválasztott konfigurációtól függően a fájlok exportálása ZIP- vagy CSV-formátumban történik. konfigurációs fájl exportálása konfigurációs fájl exportálás"},{"UUID":"65db102a-705c-4a53-9fb1-0e442b3420be","title":"Szoftver, illesztőprogramok és firmware telepítése, illetve frissítése","link":"installing-printer-software-topic.html","desc":"Konfigurációs fájl importálása Nyisson meg","descFull":"Konfigurációs fájl importálása Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Az Embedded Web Serveren kattintson a  Konfiguráció importálása  elemre. Keresse meg a fájl mentési helyét. A fájlok ZIP vagy CSV formátumban kerülnek elmentésre. Kattintson az  Importálás  gombra. konfigurációs fájl importálása konfigurációs fájl importálás"},{"UUID":"21ce574c-7475-46ca-9a29-a2a200642d78","title":"Szoftver, illesztőprogramok és firmware telepítése, illetve frissítése","link":"installing-printer-software-topic.html","desc":"Választható lehetőségek hozzáadása a nyomtató-illesztőprogramban","descFull":"Választható lehetőségek hozzáadása a nyomtató-illesztőprogramban Útmutatás Windows-felhasználók számára Nyissa meg a nyomtatók mappáját. Válassza ki a frissíteni kívánt nyomtatót, majd végezze el az alábbiak egyikét: Windows 7 vagy újabb rendszeren válassza a  Nyomtató tulajdonságai  elemet. Korábbi verziójú rendszeren válassza a  Tulajdonságok  elemet. Lépjen a  Konfiguráció  lapra, majd válassza a  Frissítés most – Nyomtató megkérdezése  elemet. Alkalmazza a módosításokat. Macintosh-felhasználók számára Nyiss meg a  Nyomtatók & lapolvasók  menüt. Kattintson a  Nyomtató, szkenner vagy fax hozzáadása  gombra, majd válasszon ki egy nyomtatót. Válasszon nyomtatóillesztő-programot. Alkalmazza a módosításokat. hardverkiegészítők hozááadása a nyomtató-illesztőprogramban nyomtatóillesztő hardverkiegészítők hozááadása"},{"UUID":"71708ba9-e1d8-4aa8-b788-d1609c01cdfc","title":"Firmware frissítése","link":"installing-printer-software-topic.html","desc":"A firmware frissítése a kezelőpanel","descFull":"A firmware frissítése a kezelőpanel segítségével Az értesítési központ használata Ez a módszer nem vonatkozik minden nyomtatómodellre. A kezelőpanelen navigáljon az értesítési központra, majd válassza a  Firmware-frissítés érhető el  lehetőséget. Válassza a  Telepítés most  lehetőséget. A nyomtató a frissítés után automatikusan újraindul. A Beállítások menü használata A kezelőpanelen navigáljon a  Beállítások Eszköz Firmware frissítése  menüpontra. A nyomtató modelljétől függően válassza a  Frissítések keresése  vagy a  Frissítések keresése most  lehetőséget. Ha új frissítés érhető el, válassza a  Telepítés most  lehetőséget. A nyomtató a frissítés után automatikusan újraindul. firmware frissítése a kezelőpanel használata firmware, frissítés a kezelőpanel használata"},{"UUID":"8915d738-a459-4555-9da4-dcff1c07c656","title":"Firmware frissítése","link":"installing-printer-software-topic.html","desc":"A firmware frissítése az Embedded","descFull":"A firmware frissítése az Embedded Web Server segítségével Mielőtt elkezdené, győződjön meg a következőkről: Letöltötte a nyomtató legújabb firmware-ét a  https://support.lexmark.com  oldalról, és elmentette a flash-meghajtóra vagy a számítógépére. A nyomtató firmware-jének telepítéséhez bontsa ki az FLS firmware fájlt a ZIP csomagból. Letöltötte a legújabb nyomtatószoftvert, és elmentette a flash-meghajtóra vagy a számítógépre. További információért fáradjon el oda, ahol a nyomtatót vásárolta. Letöltötte a legújabb nyomtatószoftvert, és elmentette a flash-meghajtóra vagy a számítógépre. További tájékoztatásért forduljon a forgalmazóhoz. Nem használ speciális kódot a nyomtatón, hogy ne veszítse el ezt a funkciót. Győződjön meg arról, hogy a firmware-frissítésben részesülő nyomtatók a firmware-frissítési folyamat teljes időtartama alatt be vannak kapcsolva. A nyomtató kikapcsolása a firmware-frissítés alatt súlyosan károsíthatja a nyomtatót. Ha a nyomtató a frissítések keresésekor csatlakozik a hálózathoz, akkor a firmware letöltése nem szükséges. Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson az  Eszköz  gombra. Görgessen lefelé, majd kattintson a  Firmware frissítése  gombra. A nyomtató modelljétől függően kattintson a  Frissítések keresése  vagy a  Frissítések keresése most  gombra. Ha új frissítés érhető el, akkor kattintson az  Egyetértek, frissítés indítása  gombra. A nyomtató a frissítés után automatikusan újraindul. firmware frissítése az Embedded Web Server használata firmware, frissítés az Embedded Web Server használata"},{"UUID":"a60b7d51-b3be-4092-97f0-f56137ddc1b6","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A külön megvásárolható 550 lapos","descFull":"A külön megvásárolható 550 lapos tálca beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Csomagolja ki a külön megvásárolható 550 lapos tálcát. A tálca sérülésének elkerülése érdekében emeléskor mindenképpen fogja meg az elülső és a hátsó oldalt. Szerelje fel a tálca jobb oldali fedelét. Húzza ki az 550 lapos tálca mozgatható részét. Vegye le a tálca felső fedelét. Távolítsa el a csavarokat. Csatlakoztassa a tálca alsó fedelét. Szerelje be a csavarokat. Szerelje fel a tálca felső fedelét. Helyezze be az 550 lapos tálca mozgatható részét. Távolítsa el a nyomtató jobb oldala alatti fedelet. Igazítsa a nyomtatót az 550 lapos tálcához, majd engedje le a helyére. Ha a nyomtató nehezebb mint 20 kg (44 font), előfordulhat, hogy a biztonságos megemeléséhez legalább két ember szükséges. Húzza ki a normál tálca mozgatható részét. Rögzítse az 550 lapos tálcát a nyomtatóhoz. Helyezze be a normál tálca mozgatható részét. Rögzítse az 550 lapos tálca hátsó részét a nyomtatóhoz. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. Adja hozzá a tálcát a nyomtató-illesztőprogramban, hogy az elérhető legyen a nyomtatási feladatokhoz. További információkért lásd:  . a 550 lapos tálca beszerelése 550 lapos tálca beszerelés hardveropciók 550 lapos tálca"},{"UUID":"34b08a54-21b6-4f85-956e-39b4dc4c605a","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A 2 x 550 lapos","descFull":"A 2 x 550 lapos tálca beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ezt az opciót a külön megvásárolható 550 lapos tálcával együtt kell beszerelni. Ezt az opciót a konfiguráció aljára szerelje. Ha már be van szerelve egy 550 lapos tálca, szerelje le a tálcát, vegye le a tálca oldalsó fedelét, vegye le a tálca alsó fedelét, majd helyezze a tálcát ennek az opciónak a tetejére. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Csomagolja ki a 2 x 550 lapos tálcát, majd távolítsa el az összes csomagolóanyagot. Rögzítse a görgőt, hogy megakadályozza a 2 x 550 lapos tálca elmozdulását. Igazítsa a 2 x 550 lapos tálcát az 550 lapos tálcához, majd engedje le a helyére. A tálca sérülésének elkerülése érdekében emeléskor mindenképpen fogja meg az elülső és a hátsó oldalt. Húzza ki az 550 lapos tálca mozgatható részét. Rögzítse az 550 lapos tálcát a 2 x 550 lapos tálcához. Helyezze be az 550 lapos tálca mozgatható részét. Rögzítse az 550 lapos tálca hátsó részét a 2 x 550 lapos tálcához. Távolítsa el a nyomtató jobb oldala alatti fedelet. Igazítsa a nyomtatót a külön megvásárolható tálcákhoz, majd engedje le a helyére. Ha a nyomtató nehezebb mint 20 kg (44 font), előfordulhat, hogy a biztonságos megemeléséhez legalább két ember szükséges. Húzza ki a normál tálca mozgatható részét. Rögzítse az 550 lapos tálcát a nyomtatóhoz. Helyezze be a normál tálca mozgatható részét. Rögzítse az 550 lapos tálca hátsó részét a nyomtatóhoz. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. Adja hozzá a tálcát a nyomtató-illesztőprogramban, hogy az elérhető legyen a nyomtatási feladatokhoz. További információkért lásd:  . 2 x 550 lapos tálca beszerelés hardveropciók 2 x 550 lapos tálca 2 x 550 lapos tálca beszerelése"},{"UUID":"ff47c9c4-675b-4e4d-88b7-9e0d0fe5414e","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A 2000 lapos kettős bemeneti","descFull":"A 2000 lapos kettős bemeneti egység beszerelése A 2000 lapos kettős bemeneti egység beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ezt az opciót a külön megvásárolható 550 lapos tálcával együtt kell beszerelni. Ezt az opciót a konfiguráció aljára szerelje. Ha már be van szerelve egy 550 lapos tálca, szerelje le a tálcát, vegye le a tálca oldalsó fedelét, vegye le a tálca alsó fedelét, majd helyezze a tálcát ennek az opciónak a tetejére. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Csomagolja ki a kettős bemeneti egységet, majd távolítsa el az összes csomagolóanyagot. Rögzítse a görgőt, hogy a kettős bemeneti egység ne mozduljon el. D Igazítsa az 550 lapos tálcát a kettős bemeneti egységhez, majd engedje a helyére. A tálca sérülésének elkerülése érdekében emeléskor mindenképpen fogja meg az elülső és a hátsó oldalt. Húzza ki az 550 lapos tálca mozgatható részét. Rögzítse az 550 lapos tálcát a kettős bemeneti egységhez. Helyezze be a tálca mozgatható részét. Rögzítse az 550 lapos tálca hátsó részét a kettős bemeneti egységhez. Távolítsa el a nyomtató jobb oldala alatti fedelet. Igazítsa a nyomtatót a külön megvásárolható tálcákhoz, majd engedje le a helyére. Ha a nyomtató nehezebb mint 20 kg (44 font), előfordulhat, hogy a biztonságos megemeléséhez legalább két ember szükséges. Húzza ki a normál tálcát. Rögzítse az 550 lapos tálcát a nyomtatóhoz. Szerelje fel a tálcát. Rögzítse az 550 lapos tálca hátsó részét a nyomtatóhoz. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. Adja hozzá a tálcát a nyomtató-illesztőprogramban, hogy az elérhető legyen a nyomtatási feladatokhoz. További információkért lásd:  . 2000 lapos kettős bemeneti egység beszerelés hardveropciók 2000 lapos kettős bemeneti egység 2000 lapos kettős bemeneti egység beszerelése"},{"UUID":"4962c326-385e-4ed3-a4d9-ce1af8fe5544","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A szekrény beszerelése Ha a","descFull":"A szekrény beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ezt az opciót egy 550 lapos tálcával együtt kell beszerelni. Ezt az opciót a konfiguráció aljára szerelje. Ha már be van szerelve egy 550 lapos tálca, akkor távolítsa el a tálcát, vegye le a tálca alsó fedelét, és helyezze rá erre az opcióra. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Csomagolja ki, majd szerelje össze a szekrényt. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Rögzítse a görgőt, hogy megakadályozza a szekrény elmozdulását. Helyezze fel az 550 lapos tálca oldalsó fedelét. Igazítsa a tálcát a szekrényhez, majd engedje le a helyére. A tálca sérülésének elkerülése érdekében emeléskor mindenképpen fogja meg az elülső és a hátsó oldalt. Húzza ki a tálca mozgatható részét. Rögzítse a tálcát a szekrényhez. Helyezze be a tálca mozgatható részét. Rögzítse a tálca hátsó részét a szekrényhez. Távolítsa el a nyomtató jobb oldala alatti fedelet. Igazítsa a nyomtatót a szekrényhez és a tálcához, majd engedje le a helyére. Ha a nyomtató nehezebb mint 20 kg (44 font), előfordulhat, hogy a biztonságos megemeléséhez legalább két ember szükséges. Húzza ki a normál tálca mozgatható részét. Rögzítse az 550 lapos tálcát a nyomtatóhoz. Helyezze be a normál tálca mozgatható részét. Rögzítse az 550 lapos tálca hátsó részét a nyomtatóhoz. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. szekrény beszerelés hardveropciók szekrény A szekrény beszerelése"},{"UUID":"78240892-eddd-4df5-a23c-5843b0ec8937","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"Az 1500 lapos fiók beszerelése","descFull":"Az 1500 lapos fiók beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Mielőtt beszerelné ezt az opciót, győződjön meg arról, hogy a külön megvásárolható 550 lapos tálca és a 2 x 500 lapos tálca vagy a 2000 lapos fiók valamelyike már be van szerelve. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Távolítsa el a csatlakozófedelet. Ne dobja ki a fedelet. Távolítsa el a portfedelet. Ne dobja ki a fedelet. Távolítsa el a csavaros kupakokat a nyomtatóról. Ne dobja ki a csavaros kupakokat. Csomagolja ki az 1500 lapos fiókot, majd távolítsa el az összes csomagolóanyagot. Szerelje fel a tartópánt csavarjait. Szerelje fel a tartópántot a nyomtatóra. Használja az 1500 lapos fiókhoz mellékelt tartópántot és csavarokat. Szerelje be a maradék csavarokat. Szerelje be az 1500 lapos fiókot. Csatlakoztassa a fiók kábelét a nyomtatóhoz. Szerelje fel a fiókkábel burkolatát. Csúsztassa az 1500 lapos fiókot a nyomtató felé. Csatlakoztassa a nyomtató tápkábelének egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. Adja hozzá a tálcát a nyomtató-illesztőprogramban, hogy az elérhető legyen a nyomtatási feladatokhoz. További információkért lásd:  . 1500 lapos fiók beszerelése 1500 lapos tálca beszerelés hardveropciók 1500 lapos tálca"},{"UUID":"9dfbf148-9fb0-4b2a-82a1-dace421d2dcc","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A kapcsozó kiadó beszerelése A","descFull":"A kapcsozó kiadó beszerelése A kapcsozó kiadó beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Csomagolja ki a kapcsozó kiadót, majd távolítsa el róla az összes csomagolóanyagot. Szerelje be az adagolóvezetőt. Vegye ki a normál rekeszt. Ne dobja ki a rekeszt. Az opció beszerelése előtt állítsa a kimeneti rekesz jelzőkarját zárt helyzetbe. Az opció eltávolításakor, helyezze a kimeneti rekesz jelzőkarját nyitott állásba. Vegye ki a biztonsági görgőt. Ne dobja ki a görgőt. Helyezze be a kapcsozó kiadóhoz mellékelt adagológörgőt, amíg az be nem  kattan  a helyére. Győződjön meg róla, hogy a fémrugó az adagológörgő előtt van. helyezze fel a görgőfedelet, amíg az a helyére nem  kattan . Nyissa ki az elülső ajtót, majd vegye le a nyomtató bal oldalán lévő fedelet. Ne dobja ki a csavart és a fedelet. Távolítsa el a bal hátsó fedelet. Ne dobja ki a csavart és a fedelet. Távolítsa el a belső rekeszfedelet. Ne dobja ki a fedelet. Pozicionálja, majd helyezze be a kapcsozó kiadóhoz mellékelt belső rekeszfedelet. Szerelje fel a csavarokat a belső rekeszfedélre. Csatlakoztassa a kapcsozó kiadó csúszóelemét. Helyezze be a kapcsozó kiadót. Szerelje fel a tartópántot a kiadóegység nyomtatóhoz rögzítéséhez. Használja a kiadóegységhez mellékelt csavart. Helyezze fel a bal hátsó fedelet, majd csúsztassa a kapcsozó kiadót balra. Helyezze fel a kiadóegységgel együtt kapott bal felső díszítőfedelet. Nyomja be a tűzőkazettát a szétválogatóba, amíg a helyére nem  kattan . Zárja be az elülső ajtót, majd csúsztassa a kiadóegységet a nyomtató felé. Csatlakoztassa az opció kábelét a nyomtatóhoz. Csatlakoztassa a nyomtató tápkábelének egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. Adja hozzá a kiadóegységet a nyomtató-illesztőprogramban, hogy az elérhető legyen a nyomtatási feladatokhoz. További információkért lásd:  . a kapcsozó kiadó beszerelése kapcsozó kiadó beszerelés hardveropciók kapcsozó kiadó"},{"UUID":"74aeaa8c-367b-4e99-a273-27babfd83fd3","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"Kötegelő rendezőtálca beszerelése Kötegelő rendezőtálca","descFull":"Kötegelő rendezőtálca beszerelése Kötegelő rendezőtálca beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Csomagolja ki a kötegelő rendezőtálcát, majd távolítsa el róla az összes csomagolóanyagot. Csatlakoztassa a belső hátsó burkolatot a kötegelő rendezőtálcához. Vegye ki a normál rekeszt. Ne dobja ki a rekeszt. Távolítsa el a papírszállító egység csatlakozófedelét. Ne dobja ki a fedelet. Az opció beszerelése előtt állítsa a kimeneti rekesz jelzőkarját zárt helyzetbe. Pozicionálja, majd szerelje be a kötegelő rendezőtálcát a nyomtatóba.  Győződjön meg arról, hogy az alkatrészek biztonságosan rögzülnek és illeszkednek a nyomtatóhoz. Rögzítse a kötegelő rendezőtálca védőcsíkjait a nyomtatóhoz. Helyezze a kimeneti rekesz jelzőkarját nyitott állásba. Helyezze fel a rekesz jelzőkarjának fedelét, amíg az a helyére nem  kattan . Csatlakoztassa a nyomtató tápkábelének egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. Adja hozzá a kötegelő rendezőtálcát a nyomtató-illesztőprogramban, hogy az elérhető legyen a nyomtatási feladatokhoz. További információkért lásd:  . kötegelő rendezőtálca beszerelés kötegelő rendezőtálca beszerelése hardveropciók beszerelés"},{"UUID":"dd3b8368-fb36-4b3f-acde-383fcc58f646","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A használata hajtogatási lehetőséggel ellátott","descFull":"A használata hajtogatási lehetőséggel ellátott papírszállító egység beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ez az opció kapcsozó-lyukasztó kiadóegységgel és füzetkészítő egységgel együtt is beszerelhető. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Csomagolja ki a hajtogatási lehetőséggel ellátott papírszállító egységet, majd távolítsa el róla az összes csomagolóanyagot. Vegye ki a normál rekeszt. Ne dobja ki a rekeszt. Az opció beszerelése előtt állítsa a kimeneti rekesz jelzőkarját zárt helyzetbe. Az opció eltávolításakor, helyezze a kimeneti rekesz jelzőkarját nyitott állásba. Vegye ki a biztonsági görgőt. Ne dobja ki a görgőt. Helyezze be az opcióhoz mellékelt adagológörgőt, amíg az be nem  kattan  a helyére. Győződjön meg róla, hogy a fémrugó az adagológörgő előtt van. helyezze fel a görgőfedelet, amíg az a helyére nem  kattan . Nyissa ki az elülső ajtót, majd vegye le a nyomtató bal oldalán lévő fedelet. Ne dobja ki a csavart és a fedelet. Csukja be az elülső ajtót. Távolítsa el a papírszállító egység csatlakozófedelét. Ne dobja ki a fedelet. Távolítsa el a bal hátsó fedelet. Ne dobja ki a csavart és a fedelet. Távolítsa el a belső rekeszfedelet. Ne dobja ki a csavart és a fedelet. Pozicionálja, majd helyezze be az opcióhoz mellékelt belső rekeszfedelet. Szerelje fel a csavarokat a belső rekeszfedélre. Rögzítse a habszalagdarabokat az opcióhoz. Nyissa ki az F ajtót, majd húzza meg a csavarokat. Csukja be az F ajtót. Rögzítse a fémpántot az opcióhoz. Helyezze be az opciót. Győződjön meg róla, hogy a fémpánt a nyomtató előtt van. Nyissa ki az F ajtót, majd az opcióhoz mellékelt csavarhúzóval szerelje be a csavart. Csukja be az F ajtót. Szerelje be a csavarokat az opcióba. Csatlakoztassa a bal hátsó fedelet. Nyissa ki az elülső ajtót, majd rögzítse a fedelet a nyomtató bal oldalára. Csukja be az elülső ajtót. Emelje fel a rekesz fülét, majd pozicionálja és rögzítse az opciórekeszt. Szerelje fel a csavarokat az opciórekeszhez. Rögzítse a díszfedelet. Csatlakoztassa az opció kábelét a nyomtatóhoz. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. hardveropciók papírszállító egység hajtogatási lehetőséggel papírszállító egység hajtogatási lehetőséggel beszerelés"},{"UUID":"71447a33-6ffa-4d29-9253-19e99d6dacf6","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A kapcsozó-lyukasztó kiadóegység és a","descFull":"A kapcsozó-lyukasztó kiadóegység és a papírszállító egység opció beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Csomagolja ki a papírszállító egységet. Vegye ki a normál rekeszt. Ne dobja ki a rekeszt. Az opció beszerelése előtt állítsa a kimeneti rekesz jelzőkarját zárt helyzetbe. Az opció eltávolításakor, helyezze a kimeneti rekesz jelzőkarját nyitott állásba. Vegye ki a biztonsági görgőt. Ne dobja ki a görgőt. Helyezze be a papírszállító egységhez mellékelt adagológörgőt, amíg az be nem  kattan  a helyére. Győződjön meg róla, hogy a fémrugó az adagológörgő előtt van. Csatlakoztassa a fedelet, amíg a helyére nem  kattan . Nyissa ki az elülső ajtót, majd vegye le a nyomtató bal oldalán lévő fedelet. Ne dobja ki a csavart és a fedelet. Csukja be az elülső ajtót. Távolítsa el a papírszállító egység csatlakozófedelét. Ne dobja ki a fedelet. Távolítsa el a fedelet. Ne dobja ki a fedelet. Rögzítse a fémpántot. Helyezze be a papírszállító egységet. Nyissa ki a G fogantyút, majd szerelje be a csavart a papírszállító egység elülső részébe. Zárja be a G fogantyút. Szerelje be a csavart a papírszállító egység hátsó részébe. Nyissa ki az elülső ajtót, majd rögzítse a papírszállító egységhez mellékelt fedelet a nyomtató bal oldalára. Csukja be az elülső ajtót. Csomagolja ki a kapcsozó-lyukasztó kiadóegységet. Szerelje be a stabilizátort. Vegye le a kiadóegység körüli szalagdarabokat. Csatlakoztassa a pántot a kiadóegységhez. Rögzítse a habszalagot a kiadóegységhez. Csatlakoztassa az adagolóvezetőt a kiadóegységhez. Csatlakoztassa a rekeszt a kiadóegységhez. Nyissa ki a kiadóegység ajtaját, majd helyezze be a lyukasztódobozt. Helyezze a rekeszbővítőt a kiadóegység rekeszébe. A rekeszbővítő A3-as vagy annál hosszabb papír esetén és magas páratartalom mellett használatos, hogy segítse a papír gyűjtését. A rekeszbővítő használata esetén a rekeszkapacitás csökken. Csukja be a szétválogató ajtaját. Szerelje fel a tartópántot a nyomtatóra. Győződjön meg róla, hogy a csavarok a tartópánton lévő jelölésekkel egy vonalban vannak. Csatlakoztassa a papírszállító egységhez mellékelt fémpántot a nyomtatóhoz. Nyissa ki a kiadóegység ajtaját, távolítsa el a csavart, majd húzza ki a kiadóegység zárját. Csatlakoztassa a kiadóegységet a nyomtatóhoz. Rögzítse a kiadóegységet a nyomtatóhoz, majd szerelje be a csavart. Csatlakoztassa a kiadóegység kábelét a nyomtatóhoz. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. hardveropciók papírszállító egység hardveropciók kapcsozó-lyukasztó kiadóegység papírszállító egység beszerelés kapcsozó-lyukasztó kiadóegység beszerelés"},{"UUID":"170c08ab-eae5-413d-981a-4b55702825ff","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A kapcsozó-lyukasztó kiadóegység és a","descFull":"A kapcsozó-lyukasztó kiadóegység és a hajtogatási lehetőséggel ellátott papírszállító egység beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Csomagolja ki a hajtogatási lehetőséggel ellátott papírszállító egységet, majd távolítsa el róla az összes csomagolóanyagot. Vegye ki a normál rekeszt. Ne dobja ki a rekeszt. Az opció beszerelése előtt állítsa a kimeneti rekesz jelzőkarját zárt helyzetbe. Az opció eltávolításakor, helyezze a kimeneti rekesz jelzőkarját nyitott állásba. Vegye ki a biztonsági görgőt. Ne dobja ki a görgőt. Helyezze be az opcióhoz mellékelt adagológörgőt, amíg az be nem  kattan  a helyére. Győződjön meg róla, hogy a fémrugó az adagológörgő előtt van. Csatlakoztassa a fedelet, amíg a helyére nem  kattan . Nyissa ki az elülső ajtót, majd vegye le a nyomtató bal oldalán lévő fedelet. Ne dobja ki a csavart és a fedelet. Csukja be az elülső ajtót. Távolítsa el a papírszállító egység csatlakozófedelét. Ne dobja ki a fedelet. Távolítsa el a bal hátsó fedelet. Ne dobja ki a csavart és a fedelet. Távolítsa el a belső rekeszfedelet. Ne dobja ki a csavart és a fedelet. Pozicionálja, majd helyezze be a hajtogatási lehetőséggel ellátott papírszállító egységhez mellékelt belső rekeszfedelet. Szerelje fel a csavarokat a belső rekeszfedélre. Rögzítse a habszalagdarabokat az opcióhoz. Nyissa ki az F ajtót, majd húzza meg a csavarokat. Csukja be az F ajtót. Rögzítse a pántot az opcióhoz. Helyezze be az opciót. Győződjön meg róla, hogy a fémpánt a nyomtató előtt van. Nyissa ki az F ajtót, majd az opcióhoz mellékelt csavarhúzóval szerelje be a csavart. Csukja be az F ajtót. Szerelje be a csavarokat az opcióba. Csatlakoztassa a bal hátsó fedelet. Csomagolja ki a kapcsozó-lyukasztó kiadóegységet. Szerelje be a stabilizátort. Vegye le a kiadóegység körüli szalagdarabokat. Csatlakoztassa a pántot a kiadóegységhez. Rögzítse a habszalagot a kiadóegységhez. Távolítsa el a kis adag habot a kiadóegység jobb oldalán. Csatlakoztassa az adagolóvezetőt a kiadóegységhez. Csatlakoztassa a rekeszt a kiadóegységhez. Nyissa ki a kiadóegység ajtaját, majd helyezze be a lyukasztódobozt. Helyezze a rekeszbővítőt a kiadóegység rekeszébe. A rekeszbővítő A3-as vagy annál hosszabb papír esetén és magas páratartalom mellett használatos, hogy segítse a papír gyűjtését. A rekeszbővítő használata esetén a rekeszkapacitás csökken. Csukja be a szétválogató ajtaját. Emelje fel a rekesz fülét, majd pozicionálja és rögzítse a fedelet az opcióhoz. Szerelje be a csavarokat. Nyissa ki az elülső ajtót, majd rögzítse az opcióhoz mellékelt díszítőfedelet. Szerelje fel a tartópántot a nyomtatóra. Győződjön meg róla, hogy a csavarok a tartópánton lévő jelölésekkel egy vonalban vannak. Nyissa ki a kiadóegység ajtaját, távolítsa el a csavart, majd húzza ki a kiadóegység zárját. Csatlakoztassa az opció kábelét a nyomtatóhoz. Csatlakoztassa a kiadóegység kábelét az opcióhoz. Csatlakoztassa a kiadóegységet a nyomtatóhoz. Rögzítse a kiadóegységet a nyomtatóhoz, majd szerelje be a csavart. Csukja be a szétválogató ajtaját. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. hardveropciók papírszállító egység hajtogatási lehetőséggel hardveropciók kapcsozó-lyukasztó kiadóegység papírszállító egység hajtogatási lehetőséggel beszerelés kapcsozó-lyukasztó kiadóegység beszerelés"},{"UUID":"0215c241-833d-4538-8933-1fc97dc22f69","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A füzetkészítő egység és a","descFull":"A füzetkészítő egység és a papírszállító egység beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Csomagolja ki a papírszállító egységet. Vegye ki a normál rekeszt. Ne dobja ki a rekeszt. Az opció beszerelése előtt állítsa a kimeneti rekesz jelzőkarját zárt helyzetbe. Az opció eltávolításakor, helyezze a kimeneti rekesz jelzőkarját nyitott állásba. Vegye ki a biztonsági görgőt. Ne dobja ki a görgőt. Helyezze be a papírszállító egységhez mellékelt adagológörgőt, amíg az be nem  kattan  a helyére. Győződjön meg róla, hogy a fémrugó az adagológörgő előtt van. helyezze fel a görgőfedelet, amíg az a helyére nem  kattan . Nyissa ki az elülső ajtót, majd vegye le a nyomtató bal oldalán lévő fedelet. Ne dobja ki a csavart és a fedelet. Csukja be az elülső ajtót. Távolítsa el a papírszállító egység csatlakozófedelét. Ne dobja ki a fedelet. Távolítsa el a fedelet. Ne dobja ki a fedelet. Rögzítse a fémpántot. Helyezze be a papírszállító egységet. Nyissa ki a G fogantyút, majd szerelje be a csavart a papírszállító egység elülső részébe. Zárja be a G fogantyút. Szerelje be a csavart a papírszállító egység hátsó részébe. Nyissa ki az elülső ajtót, majd rögzítse a papírszállító egységhez mellékelt fedelet a nyomtató bal oldalára. Csukja be az elülső ajtót. Csomagolja ki a füzetkészítő egységet, majd távolítsa el róla az összes csomagolóanyagot. Csatlakoztassa a pántot a kiadóegységhez. Rögzítse a habszalagot a kiadóegységhez. Csatlakoztassa az adagolóvezetőt a kiadóegységhez. Csatlakoztassa a felső rekeszt a kiadóegységhez. Emelje fel a rekesz fülét, majd rögzítse az alsó rekeszt a kiadóegységhez. Nyissa ki a kiadóegység ajtaját. Vegye le a csomagolóanyagot a lyukasztódobozról, majd helyezze be a kiadóegységbe. Helyezze a rekeszbővítőt a kiadóegység rekeszére. A rekeszbővítő A3-as vagy annál hosszabb papír esetén és magas páratartalom mellett használatos, hogy segítse a papír gyűjtését. A rekeszbővítő használata esetén a rekeszkapacitás csökken. Csatlakoztassa a kosarat a kiadóegység hátsó részéhez. Csukja be a szétválogató ajtaját. Szerelje fel a tartópántot a nyomtatóra. Győződjön meg róla, hogy a csavarok a tartópánton lévő jelölésekkel egy vonalban vannak. Csatlakoztassa a papírszállító egységhez mellékelt pántot a nyomtatóhoz. Nyissa ki a kiadóegység ajtaját, távolítsa el a csavart, majd húzza ki a kiadóegység zárját. Csatlakoztassa a kiadóegységet a nyomtatóhoz. Rögzítse a kiadóegységet a nyomtatóhoz, majd szerelje be a csavart. Csukja be a szétválogató ajtaját. Csatlakoztassa a kiadóegység kábelét a nyomtatóhoz. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. papírszállító egység beszerelése beszerelés papírszállító egység füzetkészítő egység beszerelése beszerelés füzetkészítő egység"},{"UUID":"c8dfbe6c-5f05-4e45-bc40-cf01967adac2","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A füzetkészítő egység és a","descFull":"A füzetkészítő egység és a hajtogatási lehetőséggel ellátott papírszállító egység beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Csomagolja ki a hajtogatási lehetőséggel ellátott papírszállító egységet. Vegye ki a normál rekeszt. Ne dobja ki a rekeszt. Az opció beszerelése előtt állítsa a kimeneti rekesz jelzőkarját zárt helyzetbe. Az opció eltávolításakor, helyezze a kimeneti rekesz jelzőkarját nyitott állásba. Vegye ki a biztonsági görgőt. Ne dobja ki a görgőt. Helyezze be az opcióhoz mellékelt adagológörgőt, amíg az be nem  kattan  a helyére. Győződjön meg róla, hogy a fémrugó az adagológörgő előtt van. helyezze fel a görgőfedelet, amíg az a helyére nem  kattan . Nyissa ki az elülső ajtót, majd vegye le a nyomtató bal oldalán lévő fedelet. Ne dobja ki a csavart és a fedelet. Csukja be az elülső ajtót. Távolítsa el a papírszállító egység csatlakozófedelét. Ne dobja ki a fedelet. Távolítsa el a bal hátsó fedelet. Ne dobja ki a csavart és a fedelet. Távolítsa el a belső rekeszfedelet. Ne dobja ki a csavart és a fedelet. Pozicionálja, majd helyezze be az opcióhoz mellékelt belső rekeszfedelet. Szerelje fel a csavarokat a belső rekeszfedélre. Rögzítse a habszalagdarabokat az opcióhoz. Nyissa ki az F ajtót, majd húzza meg a csavarokat. Csukja be az F ajtót. Rögzítse a pántot az opcióhoz. Helyezze be az opciót. Győződjön meg róla, hogy a fémpánt a nyomtató előtt van. Nyissa ki az F ajtót, majd az opcióhoz mellékelt csavarhúzóval szerelje be a csavart. Csukja be az F ajtót. Szerelje be a csavarokat az opcióba. Csatlakoztassa a bal hátsó fedelet. Csomagolja ki a füzetkészítő egységet, majd távolítsa el róla az összes csomagolóanyagot. Csatlakoztassa a pántot a kiadóegységhez. Rögzítse a habszalagot a kiadóegységhez. Csatlakoztassa az adagolóvezetőt a kiadóegységhez. Csatlakoztassa a felső rekeszt a kiadóegységhez. Emelje fel a rekesz fülét, majd rögzítse az alsó rekeszt a kiadóegységhez. Nyissa ki a kiadóegység ajtaját. Vegye le a csomagolóanyagot a lyukasztódobozról, majd helyezze be a kiadóegységbe. Helyezze a rekeszbővítőt a kiadóegység rekeszére. A rekeszbővítő A3-as vagy annál hosszabb papír esetén és magas páratartalom mellett használatos, hogy segítse a papír gyűjtését. A rekeszbővítő használata esetén a rekeszkapacitás csökken. Csatlakoztassa a kosarat a kiadóegység hátsó részéhez. Csukja be a szétválogató ajtaját. Emelje fel a rekesz fülét, majd pozicionálja és rögzítse a fedelet az opcióhoz. Szerelje be a csavarokat. Nyissa ki az elülső ajtót, majd rögzítse az opcióhoz mellékelt díszítőfedelet. Szerelje fel a tartópántot a nyomtatóra. Győződjön meg róla, hogy a csavarok a tartópánton lévő jelölésekkel egy vonalban vannak. Nyissa ki a kiadóegység ajtaját, távolítsa el a csavart, majd húzza ki a kiadóegység zárját. Csatlakoztassa az opció kábelét a nyomtatóhoz. Csatlakoztassa a kiadóegység kábelét az opcióhoz. Csatlakoztassa a kiadóegységet a nyomtatóhoz. Rögzítse a kiadóegységet a nyomtatóhoz, majd szerelje be a csavart. Csukja be a szétválogató ajtaját. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Kapcsolja be a nyomtatót. hardveropciók papírszállító egység hajtogatási lehetőséggel hardveropciók füzetkészítő egység papírszállító egység hajtogatási lehetőséggel beszerelés füzetkészítő egység beszerelés"},{"UUID":"09aa9a45-0851-4fa6-9e32-c8e9602b9334","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A billentyűzetpolc beszerelése Kapcsolja ki","descFull":"A billentyűzetpolc beszerelése Kapcsolja ki a nyomtatót. Nyissa ki a B ajtót. Vegye le az elülső fedelet, majd zárja be a B ajtót. Csomagolja ki a billentyűzetpolcot. Helyezze be a billentyűzetkábelt a polcba. Hurkolja be a kábelt a polc belsejébe. Távolítsa el a tapadó borítást. Igazítsa, majd rögzítse a billentyűzetet az alaphoz. Pozicionálja a polcot, csatlakoztassa a billentyűzetkábelt a nyomtatóhoz, helyezze be a polcot, majd rögzítse a nyomtatóhoz. Kapcsolja be a nyomtatót. hardveropciók billentyűzetpolc billentyűzetpolc beszerelés billentyűzetpolc beszerelése"},{"UUID":"a1c4c074-ef6e-4d65-9e77-ad3e1c274957","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"Faxoláshoz használt kártya telepítése Ha","descFull":"Faxoláshoz használt kártya telepítése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Nyissa ki a vezérlőkártya borítását. A vezérlőkártyán található elektronikus alkatrészekben könnyen kárt tehet a statikus elektromosság. Érintse meg a nyomtató valamelyik fém alkatrészét, mielőtt a vezérlőkártya elektronikus alkatrészeihez vagy csatlakozóihoz nyúlna. Távolítsa el a faxport fedelét. Ne dobja ki a csavart és a fedelet. Vegye ki a faxkártyát a védőcsomagolásból. Csatlakoztassa a faxkábelt a vezérlőkártyához. Pozicionálja, majd helyezze be a faxkártyát a nyomtatóba. Zárja be a vezérlőkártya borítását, amíg az a helyére nem  kattan , majd szerelje be a csavart. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűzveszély és az áramütés elkerülése érdekében a tápkábelt közvetlenül egy, a készülékhez közeli, könnyen hozzáférhető, megfelelő besorolású és megfelelően földelt konnektorba csatlakoztassa. Kapcsolja be a nyomtatót. faxkártya beszerelés belső opciók telepítése faxkártya"},{"UUID":"4579978f-3f46-44ca-a154-709ac6280a4c","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A kártyaolvasó telepítése Ha a","descFull":"A kártyaolvasó telepítése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Kapcsolja ki a nyomtatót. Nyissa ki a B ajtót. Nyissa ki az elülső USB-port fedelét. Távolítsa el az alsó USB-port fedelét. Ha a nyomtatója nem rendelkezik ezzel a részegységgel, akkor folytassa a következő lépéssel. Távolítsa el a védőburkolatot a kártyaolvasóról. Helyezze be a kártyaolvasót. Csatlakoztassa az alsó portfedelet, amíg az a helyére nem  kattan . Ragassza fel az öntapadó vezetőt. Csatlakoztassa az elülső USB-port fedelét, amíg az a helyére nem  kattan . Zárja be a B ajtót, amíg az a helyére nem  kattan . Kapcsolja be a nyomtatót. kártyaolvasó beszerelés belső kiegészítők kártyaolvasó"},{"UUID":"683fd3ee-5219-4c50-b8f3-aeeebd419bd8","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"Belső megoldások port beszerelése Belső","descFull":"Belső megoldások port beszerelése Belső megoldások port beszerelése Ha a vezérlőkártyával dolgozik, illetve külön megvásárolható hardvert vagy memóriaeszközöket helyez a nyomtatóba a beállítást követően, akkor az áramütés kockázatának elkerülése érdekében kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Ha bármilyen más eszköz is csatlakozik a nyomtatóhoz, akkor azt is kapcsolja ki, és húzza ki a nyomtatóval összekötő kábelt. Ehhez a feladathoz lapos fejű csavarhúzó szükséges. Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból.  Nyissa ki a vezérlőkártya borítását. A vezérlőkártyán található elektronikus alkatrészekben könnyen kárt tehet a statikus elektromosság. Érintse meg a nyomtató valamelyik fém alkatrészét, mielőtt a vezérlőkártya elektronikus alkatrészeihez vagy csatlakozóihoz nyúlna. Távolítsa el a belső megoldások port (ISP) burkolatát. Ne dobja ki a csavart és a fedelet. Csomagolja ki az ISP-készletet. Az ISP-készlet tartalma 1 ISP 2 Meghosszabbított ISP-kábel 3 Tartópánt 4 Csavarok Csatlakoztassa a tartópántot a vezérlőkártyához, amíg az a helyére nem  kattan . Rögzítse az ISP-t a tartópánthoz, majd csatlakoztassa az ISP meghosszabbított kábelét a vezérlőkártyán lévő csatlakozójához. Rögzítse az ISP-t a nyomtatóhoz. Zárja be a vezérlőkártya borítását. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűzveszély és az áramütés elkerülése érdekében a tápkábelt közvetlenül egy, a készülékhez közeli, könnyen hozzáférhető, megfelelő besorolású és megfelelően földelt konnektorba csatlakoztassa. Kapcsolja be a nyomtatót. belső megoldásport beszerelés kiegészítők beszerelése belső megoldásport"},{"UUID":"2d8c101d-1ec8-4ead-9e9c-61edb806419e","title":"Hardverkiegészítők telepítése","link":"installing-optional-550-sheet-tray-topic.html","desc":"A nyomtatóport-beállítások módosítása belső megoldások","descFull":"A nyomtatóport-beállítások módosítása belső megoldások port telepítése után Ha a nyomtatónak statikus IP-címe van, akkor nem kell módosításokat végeznie a konfiguráción. Ha a számítógépek úgy vannak konfigurálva, hogy IP-cím helyett hálózati nevet használjanak, akkor ne végezzen módosítást. Ha egy korábban Ethernet kapcsolatra konfigurált nyomtatóra vezeték nélküli belső megoldások portot (ISP) telepít, akkor a nyomtatót mindenképpen csatlakoztassa le az Ethernet hálózatról. Útmutatás Windows-felhasználók számára Nyissa meg a nyomtatók mappáját. Az új ISP-vel rendelkező nyomtató menüjének parancsikonjával nyissa meg a Nyomtató tulajdonságai párbeszédpanelt. Konfigurálja a port elemet a listából. Frissítse az IP-címet. Alkalmazza a módosításokat. Útmutatás Macintosh-felhasználók számára Az Apple menü System Preferences (Rendszerbeállítások) részében lépjen a nyomtatók listájához, majd válassza a  + IP  elemet. Írja be az IP-címet a címmezőbe. Alkalmazza a módosításokat. nyomtató-portbeállítások módosítása a nyomtató portbeállításainak módosítása az ISP-port beszerelését követően"},{"UUID":"bc90fbf1-be52-4ee7-a71e-73e8ca046099","title":"Hálózati használat","link":"connecting-printer-to-wireless-network-topic.html","desc":"Nyomtató csatlakoztatása Wi-Fi hálózathoz Mielőtt","descFull":"Nyomtató csatlakoztatása Wi-Fi hálózathoz Mielőtt elkezdené, győződjön meg a következőkről: Az  Aktív adapter Automatikus  értékre van állítva. A kezelőpanelen válassza a  Beállítások Hálózat/portok Hálózati áttekintés Aktív adapter  lehetőséget. Győződjön meg róla, hogy az Ethernet-kábel nincs-e bedugva a nyomtatóba. A kezelőpanel használata A kezelőpanelről navigáljon a  Beállítások Hálózat/portok Vezeték nélküli Beállítás a nyomtató kezelőpaneljén Hálózatot kiválasztása  menüpontra. Válasszon ki egy Wi-Fi hálózatot, majd írja be a hálózati jelszót. A beépített Wi-Fi funkcióval rendelkező nyomtatók esetében a kezdeti beállítás során megjelenik a Wi-Fi hálózat beállítására vonatkozó felszólítás. nyomtató csatlakoztatása Wi-Fi-hez nyomtató csatlakoztatása vezeték nélküli hálózathoz vezeték nélküli hálózatok"},{"UUID":"7424ae42-8fe8-45bb-ad4c-a965ecd4d9f3","title":"Hálózati használat","link":"connecting-printer-to-wireless-network-topic.html","desc":"A nyomtató csatlakoztatása vezeték nélküli","descFull":"A nyomtató csatlakoztatása vezeték nélküli hálózathoz Wi-Fi Protected Setup (WPS) használatával Mielőtt elkezdené, győződjön meg a következőkről: A hozzáférési pont (vezeték nélküli útválasztó) rendelkezik WPS-tanúsítvánnyal, illetve kompatibilis a WPS technológiával. További információ a hozzáférési ponthoz mellékelt dokumentációban található. A vezeték nélküli hálózati adapter csatlakoztatva van a nyomtatójához. További információ az adapterhez mellékelt útmutatóban található. Az  Aktív adapter Automatikus  értékre van állítva. A kezelőpanelen válassza a  Beállítások Hálózat/portok Hálózati áttekintés Aktív adapter  lehetőséget. A gombnyomásos módszer használata A kezelőpanelen navigáljon a  Beállítások Hálózat/portok Vezeték nélküli Wi-Fi Protected Setup Gombnyomásos módszer indítása  menüpontra. Kövesse a kijelzőn megjelenő utasításokat. A személyes azonosító kód (PIN-kód) használata A kezelőpanelen navigáljon a  Beállítások Hálózat/portok Vezeték nélküli Wi-Fi Protected Setup PIN-módszer indítása  menüpontra. Másolja ki a nyolc karakteres WPS PIN-kódot. Nyisson meg egy webböngészőt, és írja be a hozzáférési pont IP-címét a címmezőbe. Az IP-cím megismeréséhez szükséges információ a hozzáférési ponthoz mellékelt dokumentációban található. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Hozzáférés a WPS-beállításokhoz: További információ a hozzáférési ponthoz mellékelt dokumentációban található. Adja meg a nyolc számjegyű PIN-kódot, majd mentse a módosításokat. Wi-Fi Protected Setup vezeték nélküli hálózat vezeték nélküli hálózat Wi-Fi Protected Setup vezeték nélküli hálózathoz való csatlakozás PIN-módszer használata vezeték nélküli hálózathoz való csatlakozás gombnyomásos módszer használata"},{"UUID":"286a606e-9cb4-4b04-b7b0-15454a33d85f","title":"Hálózati használat","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi‑Fi Direct konfigurálása Wi-Fi Direct","descFull":"Wi‑Fi Direct konfigurálása Wi-Fi Direct  lehetővé teszi, hogy a Wi-Fi-eszközök hozzáférési pont (vezeték nélküli útválasztó) használata nélkül közvetlenül kapcsolódjanak egymáshoz. A kezelőpanelen navigáljon a  Beállítások Hálózat/portok Wi-Fi Direct  menüpontra. Konfigurálja a beállításokat. Wi‑Fi Direct engedélyezése  – Engedélyezi, hogy a nyomtató a saját Wi‑Fi Direct hálózatát szórja. Wi‑Fi Direct neve  – Nevet rendel a Wi‑Fi Direct hálózathoz. Wi‑Fi Direct jelszava  – Jelszót rendel az eszközhöz, melynek segítségével az engedi egy peer-to-peer eszköz kapcsolódását a vezeték nélküli hálózathoz. Mutassa a jelszót a Beállítások oldalon  – Megjeleníti a jelszót a Hálózati beállítások oldalán. Előnyben részesített csatorna száma  – A Wi-Fi Direct hálózat preferált csatornájának kijelölése. Csoporttulajdonos IP-címe  – A csoport tulajdonosának IP-címét jelöli ki. A nyomógombkérések automatikus elfogadása  – Engedélyezi, hogy a nyomtató automatikusan elfogadja a csatlakozási kéréseket. A nyomógombkérések automatikus elfogadása nem biztonságos. Alapbeállítás szerint a Wi-Fi Direct hálózati jelszó nem látható a nyomtató kijelzőjén. A jelszó megjelenítéséhez engedélyezze a jelszóbetekintő ikont. A kezelőpanelről kiindulva lépjen a  Beállítások Biztonság Egyéb Jelszó/PIN-kód mutatásának engedélyezése  elemre. Ha úgy szeretné megismerni a Wi-Fi Direct hálózat jelszavát, hogy nem jeleníti meg a nyomtató kijelzőjén, nyomtassa ki a  Hálózati beállítások oldalát . A kezelőpanelen navigáljon a  Beállítások Jelentések Hálózat Hálózati beállítások oldala  menüpontra. Wi-Fi Direct konfigurálás Wi‑Fi Direct konfigurálása"},{"UUID":"02d88056-00b3-4a7a-b261-b286d0e0e212","title":"Hálózati használat","link":"connecting-printer-to-wireless-network-topic.html","desc":"Mobileszköz csatlakoztatása a nyomtatóhoz A","descFull":"Mobileszköz csatlakoztatása a nyomtatóhoz A mobileszköz csatlakoztatása előtt győződjön meg róla, hogy a Wi-Fi Direct konfigurálva van. További információkért lásd:  . A Wi-Fi Direct használata Ezek az utasítások csak az  Android  platformon futó mobileszközökre vonatkoznak. A mobileszközön lépjen a  Beállítások  menübe. Engedélyezze a  Wi-Fi-t , majd koppintson a Wi-Fi Direct  lehetőségre. Válassza ki a nyomtató Wi-Fi Direct nevét. Erősítse meg a csatlakozást a nyomtató kezelőpaneljén. A Wi-Fi használata A mobileszközön lépjen a  Beállítások  menübe. Érintse meg a  Wi-Fi  elemet, majd válassza ki a nyomtató Wi‑Fi Direct nevét. A Wi-Fi Direct név elé a DIRECT-xy karakterlánc kerül (ahol x és y két véletlenszerű karakter). Írja be a Wi‑Fi Direct jelszót. mobileszköz csatlakoztatása nyomtatóhoz a nyomtató csatlakoztatása a Wi-Fi Direct használata"},{"UUID":"fa587ca1-b0b7-4b0c-96d4-18d3be5bbb8c","title":"Hálózati használat","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi‑Fi Direct A számítógép csatlakoztatása","descFull":"Wi‑Fi Direct A számítógép csatlakoztatása a nyomtatóhoz A számítógép csatlakoztatása előtt győződjön meg róla, hogy a Wi-Fi Direct konfigurálva van. További információkért lásd:  . Útmutatás Windows-felhasználók számára Nyissa meg a  Nyomtatók & lapolvasók  menüt, majd kattintson a  Nyomtató vagy lapolvasó hozzáadása  gombra. Kattintson a  Wi-Fi Direct nyomtatók megjelenítése  elemre, majd válassza ki a nyomtató Wi‑Fi Direct nevét. Jegyezze meg a nyomtató nyolcjegyű PIN-kódját, amely a nyomtató kijelzőjén jelenik meg. Adja meg a PIN-kódot a számítógépen. Ha a nyomtató illesztőprogramja még nincs telepítve, a Windows letölti a megfelelő illesztőprogramot. Macintosh-felhasználók számára Kattintson a vezeték nélküli ikonra, majd válassza ki a nyomtató Wi‑Fi Direct nevét. A Wi-Fi Direct név elé a DIRECT-xy karakterlánc kerül (ahol x és y két véletlenszerű karakter). Írja be a Wi‑Fi Direct jelszavát. Miután lecsatlakozott a Wi‑Fi Direct hálózatról, váltson vissza a számítógépén az előző hálózatra. számítógép és nyomtató csatlakoztatása"},{"UUID":"f5603789-693e-4030-93da-e9b145aec463","title":"Hálózati használat","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi‑Fi hálózat kikapcsolása A kezelőpanelen","descFull":"Wi‑Fi hálózat kikapcsolása A kezelőpanelen navigáljon a  Beállítások Hálózat/portok Hálózat áttekintése Aktív adapter Standard hálózat  menüpontra. Válassza az  Igen  lehetőséget a nyomtató újraindításához. Wi-Fi hálózat, kikapcsolás Wi-Fi hálózat kikapcsolása"},{"UUID":"2088ebae-181a-4354-a990-a70bdc799d41","title":"Hálózati használat","link":"connecting-printer-to-wireless-network-topic.html","desc":"Nyomtató csatlakozásának ellenőrzése Nyomtató csatlakozásának","descFull":"Nyomtató csatlakozásának ellenőrzése Nyomtató csatlakozásának ellenőrzése A kezelőpanelen navigáljon a  Beállítások Jelentések Hálózat Hálózati beállítások oldala  menüpontra. Ellenőrizze az oldal első szakaszát, és győződjön meg arról, hogy az állapot értéke a csatlakoztatva. Ha az állapot értéke a nincs csatlakoztatva, akkor előfordulhat, hogy a hálózati csatlakozó inaktív, vagy a hálózati kábel hibásan működik. Kérjen segítséget a rendszergazdától. hálózati kapcsolat ellenőrzése nyomtató csatlakoztatása a hálózathoz ellenőrzés"},{"UUID":"794343df-1589-4b4b-a9df-287e0bfa2fe3","title":"Hálózati használat","link":"connecting-printer-to-wireless-network-topic.html","desc":"Soros porton keresztüli nyomtatás beállítása","descFull":"Soros porton keresztüli nyomtatás beállítása (csak Windows rendszeren) Állítsa be a paramétereket a nyomtatón. A kezelőpanelről navigáljon a portbeállításokat tartalmazó menühöz. Keresse meg a soros portbeállítások menüjét, majd szükség esetén módosítsa a beállításokat. Alkalmazza a módosításokat. A számítógépen nyissa meg a Nyomtatók mappát, majd válassza ki a nyomtatót. Nyissa meg a Nyomtató tulajdonságai párbeszédpanelt, majd válassza a COM port lehetőséget a listából. Adja meg a COM port paramétereit az Eszközkezelőben. A soros nyomtatás csökkenti a nyomtatási sebességet. Ügyeljen rá, hogy a soros kábel a nyomtató soros portjához legyen csatlakoztatva. soros nyomtatás beállítása soros nyomtatás beállítás"},{"UUID":"ee78e76e-b04a-4617-a6de-8b6afa46269d","title":"A nyomtató biztonsága","link":"erasing-printer-memory-topic.html","desc":"Nyomtatómemória törlése A nyomtató felejtő","descFull":"Nyomtatómemória törlése A nyomtató felejtő memóriájának vagy pufferelt adatainak törléséhez kapcsolja ki a nyomtatót. A nem felejtő memória, eszköz- és hálózati beállítások, biztonsági beállítások és beépített megoldások törléséhez az alábbiak szerint járjon el: A kezelőpanelről navigáljon a  Beállítások Eszköz Karbantartás Üzemen kívüli törlés . Válassza a  Minden információ tisztítása a nem felejtő memóriáról  lehetőséget, majd válassza a  TÖRLÉS  lehetőséget. Válassza az  Első beállítás varázsló indítása  vagy a  Nyomtató offline üzemmódban marad  lehetőséget, majd válassza a  Tovább  lehetőséget. Indítsa el a folyamatot. Ez a módszer a felhasználói adatok védelmére szolgáló titkosítási kulcsot is megsemmisíti. A titkosítási kulcs megsemmisítése után az adatok nem lesznek helyreállíthatók. felejtő memória törlés nem felejtő memória törlés nyomtatómemória törlés törlés nyomtatómemória törlés felejtő memória törlés nem felejtő memória"},{"UUID":"34643c34-4a13-4166-afef-7722cf6e5465","title":"A nyomtató biztonsága","link":"erasing-printer-storage-drive-topic.html","desc":"Nyomtató tárolómeghajtójának törlése Nyomtató tárolómeghajtójának","descFull":"Nyomtató tárolómeghajtójának törlése Nyomtató tárolómeghajtójának törlése A kezelőpanelről navigáljon a  Beállítások Eszköz Karbantartás Üzemen kívüli törlés . A nyomtatóra szerelt tárolómeghajtótól függően tegye a következők egyikét: A merevlemez esetében válassza a  Minden információ letisztítása a merevlemezről , majd a  TÖRLÉS  lehetőséget, és válassza ki az adatok törlésének módját. Az összes információ merevlemezről való tisztítása néhány perctől akár több mint egy óráig is eltarthat, ezalatt a nyomtató nem vehető igénybe más feladatokra. Az intelligens tárolómeghajtó esetében válassza a  Az ISD-n található összes felhasználói adat kriptográfiai törlése  lehetőséget, majd válassza a  TÖRLÉS  lehetőséget. tárolómeghajtó törlés merevlemez törlés intelligens tárolómeghajtó törlés törlés tárolómeghajtó törlés merevlemez törlés intelligens tárolómeghajtó"},{"UUID":"358c5c66-b78e-476f-ae6c-1f5a905d8fa7","title":"A nyomtató biztonsága","link":"restoring-factory-default-settings-topic.html","desc":"Gyári alapértelmezett értékek visszaállítása A","descFull":"Gyári alapértelmezett értékek visszaállítása A kezelőpanelen navigáljon a  Beállítások Eszköz Gyári alapbeállítások visszaállítása  menüpontra. Válassza a  Beállítások visszaállítása  lehetőséget. Válassza ki a visszaállítani kívánt beállításokat, majd válassza a  VISSZAÁLLÍTÁS  lehetőséget. gyári alapértelmezések visszaállítás nyomtatóbeállítások gyári alapértékek visszaállítása"},{"UUID":"d5e1b905-70dc-423e-a55d-e88bfb2d2cbf","title":"A nyomtató biztonsága","link":"statement-of-volatility-topic.html","desc":"Törölhetőségi nyilatkozat Törölhetőségi nyilatkozat Memóriatípusok","descFull":"Törölhetőségi nyilatkozat Törölhetőségi nyilatkozat Memóriatípusok és leírásuk Memóriatípus Leírás Felejtő memória A nyomtató szabványos közvetlen elérésű memóriát (RAM) használ az ideiglenes felhasználói adatok puffereléséhez az egyszerű nyomtatási és másolási feladatok végrehajtása során. Nem felejtő memória A nyomtató a következő két típusú nem felejtő memóriát használhatja: EEPROM és NAND (flash-memória). Mindkét típus eltárolja az operációs rendszert, nyomtatóbeállításokat és hálózati információkat. A szkenner- és könyvjelző-beállításokat, valamint a beépített megoldásokat is eltárolják. Merevlemezes meghajtós tárolás Egyes nyomtatókban merevlemez is található. A nyomtató-merevlemez nyomtatóspecifikus feladatokhoz van kialakítva. A merevlemez segítségével a nyomtatón összetett nyomtatási feladatok pufferelt felhasználói adatai, űrlapadatok és betűtípusadatok tárolhatók. Intelligens tárolómeghajtó (ISD) Egyes nyomtatók ISD-vel szereltek. Az ISD nem felejtő flash memóriát használ az összetett nyomtatási feladatok, űrlapadatok és betűtípusadatok felhasználói adatainak tárolásához. A következő körülmények esetén törölje a telepített nyomtatómemóriák tartalmát: A nyomtatót szétszerelik. Lecserélik a nyomtató-merevlemezt vagy az ISD-t. A nyomtatót másik részlegbe vagy helyre szállítják. A nyomtatót egy külső szolgáltató javítja. A nyomtatót javítás céljából elszállítják a vállalat telephelyéről. A nyomtatót eladják egy másik szervezetnek. A tárolómeghajtó ártalmatlanításához kövesse szervezete irányelveit és eljárásait. törölhetőségi nyilatkozat felejtő memória Nem felejtő memória merevlemezes meghajtós tárolás intelligens tárolómeghajtó nyomtatómemória törlése nyomtatóadatok biztosítása"},{"UUID":"05bc38b9-f96a-4bf0-9ced-ed3bb4f03112","title":"Nyomtatás","link":"printing-from-computer-topic.html","desc":"Nyomtatás a számítógépről Útmutatás Windows-felhasználók","descFull":"Nyomtatás a számítógépről Útmutatás Windows-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd kattintson a  Tulajdonságok ,  Jellemzők ,  Beállítások  vagy  Beállítás  gombra. Szükség esetén módosítson a beállításokon. Kattintson az  OK , majd a  Nyomtatás  gombra. Macintosh-felhasználók számára Megnyitott dokumentum esetén válassza a  Fájl Nyomtatás  menüpontot. Válasszon ki egy nyomtatót, majd válasszon ki egy beállítást az  Előzetes beállítások  közül. Szükség esetén módosítson a beállításokon. Kattintson a  Nyomtatás  gombra. nyomtatás a számítógépről dokumentumok, nyomtatás a számítógépről"},{"UUID":"04994ef1-de85-45b8-a226-d600fe029554","title":"Nyomtatás mobileszközről","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Nyomtatás mobileszközről a Lexmark Print","descFull":"Nyomtatás mobileszközről a Lexmark Print szolgáltatás használatával A  Lexmark  Print egy mobil nyomtatási megoldás az  Android  platform 6.0-s vagy újabb verzióját futtató mobileszközökhöz. Segítségével dokumentumokat és képeket küldhet hálózati nyomtatókra és nyomtatáskezelő kiszolgálókra. Győződjön meg róla, hogy letöltötte a Lexmark Print alkalmazást a  Google Play  áruházból, és engedélyezze azt a mobileszközön. Győződjön meg róla, hogy a nyomtató és a mobileszköz ugyanahhoz a hálózathoz csatlakozik. A mobileszközén válasszon ki egy dokumentumot a fájlkezelőben. Küldje el vagy ossza meg a dokumentumot a Lexmark Print alkalmazással. Előfordulhat, hogy egyes harmadik féltől származó alkalmazások nem támogatják a küldési vagy megosztási funkciót. További információkért lásd az alkalmazáshoz mellékelt dokumentációt. Itt kiválaszthatja a kívánt nyomtatót. Szükség esetén módosítson a beállításokon. Nyomtassa ki a dokumentumot. Lexmark Nyomtatás használat dokumentumok nyomtatása nyomtatás mobileszközről mobileszköz nyomtatás róla"},{"UUID":"9ff6dbd3-8b07-4925-bbac-cb5aac02a894","title":"Nyomtatás mobileszközről","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Nyomtatás mobil eszközről a Mopria™","descFull":"Nyomtatás mobil eszközről a Mopria™ Print Service használatával A Mopria Print Service egy mobil nyomtatási megoldás az  Android  5.0-s vagy újabb verzióját futtató mobileszközökre. Lehetővé teszi a közvetlen nyomtatást bármelyik, Mopria™ tanúsítványú nyomtatóra. Győződjön meg róla, hogy letöltötte a Mopria nyomtatási szolgáltatást a  Google Play  áruházból, és engedélyezze azt mobileszközén. A mobileszközéről indítson el egy kompatibilis alkalmazást, vagy válasszon ki egy dokumentumot a fájlkezelőből. Koppintson a  Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd szükség esetén állítsa be a beállításokat. Koppintson ide:  . Mopria nyomtatási szolgáltatás nyomtatás nyomtatás mobileszközről mobileszköz nyomtatás róla nyomtatás Mopria nyomtatási szolgáltatás használata"},{"UUID":"c7bb36ab-f140-499c-a60a-6daa3939a527","title":"Nyomtatás mobileszközről","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Fényképnyomtatás mobileszközről az AirPrint segítségével","descFull":"Fényképnyomtatás mobileszközről az AirPrint segítségével Az AirPrint szoftverfunkció egy olyan mobil nyomtatási megoldás, amely lehetővé teszi, hogy az Apple-eszközökről közvetlenül AirPrint tanúsítványú nyomtatóra nyomtasson. Győződjön meg róla, hogy az Apple eszköz és a nyomtató ugyanahhoz a hálózathoz csatlakozik. Ha a hálózat több vezeték nélküli hubbal rendelkezik, akkor győződjön meg róla, hogy mindkét eszköz ugyanahhoz az alhálózathoz csatlakozik. Ezt azt alkalmazást csak bizonyos Apple eszközök támogatják. A mobilkészülékről válasszon ki egy dokumentumot a fájlkezelőben, vagy indítson el egy kompatibilis alkalmazást. Koppintson a  Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd szükség esetén állítsa be a beállításokat. Nyomtassa ki a dokumentumot. AirPrint használata nyomtatás nyomtatás mobileszközről mobileszköz nyomtatás róla"},{"UUID":"8864babc-9ea1-4fde-8ea3-4d33435eefd1","title":"Nyomtatás mobileszközről","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Nyomtatás mobileszközről a Wi‑Fi Direct®","descFull":"Nyomtatás mobileszközről a Wi‑Fi Direct® szolgáltatás használatával Wi‑Fi Direct  egy nyomtatási szolgáltatás, amely lehetővé teszi, hogy bármilyen Wi-Fi Direct szolgáltatást támogató nyomtatóval nyomtathasson. Bizonyosodjon meg arról, hogy a mobileszköz csatlakozik a nyomtató vezeték nélküli hálózatához. További információkért lásd:  . Indítson el egy kompatibilis alkalmazást a mobileszközön, vagy válasszon ki egy dokumentumot a fájlkezelőben. Tegye a következők egyikét a mobileszköztől függően: Koppintson a  Nyomtatás  gombra. Koppintson a  Nyomtatás  gombra. Koppintson a  Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd szükség esetén állítsa be a beállításokat. Nyomtassa ki a dokumentumot. Wi‑Fi Direct nyomtatás mobileszközről nyomtatás mobileszközről mobileszköz nyomtatás innen nyomtatás Wi‑Fi Direct használata"},{"UUID":"e4fbad18-3170-4125-b45e-5fbf56bcd1f5","title":"Nyomtatás","link":"printing-from-flash-drive-topic.html","desc":"Nyomtatás flash-meghajtóról Helyezze be a","descFull":"Nyomtatás flash-meghajtóról Helyezze be a flash-meghajtót. A támogatott flash-meghajtókról további információkat itt talál:  . Ha a flash-meghajtót olyankor helyezi be, amikor a kijelzőn hibaüzenet látható, a nyomtató figyelmen kívül hagyja a flash-meghajtót. Ha a flash-meghajtót olyankor helyezi be, amikor a nyomtató más nyomtatási feladatokat dolgoz fel, a kijelzőn a  Foglalt  üzenet jelenik meg. A kezelőpanelen válassza a  Nyomtatás  lehetőséget. Válassza ki az  USB-meghajtót , majd válassza ki a nyomtatni kívánt dokumentumot. Ha szükséges, konfigurálja a beállításokat. Nyomtassa ki a dokumentumot. Az adatvesztés és a nyomtatóhibák elkerülése érdekében memóriaeszközről való nyomtatás, olvasás vagy írás közben ne érjen hozzá a flash-meghajtóhoz vagy a nyomtatóhoz az ábrán jelzett részen. nyomtatás flash-meghajtóról pendrive, nyomtatás"},{"UUID":"83d84a1d-d3bd-4c7b-8fe9-0990c574beff","title":"Nyomtatás","link":"configuring-confidential-jobs-topic.html","desc":"Titkosított feladatok konfigurálása A kezelőpanelen","descFull":"Titkosított feladatok konfigurálása A kezelőpanelen navigáljon a  Beállítások Biztonság Titkosított nyomtatás beállítása  menüponthoz. Konfigurálja a beállításokat. A  Titkosított nyomtatás beállításai  menü elemei és leírásuk Beállítás Leírás Érvényt. PIN max. Állítsa be az érvénytelen PIN-kód megadására vonatkozó korlátot. A limit elérésekor az adott felhasználónévhez tartozó nyomtatási feladatok törlődnek. Titkosított feladatok lejárata Állítson be lejárati időt minden felfüggesztett feladathoz, mielőtt az automatikusan törlődne a nyomtatómemóriából, a merevlemezről vagy az intelligens tárolómeghajtóból. A felfüggesztett feladat típusa lehet  Titkosított ,  Ismétlés ,  Tartalék  vagy  Ellenőrzés . Feladatismétlés lejárata Ismételni kívánt nyomtatási feladatok lejárati idejének beállítása. Feladatellenőrzés lejárata Lejárati idő beállítása a feladat egyetlen példányban történő nyomtatásához annak érdekében, hogy ellenőrizni lehessen a minőséget a fennmaradó példányok nyomtatása előtt. Feladatmegőrzés lejárata Lejárati idő beállítása azokhoz a feladatokhoz, amelyeket a nyomtatóban későbbi nyomtatáshoz tárolni szeretne. Minden feladat várakozzon Ezzel a funkcióval beállíthatja, hogy a nyomtató várakoztassa a nyomtatási feladatokat. Másolat megőrzése a dokumentumokról Beállítja, hogy a nyomtató az összes azonos fájlnevű dokumentumot megőrizze. titkosított nyomtatási feladatok konfigurálás függő feladatok konfigurálás nyomtatási feladatok eltárolása nyomtatási feladatok várakozása"},{"UUID":"fdd92ba1-7a01-4a05-993b-f0b86f7ae667","title":"Nyomtatás","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Bizalmas és más típusú függő","descFull":"Bizalmas és más típusú függő feladatok nyomtatása Útmutatás Windows-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd kattintson a  Tulajdonságok ,  Jellemzők ,  Beállítások  vagy  Beállítás  gombra. Kattintson a  Nyomtatás és felfüggesztés  gombra. Kattintson a  Nyomtatás és felfüggesztés használata  gombra, majd rendeljen hozzá felhasználónevet. Válasszon a következő nyomtatási feladattípusok közül: Titkosított nyomtatás  – A nyomtató személyes azonosítószámot kér, mielőtt a nyomtatásra engedélyezné a feladatot. Ha ezt a feladattípust választja, akkor adjon meg egy négyjegyű személyi azonosító számot (PIN). Nyomtatás ellenőrzése  – A nyomtató kinyomtat egy példányt, és a nyomtató memóriájában tartja a többi példányt, amelyet az illesztőprogramtól kért. Nyomtatás háttértárba mentése  – A nyomtató a munkát a memóriában tárolja, hogy később is kinyomtathassa. Nyomtatás megismétlése  – A nyomtató kinyomtatja a feladat összes kért példányát, és a feladatot a memóriában tárolja, hogy később további példányokat nyomtathasson. Kattintson az  OK  gombra. Kattintson a  Nyomtatás  gombra. A nyomtató kezelőpaneljén indítsa el a nyomtatási feladatot. Válassza a  Nyomtatás  lehetőséget. Válassza ki a  Felfüggesztett feladatok  lehetőséget, majd válassza ki a felhasználónevét. Titkosított nyomtatási feladatok esetén válassza a  Titkosított  lehetőséget, adja meg a PIN-kódot, majd válassza az  OK  lehetőséget. Jelölje ki a nyomtatási feladatot, majd válassza a  Nyomtatás  lehetőséget. Macintosh-felhasználók számára Megnyitott dokumentum esetén válassza a  Fájl Nyomtatás  menüpontot. Itt kiválaszthatja a kívánt nyomtatót. A  Nyomtatási feladat biztonsága  legördülő menüben engedélyezze a  Nyomtatás PIN-kóddal  lehetőséget, majd adjon meg egy négyjegyű PIN-kódot. Kattintson a  Nyomtatás  gombra. A nyomtató kezelőpaneljén indítsa el a nyomtatási feladatot. Válassza ki a  Felfüggesztett feladatok  lehetőséget, majd válassza ki a számítógép nevét. Válassza a  Titkosított  lehetőséget, majd adja meg a PIN-kódot. Jelölje ki a nyomtatási feladatot, majd válassza a  Nyomtatás  lehetőséget. nyomtatás függő feladatok nyomtatás titkosított nyomtatási feladatok titkosított nyomtatási feladatok nyomtatás függő feladatok nyomtatás"},{"UUID":"98e3a0cb-e571-4163-8e8b-41d94c31a1c0","title":"Nyomtatás","link":"printing-font-sample-list-topic.html","desc":"Betűtípusminták listájának nyomtatása A kezelőpanelről","descFull":"Betűtípusminták listájának nyomtatása A kezelőpanelről navigáljon a  Beállítások  Jelentések Nyomtatás Nyomtatási betűtípusok  menüpontba. Válassza ki a betűtípust. nyomtatás betűtípusminták listája betűtípusminták listája nyomtatás"},{"UUID":"96ef9e5d-cc6e-43e4-b54c-a8407a7234bd","title":"Nyomtatás","link":"printing-directory-list-topic.html","desc":"Könyvtárlista nyomtatása A kezelőpanelen navigáljon","descFull":"Könyvtárlista nyomtatása A kezelőpanelen navigáljon a  Beállítások Jelentések Nyomtatás  menüpontra. Válassza a  Nyomtatási könyvtár  lehetőséget. nyomtatás könyvtárlista könyvtárlista nyomtatás"},{"UUID":"db3e99a5-bde9-484c-a752-c7443808fd61","title":"Nyomtatás","link":"placing-separator-sheets-in-print-jobs-topic.html","desc":"Elválasztó lapok elhelyezése nyomtatási feladatokban","descFull":"Elválasztó lapok elhelyezése nyomtatási feladatokban Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd kattintson a  Tulajdonságok ,  Jellemzők ,  Beállítások  vagy  Beállítás  gombra. Kattintson a  Papír/utófeldolgozás  elemre. Az  Elválasztólapok  menüben válasszon ki egy beállítást. Kattintson az  OK , majd a  Nyomtatás  gombra. elválasztólapok elhelyezés elválasztólapok elhelyezése"},{"UUID":"14d611fe-b991-4553-87da-84beed493bae","title":"Nyomtatás","link":"canceling-print-job-topic.html","desc":"Nyomtatási feladat törlése A kezelőpanelen","descFull":"Nyomtatási feladat törlése A kezelőpanelen válassza a  Feladatsor  lehetőséget. Válassza a  Nyomtatás  lehetőséget, majd válasszon ki egy törlendő feladatot. Ha a dokumentum nyomtatása már folyamatban van, akkor a nyomtatás leállításához válassza a kijelző jobb alsó sarkában a  Feladat törlése  lehetőséget. nyomtatási feladat leállítás nyomtatási feladat törlése"},{"UUID":"131819c2-895f-4832-bff5-51814317c57a","title":"Nyomtatás","link":"adjusting-toner-darkness-topic.html","desc":"A festékmennyiség beállítása A kezelőpanelen","descFull":"A festékmennyiség beállítása A kezelőpanelen navigáljon a  Beállítások Nyomtatás Minőség  menüponthoz. Állítsa be a  Festékmennyiség  beállítást. festék sötétsége beállítás a festékmennyiség beállítása"},{"UUID":"a462bd9a-1f2c-4a9e-a30f-cd2812105c07","title":"Másolás","link":"making-copies-topic.html","desc":"Másolatok készítése Tegye az eredeti","descFull":"Másolatok készítése Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kép levágásának elkerülése érdekében győződjön meg arról, hogy az eredeti dokumentum és a kimeneti papír mérete megegyezik. A kezelőpanelen válassza ki a  Másolás  elemet, majd adja meg a példányszámot. Szükség szerint állítsa be a másolási beállításokat. Indítsa el a másolási műveletet. másolatok készítése másolás dokumentumok másolás automatikus lapadagoló használata másolás a lapolvasó üveglapjának használata"},{"UUID":"aad3df5f-784d-41c1-8a2c-6ea7b28b5dfa","title":"Másolás","link":"copying-photos-topic.html","desc":"Fényképek másolása Fényképek másolása Helyezzen","descFull":"Fényképek másolása Fényképek másolása Helyezzen egy fényképet a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Másolás További beállítások Tartalom Tartalom típusa Fénykép  menüpontra. Válassza ki a  Tartalom forrása  lehetőséget, majd válassza ki az eredeti fényképnek leginkább megfelelő beállítást. Másolja át a fényképet. másolás fénykép fényképek, másolása"},{"UUID":"9ecd688f-384b-49fb-aeec-e731db7f8918","title":"Másolás","link":"copying-on-letterhead-topic.html","desc":"Másolás fejléces papírra Másolás fejléces","descFull":"Másolás fejléces papírra Másolás fejléces papírra Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Másolás Másolás innen . Válassza ki az eredeti dokumentum méretét. Válassza a  Másolás ide  elemet, majd válassza ki a papírforrást, amely a fejléces papírt tartalmazza. Ha a fejléces papírt többcélú adagolóba töltötte be, válassza a  Többcélú adagoló  lehetőséget, válasszon papírméretet, majd válassza a  Fejléces papír  lehetőséget. Indítsa el a másolási műveletet. másolás fejléces papírra fejléces papír másolás"},{"UUID":"2a3cf6eb-8c4d-41a3-9b21-fc715bd8d59a","title":"Másolás","link":"copying-on-both-sides-of-paper-topic.html","desc":"Másolás a papír mindkét oldalára","descFull":"Másolás a papír mindkét oldalára Másolás a papír mindkét oldalára Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Másolás További beállítások Oldalak  menüpontra. Válasszon egy beállítást. Indítsa el a másolási műveletet. másolás mindkét oldal, papír kétoldalas másolás kétoldalas másolás"},{"UUID":"30dd1ec4-4454-4ab5-adea-ec8aa152e362","title":"Másolás","link":"reducing-or-enlarging-copies-topic.html","desc":"A másolatok kicsinyítése és nagyítása","descFull":"A másolatok kicsinyítése és nagyítása A másolatok kicsinyítése és nagyítása Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Másolás További beállítások Méretezés  menüpontra. Válasszon egy beállítást. Az eredeti vagy a kimeneti dokumentum méretének a  Méretezés  beállítása utáni változtatásakor a méretezés visszaáll  Automatikus  értékre. Indítsa el a másolási műveletet. példány méretének csökkentése példány méretének növelése másolási méret beállítás"},{"UUID":"87494a00-dd57-4e2d-90ca-2a60c4c1fecd","title":"Másolás","link":"collating-copies-topic.html","desc":"Példányok leválogatása Példányok leválogatása Tegye","descFull":"Példányok leválogatása Példányok leválogatása Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Másolás További beállítások Leválogatás Be [1,2,1,2,1,2]  menüpontra. Indítsa el a másolási műveletet. példányok leválogatása több példány rendezése"},{"UUID":"d262a921-d8ef-41ae-ba67-3e20dd835cee","title":"Másolás","link":"placing-separator-sheets-between-copies-topic.html","desc":"Elválasztólapok másolatok közé helyezése Elválasztólapok","descFull":"Elválasztólapok másolatok közé helyezése Elválasztólapok másolatok közé helyezése Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Másolás További beállítások Elválasztólapok menüpontra. Kapcsolja be a menüt, majd válasszon ki egy beállítást. Indítsa el a másolási műveletet. elválasztólapok hozzáadás elválasztólapok elhelyezése"},{"UUID":"c06e76b6-edac-4c13-b25b-9eae21991260","title":"Másolás","link":"copying-multiple-pages-onto-single-sheet-topic.html","desc":"Több oldal másolása egyetlen lapra","descFull":"Több oldal másolása egyetlen lapra Több oldal másolása egyetlen lapra Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Másolás További beállítások Oldal/lap  menüpontra. Kapcsolja be a menüt, majd válasszon ki egy beállítást. Indítsa el a másolási műveletet. több oldal másolása egyetlen lapra papírtakarékosság"},{"UUID":"019c4d27-9dad-4ab2-9ce8-43d3c54142f6","title":"Másolás","link":"copying-cards-topic.html","desc":"Kártyák másolása Kártyák másolása Helyezzen","descFull":"Kártyák másolása Kártyák másolása Helyezzen egy kártyát a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Másolás Másolás innen Igazolvány  menüpontra. Másolja le a kártyát. másolás kártyák kártyák, másolás"},{"UUID":"0a20ba17-6a70-4a30-a10c-e60f2bbc893f","title":"Másolás","link":"creating-copy-shortcut-topic.html","desc":"Másolási parancsikon létrehozása Másolási parancsikon","descFull":"Másolási parancsikon létrehozása Másolási parancsikon létrehozása A kezelőpanelen válassza a  Másolás  lehetőséget. Adja meg a beállításokat, majd válassza a   lehetőséget. Hozzon létre egy parancsikont. parancsikon létrehozása másolás parancsikon hozzáadása másolás"},{"UUID":"f738811f-51e8-4cc3-9099-4bea1cf01684","title":"E-mail","link":"configuring-smtp-settings-topic.html","desc":"A SMTP-beállítások konfigurálása A SMTP-beállítások","descFull":"A SMTP-beállítások konfigurálása A SMTP-beállítások konfigurálása Konfigurálja a Simple Mail Transfer Protocol (SMTP) beállításokat, hogy beolvasott dokumentumot küldhessen e-mailben. A beállítások az e-mail-szolgáltatótól függően változhatnak. Mielőtt elkezdené, győződjön meg arról, hogy a nyomtató csatlakozik a hálózathoz, és a hálózat az internethez kapcsolódik. A kezelőpanel használata A kezelőpanelen navigáljon a  Beállítások E-mail E-mail beállítása  menüpontra. Konfigurálja a beállításokat.  Az Embedded Web Server használata Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Beállítások E-mail  lehetőségre. Az  E-mail beállítása  menüben konfigurálja a beállításokat.  Kattintson a  Mentés  gombra. E‑mail-szolgáltatók AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live vagy Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail Ha a megadott beállítások használatával hibákat tapasztal, akkor forduljon a szolgáltatójához. Ha az Ön szolgáltatója nem szerepel a listán, akkor lépjen kapcsolatba a szolgáltatójával. AOL Mail Beállítások az AOL Mail szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.aol.com Elsődleges SMTP-átjáró port 587 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Alkalmazás jelszava  Az alkalmazás jelszavának létrehozásához menjen az  AOL Account Security  (AOL Fiókbiztonság) oldalra, jelentkezzen be a fiókjába, majd kattintson a  Generate and manage app password  (Alkalmazásjelszó létrehozása és kezelése) lehetőségre. Comcast Mail Beállítások a Comcast Mail szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.comcast.net Elsődleges SMTP-átjáró port 587 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Fiók jelszava Győződjön meg arról, hogy a harmadik fél biztonsági beállításai engedélyezve vannak fiókjában. A további információkért látogasson el a  Comcast Xfinity Connect  súgóoldalára. Gmail Győződjön meg arról, hogy a kétlépcsős azonosítás engedélyezve van a fiókjában. A kétlépcsős azonosítás bekapcsolásához menjen a  Google-fiók Biztonság  oldalra, jelentkezzen be a fiókjába, majd a  Bejelentkezés a Google-ba  szakaszban kattintson a  Kétlépcsős azonosítás  opcióra. SMTP-beállítások a Gmail szolgáltatáshoz Beállítás Érték Elsődleges SMTP-átjáró smtp.gmail.com Elsődleges SMTP-átjáró port 587 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Alkalmazás jelszava Alkalmazásjelszó létrehozásához menjen a  Google-fiók Biztonság  oldalra, jelentkezzen be a fiókjába, majd a  Bejelentkezés a Google-ba  szakaszban kattintson a  Kétlépcsős azonosítás Alkalmazásjelszavak  opcióra. Az „ Alkalmazásjelszó ” csak akkor jelenik meg, ha a kétlépcsős azonosítás engedélyezve van. iCloud Mail Győződjön meg arról, hogy a kétlépcsős azonosítás engedélyezve van a fiókjában. Beállítások az iCloud Mail szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.mail.me.com Elsődleges SMTP-átjáró port 587 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Alkalmazás jelszava Alkalmazásjelszó létrehozásához lépjen az  iCloud-fiókkezelő  oldalra, jelentkezzen be fiókjába, majd a  Bejelentkezés és biztonság  szakaszban kattintson az  Alkalmazásspecifikus jelszavak Alkalmazásspecifikus jelszó létrehozása  menüpontra. Mail.com Beállítások a Mail.com szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.mail.com Elsődleges SMTP-átjáró port 587 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Fiók jelszava NetEase Mail (mail.126.com) Győződjön meg arról, hogy az SMTP-szolgáltatás engedélyezve van a fiókjában. A szolgáltatás engedélyezéséhez a NetEase Mail kezdőlapján kattintson a  Settings (Beállítások) POP3/SMTP/IMAP  elemre, majd engedélyezze az  IMAP/SMTP szolgáltatást  vagy a  POP3/SMTP szolgáltatást . Beállítások a NetEase Mail (mail.126.com) szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.126.com Elsődleges SMTP-átjáró port 465 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Hitelesítő jelszó Akkor kapja meg a hitelesítő jelszót, ha az  IMAP/SMTP szolgáltatás  vagy  POP3/SMTP szolgáltatás  engedélyezve van. NetEase Mail (mail.163.com) Győződjön meg arról, hogy az SMTP-szolgáltatás engedélyezve van a fiókjában. A szolgáltatás engedélyezéséhez a NetEase Mail kezdőlapján kattintson a  Settings (Beállítások) POP3/SMTP/IMAP  elemre, majd engedélyezze az  IMAP/SMTP szolgáltatást  vagy a  POP3/SMTP szolgáltatást . Beállítások a NetEase Mail (mail.163.com) szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.163.com Elsődleges SMTP-átjáró port 465 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Hitelesítő jelszó Akkor kapja meg a hitelesítő jelszót, ha az  IMAP/SMTP szolgáltatás  vagy  POP3/SMTP szolgáltatás  engedélyezve van. NetEase Mail (mail.yeah.net) Győződjön meg arról, hogy az SMTP-szolgáltatás engedélyezve van a fiókjában. A szolgáltatás engedélyezéséhez a NetEase Mail kezdőlapján kattintson a  Settings (Beállítások) POP3/SMTP/IMAP  elemre, majd engedélyezze az  IMAP/SMTP szolgáltatást  vagy a  POP3/SMTP szolgáltatást . Beállítások a NetEase Mail (mail.yeah.net) szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.yeah.net Elsődleges SMTP-átjáró port 465 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Hitelesítő jelszó Akkor kapja meg a hitelesítő jelszót, ha az  IMAP/SMTP szolgáltatás  vagy  POP3/SMTP szolgáltatás  engedélyezve van. Outlook Live vagy Microsoft 365 Ezek a beállítások érvényesek az outlook.com és a hotmail.com e-mail-tartományokra, valamint a Microsoft 365 fiókokra. Beállítások az Outlook Live vagy a Microsoft 365 szolgáltatáshoz Beállítás Érték Elsődleges SMTP-átjáró smtp.office365.com Elsődleges SMTP-átjáró port 587 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Fiók jelszava vagy az alkalmazás jelszava Azoknál a fiókoknál, amelyeknél a kétlépcsős azonosítás ki van kapcsolva, használja a fiók jelszavát. Azoknál az outlook.com vagy hotmail.com fiókoknál, amelyeknél a kétlépcsős azonosítás be van kapcsolva, használja az alkalmazás jelszavát. Az alkalmazásjelszó létrehozásához lépjen az  Outlook Live fiókkezelési  oldalára, jelentkezzen be fiókjába, majd kattintson az  Új alkalmazásjelszó létrehozása  gombra. A Microsoft 365-öt használó vállalkozások számára további beállítási lehetőségekért látogasson el a  Microsoft 365 súgóoldalára . QQ Mail Győződjön meg arról, hogy az SMTP-szolgáltatás engedélyezve van a fiókjában. A szolgáltatás engedélyezéséhez menjen a QQ Mail kezdőoldalára, és kattintson a  Settings (Beállítások) Account (Fiók)  opcióra. A  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service  szakaszban engedélyezze a  POP3/SMTP  szolgáltatást vagy az  IMAP/SMTP  szolgáltatást. Beállítások a QQ Mail szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.qq.com Elsődleges SMTP-átjáró port 587 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Engedélyezési kód Engedélyezési kód generálásához a QQ Mail kezdőoldalán kattintson a  Settings (Beállítások) Account (Fiók)  opcióra, majd a  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service  szakaszban kattintson a  Generate authorization code (Engedélyezési kód generálása)  opcióra. Sina Mail Győződjön meg arról, hogy az POP3/SMTP-szolgáltatás engedélyezve van a fiókjában. A szolgáltatás engedélyezéséhez a Sina Mail kezdőlapján kattintson a  Settings (Beállítások) More settings (További beállítások) User‑end POP/IMAP/SMTP (Felhasználóoldali POP/IMAP/SMTP)  opcióra, majd engedélyezze a  POP3/SMTP szolgáltatást . Beállítások a Sina Mail szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.sina.com Elsődleges SMTP-átjáró port 587 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Engedélyezési kód Engedélyezési kód létrehozásához az e-mail kezdőlapján kattintson a  Settings (Beállítások) More settings (További beállítások) User‑end POP/IMAP/SMTP (Felhasználóoldali POP/IMAP/SMTP)  opcióra, majd engedélyezze a következőt:  Authorization code status  (Engedélyezési kód státusza). Sohu Mail Győződjön meg arról, hogy az SMTP-szolgáltatás engedélyezve van a fiókjában. A szolgáltatás engedélyezéséhez a Sohu Mail kezdőlapján kattintson az  Options (Opciók) Settings (Beállítások) POP3/SMTP/IMAP  opcióra, majd engedélyezze az  IMAP/SMTP szolgáltatást  vagy a  POP3/SMTP szolgáltatást . Beállítások a Sohu Mail szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.sohu.com Elsődleges SMTP-átjáró port 465 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Független jelszó Akkor kap független jelszót, amikor engedélyezi az  IMAP/SMTP  szolgáltatást vagy a  POP3/SMTP  szolgáltatást. Yahoo! Mail Beállítások a Yahoo! szolgáltatóhoz Mail Beállítás Érték Elsődleges SMTP-átjáró smtp.mail.yahoo.com Elsődleges SMTP-átjáró port 587 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Alkalmazás jelszava  Alkalmazásjelszó létrehozásához menjen a  Yahoo Account Security  (Yahoo-fiókbiztonság) oldalra, jelentkezzen be a fiókjába, majd az  App password  (Alkalmazásjelszó) szakaszban kattintson a  Generate app password  (Alkalmazásjelszó létrehozása) opcióra. Zoho Mail Beállítások a Zoho Mail szolgáltatóhoz Beállítás Érték Elsődleges SMTP-átjáró smtp.zoho.com Elsődleges SMTP-átjáró port 587 SSL/TLS használata Kötelező Megbízható tanúsítvány szükséges Letiltva Válaszcím Az Ön e-mail-címe SMTP-kiszolgáló hitelesítése Bejelentkezés/normál Eszköz által kezdeményezett e-mail Az eszköz SMTP-belépési adatainak használata Eszköz felhasználói azonosítója Az Ön e-mail-címe Eszköz jelszava Fiók jelszava vagy az alkalmazás jelszava Azoknál a fiókoknál, amelyeknél a kétlépcsős azonosítás ki van kapcsolva, használja a fiók jelszavát. Azoknál a fiókoknál, amelyeknél a kétlépcsős azonosítás be van kapcsolva, használja az alkalmazás jelszavát. Alkalmazásjelszó létrehozásához menjen a Zoho Mail  Account Security  (Fiókbiztonság) oldalára, jelentkezzen be a fiókjába, majd az  Application‑Specific Passwords  (Alkalmazásspecifikus jelszavak) szakaszban kattintson a  Generate New Password  (Új jelszó létrehozása) opcióra. e-mail-szolgáltatók konfigurálás e-mail-kiszolgáló beállításai SMTP beállítások konfigurálás e-mail-funkció beállítás e-mail-kiszolgáló beállításai konfigurálás"},{"UUID":"83a14f56-98f9-49c9-9e57-6a7570a90f2a","title":"E-mail","link":"sending-email-topic.html","desc":"E-mail küldése Mielőtt elkezdené a","descFull":"E-mail küldése Mielőtt elkezdené a műveletet, győződjön meg róla, hogy az SMTP-beállítások konfigurálva vannak-e. További információkért lásd:  . Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Beolvasás E-mail  menüpontra. Adja meg a szükséges információkat, majd válassza a  Tovább  gombot. Ha szükséges, konfigurálja a beállításokat. Válassza a  Beolvasás  lehetőséget, majd küldje el az e-mailt. e-mail küldés e-mail küldése"},{"UUID":"ef86ae09-c4f9-469a-bcd6-20fe9907f5ed","title":"E-mail","link":"creating-email-shortcut-topic.html","desc":"E-mail parancsikon létrehozása A kezelőpanel","descFull":"E-mail parancsikon létrehozása A kezelőpanel használata A kezelőpanelen navigáljon a  Beolvasás E-mail  menüpontra. Adja meg a szükséges információkat, majd válassza a   lehetőséget. Hozzon létre egy parancsikont. Az Embedded Web Server használata Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Parancsikonok Parancsikon hozzáadása  gombra. Konfigurálja a beállításokat. Kattintson a  Mentés  gombra. parancsikon létrehozása e-mail parancsikon hozzáadása e-mail e-mail gyorsbillentyű létrehozás"},{"UUID":"d4e20cd6-3ceb-4ab5-a541-f023111a9831","title":"Fax","link":"sending-fax-topic.html","desc":"Faxküldés Faxküldés A kezelőpanel használata","descFull":"Faxküldés Faxküldés A kezelőpanel használata Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen válassza a  Fax  menüpontot. Válassza a  Címzett hozzáadása  vagy a  Címjegyzék  lehetőséget. Szükség esetén módosítson a beállításokon. Küldje el a faxot. Számítógép segítségével Mielőtt elkezdené a műveleteket, ellenőrizze, hogy a fax illesztőprogramja telepítve van-e. További információkért lásd:  . Útmutatás Windows-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd kattintson a  Tulajdonságok ,  Jellemzők ,  Beállítások  vagy  Beállítás  gombra. Kattintson a következőkre:  Fax Fax engedélyezése Mindig mutassa a beállításokat a fax elküldése előtt , majd adja meg a címzett faxszámát. Ha szükséges, konfigurálja a beállításokat. Küldje el a faxot. Macintosh-felhasználók számára Megnyitott dokumentum esetén válassza a  Fájl Nyomtatás  menüpontot. Válassza ki azt a nyomtatót, amelynek a neve után a  ‑ Fax  szöveg szerepel. A Címzett mezőbe írja be a címzett számát. Ha szükséges, konfigurálja a beállításokat. Küldje el a faxot. faxküldés fax, küldés"},{"UUID":"cb6b1193-2fdc-4191-8e51-672d4e782197","title":"Fax","link":"scheduling-fax-topic.html","desc":"Fax ütemezése Fax ütemezése Tegye","descFull":"Fax ütemezése Fax ütemezése Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen válassza a  Fax  menüpontot. Válassza a  Címzett hozzáadása  vagy a  Címjegyzék  lehetőséget, majd adja meg a szükséges adatokat. Válassza a  Küldés ideje  lehetőséget, állítsa be a dátumot és az időt, majd válassza a  Kész  lehetőséget. Ha szükséges, konfigurálja a fax egyéb beállításait. Küldje el a faxot. fax ütemezése fax, ütemezés"},{"UUID":"0b05a11b-0df5-4787-9581-ab8dfee7ac6a","title":"Fax","link":"creating-fax-destination-shortcut-topic.html","desc":"Faxelérési célhely parancsikon létrehozása Faxelérési","descFull":"Faxelérési célhely parancsikon létrehozása Faxelérési célhely parancsikon létrehozása A kezelőpanelen válassza a  Fax  menüpontot. Válassza a  Címzett hozzáadása  vagy a  Címjegyzék  lehetőséget, majd adja meg a szükséges adatokat. Szükség esetén módosítson a beállításokon. Válassza ki a   elemet. Hozzon létre egy parancsikont. parancsikon létrehozása fax címzettje fax címzettje parancsikon létrehozása parancsikon hozzáadása fax címzettje parancsikon, létrehozás fax címzettje"},{"UUID":"a1f5ebb1-3303-4047-a728-03d952e072c7","title":"Fax","link":"changing-fax-resolution-topic.html","desc":"A fax felbontásának módosítása A","descFull":"A fax felbontásának módosítása A fax felbontásának módosítása Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen válassza a  Fax  menüpontot. Válassza a  Címzett hozzáadása  vagy a  Címjegyzék  lehetőséget, majd adja meg a szükséges adatokat. Válassza a  Felbontás  lehetőséget, majd válasszon ki egy beállítást. Küldje el a faxot. faxfelbontás módosítás fax felbontásának módosítása"},{"UUID":"6aa9c195-56f6-4096-ac53-5c0bb3d1407f","title":"Fax","link":"adjusting-fax-darkness-topic.html","desc":"Fax sötétségének módosítása Fax sötétségének","descFull":"Fax sötétségének módosítása Fax sötétségének módosítása Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen válassza a  Fax  menüpontot. Válassza a  Címzett hozzáadása  vagy a  Címjegyzék  lehetőséget, majd adja meg a szükséges adatokat. Válassza a  További beállítások Sötétség  lehetőséget, majd állítsa be a beállítást. Küldje el a faxot. fax sötétségének módosítása fax sötétsége beállítás"},{"UUID":"c826d7b7-ee2a-4faf-aafc-21d184969a49","title":"Fax","link":"printing-fax-log-topic.html","desc":"Faxnapló nyomtatása Faxnapló nyomtatása A","descFull":"Faxnapló nyomtatása Faxnapló nyomtatása A kezelőpanelen navigáljon a  Beállítások Jelentések Fax  menüponthoz. Válasszon ki egy faxnaplót. faxnapló nyomtatás fax napló nyomtatása"},{"UUID":"edd37f62-6184-404c-b883-2c91b203ac0a","title":"Fax","link":"blocking-junk-faxes-topic.html","desc":"Kéretlen faxok blokkolása A kezelőpanelen","descFull":"Kéretlen faxok blokkolása A kezelőpanelen navigáljon a  Beállítások Fax Faxbeállítás Faxfogadási beállítások Rendszergazdai beállítások  menüpontra. Engedélyezze a  Név nélküli faxok blokkolása  menüpontot. kéretlen faxok blokkolás kéretlen faxok blokkolása"},{"UUID":"1346cf5e-6379-4551-a381-e4730d986006","title":"Fax","link":"holding-faxes-topic.html","desc":"Faxok felfüggesztése Faxok felfüggesztése A","descFull":"Faxok felfüggesztése Faxok felfüggesztése A kezelőpanelről navigáljon a  Beállítások Fax Faxbeállítás Faxfogadási beállítások Faxok felfüggesztése  menüpontra. Válasszon egy beállítást. faxok tartása fogadott faxok tartása fax tartása"},{"UUID":"37d065c9-1772-45cd-9efe-7fcf00012240","title":"Fax","link":"forwarding-fax-topic.html","desc":"Fax továbbítása Fax továbbítása A","descFull":"Fax továbbítása Fax továbbítása A kezelőpanelen navigáljon a  Beállítások Fax Faxbeállítás Faxfogadási beállítások Rendszergazdai beállítások  menüpontra. Válassza a  Fax továbbítása , majd a  Nyomtatás és továbbítás  vagy a  Továbbítás  lehetőséget. A  Továbbítás ide  menüben válasszon ki egy célállomást, majd konfigurálja a beállításokat. faxtovábbítás fax továbbítás"},{"UUID":"32e8eef5-06e6-4709-bbba-510b2c20642c","title":"Beolvasás","link":"scanning-to-computer-topic.html","desc":"Beolvasás számítógépre Mielőtt elkezdené a","descFull":"Beolvasás számítógépre Mielőtt elkezdené a műveletet, győződjön meg róla, hogy a számítógép és a nyomtató ugyanahhoz a hálózathoz csatlakozik. Útmutatás Windows-felhasználók számára A Lexmark ScanBack Utility segédprogram használata A számítógépen futtassa a  Lexmark ScanBack Utility  programot, majd kattintson a  Profil létrehozása  gombra. A segédprogram letöltéséhez látogasson el ide:  www.lexmark.com/downloads . Ha egy meglévő beolvasási profilt szeretne használni, kattintson a  Meglévő profil  gombra. Kattintson a  Beállítás  gombra, majd adja meg a nyomtató IP-címét. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Kattintson az  OK  gombra, majd a  Bezárás  gombra. Válassza ki a beolvasandó dokumentum formátumát és méretét. Válasszon ki egy fájlformátumot és egy beolvasási felbontást, majd kattintson a  Tovább  gombra. Írjon be egy egyedi beolvasási profilnevet. Keresse meg azt a helyet, ahová a beolvasott dokumentumot menteni kívánja, majd hozzon létre egy fájlnevet. A beolvasási profil újbóli használatához engedélyezze a  Parancsikon létrehozása  lehetőséget, majd adja meg a parancsikon egyedi nevét. Kattintson a  Befejezés  gombra. Tegyen egy eredeti dokumentumot az automatikus lapadagolóba, vagy a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Beolvasási profilok Beolvasás számítógépre  menüpontra, majd válasszon ki egy beolvasási profilt. Kattintson a számítógépen a  Beolvasás kész  gombra. Útmutatás Windows-felhasználók számára Windows Fax és Beolvasás Győződjön meg róla, hogy a nyomtató hozzá van adva a számítógéphez. További információkért lásd:  . Tegyen egy eredeti dokumentumot az automatikus lapadagolóba, vagy a lapolvasó üveglapjára. A számítógépről nyissa meg a  Windows fax és lapolvasó  elemet. Kattintson az  Új beolvasás  elemre, majd válassza ki a lapolvasó forrást. Szükség szerint módosítsa a beolvasási beállításokat. Olvassa be a dokumentumot. Kattintson a  Mentés másként  elemre, írjon be egy fájlnevet, majd kattintson a  Mentés  lehetőségre. Macintosh-felhasználók számára Győződjön meg róla, hogy a nyomtató hozzá van adva a számítógéphez. További információkért lásd:  . Tegyen egy eredeti dokumentumot az automatikus lapadagolóba, vagy a lapolvasó üveglapjára. A számítógépről végezze el a következő lépések valamelyikét: Nyissa meg az  Image Capture  programot. Nyissa meg a következőt:  Nyomtatók és lapolvasók , majd válasszon ki egy nyomtatót. Kattintson a  Beolvasás Lapolvasó megnyitása  lehetőségre. A Lapolvasó ablakból próbálkozzon az alábbiakkal: Válassza ki azt a helyet, ahová menteni szeretné a beolvasott dokumentumot. Válassza ki az eredeti dokumentum méretét. Az automatikus lapadagolóból való beolvasáshoz válassza ki a  Lapadagoló  opciót a  Beolvasás menüből , vagy engedélyezze a  Lapadagoló használata  opciót. Ha szükséges, konfigurálja a beolvasási beállításokat. Kattintson a  Beolvasás  gombra. szkennelés számítógépre számítógép, beolvasás Lexmark ScanBack Utility"},{"UUID":"05a61bbe-1823-4525-a77a-dc1dc37710d7","title":"Beolvasás","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Beolvasás FTP-kiszolgálóra Beolvasás FTP-kiszolgálóra Mielőtt","descFull":"Beolvasás FTP-kiszolgálóra Beolvasás FTP-kiszolgálóra Mielőtt elkezdené, győződjön meg róla, hogy a nyomtató csatlakozik egy FTP-kiszolgálóhoz. Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Beolvasás FTP  menüpontra. Adja meg a szükséges információkat, majd válassza a  Tovább  gombot. Szükség esetén konfigurálja az FTP-beállításokat. Olvassa be a dokumentumot. FTP-kiszolgáló beolvasás a következőre beolvasás FTP-kiszolgálóra"},{"UUID":"71d6e668-39dd-46c7-b99e-cc02f3d676a1","title":"Beolvasás","link":"creating-FTP-shortcut-topic.html","desc":"FTP-parancsikon létrehozása FTP-parancsikon létrehozása A","descFull":"FTP-parancsikon létrehozása FTP-parancsikon létrehozása A kezelőpanelen válassza a  Beolvasás FTP  lehetőséget. Adja meg az FTP-kiszolgáló címét, majd érintse meg a   lehetőséget. Hozzon létre egy parancsikont. parancsikon létrehozása FTP-cím parancsikon hozzáadása FTP-cím"},{"UUID":"2782a6e9-57e2-4f34-ae1b-0fa4932ade29","title":"Beolvasás","link":"scanning-to-network-folder-topic.html","desc":"Beolvasás hálózati mappába Mielőtt elkezdené,","descFull":"Beolvasás hálózati mappába Mielőtt elkezdené, győződjön meg arról, hogy a hálózati mappa, amelybe a dokumentumot be kívánja olvasni, már be van-e állítva. Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kezelőpanelen navigáljon a  Beolvasási központ Hálózati mappa  menüpontra. Válassza ki a megfelelő hálózati mappát. Hálózati mappa hozzáadásához lásd:  . Olvassa be a dokumentumot. beolvasás hálózati mappába hálózati mappa beolvasás a következőre"},{"UUID":"285caff4-ebd0-402e-8ca1-59ffa43b8ad8","title":"Beolvasás","link":"configuring-network-folder-destination-topic.html","desc":"Hálózati célmappa beállítása Hálózati célmappa","descFull":"Hálózati célmappa beállítása Hálózati célmappa beállítása A kezelőpanelen navigáljon a  Beolvasási központ Hálózati mappa Hálózati mappa létrehozása  menüpontra. Konfigurálja a szükséges beállításokat. Jelentkezzen be a hálózatba, majd válassza a  Tovább  lehetőséget. Konfigurálja a hálózati mappa beállításait, majd válassza a  Kész  lehetőséget. Dokumentum hálózati mappába történő beolvasásához lásd:  . hálózati célmappa konfigurálás hálózati mappa létrehozása"},{"UUID":"daad25b2-a4a8-47b3-add4-f12dc5e464d9","title":"Beolvasás","link":"creating-network-folder-shortcut-topic.html","desc":"Hálózati mappa hivatkozásának hozzáadása Nyisson","descFull":"Hálózati mappa hivatkozásának hozzáadása Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Parancsikonok Parancsikon hozzáadása  gombra. A  Parancsikontípus  menüből válassza a  Hálózati mappa  lehetőséget, majd konfigurálja a beállításokat. Alkalmazza a módosításokat. hálózati mappa hivatkozása parancsikon létrehozása"},{"UUID":"83b1cc14-8702-49be-ba84-3eaa0576f154","title":"Beolvasás","link":"scanning-to-flash-drive-topic.html","desc":"Beolvasás flash-meghajtóra Beolvasás flash-meghajtóra Tegye","descFull":"Beolvasás flash-meghajtóra Beolvasás flash-meghajtóra Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. Helyezze be a flash-meghajtót. A kezelőpanelen válassza a  Beolvasás , majd az  USB-meghajtó  lehetőséget. Válassza ki a fájl mentési helyét, adjon meg egy fájlnevet, majd válassza a  Tovább  gombot. A beolvasási beállítások konfigurálása. Olvassa be a dokumentumot. Az adatvesztés és a nyomtatóhibák elkerülése érdekében memóriaeszközről való nyomtatás, olvasás vagy írás közben ne érjen hozzá a flash-meghajtóhoz vagy a nyomtatóhoz az ábrán jelzett részen. beolvasás flash-meghajtóra flash meghajtó beolvasás a következőre"},{"UUID":"3072d6f1-0138-4f9a-be6b-2f64d5f2e4f0","title":"Nyomtatómenük","link":"menu-map-topic.html","desc":"Menütérkép 1  Csak akkor","descFull":"Menütérkép 1  Csak akkor jelenik meg, ha be van szerelve kiadóegység. 2  Csak akkor jelenik meg, ha be van szerelve tárolómeghajtó. Eszköz Beállítások Gazdaságos mód Távoli kezelőpanel Értesítések Energiagazdálkodás Adatok megosztása a Lexmarkkal Kisegítő lehetőségek Gyári alapértelmezett értékek visszaállítása Karbantartás Firmware frissítése Nyomtató névjegye Eszköz Beállítások Gazdaságos mód Távoli kezelőpanel Értesítések Energiagazdálkodás Kisegítő lehetőségek Gyári alapértelmezett értékek visszaállítása Karbantartás Firmware frissítése Nyomtató névjegye Nyomtatás Elrendezés Utófeldolgozás 1 Beállítás Minőség Feladat-nyilvántartás PDF PostScript PCL Kép Papír Tálcakonfiguráció Hordozókonfiguráció Rekeszkonfiguráció 1 Másolás Másolási alapbeállítások Fax Fax alapbeállítások E-mail E-mail beállítása E‑mail alapbeállítások Webes kapcsolat beállítása FTP FTP alapbeállítások USB-meghajtó Flash-meghajtó beolvasása Nyomtatás flash-meghajtóról Hálózat/portok Hálózati áttekintés Vezeték nélküli Wi-Fi Direct Mobilszolgáltatás-kezelő Ethernet TCP/IP SNMP IPSec 802.1x LPD-konfiguráció HTTP-/FTP-beállítások ThinPrint USB Külső hálózati hozzáférés korlátozása Biztonság Bejelentkezési módszerek USB-eszközök ütemezése Biztonsági ellenőrzési napló Bejelentkezési korlátozások Titkosított nyomtatás beállításai Titkosítás Ideiglenes adatfájlok törlése Megoldások: LDAP-beállítások Egyebek Felhőszolgáltatások Felhőalapú szolgáltatások – regisztráció Jelentések Menübeállítási oldal Eszköz Nyomtatás Parancsikonok Fax Hálózat Hibaelhárítás Tesztoldal nyomtatása A lapolvasó tisztítása Forms Merge 2 Forms Merge menütérkép nyomtató menüi"},{"UUID":"a54cf515-f328-44f8-a5a9-77c9b23aaae2","title":"Eszköz","link":"preferences-topic.html","desc":"Beállítások A Beállítások menü elemei","descFull":"Beállítások A Beállítások menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Kijelző nyelve N/A [Nyelvlista] A kijelzőn megjelenő szöveg nyelvének beállítása. Ország/terület N/A [Országok vagy területek listája] Adja meg a nyomtató működéséhez beállított országot vagy területet. Kezdeti beállítások futtatása N/A Ki * Be Futtassa a telepítővarázslót. Billentyűzet Billentyűzettípus [Nyelvlista] Válasszon nyelvet a billentyűzettípushoz. Előfordulhat, hogy a  Billentyűzettípus  nem minden értéke jelenik meg, vagy ahhoz speciális hardverre lehet szükség. Dátum és idő Konfigurálás Aktuális dátum és idő Dátum és idő kézi beállítása Dátumformátum  (HH-NN-ÉÉÉÉ* ) Időformátum  ( 12 órás de./du. *) Időzóna DST (GMT)-eltérés DST kezdete DST vége Nyári időszámítás eltolódása A nyomtató dátumának és óraidejének, valamint a hálózati időprotokoll megadása. Az egyesült államokbeli gyári alapértelmezett érték a  HH-NN-ÉÉÉÉ . A gyári alapértelmezett érték világszerte a  NN-HH-ÉÉÉÉ . Az  UTC (GMT) eltolás ,  DST kezdete ,  DST vége  és  Nyári időszámítás eltolódása  csak akkor jelenik meg, ha az  Időzóna (UTC+felhasználó) Egyéni  értékre van beállítva. A  Kulcsazonosító  és a  Jelszó  csak akkor jelennek meg, ha a  Hitelesítés engedélyezése  beállítás értéke  MD5 kulcs . Hálózati időprotokoll NTP engedélyezése  ( Be *) NTP-kiszolgáló Hitelesítés engedélyezése  ( Nincs *) Kulcsazonosító Jelszó Papírméretek N/A U.S. * Metrikus A papírméretek mértékegységeinek meghatározása. A papírméret kezdeti beállítását a kezdeti beállításvarázslóban kiválasztott ország és régió határozza meg. Kijelző fényereje N/A 20–100%  (100*) A kijelző fényerejének beállítása. Flash-meghajtó elérése N/A Letiltva Engedélyezve * Engedélyezi a nyomtató flash-meghajtó funkciójának elérését. Háttér eltávolításának engedélyezése N/A Ki Be * Meghatározza, hogy engedélyezve van-e a háttér eltávolítása. Egyéni beolvasási feladat engedélyezése N/A Ki Be * Meghatározhatja, hogy az  Egyéni feladat beolvasása  beállítás megjelenjen-e másoláshoz, beolvasáshoz és faxoláshoz. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Egyoldalas síkágyas beolvasás N/A Ki * Be Úgy állítja be a nyomtatót, hogy a lapolvasó üveglapját igénybe vevő bármilyen feladatot egyetlen oldalként olvasson be. Rákérdezés helyett a nyomtató visszatér a kezdőképernyőre egyoldalas síkágybeolvasás után. A készülék hangjelzései Minden hang elnémítása Ki * Be A nyomtató hangbeállításainak megadása. Gombos visszajelzés Ki Be * Hangerősség 0–10  (5*) ADF betöltve hangjelzés Ki Be * Riasztás vezérlés Ki Egyszeri * Folyamatos Kazettariasztás Ki Egyszeri * Folyamatos Hangszórómód Mindig ki * Mindig be Kapcsolódásig Hangszóró hangereje Ki * Be Kijelző időtúllépése N/A 5–300 másodperc  (60*) Adja meg, hogy a kijelzőn hány másodperc tétlenség után jelenjen meg a kezdőképernyő, illetve a nyomtató mennyi idő után jelentkeztesse ki automatikusan a felhasználót. menü Beállítások"},{"UUID":"ca263046-feb4-42a5-af58-f5d8fb988937","title":"Eszköz","link":"preferences-topic.html","desc":"Gazdaságos mód A Gazdaságos mód","descFull":"Gazdaságos mód A Gazdaságos mód menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Nyomtatás Oldalak Egyoldalas Kétoldalas * Meghatározhatja, hogy a nyomtatás a papír egyik vagy mindkét oldalára készüljön. Oldal/lap Ki * 2 oldal/lap 3 oldal/lap 4 oldal/lap 6 oldal/lap 9 oldal/lap 12 oldal/lap 16 oldal/lap Adja meg a papírlap egy oldalára nyomtatandó oldalak számát. Festékmennyiség 1–5  (4*) A szövegbeli képek fényességének vagy sötétségének a beállítása. Színmegtakarító Ki * Be Állítsa be a nyomtatót úgy, hogy grafikák és képek nyomtatásakor csökkentse a felhasznált festék mennyiségét. Másolás Oldalak Egyoldalas egyoldalassá * Egyoldalas kétoldalassá Kétoldalas egyoldalassá Kétoldalas kétoldalassá A beolvasás módjának beállítása az eredeti dokumentum alapján. Oldal/lap Ki * 2 álló oldal 4 álló oldal 2 fekvő oldal 4 fekvő oldal Adja meg a papírlap egy oldalára nyomtatandó oldalak számát. Sötétség 1–9  (5*) Meghatározza a beolvasott szövegbeli képek sötétségét. menü Gazdaságos mód"},{"UUID":"856b3c81-7547-45e8-8aac-fd3b7c1d516f","title":"Eszköz","link":"preferences-topic.html","desc":"Távoli kezelőpanel A Távoli kezelőpanel","descFull":"Távoli kezelőpanel A Távoli kezelőpanel menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Külső VNC csatlakozás Nem engedélyez * Engedélyezés Egy külső Virtual Network Computing (VNC) ügyfél csatlakoztatása a távoli kezelőpanelhez. Hitelesítés típusa Nincs * Standard hitelesítés A VNC-ügyfélkiszolgáló elérésekor használandó hitelesítési típus beállítása. VNC jelszó A beállítás felhasználó által meghatározott. A VNC-ügyfélkiszolgálóhoz való csatlakozáskor használandó jelszó beállítása. Ez a menüpont csak akkor jelenik meg, ha a  Hitelesítés típusa  beállítás értéke  Standard hitelesítés . menü Távoli kezelőpanel"},{"UUID":"50f43312-bad4-408a-8fbf-5064d50b9a91","title":"Eszköz","link":"preferences-topic.html","desc":"Értesítések Az Értesítések menü elemei","descFull":"Értesítések Az Értesítések menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. ADF betöltve hangjelzés N/A Ki Be * Meghatározza, hogy a nyomtató adjon-e egyéni hangjelzést, amikor eredeti dokumentumot helyez be az automatikus lapadagolóba. Riasztás vezérlés N/A Ki Egyszeri * Folyamatos Állítsa be, hányszor szólaljon meg a riasztó, amikor a nyomtató felhasználói beavatkozást igényel. Kellékek Kellékanyagbecslés megjelenítése Becslések megjelenítése * Becslések elrejtése A kellékanyagok becsült állapotának megjelenítése. Kazettariasztás Ki Egyszeri * Folyamatos Állítsa be hányszor szólaljon meg a riasztó a kifogyóban lévő tonerkazetta miatt. Kapocsriasztás Ki * Egyetlen Folyamatos Állítsa be hányszor szólaljon meg a riasztó a kiürült tűzőkazetta miatt. Ez a menü csak akkor jelenik meg, ha a kapcsozó kiadóegység telepítve van. Lyukasztó riasztás Ki * Egyetlen Folyamatos Állítsa be, hányszor szólaljon meg a riasztás, ha a lyukasztó tárolója megtelt vagy hiányzik. Ez a menü csak akkor jelenik meg, ha telepítve van egy kapcsozó-lyukasztó kiadóegység. E-mail-riasztások beállítása Elsődleges SMTP-átjáró A beállítás felhasználó által meghatározott. Adja meg az elsődleges SMTP-kiszolgáló IP-címét vagy állomásnevét. Elsődleges SMTP-átjáró port 1–65535  (25*) Adja meg az elsődleges SMTP-kiszolgáló portszámát. Másodlagos SMTP-átjáró A beállítás felhasználó által meghatározott. Írja be a másodlagos SMTP-kiszolgáló IP-címét vagy állomásnevét. Másodlagos SMTP-átjáró port 1–65535  (25*) Adja meg a másodlagos SMTP-kiszolgáló kiszolgálóportjának számát. SMTP időtúllépés 5–30 másodperc  (30*) Adja meg, hogy az SMTP-kiszolgáló mennyi ideig várjon, mielőtt leállítja az e-mail-küldési kísérletet. Válaszcím A beállítás felhasználó által meghatározott. Válaszcím megadása az e-mailben. Alapértelmezett SMTP-válaszcím használata mindig Be Ki * Mindig használja az alapértelmezett válaszadási címet az SMTP-kiszolgálóban. SSL/TLS használata Letiltva * Egyeztetés Kötelező E-mail küldése titkosított hivatkozás segítségével. Megbízható tanúsítvány szükséges Be * Ki Kérjen megbízható tanúsítványt az SMTP-kiszolgálóhoz való hozzáféréshez. Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. E-mail-riasztások beállítása SMTP-kiszolgáló hitelesítése Nem szükséges hitelesítés * Bejelentkezés/sima NTLM CRAM-MD5 Digest-MD5 Kerberos 5 Az SMTP-kiszolgáló hitelesítési típusának beállítása. Eszköz által kezdeményezett e-mail Nincs * Az eszköz SMTP-belépési adatainak használata Meghatározza, hogy kérjen-e a rendszer hitelesítő adatokat az eszköz által kezdeményezett e-mailek esetében. Felhasználó által kezdeményezett e-mail Nincs * Az eszköz SMTP-belépési adatainak használata A munkamenet felhasználói azonosítójának és jelszavának a használata Munkafolyamati e-mail-cím és jelszó használata Azonosító adatok bekérése Meghatározza, hogy kérjen-e a rendszer hitelesítő adatokat a felhasználók által kezdeményezett e-mailek esetében. Active Directory eszközhitelesítő használata Be Ki * Ezzel a funkcióval engedélyezheti a felhasználói hitelesítő adatok és a csoportmegjelölések használatát az SMTP-kiszolgálóhoz való csatlakozáshoz. Eszköz felhasználói azonosítója A beállítás felhasználó által meghatározott. Adja meg az SMTP-kiszolgálóra való bejelentkezéshez szükséges felhasználói azonosítót. Eszköz jelszava A beállítás felhasználó által meghatározott. Adja meg az SMTP-kiszolgálóra való bejelentkezéshez szükséges jelszót. Kerberos 5 TARTOMÁNY A beállítás felhasználó által meghatározott. A Kerberos 5 hitelesítési protokoll tartományának meghatározására szolgál. NTLM-tartomány A beállítás felhasználó által meghatározott. Az NTLM biztonsági protokoll tartománynevének meghatározására szolgál. „Az SMTP-kiszolgáló nincs beállítva.” hiba letiltása Be Ki * Az SMTP-kiszolgáló beállításával kapcsolatos hibaüzenet letiltása. E-mail-listák és értesítések beállítása A beállítás felhasználó által meghatározott. Adja meg az e-mail-címeket, és engedélyezze az e-mail-riasztási eseményeket. Ezt a menüelemet csak az Embedded Web Server kiszolgáló használatával lehet elérni. Hibamegelőzés ADF többszörös adagolás érzékelő Ki Be * Állítsa be a nyomtatót úgy, hogy érzékelje, ha az ADF egyszerre egynél több papírlapot vesz fel. Automatikus folytatás Ki Be * Bizonyos jelenlévő feltételek automatikus törlésének engedélyezésével beállíthatja, hogy a nyomtató folytassa egy feladat feldolgozását vagy nyomtatását. Ha  Be  van kapcsolva, az alapértelmezett beállítás 5 másodperc. Automatikus újraindítás Újraindítás, ha tétlen Újraindítás mindig * Újraindítás soha A nyomtató újraindítása, ha valamilyen hiba történt. Automatikus újraindítások maximális száma 1–20  (2*) Meghatározza a nyomtató által végrehajtható automatikus újraindítások számát. Automatikus újraindítási időtartam 1–525600  (720*) Beállíthatja, hogy a nyomtató hány másodperc után induljon újra automatikusan. Automatikus újraindítások számlálója A beállítás csak olvasható információ. Megjeleníti a nyomtató által végrehajtott automatikus újraindítások számát. Rövid papír hiba megjelenítése Be Automatikus törlés * A nyomtató beállítása a papír rövidsége esetén küldött hibaüzenet megjelenítésére. A rövid papír a betöltött papír méretére vonatkozik. Oldalvédelem Ki * Be Ezzel a funkcióval azt állíthatja be, hogy a nyomtató a nyomtatási művelet elindítása előtt az egész oldalt beolvassa a memóriába. Elakadáselhárítás Elakadás utáni helyreállítás Ki Be Auto * Úgy állítja be a nyomtatót, hogy újból kinyomtassa az elakadt oldalakat. Lapolvasó elakadásának elhárítása Feladatszint Oldalszint * Meghatározza, hogy a rendszer hogyan indítsa újra a beolvasási feladatokat a papírelakadás elhárítása után. menü Értesítések"},{"UUID":"c1d80ed3-426a-445e-9048-67351b870cd2","title":"Eszköz","link":"preferences-topic.html","desc":"Energiagazdálkodás Az Energiagazdálkodás menü elemei","descFull":"Energiagazdálkodás Az Energiagazdálkodás menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Alvó üzemmód profilja Nyomtatás alvó üzemmódból Aktív állapot nyomtatás után Nyomtatás után belépés alvó üzemmódba * Állítsa be a nyomtatót, hogy nyomtatás után ébren maradjon vagy  alvó üzemmódba  lépjen. Megérintés mély alvás befejezéséhez Ki Be * A nyomtató felébresztése  mély alvó üzemmódból . Időtúllépések Alvó üzemmód 1–114 perc  (15*) Állítsa be a készenlétben töltött időt a nyomtató  alvó üzemmódban  lépéséig. Hibernálási idő Letiltva 1 óra 2 óra 3 óra 6 óra 1 nap 2 nap 3 nap * 1 hét 2 hét 1 hónap Beállítja azt az időt, mielőtt a nyomtató kikapcsol. Hibernálás időkorlátja kapcsolatban Hibernált mód Ne hibernáljon * Beállítja a  Hibernálási időt , hogy kikapcsolja a nyomtatót, amíg van aktív Ethernet kapcsolat. Teljesítmény-üzemmódok ütemezése Ütemezések Új ütemezés hozzáadása Ütemezze a nyomtatót, hogy mikor lépjen  alvó üzemmódba  vagy  hibernált  üzemmódba. menü Energiagazdálkodás"},{"UUID":"1f0dc19e-4d78-40ff-ab6d-3d4f07d37bd7","title":"Eszköz","link":"preferences-topic.html","desc":"Adatok megosztása a Lexmarkkal Az","descFull":"Adatok megosztása a Lexmarkkal Az Adatok megosztása Lexmarkkal menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Adatok megosztása a Lexmarkkal Igen Nem * Nyomtatóhasználati és teljesítményinformációk küldése a Lexmarknak. Adatküldés időpontjának megosztása Kezdési idő Befejezési idő Válassza ki az adatgyűjtés és -átvitel időablakát. Az  Adatküldés időpontjának megosztása  csak akkor jelenik meg, ha az  Igen  lehetőséget választja az  Adatok megosztása a Lexmarkkal  mezőben. menü Adatok megosztása a Lexmarkkal"},{"UUID":"6d577849-84b4-4ed7-9045-fb756950e8cc","title":"Eszköz","link":"preferences-topic.html","desc":"Kisegítő lehetőségek A Kisegítő lehetőségek","descFull":"Kisegítő lehetőségek A Kisegítő lehetőségek menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Duplabillentyű-leütési intervallum 0.00–5.00  (0.00*) Beállítja azt a másodpercenkénti időközt, amely során a nyomtató figyelmen kívül hagyja a dupla billentyűleütést a csatlakoztatott billentyűzet esetén. Gombismétlési kezdeti késleltetés 0.25–5.00  (1.00*) Beállítja a kezdeti késleltetés hosszát (másodpercben), mielőtt az ismétlődő gomb megismétlődne. Gombismétlési arány 0.5–30.0  (30.0*) Beállítja egy ismétlődő gomb másodpercenkénti megnyomásának számát. Kijelz. időt. meghossz Ki * Be A felhasználó maradhat ugyanazon a helyen, és visszaállíthatja a  Kijelző időtúllépésének  időzítőjét annak lejártakor a kezdőképernyőre való visszalépés helyett. Fejhallgató-hangerő 1–10  (5*) A fejhallgató hangerejének módosítása. Hangutasítások engedélyezése, amikor a headset csatlakoztatva van Ki * Be Hangutasítások engedélyezése, ha a fejhallgató-csatlakozóba fejhallgatót csatlakoztattak. Jelszavak/PIN-kódok felolvasása Ki * Be Nyomtató beállítása a jelszavak és személyes azonosító kódok felolvasásához. Beszédsebesség Nagyon lassú Lassú Normál * Gyors Gyorsabb Nagyon gyors Sebes Nagyon sebes Leggyorsabb A hangutasítások beszédsebességének beállítása. menü Kisegítő lehetőségek"},{"UUID":"2ddf6621-8bba-4471-bffc-5e5fd1f7202c","title":"Eszköz","link":"preferences-topic.html","desc":"Gyári alapértelmezett értékek visszaállítása A","descFull":"Gyári alapértelmezett értékek visszaállítása A Gyári alapértelmezett értékek visszaállítása menü elemei és leírásuk Menüelem Beállítások Leírás Beállítások visszaállítása Minden beállítás visszaállítása Nyomtatóbeállítások visszaállítása Hálózati beállítások visszaállítása Faxbeállítások visszaállítása Alkalmazás beállításainak visszaállítása A nyomtató gyári alapbeállításainak visszaállítása. menü Gyári alapértelmezett értékek visszaállítása"},{"UUID":"02db0ad0-39ec-4312-97a3-d82be17461e2","title":"Karbantartás","link":"preferences-topic.html","desc":"Konfigurációs menü A Konfiguráció menü","descFull":"Konfigurációs menü A Konfiguráció menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. USB-konfiguráció USB PnP 1 * 2 A nyomtató és a számítógép kompatibilitásának javításához változtassa meg a nyomtató USB-illesztőjének üzemmódját. USB-beolvasás helyire Be * Ki Beállíthatja, hogy az USB-eszközillesztő egyszerű USB-eszközként (egyetlen kezelőfelület) vagy összetett USB-eszközként (több kezelőfelület) szerepeljen. USB-sebesség Teljes Auto * Állítsa be az USB-port futtatását teljes sebességre, és kapcsolja ki a nagy sebességű üzemmódot. Tálcakonfiguráció Méretérzékelés Tálca  [x]  Érzékelés  ( Be *) Beállítja a tálcát a beletöltött papír méretének automatikus érzékelésére. Tálcák összekapcsolása Automatikus * Ki Meghatározza, hogy a nyomtató összekapcsolja-e az azonos papírtípusra és -méretre beállított tálcákat. Tálcabehelyezési üzenet megjelenítése Ki Csak az ismeretlen méretek esetében * Mindig A tálca beillesztése után üzenetet jelenít meg, melynek segítségével a felhasználó módosíthatja a papírméret- és papírtípus-beállításokat. Papír megadása Auto * Többcélú adagoló Kézi papíradagolás Amikor a rendszer papír behelyezését kéri, határozza meg a használni kívánt papírforrást. A  többcélú adagoló  megjelenéséhez a  Papír  menüben állítsa az  MP beállítása  értéket  Kazetta  értékre. Boríték megadása Auto * Többcélú adagoló Manuális borítékadagolás Amikor a rendszer boríték behelyezését kéri, határozza meg a használni kívánt papírforrást. A  többcélú adagoló  megjelenéséhez a  Papír  menüben állítsa az  MP beállítása  értéket  Kazetta  értékre. Kérdésekhez tartozó műveletek Azonosító adatok bekérése * Folytatás Aktuális használata Azt határozza meg, hogy a nyomtató automatikusan váltson-e papír vagy boríték nyomtatására. Többféle univerzális méret Ki * Be A tálca beállítása úgy, hogy több univerzális papírméretet támogasson. Jelentések N/A Menübeállítási oldal Eseménynapló Eseménynapló összegzése Jelentések nyomtatása a nyomtató menüinek beállításairól és állapotáról, illetve eseménynaplók nyomtatása. Kellékanyag-használat és számlálók Kellékhasználat előzményeinek törlése Indítás Állítsa vissza a kellékanyag-használati előzményeket a gyárilag szállított szintre. ITM visszaállítása Indítás Visszaállítja a számlálót egy új kellékanyag vagy karbantartó készlet behelyezését követően. Fekete tonerkazetta számlálójának nullázása Indítás Cián tonerkazetta számlálójának nullázása Indítás Magenta tonerkazetta számlálójának nullázása Indítás Sárga tonerkazetta számlálójának nullázása Indítás Fekete képalkotó egység számlálójának visszaállítása Indítás Színes képalkotó készlet számlálójának visszaállítása Indítás Az MPF görgőkészlet számlálójának visszaállítása Indítás Az 1500 lapos görgőkészlet számlálójának visszaállítása Indítás Görgőkész. száml. visszaáll. Indítás Differenciáltszolgáltatás-tartományok Differenciált szolgáltatás mérőszámai  ( megjelenítés *) Az Eszközstatisztika jelentésben megjeleníti a Színesoldal-kapacitás részt. Differenciáltszolgáltatás-tartományok Nagy méretű hordozók beállításai Ki * Be Engedélyezze a beállításokat nagy vagy vastag papírra történő nyomtatáskor. Nyomtatóemulációk PPDS-emuláció Ki * Be A nyomtató beállítása a PPDS-adatfolyam felismerésére és használatára. PS-emuláció Ki Be * A nyomtató beállítása a PS-adatfolyam felismerésére és használatára. Formsmerge engedélyezése Ki * Be A Forms Merge aktiválása. A Formsmerge licencet telepíteni kell. Egy felhasználói flash-memóriát kell telepíteni. Prescribe engedélyezése Ki * Be A PRESCRIBE nyomtatónyelv aktiválása. A PRESCRIBE-licencet telepíteni kell. Emulátorbiztonság Oldal időtúllépés  (60*) Az oldal időtúllépésének beállítása emuláció alatt. Emulátor visszaállítása a feladat után  ( Ki *) Az emulátor visszaállítása nyomtatási feladat után. Nyomtatóüzenet-hozzáférés letiltása  ( Be *) Határozza meg, hogy az emulátor hozzáfér-e a nyomtató kezdeti beállításaihoz vagy sem. Fax beállítása Fax alacsony telj. támogat. Alvó üzemmód letiltása Alvó üzemmód engedélyezése Auto * Határozza meg, hogy a nyomtató támogatja-e az alacsony energiafelhasználású architektúra fax részét. Faxtárolási hely Lemez * NAND Meghatározza az összes fax tárolási helyét. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Nyomtatás konfigurálása Csak fekete mód Ki * Be Nem másolási feladatok szürkeárnyalatos nyomtatása. Színalátöltés Ki 1 2 * 3 4 5 A nyomatok minőségének javítása a nyomtató nem megfelelő regisztrációjának korrigálása érdekében. Betűélesítés 0–150  (24*) Állítsa be azt a betűtípusméretet, amely alatt a rendszer a nagy frissítési gyakoriságú képernyőket használja a betűtípusadatok nyomtatásához. Ha ez az érték például 24, akkor az összes 24-es vagy annál kisebb betűméret a nagy frissítési gyakoriságú képernyőt használja. Natív ISD betűtípusok használata Be * Ki Hagyja, hogy a felhasználó döntse el, hogy az intelligens tárolómeghajtón (ISD) lévő ingyenes betűtípusokat használja-e. Ez a menü csak telepített ISD esetén jelenik meg. Eszközműveletek Csendes üzemmód Ki * Be Állítsa be a nyomtató által kiadott zaj mértékét. Ennek a beállításnak az engedélyezése lelassítja a nyomtató általános teljesítményét. Löket mód engedélyezése Be * Ki Állítsa be a nyomtatót egy oldal, illetve egy többoldalas feladat első oldalának gyorsítására, hogy gyorsabban végezzen a feladattal. Ez a menüelem csak bizonyos nyomtatómodelleknél látható. Biztonságos mód Ki * Be A nyomtató beállítása olyan speciális üzemmódba, amelyben az ismert problémák ellenére a lehető legtöbb funkciót kínálja. Ha például  Be  van kapcsolva, és a kétoldalas motor nem működik, akkor egyoldalas nyomtatást végez, még akkor is, ha a feladat kétoldalas nyomtatásra van beállítva. Ha engedélyezi ezt a beállítást, csak a többcélú adagolóból nyomtathat. Minimális másolási memória 20 MB 30 MB 50 MB 80 MB * 100 MB A másolási feladatok tárolásához használható minimális memória mennyiségének beállítása. Egyéni állapot törlése Indítás Törölje az  alapértelmezett  vagy  módosított  egyéni üzenetek felhasználó által beállított karaktersorait. A távolról telepített üzenetek törlése Indítás Töröljön minden távolról telepített üzenetet. Hibaképernyők automatikus megjelenítése Ki Be * A fennálló hibaüzenetek megjelenítése a kijelzőn, ha a nyomtató kezdőképernyője adott ideig inaktív marad. Tájolás megtartása gyors fénymásolás esetén Ki * Be Engedélyezi, hogy a nyomtató gyors másolási feladatok küldése esetén a  Másolás  menüben megadott tájolási beállítást használja. Nem felejtő memória szolgáltatás Titkosítási állapot A belső tároló titkosítási állapotának megjelenítése. Titkosítási szolgáltatás – nem felejtő memória Tükörtitkosítás engedélyezése manuálisan. Festékfolt-érzékelő beállítása Kalibrálás gyakoriságának beállítása Letiltva Legkevesebb színállítás Kevesebb színállítás Normál * Jobb színhelyesség Legjobb színhelyesség A nyomtatáshoz használt festékmennyiség beállítása a színkonzisztencia megőrzéséhez. Teljes kalibrálás Indítás A teljes színkalibrálás futtatása. TPS információs oldal nyomtatása Indítás A festékfolt-érzékelő kalibrálására vonatkozó diagnosztikai lap nyomtatása. Alkalmazások konfigurálása LES alkalmazások Ki Be * Lexmark Embedded Solutions (LES) alkalmazások engedélyezése. Lapolvasó beállítása Lapolvasó kézi regisztrálása Nyomtatási gyorsteszt Automatikus lapadagoló elülső regisztrációja Automatikus lapadagoló hátsó regisztrációja Síkágy-regisztráció Nyomtasson ki egy Gyorsteszt céloldalt, vagy regisztrálja manuálisan a síkágyat és az automatikus lapadagolót (ADF) az ADF, a lapolvasó üveglapja vagy a vezérlőkártyacseréje után. A Gyorsteszt céloldal nyomtatásakor győződjön meg arról, hogy a céloldalon a margótávolság a céloldal teljes hosszában egységes. Ellenkező esetben a nyomtatómargókat vissza kell állítani. Karbantartási számláló visszaállítása Az ADF karbantartási számláló visszaállítása  ( Indítás ) Az automatikus lapadagoló karbantartó készletének cseréje után nullázza a számlálót. Szegélytörlés Síkágy szél törlése  (3*) ADF szél törlése  (3*) Adja meg milliméterben az ADF vagy síkágyas beolvasási feladat nem nyomtatandó területének méretét. ADF-ferdeség korrigálása ADF-ferdeség elektronikus korrigálása  ( Be *) Az automatikus lapadagolóból beolvasott dokumentumok ferdeségének csökkentése. Lapolvasó letiltása Nem * Igen Csak ADF Tiltsa le a lapolvasót, ha az nem működik megfelelően. Tiff bájtsorrend CPU bájtsorrend Kis bájtsorrend Nagy bájtsorrend TIFF-formázott beolvasott fájl bájtsorrendjének beállítása. Pontos Tiff sorok szalagonként Be * Ki A TIFF-formázott beolvasás-kimeneteli fájl RowsPerStrip címkéjének értékének beállítása. Lapolvasó üveglapjának tisztítási küszöbértéke 1000–30000  (10000*) A beolvasások száma, mielőtt a felhasználó figyelmeztetést kap, hogy tisztítsa meg a lapolvasó üveglapját. menü Konfigurációs menü"},{"UUID":"14386b0c-df20-4d7b-97ee-04c807dd63c7","title":"Karbantartás","link":"preferences-topic.html","desc":"Üzemen kívüli törlés Az Üzemen","descFull":"Üzemen kívüli törlés Az Üzemen kívüli törlés menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Üzemen kívüli törlés Memória utolsó tisztítása A beállítás csak olvasható információ. Megmutatja, mikor törölték utoljára a nyomtató memóriáját. Merevlemez utolsó tisztítása A beállítás csak olvasható információ. Megmutatja, mikor törölték utoljára a merevlemezt. Ez a menüelem csak telepített merevlemez esetén jelenik meg. Az ISD utolsó törlése A beállítás csak olvasható információ. Megmutatja, mikor törölték utoljára az intelligens tárolómeghajtót (ISD). Ez a menü csak telepített ISD esetén jelenik meg. Minden információ tisztítása a nem felejtő memóriáról Az összes nyomtató- és hálózati beállítás törlése Az összes alkalmazás és alkalmazásbeállítás törlése Összes parancsikon és parancsikon-beállítás törlése A nem felejtő memórián található összes adat törlése. Minden információ tisztítása a merevlemezről Letöltések törlése (minden makró, betűtípus, PFO stb. törlése) Pufferelt feladatok törlése Felfüggesztett feladatok törlése Minden információ törlése a merevlemezről. Ez a menüelem csak telepített merevlemez esetén jelenik meg. Intelligens tárolómeghajtó törlése Törlés Minden információ törlése az ISD-ről. Ez a menü csak telepített ISD esetén jelenik meg. menü Üzemen kívüli törlés"},{"UUID":"609aea56-ca51-4b23-a8c4-571b6e30f3d7","title":"Eszköz","link":"preferences-topic.html","desc":"Firmware frissítése  A Firmware","descFull":"Firmware frissítése  A Firmware frissítése menü elemei és leírásuk Menüelem Beállítások Leírás Aktuális változat A beállítás csak olvasható információ. A nyomtatóra telepített aktuális firmware-verzió megjelenítése. Frissítések keresése most Telepítés most Telepítés később Firmware-frissítések keresése. Frissítések automatikus keresése Be Ki * A nyomtató beállítása a firmware-frissítések automatikus keresésére. menü Firmware frissítése"},{"UUID":"4531c99b-74f1-4155-84ca-a6ad057c40a3","title":"Eszköz","link":"preferences-topic.html","desc":"Nyomtató névjegye A Nyomtató névjegye","descFull":"Nyomtató névjegye A Nyomtató névjegye menü elemei és leírásuk Menüelem Leírás Leltári címke Meghatározza a nyomtató identitását. Nyomtató helye Meghatározza a nyomtató helyét. Kapcsolat Meghatározza a kapcsolattartói adatokat a nyomtatóhoz. Firmware-verzió A nyomtatóra telepített firmware-verzió megjelenítése. Motor A nyomtató motorszámának megjelenítése. Sorozatszám A nyomtató sorozatszámának megjelenítése. Konfigurációs fájl exportálása USB-re Konfigurációs fájlok exportálása flash-meghajtóra. Tömörített naplók exportálása USB-re Tömörített naplófájlok exportálása flash-meghajtóra. Naplók küldése Nyomtatónapló-információk küldése a Lexmarknak. menü Nyomtató névjegye"},{"UUID":"316e169e-3c61-4054-9b9c-534f9c5f0449","title":"Nyomtatás","link":"layout-topic.html","desc":"Elrendezés Az Elrendezés menü elemei","descFull":"Elrendezés Az Elrendezés menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Oldalak Egyoldalas Kétoldalas * Meghatározhatja, hogy a nyomtatás a papír egyik vagy mindkét oldalára készüljön. Lapozási stílus Hosszú oldal * Rövid oldal Határozza meg, hogy kétoldalas nyomtatás esetén a papír melyik oldala legyen bekötve. Üres oldalak Nyomtatás Nincs nyomtatás * A nyomtatási feladathoz tartozó üres oldalak nyomtatása. Leválogatás Ki (1,1,1,2,2,2) Be (1,2,1,2,1,2) * Ha ugyanarról az eredetiről több másolatot is nyomtat, akkor a nyomtató az egyes példányokat összerendezi. Elválasztólapok Nincs * Példányok között Feladatok között Oldalak között Üres elválasztólapok beillesztése a nyomtatás során. Elválasztólap forrása [x].  tálca  (1*) Többcélú adagoló Adja meg az elválasztó lap papírforrását. Oldal/lap Ki * 2 oldal/lap 3 oldal/lap 4 oldal/lap 6 oldal/lap 9 oldal/lap 12 oldal/lap 16 oldal/lap Több egy oldalon lévő kép nyomtatása a papír egyik oldalára. Oldal/lap rendelés Vízszintes * Fordított vízszintes Függőleges Fordított függőleges Több, az oldalon lévő kép elrendezésének beállítása az  Oldal/lap  menü használata esetén. Oldal/oldal tájolás Auto * Fekvő Álló Több, az oldalon lévő kép tájolásának beállítása az  Oldal/lap  menü használata esetén. Oldal/lap szegélye Nincs * Halvány Oldalszegély nyomtatása az oldalon lévő képek köré az  Oldal/lap  menü használata esetén. Példányok 1–9999  (1*) Itt adhatja meg a példányszámot az egyes nyomtatási feladatokhoz. Nyomtatási terület Normál * Az oldalnak megfelelő Teljes oldal Nyomtatási terület beállítása a papíron. menü Elrendezés"},{"UUID":"f4d13f71-6713-46bf-9245-96e1160392b4","title":"Nyomtatás","link":"layout-topic.html","desc":"Utófeldolgozás Az Utófeldolgozás menü elemei","descFull":"Utófeldolgozás Az Utófeldolgozás menü elemei és azok leírása Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Tűzési feladat Ki * 1 kapocs, bal felső sarok 2 kapocs, balra 1 kapocs, jobb felső sarok 2 kapocs, fent 1 kapocs, bal alsó sarok 2 kapocs, alul 1 kapocs, jobb alsó sarok 2 kapocs, jobb A kapcsok helyzetének beállítása az összes nyomtatási feladathoz. Ez a menü csak akkor jelenik meg, ha a kapcsozó kiadóegység telepítve van. Tűzőteszt Indítás A kapcsozó kiadóegység megfelelő működésének ellenőrzése. Ez a menü csak akkor jelenik meg, ha a kapcsozó kiadóegység telepítve van. Lyukasztás Ki * Be A kinyomtatott oldalak széleinek kilyukasztása. Ez a menü csak akkor jelenik meg, ha támogatott tűző és lyukasztó kiadóegység van telepítve. Lyukasztó mód 2 lyuk 3 lyuk 4 lyuk A lyukasztási mód beállítása a kinyomtatott oldalhoz. A  3 lyuk  az egyesült államokbeli gyári alapértelmezett érték. A nemzetközi gyári alapértelmezett érték a  4 lyuk . Ez a menü csak akkor jelenik meg, ha van telepítve többpozíciós kapcsozó-lyukasztó kiadóegység. Oldalak eltolása Nincs * Példányok között Feladatok között Az egyes nyomtatási feladatok, vagy az azokból származó egyes példányok kimenetének eltolása. Ha a  Példányok között  beállítást választja, a rendszer a nyomtatási feladat minden példányát eltolja, ha a  Leválogatás  beállításnál a  Be [1, 2, 1, 2, 1, 2]  értéket választotta. Ha a  Leválogatás  beállításnál a  Ki [1, 1, 1, 2, 2, 2]  értéket választotta, akkor a rendszer készletenként tolja el az oldalakat (azaz az összes elsőként megjelölt oldalt, az összes másodikként megjelölt oldalt stb.). A  Feladatok között  lehetőség ugyanazt az eltolási helyzetet állítja be a teljes nyomtatási feladatra, függetlenül a kinyomtatott példányszámtól. menü Utófeldolgozás"},{"UUID":"8e6f420a-a53b-4bae-a87e-095948a3be6b","title":"Nyomtatás","link":"layout-topic.html","desc":"Beállítás A Beállítás menü elemei","descFull":"Beállítás A Beállítás menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Nyomtató nyelve PCL-emuláció PS-emuláció * Beállítja a nyomtató nyelvét. A nyomtatónyelv alapértelmezettként való beállítása nem akadályozza meg a szoftvert abban, hogy más nyomtatónyelvet használó nyomtatási feladatokat küldjön. Feladatvárakoztatás Ki * Be Az anyagra váró nyomtatási feladatokat úgy őrzi meg, hogy az anyagra nem váró nyomtatási feladatokat kinyomtatja. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Feladattartási időtúllépés 0–255  (30*) Beállíthatja, hogy a nyomtató hány másodpercig várjon a felhasználó beavatkozására, ameddig a nyomtató tartja a feladatokat, amelyek nem elérhető erőforrásokat igényelnek. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Célfájl letöltése RAM * Flash Lemez Adja meg a nyomtatóra letöltött állandó erőforrások mentési helyét. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Nyomtatóhasználat Max. sebesség Max. hozam * Határozza meg, hogy a visszahúzó hardver elengedje vagy csatlakoztassa a színes előhívó egységet nyomtatás közben. A  Max. hozam  beállítás esetén a hardver akkor is kapcsolatban marad a színes előhívó egységgel, amikor a nyomtató készenléti állapotban van. A  Max. sebesség  beállítás esetén a hardver továbbra is kapcsolatban marad a színes előhívó egységgel, függetlenül attól, hogy a feladat monokróm vagy színes tartalommal rendelkezik. Kis sebességű nyomtatóhasználat Max. hozam * Max. sebesség Hagyja, hogy a nyomtató alacsony sebességen történő működés közben a nagy teljesítményű (csak fekete üzemmód) és a nagy sebességű (színes üzemmód) között váltson. Ez a beállítás csak akkor változtatja meg a nyomtató viselkedését, ha a nyomtatómotor 25 oldal/perc feldolgozási sebességgel működik. Nincs hatása akkor, ha a nyomtatómotor gyorsabb feldolgozási sebességgel üzemel. Az erőforrások mentése Ki * Be Megállapítja, hogy a nyomtató hogyan kezelje a letöltött erőforrásokat azoknál a feladatoknál, amelyek az elérhető memóriánál többet igényelnek. Kikapcsolás  esetén a nyomtató csak addig őrzi meg a letöltött erőforrásokat, amíg memóriára van szükség. Az inaktív nyomtatónyelvvel kapcsolatos erőforrások törlésre kerülnek. Bekapcsolás  esetén a nyomtató minden nyelvváltoztatáskor megőrzi az összes letöltött állandó erőforrást. Szükség esetén a nyomtató a memória megteltére vonatkozó üzeneteket jelenít meg az állandó erőforrások törlése helyett. Az összes kinyomtatása Betűrendben * A legújabbat előre A legrégebbit előre Meghatározza a sorrendet, ha az összes felfüggesztett és titkosított feladat kinyomtatását választja. A felfüggesztett nyomtatási feladatok automatikus törlése Ki * Be Beállítja a nyomtatót, hogy automatikusan törölje a sorban álló nyomtatási feladatokat, amelyek hibák, például papírelakadás vagy hiányzó kellékek miatt megszakadtak. menü Beállítás"},{"UUID":"94edf1e9-6615-427f-b272-eb03a91d2c56","title":"Nyomtatás","link":"layout-topic.html","desc":"Minőség A Minőség menü elemei","descFull":"Minőség A Minőség menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Nyomtatási mód N/A Fekete-fehér Színes * Azt állítja be, hogyan hozza létre a nyomtató a színes tartalmat. Nyomtatási felbontás N/A 4800 CQ * 1200 dpi A kinyomtatott oldal felbontásának beállítása. A  4800 CQ  kiváló minőségű nyomtatást biztosít maximális sebességgel. Festékmennyiség N/A 1 és 5 között  (4*) A szövegbeli képek fényességének vagy sötétségének a beállítása. Féltónus N/A Normál * Részlet Javítja a kinyomtatott anyag minőségét azáltal, hogy simább vonalakat hoz létre élesebb szélekkel. Színmegtakarító N/A Ki * Be Az ábrák és képek nyomtatásához felhasznált festék mennyiségének csökkentésére használható. Ez a beállítás  Be  értékre állítva felülírja a  Festék sötétsége  beállítást. RGB fényerő N/A -6 és 6 között  (0*) Az oldalon lévő minden RGB és szürke objektum fényerejének beállítása. Ez nincs hatással a CMYK-színspecifikációt használó fájlokra. RGB kontraszt N/A 0 és 5 között  (0*) Az oldalon lévő minden RGB és szürke objektum kontrasztjának beállítása. Ez nincs hatással a CMYK-színspecifikációt használó fájlokra. RGB telítettség N/A 0 és 5 között  (0*) A fekete és fehér értékek megőrzése, azonban oldalon lévő összes objektum színes értékének átállítása. Ez nincs hatással a CMYK-színspecifikációt használó fájlokra. Speciális képalkotás Színegyensúly Ciánkék  (0*) Bíbor  (0*) Sárga  (0*) Fekete  (0*) Az egyes színekhez használt festék mennyiségének beállítása. Alapért. visszaáll. Az összes színbeállítás visszaállítása az alapértelmezett értékekre. Színkorrekció Ki Auto * Kézi A kinyomtatott dokumentumok színbeállításainak módosítása. Ha a  Ki  beállítást választja, a rendszer a szoftver által küldött színkorrekciót használja. Ha az  Automatikus  beállítást választja, a rendszer a nyomtatott oldal minden objektumához különböző színprofilt fog alkalmazni. A  Manuális  színkorrekció segítségével testre szabhatja a nyomtatott oldal objektumaira alkalmazott RGB- és CMYK-színkonverziót. Színminták Színminták nyomtatása Mintaoldalakat nyomtat a nyomtató által használt RGB- és CMYK-színátalakítási táblázatokból. Színbeállítás Színbeállítás A nyomtató kalibrálása a nyomat színeinek beállítása érdekében. Direkt színkorrekció Egyedi CMYK beállítása Lehetőséget biztosít adott CMYK értékek 20 névvel ellátott direkt színekhez történő rendelésére. menü Minőség"},{"UUID":"056f8877-0fb4-47c6-8bb9-a015dd9f1cab","title":"Nyomtatás","link":"layout-topic.html","desc":"Feladat-nyilvánt. A Feladat-nyilvántartás menü elemei","descFull":"Feladat-nyilvánt. A Feladat-nyilvántartás menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Feladat-nyilvánt. Ki * Be Meghatározza, hogy a nyomtató készítsen-e naplót a kapott nyomtatási feladatokról. Nyilvántartási napló készítésének gyakorisága Naponta Hetente Havonta * A naplófájl-létrehozás gyakoriságának beállítása. Naplózási művelet az időköz végén Nincs * Aktuális napló küldése e-mailben Aktuális napló küldése e-mailben, majd törlése Aktuális napló közzététele Aktuális napló küldése, majd törlése Beállítja, hogyan reagáljon a nyomtató, amikor a gyakorisági küszöbérték lejár. A  Nyilvántartási napló készítésének gyakorisága  pontban megadott érték határozza meg, hogy a művelet mikor induljon el. Napló majdnem megtelt szint Be * (5 MB) Ki Meghatározza a naplófájl maximális méretét, mielőtt a nyomtató végrehajtaná a  Naplóművelet majdnem megtelt szintnél  műveletet. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Naplóművelet majdnem megtelt szintnél Nincs * Aktuális napló küldése e-mailben Aktuális napló küldése e-mailben, majd törlése Legrégebbi napló küldése e-mailben, majd törlése Aktuális napló közzététele Aktuális napló küldése, majd törlése Legrégebbi napló küldése, majd törlése Aktuális napló törlése A legrégebbi napló törlése Minden napló törlése, az aktuális kivételével Minden napló törlése Beállítja, hogy hogyan reagáljon a nyomtató, amikor a tárolómeghajtó kezd megtelni. A  Napló majdnem megtelt szintnél  megadott érték meghatározza, hogy a művelet mikor induljon el. Naplóművelet tele szintnél Nincs * Aktuális napló küldése e-mailben, majd törlése Legrégebbi napló küldése e-mailben, majd törlése Aktuális napló küldése, majd törlése Legrégebbi napló küldése, majd törlése Aktuális napló törlése A legrégebbi napló törlése Minden napló törlése, az aktuális kivételével Minden napló törlése Beállítja, hogy hogyan reagáljon a nyomtató, amikor a tárolómeghajtó merevlemez foglaltsága eléri a maximális határértéket (100 MB). URL-cím a napló küldéséhez A beállítás felhasználó által meghatározott. A nyomtató által készített feladat-nyilvántartási naplók küldési helyének beállítása. E-mail-cím a naplók küldéséhez A beállítás felhasználó által meghatározott. Meghatározza azt az e-mail-címet, amelyre a nyomtató a feladatnyilvántartási naplókat küldi. Naplófájl-előtag A beállítás felhasználó által meghatározott. A naplófájlok nevéhez használt előtag megadása. A TCP/IP menüben meghatározott állomásnevet használják alapértelmezett naplófájl-előtagként. menü Feladat-nyilvántartás"},{"UUID":"468b10c6-7d40-47c1-af73-4ff436cd0a0b","title":"Nyomtatás","link":"layout-topic.html","desc":"PDF A PDF menü elemei","descFull":"PDF A PDF menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Lapmérethez igazítás Ki * Be Úgy méretezi az oldal tartalmát, hogy elférjen a kiválasztott méretű papíron. Megjegyzések Nyomtatás Nincs nyomtatás * Azt határozza meg, hogy az eszköz kinyomtassa-e a PDF-ben szereplő megjegyzéseket. PDF-hiba nyomtatása Ki Be * PDF-hiba nyomtatásának engedélyezése. menü PDF"},{"UUID":"7f08d646-20d2-475f-850d-1d06b73f7fa1","title":"Nyomtatás","link":"layout-topic.html","desc":"PostScript PostScript A PostScript menü","descFull":"PostScript PostScript A PostScript menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. PS-hiba nyomtatása Ki * Be PostScript® emulációs hibát tartalmazó tesztoldal kinyomtatása. Hiba esetén a nyomtatási feladat feldolgozása szünetel, a nyomtató hibaüzenetet nyomtat és a nyomtatási feladat többi részét továbbítja. Minimális vonalvastagság 1–30  (2*) Minimális leütési szélesség beállítása. Az 1200 dpi felbontásban nyomtatott feladatok a teljes értéket használják. PS-indítási mód zárolása Ki Be * A SysStart fájl letiltása. A SysStart fájl engedélyezése biztonsági kockázatot jelent a nyomtató vagy a hálózat számára. Képsimítás Ki * Be Az alacsony felbontású képek kontrasztjának és élességének javítása. Ez a beállítás nincs hatással a legalább 300 dpi felbontású képekre. A betűtípusok prioritása Beépített * Flash/lemez Megadja a betűtípusok keresési sorrendjét. Ha a  Beépített  beállítást választja, a nyomtató először a saját memóriájában próbálja megkeresni a kért betűtípust, és csak utána a tárolómeghajtón. Ha a  Flash-meghajtó/lemez  beállítást választja, a nyomtató először a tárolómeghajtón próbálja megkeresni a kért betűtípust, és csak utána a saját memóriájában. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Várakozási időtúllépés Ki Be * Engedélyezi, hogy a nyomtató további adatokra várjon, mielőtt törölné a nyomtatási feladatot. Ha a  Be  beállítást választja, a gyári alapértelmezett érték 40 másodperc. menü PostScript"},{"UUID":"7708def7-9dc0-4514-83d8-03c567a97394","title":"Nyomtatás","link":"layout-topic.html","desc":"PCL Az PCL menü elemei","descFull":"PCL Az PCL menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Betűtípus forrása Beépített * Lemez Letöltés Flash Betűtípus kártya Mind Kiválasztja azt a forrást, amely az alapértelmezett betűkészletet tartalmazza. A  Lemez  csak akkor jelenik meg, ha egy nem hibás, nem olvasás- és írásvédett, betűtípusokat tartalmazó merevlemez van telepítve. A  Letöltés  csak akkor jelenik meg, ha a nyomtató memóriájában letöltött betűkészletek vannak. A  Flash  csak akkor jelenik meg, ha egy nem hibás, nem olvasás- és írásvédett, betűtípusokat tartalmazó flash-memória van telepítve. A  Betűtípuskártya csak akkor jelenik meg, ha érvényes betűtípuskártya van telepítve, vagy intelligens tárolómeghajtó van konfigurálva. Betűtípus neve [Elérhető betűtípusok listája] ( Courier *) Betűtípus kiválasztása a megadott betűtípusforrásból. Szimbólumtábla [Elérhető szimbólumtáblák listája] ( 10U PC‑8 *) Megadja az egyes betűtípusnevekhez tartozó jelkészletet. A jelkészlet egy betűkből és számokból, írásjelekből és különleges szimbólumokból álló készlet. A jelkészletek támogatják az egyes nyelveket, illetve a különleges alkalmazásokat, pl. a matematikai szimbólumokat tudományos szövegekben. Alapméret 0.08–100.00  (10.00*) Megadja a rögzített vagy az egy szélességű betűtípusok betűtávolságát. Ez a menüelem a rögzített szélességű betűtípusok számát jelöli hüvelykenként. Tájolás Álló * Fekvő Fordított álló Fordított fekvő Megadja a szöveg és grafika tájolását az oldalon. Sor/oldal 1–255 Megadja a PCL® adatfolyamon keresztül nyomtatott oldalon megjelenő szövegsorok számát. Ez a menüelem függőleges térközt aktivál, amely a megadott számú nyomtatandó sorokat az oldal alapértelmezett margói közé nyomtatja. Az egyesült államokbeli gyári alapértelmezett érték a 60. A nemzetközi gyári alapértelmezett érték 64. PCL5 minimális vonalvastagság 1–30  (2*) Az 1200 dpi felbontásban, a vonatkozó emulátoron keresztül nyomtatott feladatok során használt kezdeti minimális leütési szélességérték beállítása. PCLXL minimális vonalvastagság 1–30  (2*) A4-es szélesség 198 mm* 203 mm Az A4-es papírméretben való nyomtatás esetén használandó logikai oldalszélesség beállítása. A logikai oldal a fizikai lap azon területe, amelyre az adat nyomtatásra kerül. CR automatikusan LF után Be Ki * Azt állítja be, hogy a nyomtató automatikusan hajtson-e végre egy „kocsi vissza” műveletet a soremelés vezérlőparancs után. A „kocsi vissza” művelet parancsot ad a nyomtatónak arra, hogy a kurzort az aktuális sor első pozíciójába állítsa. LF automatikusan CR után Be Ki * Azt állítja be, hogy a nyomtató automatikusan szúrjon-e be egy soremelést minden „kocsi vissza” vezérlőparancs után. Tálcaátszámozás MP-adagoló hozzárendelése [x].  tálca hozzárendelése Kézi papíradagoló hozzárendelése Kézi borítékadagoló hozzárendelése Azt állítja be, hogy a nyomtató olyan más nyomtató-illesztőprogrammal vagy egyedi alkalmazásokkal is működjön-e együtt, amelyek különböző forráshozzárendelés-készleteket használnak egy adott papírforráshoz. Válasszon az alábbi beállítások közül: Ki * – A nyomtató a gyári alapértelmezett papírforrás-hozzárendelést használja. Nincs  – A papírforrás figyelmen kívül hagyja a Papíradagolás választása parancsot. 0–199  – Számérték megadása egyéni papírforrásérték hozzárendeléséhez. Gyári beállítások megtekintése Az egyes papírforrásokhoz hozzárendelt gyári alapértelmezett érték megjelenítése. Alapbeállítások visszaállítása A tálca visszaállításával az értékek visszaállnak a gyári alapértelmezettre. Nyomtatási időtúllépés Ki Be * (90) Beállíthatja, hogy a nyomtató fejezze be a nyomtatási feladatot, ha az megadott ideig készenlétben volt. menü PCL"},{"UUID":"df1f14b5-ba90-4053-996a-0d0bb420531d","title":"Nyomtatás","link":"layout-topic.html","desc":"Kép A Kép menü elemei","descFull":"Kép A Kép menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Auto. igazítás Be Ki * A képhez legjobban illő papírméret és tájolás kiválasztása az elérhető lehetőségek közül. Ha a  Be  beállítást választotta, ez felülírja a képre vonatkozó átméretezési és tájolási beállításokat. Megfordítás Ki * Be Felcseréli a feketét és a fehéret a fekete-fehér képeken. Ez a menüpont a GIF és a JPEG formátumú képekre nem lesz érvényes. Átméretezés Legjobb illesztés * Bal f. sarok rögz. Középpont rögz. Mag./szél. ig. Magasság igazítása Szélesség igazítása A kép igazítása úgy, hogy illeszkedjen a nyomtatási területhez. Ha az  Automatikus kitöltés Be  van kapcsolva, az  Átméretezés  értéke automatikusan  Legjobb kitöltésre  vált. Tájolás Álló * Fekvő Fordított álló Fordított fekvő Megadja a szöveg és grafika tájolását az oldalon. menü Kép"},{"UUID":"c18e7494-c5de-4cff-a3f2-28dbb4662659","title":"Papír","link":"tray-configuration-topic.html","desc":"Tálcakonfiguráció A Tálca konfiguráció menü","descFull":"Tálcakonfiguráció A Tálca konfiguráció menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Alapértelmezett forrás N/A [x].  tálca  (1*) Többcélú adagoló Kézi papíradagolás Manuális borítékadagolás Alapértelmezett papírforrás beállítása mindegyik nyomtatási feladathoz. Papírméret/-típus [x].  tálca Többcélú adagoló Kézi papíradagolás Manuális borítékadagolás Méret Típus Az egyes papírforrásokba töltött papír méretének vagy típusának beállítása. Csereméret N/A Ki Statement/A5 Letter/A4 11 x 17/A3 Mindegyik * Ezzel a funkcióval beállíthat egy papírméretet, amelyet a nyomtató akkor fog használni, ha a papírforrásban nincs a kért méretű papírból. Ki  – a felhasználó üzenetet kap a kívánt papírméret betöltésére. Az  Összes felsorolt  az összes elérhető cserét lehetővé teszi. MP konfigurálása N/A Kazetta * Kézi Első A többcélú adagoló viselkedésének meghatározása. A  Kazetta  a többcélú adagolót állítja be automatikus papírforrásként. A  Kézi  csak a kézi adagolású nyomtatási feladatoknál állítja be a többcélú adagolót. Az  Első  a többcélú adagolót állítja be elsődleges papírforrásként. menü Tálcakonfiguráció"},{"UUID":"4017d3e4-fae5-4b05-856b-c2f68724ded4","title":"Papír","link":"tray-configuration-topic.html","desc":"Hordozókonfiguráció A Hordozókonfiguráció menü elemei","descFull":"Hordozókonfiguráció A Hordozókonfiguráció menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Mértékegységek N/A Hüvelyk Milliméter Az univerzális papírmérethez használt mértékegység meghatározása. A gyári alapértelmezett érték az USA-ban a  hüvelyk . A gyári alapértelmezett érték világszerte a  milliméter . Univerzális beállítás Minden bemeneti tálca Álló lapszélesség Az univerzális papírméret szélességének beállítása álló tájolás esetén. Álló lapmagasság Az univerzális papírméret magasságának beállítása álló tájolás esetén. Betöltési irány  ( rövid él *) Azt határozza meg, hogy a nyomtató a hosszú vagy a rövid oldal irányából kezdje el felvenni a lapokat. A  Hosszú oldal  lehetőség csak akkor látható, ha a leghosszabb oldal rövidebb, mint a támogatott maximális lapszélesség. Egyéni beolvasási méretek A szkennelési méret neve A beállítás felhasználó által meghatározott. Adjon nevet az egyéni beolvasásnak. Szélesség 1–8.5 hüvelyk  (8,5*) 25–215,9 mm  (215,9*) Adja meg az eredeti dokumentum szélességét. Magasság 1–25 hüvelyk  (11*) 25–635 mm  (279,4*) Adja meg az eredeti dokumentum magasságát. Tájolás Álló * Fekvő Megadhatja az eredeti dokumentum tartalmának tájolását. 2 beolvasás oldalanként Ki * Be Állítsa be a beolvasások alapértelmezett számát a nyomtató mindkét oldalán. Médiatípus beállítása [Papírtípusok listája] Felület Súly Betöltési tájolás Küldés a rekeszbe A papír anyagát, súlyát és tájolását határozza meg. menü Hordozókonfiguráció"},{"UUID":"3af20679-cc65-4fe2-bf83-2e677cf00e9f","title":"Papír","link":"tray-configuration-topic.html","desc":"Rekeszkonfiguráció A Rekeszkonfiguráció menü elemei","descFull":"Rekeszkonfiguráció A Rekeszkonfiguráció menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Kimeneti rekesz Normál rekesz * [X].  rekesz A nyomtatási feladatok kimeneti rekeszének megadása. Rekeszek konfigurálása Elosztó * Összekapcsolás Kiegészítő tárolókapcsolás Típus-hozzárendelés A kimeneti rekeszek működési módjának konfigurálása. A  Postaláda  lehetővé teszi a normál és bármely külön megvásárolható rekesz külön-külön történő kiválasztását. A  Kapcsolás  lehetővé teszi az összes kimeneti rekeszt összekapcsolását, mintha egyetlen nagy rekesz lenne. Az  Opciókapcsolás  az összes külön megvásárolható rekeszt egyetlen nagy kimeneti rekeszként kezeli. A  Típus hozzárendelése  minden papírtípushoz hozzárendel egy rekeszt vagy egy összekapcsolt rekeszkészletet. Egyéni rekesznevek Normál rekesz [X].  rekesz Adjon nevet minden egyes rekeszhez. menü Rekeszkonfiguráció"},{"UUID":"70ac8cad-2861-4699-a1c6-af254d33977a","title":"Másolás","link":"copy-defaults-topic.html","desc":"Másolási alapbeállítások  A Másolási","descFull":"Másolási alapbeállítások  A Másolási alapbeállítások menü elemei és leírásuk Menüelem Almenüelemek Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Tartalom típusa N/A Szöveg Szöveg/fénykép * Fénykép Grafika A kimeneteli fájl minőségének javítása az eredeti dokumentum tartalmának használatával. Tartalom forrása N/A Monokróm lézer Színes lézer * Tintasugaras Fénykép/film Magazin Újság Sajtótermék Egyéb A kimeneteli fájl minőségének javítása az eredeti dokumentum forrásának használatával. Oldalak N/A Egyoldalas egyoldalassá * Egyoldalas kétoldalassá Kétoldalas egyoldalassá Kétoldalas kétoldalassá A beolvasás módjának beállítása az eredeti dokumentum alapján. Elválasztólapok N/A Nincs * Példányok között Feladatok között Oldalak között Azt határozza meg, hogy a rendszer illesszen-e be üres elválasztólapokat a nyomtatás során. Elválasztólap forrása N/A [x].  tálca  (1*) Többcélú adagoló Adja meg az elválasztó lap papírforrását. Színes N/A Ki Be * Automatikus Úgy állítja be a nyomtatót, hogy színes kimenetet hozzon létre a beolvasási feladatból. Oldal/lap N/A Ki * 2 álló oldal 4 álló oldal 2 fekvő oldal 4 fekvő oldal Azt adja meg, hogy az eszköz hány oldalképet nyomtasson a papír egyik oldalára. Oldalhatárok nyomtatása N/A Ki * Be Oldalszegély elhelyezése az egyes képek köré, ha egy oldalra több oldalt nyomtat. Leválogatás N/A Ki [1,1,1,2,2,2] Be [1, 2, 1, 2, 1, 2] * Több példány nyomtatása egymás után. Oldalak eltolása N/A Nincs * Példányok között Feladatok között Az egyes nyomtatási feladatok, vagy az azokból származó egyes példányok kimenetének eltolása. Ha a  Példányok  között beállítást választja, a rendszer a nyomtatási feladat minden példányát eltolja, ha a  Leválogatás  beállításnál a  Be [1,2,1,2,1,2]  értéket választotta. Ha a  Leválogatás  beállításnál a  Ki [1, 1, 1, 2, 2, 2]  értéket választotta, akkor a rendszer készletenként tolja el az oldalakat (azaz az összes első oldalt, az összes második oldalt stb.). A  Feladatok között  lehetőség ugyanazt az eltolási helyzetet állítja be a teljes nyomtatási feladatra, függetlenül a kinyomtatott példányszámtól. Ez a menüelem csak akkor jelenik meg, ha telepítve van kötegelő rendezőtálca vagy kapcsozó kiadóegység. kapcsozás N/A Ki * 1 kapocs, bal felső sarok 2 kapocs, balra 1 kapocs, jobb felső sarok 2 kapocs, fent 1 kapocs, bal alsó sarok 2 kapocs, alul 1 kapocs, jobb alsó sarok 2 kapocs, jobb 4 kapocs A kapcsok helyzetének beállítása az összes nyomtatási feladathoz. Ez a menü csak akkor jelenik meg, ha a kapcsozó kiadóegység telepítve van. Lyukasztás N/A Ki * 2 lyuk 3 lyuk 4 lyuk Lyukassza ki a nyomtatott anyagot. Ez a menü csak akkor jelenik meg, ha van telepítve többpozíciós kapcsozó-lyukasztó kiadóegység. „Másolás innen” mérete [Papírméretek listája] Az eredeti dokumentum papírméretének beállítása. A gyári alapértelmezett érték az USA-ban a  letter  papírméret.  A gyári alapértelmezett érték világszerte az A4 . „Másolás ide” forrása N/A [x].  tálca  (1*) Többcélú adagoló Automatikus méretigazítás A másolási feladatokhoz tartozó papírforrás megadása. Hőmérséklet N/A -4 és 4 között  (0*) Meghatározza, hogy hűvösebb vagy melegebb színű legyen az eredmény. Sötétség N/A 1 és 9 között  (5*) A beolvasott kép sötétségének beállítása. Példányszám N/A 1–9999  (1*) Azt határozza meg, hogy hány fénymásolt példány készüljön. Fejléc/Lábléc N/A Bal fejléc Középső fejléc Jobb fejléc Bal lábléc Középső lábléc Jobb lábléc A fejléc és lábléc adatokat határozza meg a beolvasott képen. Fedvény N/A Bizalmas Másolás Vázlat Sürgős Egyéni Ki * Háttérnyomat szöveg meghatározása az egyes másolatokon. Egyéni háttérnyomat N/A A beállítás felhasználó által meghatározott. Írja be a szöveget az  Egyéni  lehetőséghez a  Háttérnyomat  menüpontban. Speciális képalkotás Színegyensúly Cián–vörös  (0*) Bíbor–zöld  (0*) Sárga–kék  (0*) A ciánkék, bíbor és sárga színintenzitásának beállítása. Színkihagyás Színkihagyás  ( Nincs *) Alapértelmezett vörös szín küszöbérték  (128*) Alapértelmezett zöld szín küszöbérték  (128*) Alapértelmezett kék szín küszöbérték  (128*) Azt határozza meg, hogy a beolvasás során melyik színt kell elhagyni, illetve lehetőséget kínál a színre vonatkozó elhagyási beállítások módosítására. Au. színérzékelés Színérzékenység  (5*) Ter. érzékenység  (5*) Az automatikus színérzékelés beállításának megadása. Kontraszt A tartalomhoz legjobb * 0–5 A beolvasott kép kontrasztjának beállítása. Háttér eltávolítása Háttérérzékelés  ( Tartalomalapú *) Szint  (0*) Eltávolítja a háttérszínt vagy képzajt az eredeti dokumentumból. A  Tartalomalapú  lehetőség eltávolítja a háttérszínt az eredeti dokumentumból. A  Fix  lehetőség eltávolítja a képzajt a fényképről. Automatikus középre igazítás Ki * Be A tartalom középre igazítása az oldalon. Tükörkép Ki * Be Tükörképet készít az eredeti dokumentumról. Inverz kép Ki * Be Negatív képet készít az eredeti dokumentumról. Árnyék részletei -4 és 4 között  (0*) Az árnyék részleteinek beállítása az eredeti dokumentumban. Beolvasás széltől szélig Ki * Be Az eredeti dokumentum beolvasása széltől szélig. Élesség 1–5  (3*) A beolvasott kép élességének beállítása. Rendszergazdai beállítások Színes másolás engedélyezése Ki Be * Színes másolatok létrehozása. Prioritási másolatok engedélyezése Ki Be * Nyomtatási feladat félbeszakítása másolatok készítéséhez. Egyéni feladat beolvasása Ki * Be Úgy állítja be a nyomtatót, hogy az eredeti dokumentumok első készletét a megadott beállításokkal olvassa be, majd a következő készletet ugyanazokkal vagy más beállításokkal olvassa be. Mentés engedélyezése parancsikonként Ki Be * A másolási beállítások mentése parancsikonként. Próbamásolat Ki * Be Egy mintapéldány kinyomtatásával ellenőrzi a minőséget, és csak ezután nyomtatja ki a többi példányt. menü Másolási alapbeállítások"},{"UUID":"1c312b7f-e874-4d19-854e-7bac5407a0a7","title":"Fax Defaults","link":"fax-defaults-subgroup.html","desc":"Fax mód A  Fax","descFull":"Fax mód A  Fax mód  menüelem és leírása Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Fax mód Fax * Faxkiszolgáló Letiltva Válasszon ki egy fax módot. menü Fax mód"},{"UUID":"88783862-a859-4a3e-9c3f-cb9ed3c183e8","title":"Fax Defaults","link":"fax-defaults-subgroup.html","desc":"Fax beállítása Az Általános faxbeállítások","descFull":"Fax beállítása Az Általános faxbeállítások menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Általános faxbeállítások Fax neve A beállítás felhasználó által meghatározott. Határozza meg a faxazonosítót. Faxszám A beállítás felhasználó által meghatározott. Határozza meg a faxszámot. Faxazonosító Fax neve Faxszám * Állítsa be a faxegyeztetés során használt faxazonosítót. Kézi faxolás engedélyezve Ki * Be Kapcsolja be a manuális fax funkciót a nyomtatón. A menüelem használatához vonalmegosztó, illetve kézibeszélős telefon szükséges. A beérkező faxok fogadásához és a faxszámok tárcsázásához használjon hagyományos telefonvonalat. A manuális faxfunkció közvetlen használatához érintse meg a billentyűzet  #  és  0  elemeit. Memóriahasználat Összes fogadott Majdnem fogadott Egyenlő * Nagyrészt küldés Az összes küldés A belső nyomtatómemória mennyiségének beállítása a faxküldéshez. Ez a menüelem megakadályozza a memóriapufferelést, valamint a sikertelen faxküldést. Faxok törlése Engedélyezett * Nem engedélyezett Kimenő vagy bejövő faxok törlése. Faxszám maszkolása Ki * Balról Jobbról A kimenő faxszám maszkolásának formátuma. Általános faxbeállítások Maszkolandó számjegyek 0–58  (0*) Megadja egy kimenő faxszám maszkolandó számjegyeinek a darabszámát. Vonal csatlakoztatva érzékelés engedélyezése Ki Be * A telefonvonal és a nyomtató közötti kapcsolat ellenőrzése. A rendszer azonnal észleli az eseményeket. Vonal a rossz aljzatban érzékelés engedélyezése Ki Be * A telefonvonal és a megfelelő nyomtatóport közötti kapcsolat ellenőrzése. A rendszer azonnal észleli az eseményeket. Mellék használatának megállapítása Ki Be * Annak megállapítása, hogy a telefonvonalat nem használja-e valamilyen másik eszköz, például egy másik telefon. A rendszer azonnal észleli az eseményeket. Faxkompatibilitás optimalizálása A beállítás felhasználó által meghatározott. A nyomtató faxolási funkciójának optimalizálása a más faxokkal való együttműködés érdekében. Faxtovábbítás T.38 Analóg G.711 etherFAX Állítsa be a faxküldés módját. Ez a menüelem csak akkor jelenik meg, ha telepítve van egy etherFAX vagy IP-faxolási licenccsomag a nyomtatón. HTTPS fax beállításai Ez a menü csak akkor jelenik meg, ha a  Faxtovábbítás etherFAX  értékre van állítva. HTTPS szolgáltatás URL-címe A beállítás felhasználó által meghatározott. Határozza meg az etherFAX-szolgáltatás URL-címét. HTTPS proxy A beállítás felhasználó által meghatározott. Határozzon meg egy proxy kiszolgáló URL-címet. HTTPS proxy felhasználója A beállítás felhasználó által meghatározott. Határozza meg a proxy kiszolgáló felhasználónevét és jelszavát. HTTPS proxy jelszava Faxküldés titkosítása Letiltva Engedélyezve * Kötelező Engedélyezze a kimenő faxüzenetek titkosítását. Faxfogadás titkosítása Letiltva Engedélyezve * Kötelező Engedélyezze a bejövő faxüzenetek titkosítását. HTTPS fax állapota A beállítás csak olvasható információ. Az etherFAX kommunikációs állapotának megjelenítése. Faxküldési beállítások Felbontás Normál * Finom Szuperfinom Ultrafinom A beolvasott kép felbontásának beállítása. A magasabb felbontás megnöveli a faxátvitel idejét és több memória szükséges hozzá. Eredeti méret [Papírméretek listája] ( Vegyes méretek *) Az eredeti dokumentum méretének megadása. Tájolás Álló * Fekvő Az eredeti dokumentum tájolásának megadása. Oldalak Ki * Rövid él Hosszú él Az eredeti dokumentum tájolásának meghatározása a dokumentum mindkét oldalának beolvasása esetén. Tartalom típusa Szöveg * Szöveg/fénykép Fénykép Grafika A kimeneteli fájl minőségének javítása az eredeti dokumentum tartalmának használatával. Tartalom forrása Monokróm lézer Színes lézer * Tintasugaras Fénykép/film Magazin Újság Sajtótermék Egyéb A kimeneteli fájl minőségének javítása az eredeti dokumentum forrásának használatával. Sötétség 1–9  (5*) A beolvasott kép sötétségének beállítása. PABX mögött Be Ki * Beállíthatja, hogy a nyomtató a tárcsahangra való várakozás nélkül tárcsázza a faxszámot. A Private Automated Branch Exchange (PABX) egy olyan telefonhálózat, amely egy egyedi hozzáférési kóddal lehetővé teszi a vonal biztosítását kívülről jövő hívások esetén. Hívás módja Hangfrekvencia * Impulzus A ki- és bejövő faxok tárcsázási módjának megadása. Speciális képalkotás Színegyensúly Ciánkék – vörös  (0*) Bíbor – zöld  (0*) Sárga – kék  (0*) Színintenzitás beállítása beolvasás közben. Színkihagyás A tartalomhoz legjobb * 0 1 2 3 4 5 A kimenet kontrasztjának beállítása. Tükörkép Ki * Be Tükörképet készít az eredeti dokumentumról. Árnyék részletei -4 és 4 között  (0*) Megadja, hogy az árnyékok mennyire részletesen jelenjenek meg a beolvasott képen. Beolvasás széltől szélig Ki Be * Engedélyezi az eredeti dokumentum széltől szélig tartó beolvasását. Élesség 1–5  (3*) A beolvasott kép élességének beállítása. Hőmérséklet -4 és 4 között  (0*) Meghatározza, hogy hűvösebb vagy melegebb színű legyen az eredmény. Rendszergazdai beállítások Automatikus újrahívás 0–9  (5*) Adja meg, hogy hány újratárcsázási kísérlet után törölje a nyomtató a faxküldést a megadott célhelyre. Újrahívás gyakorisága 1–200  perc (3*) Az újrahívások között eltelt idő növelésével a sikeres faxküldés esélye is nő. ECM engedélyezése Be * Ki Engedélyezze a hibajavító üzemmódot (ECM) faxműveletek esetén. Az ECM felismeri és kijavítja a vonalzaj és gyenge jelerősség okozta hibákat a faxátviteli folyamat során. Faxbeolvasás engedélyezése Be * Ki Faxok létrehozása a nyomtató lapolvasójával. Faxoláshoz használt illesztőprogram Be * Ki Engedélyezze, hogy a nyomtató illesztőprogramja faxolási feladatokat küldjön. Mentés engedélyezése parancsikonként Be * Ki Faxszámok gyorshívó számokként történő mentése a nyomtatóban. Max. sebesség 33600 * 14400 9600 4800 2400 A faxküldés maximális sebességének beállítása. Egyéni feladat beolvasása Ki * Be Egyéni feladat beolvasásának bekapcsolása alapértelmezésben. Lapolvasási előnézet Ki * Be Beolvasási előnézet megjelenítése a kijelzőn. Automatikus lapadagoló ferdeségének igazítása Ki Be * A beolvasott kép kisebb mértékű ferdeségének kijavítása. Színes faxszkennelés engedélyezése Alapértelmezés szerint kikapcsolva * Alapértelmezés szerint bekapcsolva Soha ne használja Mindig használja Színes faxbeolvasás engedélyezése. Színes faxok auto. átalakítása fekete-fehérré Be * Ki A kimenő faxok fekete-fehérré alakítása. Erősítse meg a faxszámot Ki * Be Azt határozza meg, hogy a rendszer kérje-e meg a felhasználót a faxszám megerősítésére. Előhívószám A beállítás felhasználó által meghatározott. Előhívószám beállítása. Előhívószám-szabályok A beállítás felhasználó által meghatározott. Előhívószám-szabály létrehozása. Faxfogadási beállítások Várakozó faxfeladat Nincs * Festék Tonerkazetta és kellékek Eltávolítja azokat a faxfeladatokat, amelyek külön, rendelkezésre nem álló erőforrásokat igényelnek a nyomtatási sorból. Csengések a válaszig 1–25  (3*) Állítsa be, hogy a nyomtató hány csengetés után fogadja a beérkező hívásokat. Aut. kicsinyítés Be * Ki Beérkező faxok méretének igazítása az oldalhoz. Papírforrás [x].  tálca Auto * A beérkező faxok nyomtatásához használt papírforrás beállítása. Oldalak Be Ki * Nyomtatás a papír mindkét oldalára. Elválasztólapok Nincs * Feladat előtt Feladat után Azt határozza meg, hogy a rendszer illesszen-e be üres elválasztólapokat a nyomtatás során. Elválasztólap forrása [x].  tálca  (1*) Adja meg az elválasztó lap papírforrását. Kimeneti rekesz Normál rekesz Kimeneti rekesz beállítása a fogadott faxokhoz. Faxlábléc Be Ki * Az átviteli adatokat a beérkező fax oldalainak aljára nyomtatja. Faxlábléc időbélyegző Fogadás * Nyomtatás Az időbélyegzőket a beérkező fax oldalainak aljára nyomtatja. Faxok felfüggesztése Függő faxok üzemmód  (Ki*) Lehetővé teszi a nyomtató számára, hogy visszatartsa a beérkezett faxok nyomtatását, amíg azok tartása megszűnik. Faxvárakoztatási ütemezés Ütemezés beállítása a faxok tartásához. Ez a menüelem csak akkor jelenik meg, ha a  Függő faxok üzemmód  az  Ütemezett  lehetőségre van állítva. Rendszergazdai beállítások Faxfogadás engedélyezése Be * Ki A nyomtató beállítása a faxok fogadására. Színes faxok fogadásának engedélyezése Be * Ki A nyomtató beállítása a színes faxok fogadására. Hívófél-azonosító engedélyezése Be Ki * A bejövő hívás hívóazonosítójára vonatkozó információk megjelenítése a nyomtató kijelzőjén. Névtelen fax tiltása Be Ki * Faxazonosító nélküli bejövő faxok blokkolása. Tiltott faxszámok listája Tiltott faxszám hozzáadása A letiltani kívánt telefonszámok beállítása. Válasz bekapcsolva Minden csengés * Csak az egycsengéses Csak a kétcsengéses Csak a háromcsengéses Csak egyszeri vagy kétszeri csengés Csak egyszeri vagy háromszori csengés Csak a két- vagy háromcsengéses Egyedi csengőhang beállítása a beérkező faxokhoz. Automatikus válasz Be * Ki A nyomtató beállítása a faxok automatikus fogadására. Kézi válaszkód 0–9  (9*) Írjon be kézzel egy kódot a faxok fogadásához a telefon numerikus billentyűzetén. Ezt a menüelemet abban az esetben kell használni, ha a nyomtató telefonnal osztozik a vonalon. Ezt a menüelemet abban az esetben kell használni, ha a nyomtató be van állítva a faxok manuális fogadására. Fax továbbítása Nyomtatás * Nyomtatás és továbbítás Továbbítás Beállítja, hogy továbbítsa-e a beérkező faxokat. Továbbítás ide 1. cél 2. cél A beérkező faxok továbbítási célhelyének beállítása. Ez a menüelem csak akkor jelenik meg, ha a  Fax továbbítása Nyomtatás és továbbítás  vagy  Továbbítás  értékre van állítva. Max. sebesség 33600 * 14400 9600 4800 2400 A faxátvitel maximális sebességének beállítása. Fax fedőlap Fax fedőlap Alapértelmezés szerint kikapcsolva * Alapértelmezés szerint bekapcsolva Soha ne használja Mindig használja A fax fedőlapjára vonatkozó beállítások megadása. Címzett megjelenítése Ki * Be Feladó megjelenítése Ki * Be Feladó A beállítás felhasználó által meghatározott. Üzenetmező beillesztése Ki * Be Üzenet: A beállítás felhasználó által meghatározott. Logó beillesztése Ki * Be [x]. lábléc beillesztése Ki * Be Lábléc [x] A beállítás felhasználó által meghatározott. Faxnaplózási beállítások Átviteli napló gyakorisága Mindig * Soha Csak hiba esetén Az átviteli napló létrehozási gyakoriságának beállítása. Átviteli napló tevékenység Nyomtatás  ( Be *) E‑mail  ( Ki *) Napló nyomtatása vagy küldése e-mailben a sikeresen elküldött faxok és az átviteli hibák esetén. Fogadási hiba naplója Soha nincs nyomtatás * Nyomtatás hiba esetén Napló nyomtatása faxfogadási hiba esetén. Naplók automatikus nyomtatása Be * Ki Napló nyomtatása minden faxos tevékenység esetén. Naplópapír forrása [x].  tálca  (1*) Megadja a naplók nyomtatásához használt papír forrását. Naplók megjelenítése Távoli fax neve * Tárcsázott szám A feladó azonosítása a távoli fax neve vagy a faxszám alapján. Feladatnapló engedélyezése Be * Ki Az összes faxfeladat összegzésének megtekintése. Hívásnapló engedélyezése Be * Ki A fax híváselőzményeinek megtekintése. Kimeneti rekesz naplózása Normál rekesz * [X].  rekesz Megadja, hogy a nyomtatott naplók melyik kimeneti rekeszbe kerüljenek. Hangszóró-beállítások Hangszórómód Mindig ki * Mindig be Kapcsolódásig A faxhangszóró üzemmódjának beállítása. Hangszóró hangereje Alacsony * Magas A faxhangszóró hangerejének módosítása. Hangszóró hangereje Ki * Be A csengetési hangerő beállításának engedélyezése. VoIP-beállítások VoIP-protokoll SIP * H.323 Állítsa be a Voice over Internet Protocol (VoIP) protokollt. STUN-kiszolgáló A beállítás felhasználó által meghatározott. Adja meg a STUN-kiszolgálót a tűzfalakon való áthatoláshoz. Kényszerített Fax mód Ki Be * VoIP-átjáró átváltása analógról T.38-ra a faxhívás elején. Fax mód késleltetése 0–15  (7*) Késleltetés megadása másodpercekben másik  Kényszerített Fax módra  való meghívás küldésekor. SIP-beállítások Proxy A beállítás felhasználó által meghatározott. A rendszer IP-címének megadása, amely a fax célhelyeként szolgáló telefonszámot IP-címmé alakítja. Regisztráció A beállítás felhasználó által meghatározott. A rendszer nevének vagy IP-címének megadása, amely a Session Initiation Protocol (SIP) kliensek regisztrációját kezeli. Felhasználó A beállítás felhasználó által meghatározott. A SIP-felhasználó nevének megadása. Jelszó A beállítás felhasználó által meghatározott. A SIP-jegyzékbe való regisztrációhoz használt jelszó megadása. Hitelesítési azonosító A beállítás felhasználó által meghatározott. A regisztráláskor használt felhasználónév. Ha a  hitelesítési azonosító  beállítása nincs megadva, a beállítás a Felhasználó mezőben lévő felhasználónevet fogja használni. Áthelyezés regisztrációhoz UDP * TCP A SIP szállítási típus beállítása a regisztrációhoz. Áthelyezés bejövő hívásokhoz UDP * TCP UDP és TCP A SIP szállítási típus beállítása a bejövő hívásokhoz. Áthelyezés kimenő hívásokhoz UDP * TCP A SIP szállítási típus beállítása a kimenő hívásokhoz. Kimenő proxy A beállítás felhasználó által meghatározott. Kimenő proxy meghatározása az összes SIP-kommunikáció továbbításához. Kapcsolat A beállítás felhasználó által meghatározott. Kapcsolattartó nevének meghatározása a SIP-hez. Tartomány A beállítás felhasználó által meghatározott. Tartománynév meghatározása a SIP-hez. Ha a Tartomány beállítása nincs megadva, a beállítás a  Kapcsolattartó  nevét fogja használni. SIP regisztrációs státusz A beállítás csak olvasható információ. A SIP regisztrálási állapotának megjelenítése. H.323 beállítások Átjáró A beállítás felhasználó által meghatározott. A H.323 átjáró IP-címének megadása. Forgalomirányító A beállítás felhasználó által meghatározott. A H.323 forgalomirányító megadása. Felhasználó A beállítás felhasználó által meghatározott. A H.323 átjárónál használt felhasználónév megadása. Jelszó A beállítás felhasználó által meghatározott. A H.323 átjáró jelszavának megadása. Gyorsindítás engedélyezése Ki * Be Gyorsindítás engedélyezése. H.245-alagút letiltása Ki * Be H.323-alagút letiltása. Forgalomirányító észlelésének letiltása Ki Be * H.323 forgalomirányító észlelésének letiltása. T.38 beállítások Jelzőredundancia 0–5  (3*) A faxjelző ismétlései számának beállítása T.38 kommunikáció esetén. Redundancia kis sebességű adatok esetében 0–5  (3*) A kis sebességű adatok ismétlései számának beállítása T.38 kommunikáció esetén. Redundancia nagy sebességű adatok esetében 0–5  (1*) A nagy sebességű adatok ismétlései számának beállítása T.38 kommunikáció esetén. menü Fax beállítása"},{"UUID":"015f441d-57de-4fbd-9786-a6deaaebb8a4","title":"Fax Defaults","link":"fax-defaults-subgroup.html","desc":"Faxkiszolgáló beállítása Általános faxbeállítások Az","descFull":"Faxkiszolgáló beállítása Általános faxbeállítások Az Általános faxbeállítások menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Címjegyzék formátuma N/A A fax címzettjének megadása. Ha faxszámot szeretne használni, írja be a kettős kereszt (#) karaktert, és írja utána a számot. Válaszcím N/A A faxoláshoz használatos válaszadási cím megadása. Tárgy N/A A fax tárgyának megadása, és az üzenet megkomponálása. Üzenet N/A Analóg fogadás engedélyezése Ki * Be A nyomtató beállítása analóg faxok fogadására. Faxkiszolgáló e-mail-beállításai A Faxkiszolgáló e-mail-beállításai  menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. E-mail SMTP-kiszolgáló használata Be Ki * Faxok küldéséhez és fogadásához használja az e-mailekre vonatkozó Simple Mail Transfer Protocol (SMTP) beállításokat. Ha a  Be  érték van beállítva, a  Faxkiszolgáló e-mail-beállításai  menü egyéb beállításai nem jelennek meg. Elsődleges SMTP-átjáró N/A Adja meg az elsődleges SMTP-kiszolgáló IP-címét vagy állomásnevét. Elsődleges SMTP-átjáró port 1–65535 (25*) Adja meg az elsődleges SMTP-kiszolgáló portszámát. Másodlagos SMTP-átjáró N/A Adja meg a másodlagos vagy tartalék SMTP-kiszolgáló kiszolgálói IP-címét vagy állomásnevét. Másodlagos SMTP-átjáró port 1–65535 (25*) Adja meg a másodlagos vagy tartalék SMTP-kiszolgáló kiszolgálói portszámát. SMTP időtúllépés 5–30 (30*) Azt az időtartamot adja meg, amelynek elteltével a nyomtató megszakítja a kapcsolatot, ha az SMTP-kiszolgáló nem válaszol. Válaszcím N/A A faxoláshoz használatos válaszadási cím megadása. SSL/TLS használata Letiltva * Egyeztetés Kötelező Meghatározza, hogy a rendszer titkosított kapcsolat segítségével küldje-e el a faxokat. Megbízható tanúsítvány szükséges Ki Be * Azt határozza meg, hogy a rendszer kérjen-e megbízható tanúsítványt az SMTP-kiszolgálóhoz való hozzáféréshez. SMTP-kiszolgáló hitelesítése Nem szükséges hitelesítés * Bejelentkezés/normál NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Az SMTP-kiszolgáló hitelesítési típusának beállítása. Eszköz által kezdeményezett e-mail Nincs * Az eszköz SMTP-belépési adatainak használata Azt határozza meg, hogy kérjen-e a rendszer hitelesítő adatokat az eszköz által kezdeményezett e-mailek esetében. Felhasználó által kezdeményezett e-mail Nincs * Az eszköz SMTP-belépési adatainak használata Munkamenet felhasználói azonosítójának és jelszavának használata Munkafolyamati e-mail-cím és jelszó használata Azonosító adatok bekérése Azt határozza meg, hogy kérjen-e a rendszer hitelesítő adatokat a felhasználók által kezdeményezett e-mailek esetében. Active Directory eszközhitelesítő használata Ki * Be Ezzel a funkcióval engedélyezheti a felhasználói hitelesítő adatok és a csoportcélok használatát az SMTP-kiszolgálóhoz való csatlakozáshoz. Eszköz felhasználói azonosítója N/A Az SMTP-kiszolgálóhoz való csatlakozáshoz használandó felhasználói azonosítót és jelszót határozza meg. Eszköz jelszava N/A Kerberos 5 TARTOMÁNY N/A A Kerberos 5 hitelesítési protokoll tartományának meghatározására szolgál. NTLM-tartomány N/A Az NTLM biztonsági protokoll tartománynevének meghatározására szolgál. „Az SMTP-kiszolgáló nincs beállítva” hiba letiltása Ki * Be „Az SMTP-kiszolgáló nincs beállítva” hiba elrejtése. Faxkiszolgáló lapolvasási beállításai A  Faxkiszolgáló beolvasási beállításai  menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Képformátum TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) A beolvasott kép fájlformátumának kiválasztása. Tartalom típusa Szöveg * Szöveg/fénykép Fénykép Grafika A kimeneteli fájl minőségének javítása az eredeti dokumentum tartalmának használatával. Tartalom forrása Monokróm lézer Színes lézer * Tintasugaras Fénykép/film Magazin Újság Sajtótermék Egyéb A kimeneteli fájl minőségének javítása az eredeti dokumentum forrásának használatával. Faxfelbontás Normál * Finom Szuperfinom Ultrafinom A faxok felbontásának beállítása. Oldalak Ki * Rövid él Hosszú él Az eredeti dokumentum tájolásának meghatározása a dokumentum mindkét oldalának beolvasása esetén.   Sötétség 1–9 (5*) A nyomtatott anyag sötétségének beállítása. Tájolás Álló * Fekvő Megadja a szöveg és grafika tájolását az oldalon. Eredeti méret [Papírméretek listája] Az eredeti dokumentum papírméretének beállítása. Egyesült Államok esetén a gyári alapbeállítás a  Vegyes méret . A gyári alapértelmezett érték világszerte az  A4 . Ez a beállítás a nyomtatómodelltől függően változhat. Többoldalas TIFF használata Ki Be * Lehetővé teszi a választást az egyoldalas és a többoldalas TIFF-fájlok között. menü Faxkiszolgáló beállítása"},{"UUID":"3e399b46-683c-4e37-848e-93e238218ace","title":"E-mail","link":"email-setup-topic.html","desc":"E-mail beállítása  Az E-mail","descFull":"E-mail beállítása  Az E-mail beállítása menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Elsődleges SMTP-átjáró A beállítás felhasználó által meghatározott. Adja meg az e-mail küldéshez használt elsődleges SMTP-kiszolgáló IP-címét vagy állomásnevét. Elsődleges SMTP-átjáró port 1–65535 (25*) Adja meg az elsődleges SMTP-kiszolgáló portszámát. Másodlagos SMTP-átjáró A beállítás felhasználó által meghatározott. Adja meg a másodlagos vagy tartalék SMTP-kiszolgáló kiszolgálói IP-címét vagy állomásnevét. Másodlagos SMTP-átjáró port 1–65535  (25*) Adja meg a másodlagos vagy tartalék SMTP-kiszolgáló kiszolgálói portszámát. SMTP időtúllépés 5–30 másodperc  (30*) Azt az időtartamot adja meg, amelynek elteltével a nyomtató megszakítja a kapcsolatot, ha az SMTP-kiszolgáló nem válaszol. Válaszcím A beállítás felhasználó által meghatározott. Válaszcím megadása az e-mailben. Alapértelmezett SMTP-válaszcím használata mindig Be Ki * Mindig használja az alapértelmezett válaszadási címet az SMTP-kiszolgálóban. SSL/TLS használata Letiltva * Egyeztetés Kötelező Meghatározza, hogy a rendszer titkosított kapcsolat segítségével küldje-e el az e-maileket. Megbízható tanúsítvány szükséges Ki Be * Kérjen megbízható tanúsítványt az SMTP-kiszolgálóhoz való hozzáféréshez. SMTP-kiszolgáló hitelesítése Nem szükséges hitelesítés * Bejelentkezés/normál NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Az SMTP-kiszolgáló hitelesítési típusának beállítása. Eszköz által kezdeményezett e-mail Nincs * Nincs * Az eszköz SMTP-belépési adatainak használata Azt határozza meg, hogy kérjen-e a rendszer hitelesítő adatokat az eszköz által kezdeményezett e-mailek esetében. Felhasználó által kezdeményezett e-mail Nincs * Az eszköz SMTP-belépési adatainak használata Munkamenet felhasználói azonosítójának és jelszavának használata Munkafolyamati e-mail-cím és jelszó használata Azonosító adatok bekérése Azt határozza meg, hogy kérjen-e a rendszer hitelesítő adatokat a felhasználók által kezdeményezett e-mailek esetében. Active Directory eszközhitelesítő használata Ki * Be Azt határozza meg, hogy kérjen-e a rendszer hitelesítő adatokat a felhasználók által kezdeményezett e-mailek esetében. Eszköz felhasználói azonosítója A beállítás felhasználó által meghatározott. Az SMTP-kiszolgálóhoz való csatlakozáshoz használandó felhasználói azonosítót és jelszót határozza meg. Eszköz jelszava A beállítás felhasználó által meghatározott. Kerberos 5 TARTOMÁNY A beállítás felhasználó által meghatározott. A Kerberos 5 hitelesítési protokoll tartományának meghatározására szolgál. NTLM-tartomány A beállítás felhasználó által meghatározott. Az NTLM biztonsági protokoll tartománynevének meghatározására szolgál. „Az SMTP-kiszolgáló nincs beállítva.” hiba letiltása Ki * Be „Az SMTP-kiszolgáló nincs beállítva” hiba elrejtése. menü E-mail beállítása"},{"UUID":"26878122-09a2-47d8-b900-dff3fb103a94","title":"E-mail","link":"email-setup-topic.html","desc":"Alapértelmezett e-mail-beállítások  Az Alapértelmezett","descFull":"Alapértelmezett e-mail-beállítások  Az Alapértelmezett e-mail-beállítások menü elemei és leírásuk Menüelem Almenüelemek Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Tárgy: N/A A beállítás felhasználó által meghatározott. Az e-mail tárgyának megadása, és az üzenet megírása. Üzenet: N/A A beállítás felhasználó által meghatározott. Fájlnév N/A A beállítás felhasználó által meghatározott. A beolvasott dokumentum fájlnevének megadása. Formátum N/A JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) A beolvasott dokumentum fájlformátumának meghatározása. A menüelemek a nyomtatómodelltől függően változhatnak. Globális OCR-beállítások Felismert nyelvek [Nyelvlista] Az optikai karakterfelismerés (OCR) beállításainak konfigurálása. Ez a menüelem csak akkor jelenik meg, ha megvásárolt és telepített egy OCR megoldást. Auto. elforg. Ki * Be Fekete pontok eltávolítása Ki * Be Autom. kontr. jav. Ki * Be PDF-beállítások PDF-verzió 1.3 1.4 1.5 * 1.6 1.7 A beolvasott kép PDF-beállításainak konfigurálása. Az  Archív változat  és az  Archiválás (PDF/A)  csak akkor támogatott, ha a  PDF-verzió  1.4-re vagy 1.7-re van beállítva. A  Nagymértékben tömörített  beállítás csak telepített tárolómeghajtó esetén jelenik meg. A  Biztonságos  csak akkor támogatott, ha a  PDF-verzió  1.4-re vagy nagyobbra van beállítva. Archiválás (PDF/A) Ki * Be Archív változat A‑1a * A‑1b A‑2u Nagymértékben tömörített Ki * Be Biztonságos Ki * Be Kereshető Ki * Be Feladat felosztása oldalak szerint 0 * Tartalom típusa N/A Szöveg Szöveg/fénykép * Fénykép Grafika Az eredeti dokumentum tartalmának megadása. Tartalom forrása N/A Fekete-fehér lézer * Színes lézer Tintasugaras Fénykép/film Magazin Újság Sajtótermék Egyéb Az eredeti dokumentum forrásának megadása. Színes N/A Fekete-fehér Szürkeárnyalatos Színes * Automatikus Meghatározza, hogyan kerül rögzítésre az eredeti dokumentum. Felbontás N/A 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi A beolvasott kép felbontásának beállítása. Sötétség N/A 1–9  (5*) A beolvasott kép sötétségének beállítása. Tájolás N/A Álló * Fekvő Az eredeti dokumentum tájolásának megadása. Eredeti méret N/A Vegyes méretek Az eredeti dokumentum papírméretének beállítása. Oldalak N/A Ki * Rövid él Hosszú él Az eredeti dokumentum tájolásának meghatározása a dokumentum mindkét oldalának beolvasása esetén. Speciális képalkotás Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Színegyensúly Cián Bíbor Sárga ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) A ciánkék, bíbor és sárga színintenzitásának beállítása. Színkihagyás Színkihagyás Nincs * Vörös Zöld Kék Azt határozza meg, hogy a beolvasás során melyik színt kell elhagyni, illetve lehetőséget kínál a színre vonatkozó elhagyási beállítások módosítására. Alapértelmezett vörös szín küszöbérték 0–255  (128*) Alapértelmezett zöld szín küszöbérték 0–255  (128*) Alapértelmezett kék szín küszöbérték 0–255  (128*) Au. színérzékelés Színérzékenység 1–9  (5*) Az automatikus színérzékelés beállításának megadása. Ter. érzékenység 1–9  (5*) E-mail bitmélysége 1 bites * 8 bites Minimális beolvasási felbontás 75 dpi 150 dpi 200 dpi 300 dpi * JPEG-minőség N/A A tartalomhoz legjobb * 5–95 A beolvasott kép JPEG-minőségének beállítása. Kontraszt N/A A tartalomhoz legjobb * 0–5 A beolvasott kép kontrasztjának beállítása. Háttér eltávolítása Háttér érzékelése Tartalomalapú * Fix -4 és 4 közötti szint  (0*) Eltávolítja a háttérszínt vagy képzajt az eredeti dokumentumból. Tükörkép N/A Ki * Be Tükörképet készít az eredeti dokumentumról. Inverz kép N/A Ki * Be Negatív képet készít az eredeti dokumentumról. Árnyék részletei N/A -4 és 4 között  (0*) Az árnyék részleteinek beállítása a beolvasott képen. Beolvasás széltől szélig N/A Ki * Be Az eredeti dokumentum beolvasása széltől szélig. Élesség N/A 1–5  (3*) A beolvasott kép élességének beállítása. Hőmérséklet N/A -4 és 4 között  (0*) Az eredeti dokumentum kékebb vagy vörösebb kimenetét hozza létre. Üres oldalak Üres oldal eltávolítása Ne távolítsa el * Eltávolítás Távolítsa el az üres oldalakat az eredeti dokumentumból. Üres oldal érzékelése 1–9  (5*) A beolvasások érzékenységét állítja be az üres oldalakhoz viszonyítva az eredeti dokumentumban. Rendszergazdai beállítások Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. E-mail maximális mérete 0–65535  (0*) Az egyes e-mailek esetében megengedett maximális fájlméret beállítása. Méret-hibaüzenet A beállítás felhasználó által meghatározott. Itt azt választhatja ki, hogy milyen hibaüzenetet küldjön a nyomtató, ha az e-mail meghaladja a megengedett fájlméretet. Legfeljebb 1024 karaktert írhat be. Célok korlátozása A beállítás felhasználó által meghatározott. Ezzel beállíthat egy tartománynévlistát, és megadhatja, hogy a rendszer csak ezekre engedélyezze az e-mailek küldését. Az egyes tartományneveket vesszővel elválasztva adja meg. Más. küld. nekem Soha ne jelenjen meg! * Alapértelmezés szerint bekapcsolva Alapértelmezés szerint kikapcsolva Mindig be Elküldi az e-mail másolatát Önnek is. Csak saját e-mailek engedélyezése Ki * Be Ezzel a funkcióval beállíthatja, hogy a nyomtató csak Önnek küldjön e-maileket. Másolat/Titkos másolat használata: Ki * Be A „másolatot kap” és a „titkos másolat” funkciók engedélyezése az e-mailekben. Többoldalas TIFF használata Ki * Be Egyetlen TIFF-fájlban több TIFF-kép beolvasásának engedélyezése. TIFF-tömörítés JPEG LZW * A TIFF-fájlok tömörítési típusának meghatározása. Szöveg mód alapértelmezett értéke 5–95  (75*) A beolvasás alatt lévő tartalomban található szöveg minőségének beállítása. Szöveg/fénykép mód alapértelmezett értéke 5–95  (75*) A beolvasás alatt lévő tartalomban található szöveg és fénykép minőségének beállítása. Fénykép mód alapértelmezett értéke 5–95  (50*) A beolvasás alatt lévő fényképben található szöveg minőségének beállítása. Automatikus lapadagoló ferdeségének igazítása Ki * Be Úgy állítja be a nyomtatót, hogy kiigazítsa az automatikus lapadagolóból beolvasott dokumentumok képeinek ferdeségét. Átviteli napló Napló nyomtatása * Ne nyomtasson naplót Csak a hibák ny. Átviteli napló nyomtatása e-mailes beolvasásokhoz. Naplópapír forrása [x].  tálca  (1*) Többcélú adagoló Megadja a naplók nyomtatásához használt papír forrását. Egyéni feladat beolvasása Ki * Be Úgy állítja be a nyomtatót, hogy az eredeti dokumentumok első készletét a megadott beállításokkal olvassa be, majd a következő készletet ugyanazokkal vagy más beállításokkal olvassa be. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Lapolvasási előnézet Ki Be * Az eredeti dokumentum beolvasási előnézetének megjelenítése. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Mentés engedélyezése parancsikonként Ki Be * E-mail-cím mentése parancsikonként. A következő formában küldött e-mail képek Melléklet * Webes kapcsolat Az e-mailben szereplő képek küldési módjának meghatározása. E-mail adatok visszaállítása a küldés után Ki Be * A Címzett, Tárgy, Üzenet és Fájlnév mezők visszaállítása az alapértelmezett értékekre e-mail küldése után. menü Alapértelmezett e-mail-beállítások"},{"UUID":"4c045b35-e9a4-4869-b269-dfa175820485","title":"E-mail","link":"email-setup-topic.html","desc":"Webes kapcsolat beállítása A Webes","descFull":"Webes kapcsolat beállítása A Webes kapcsolat beállítása menü elemei és leírásuk Menüelem Beállítások Leírás Kiszolgáló A beállítás felhasználó által meghatározott. Az e-mailbe beillesztett képeket tároló kiszolgáló hitelesítési adatainak meghatározása. Bejelentkezés A beállítás felhasználó által meghatározott. Jelszó A beállítás felhasználó által meghatározott. Útvonal A beállítás felhasználó által meghatározott. Fájlnév A beállítás felhasználó által meghatározott. Webes kapcsolat A beállítás felhasználó által meghatározott. menü Webes kapcsolat beállítása"},{"UUID":"08fb11b4-fd01-4127-8120-12fc869d03cc","title":"FTP","link":"ftp-defaults-topic.html","desc":"FTP alapbeállítások  Az FTP-alapbeállítások","descFull":"FTP alapbeállítások  Az FTP-alapbeállítások menü elemei és leírásuk Menüelem Almenüelemek Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Formátum N/A JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) A beolvasott kép fájlformátumának kiválasztása. Globális OCR-beállítások Felismert nyelvek [Nyelvlista] Az optikai karakterfelismerés (OCR) beállításainak konfigurálása. Ez a menü csak akkor jelenik meg, ha megvásárolt és telepített egy OCR megoldást. Auto. elforg. Ki * Be Fekete pontok eltávolítása Ki * Be Autom. kontr. jav. Ki * Be PDF-beállítások PDF-verzió 1.3 1.4 1.5 * 1.6 1.7 A beolvasott kép PDF-beállításainak konfigurálása. Az  Archív változat  és az  Archiválás (PDF/A)  csak akkor támogatott, ha a  PDF-verzió  1.4-re vagy 1.7-re van beállítva. A  Nagymértékben tömörített  beállítás csak telepített tárolómeghajtó esetén jelenik meg. A  Biztonságos  csak akkor támogatott, ha a  PDF-verzió  1.4-re vagy nagyobbra van beállítva. Archiválás (PDF/A) Ki * Be Archív változat A‑1a * A‑1b A‑2u Nagymértékben tömörített Ki * Be Biztonságos Ki * Be Kereshető Ki * Be Feladat felosztása oldalak szerint 0 * Tartalom típusa N/A Szöveg Szöveg/fénykép * Grafika Fénykép A kimeneti eredmény javítása az eredeti dokumentum tartalomtípusa alapján. Tartalom forrása N/A Monokróm lézer Színes lézer * Tintasugaras Fénykép/film Magazin Újság Sajtótermék Egyéb A kimeneteli eredmény javítása az eredeti dokumentum tartalomforrása alapján. Színes N/A Fekete-fehér Szürkeárnyalatos Színes * Automatikus A nyomtató beállítása, hogy színesben vagy fekete-fehérben rögzítse a fájl tartalmát. Felbontás N/A 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi A beolvasott kép felbontásának beállítása. Sötétség N/A 1–9  (5*) A beolvasott kép sötétségének beállítása. Tájolás N/A Álló * Fekvő Az eredeti dokumentum tájolásának megadása. Eredeti méret N/A Vegyes méretek * Az eredeti dokumentum papírméretének beállítása. Oldalak N/A Ki * Hosszú él Rövid él A tájolás meghatározása a dokumentum mindkét oldalának beolvasása esetén. Fájlnév N/A A beállítás felhasználó által meghatározott. A beolvasott kép fájlnevének beállítása. Speciális képalkotás Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Színegyensúly Cián Bíbor Sárga ‑4–4  (0*) ‑4–4  (0*) ‑4–4  (0*) A ciánkék, bíbor és sárga színintenzitásának beállítása. Színkihagyás Színkihagyás Nincs * Vörös Zöld Kék Azt határozza meg, hogy a beolvasás során melyik színt kell elhagyni, illetve lehetőséget kínál a színre vonatkozó elhagyási beállítások módosítására. Alapértelmezett vörös szín küszöbérték 0–255  (128*) Alapértelmezett zöld szín küszöbérték 0–255  (128*) Alapértelmezett kék szín küszöbérték 0–255  (128*) Au. színérzékelés Színérzékenység 1–9  (5*) Az automatikus színérzékelés beállításának megadása. Ter. érzékenység 1–9  (5*) E-mail bitmélysége 1 bites * 8 bites Minimális beolvasási felbontás 75 dpi 150 dpi 200 dpi 300 dpi * JPEG-minőség N/A A tartalomhoz legjobb * 5–95 A beolvasott kép JPEG-minőségének beállítása. Kontraszt N/A A tartalomhoz legjobb * 0–5 A beolvasott kép kontrasztjának beállítása. Háttér eltávolítása Háttér érzékelése Tartalomalapú * Fix -4 és 4 közötti szint  (0*) Eltávolítja a háttérszínt vagy képzajt az eredeti dokumentumból. Tükörkép N/A Ki * Be Tükörképet készít az eredeti dokumentumról. Inverz kép N/A Ki * Be Negatív képet készít az eredeti dokumentumról. Árnyék részletei N/A -4 és 4 között  (0*) Az árnyék részleteinek beállítása a beolvasott képen. Beolvasás széltől szélig N/A Ki * Be Az eredeti dokumentum beolvasása széltől szélig. Élesség N/A 1–5  (3*) A beolvasott kép élességének beállítása. Hőmérséklet N/A -4 és 4 között  (0*) Az eredeti dokumentum kékebb vagy vörösebb kimenetét hozza létre. Üres oldalak Üres oldal eltávolítása Ne távolítsa el * Eltávolítás Távolítsa el az üres oldalakat az eredeti dokumentumból. Üres oldal érzékelése 1–9  (5*) A beolvasások érzékenységét állítja be az üres oldalakhoz viszonyítva az eredeti dokumentumban. Rendszergazdai beállítások Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Szöveg mód alapértelmezett értéke 5–95  (75*) A beolvasott képeken szereplő szöveg minőségének beállítása. Szöveg/fénykép mód alapértelmezett értéke 5–95  (75*) A beolvasott képeken szereplő szöveg és fénykép minőségének beállítása. Fénykép mód alapértelmezett értéke 5–95  (50*) A beolvasott képeken szereplő fénykép minőségének beállítása. Többoldalas TIFF használata Be * Ki Egyetlen TIFF-fájlban több TIFF-kép beolvasásának engedélyezése. TIFF-tömörítés LZW * JPEG A TIFF-fájlok tömörítési típusának meghatározása. Átviteli napló Napló nyomtatása * Ne nyomtasson naplót Csak a hibák ny. Átviteli napló nyomtatása FTP-beolvasásokhoz. Naplópapír forrása [x].  tálca  (1*) Többcélú adagoló Az FTP-naplók nyomtatásához használt papír forrásának megadása. Egyéni feladat beolvasása Ki * Be Úgy állítja be a nyomtatót, hogy az eredeti dokumentumok első készletét a megadott beállításokkal olvassa be, majd a következő készletet ugyanazokkal vagy más beállításokkal olvassa be. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Lapolvasási előnézet Ki Be * Az eredeti dokumentum előnézetének megjelenítése. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Mentés engedélyezése parancsikonként Ki Be * FTP-cím mentése parancsikonként. menü FTP alapbeállítások"},{"UUID":"fbefd38a-d8c8-4a62-8292-632d3192ff4e","title":"USB-meghajtó","link":"flash-drive-scan-topic.html","desc":"Flash-meghajtó beolvasása A Flash-meghajtó vizsgálata","descFull":"Flash-meghajtó beolvasása A Flash-meghajtó vizsgálata menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Formátum N/A JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) * DOCX (.doc) XLSX (.xlsx) CSV (.csv) A beolvasott kép fájlformátumának kiválasztása. A következő lehetőségek csak akkor jelennek meg, ha megvásárolt és telepített egy optikai karakterfelismerési (OCR) megoldást:  TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx)  és  CSV (.csv) . Globális OCR-beállítások Felismert nyelvek [Nyelvlista] Az OCR-beállítások konfigurálása. Ez a menü csak akkor jelenik meg, ha megvásárolt és telepített egy OCR megoldást. Auto. elforg. Ki * Be Fekete pontok eltávolítása Ki * Be Autom. kontr. jav. Ki * Be PDF-beállítások PDF-verzió 1.3 1.4 1.5 * 1.6 1.7 A beolvasott kép PDF-beállításainak konfigurálása. Az  Archiválás (PDF/A)  és az  Archív változat  csak akkor támogatott, ha a  PDF-verzió  1.4-re vagy 1.7-re van beállítva. A  Nagymértékben tömörített  menüelem csak telepített merevlemez esetén jelenik meg. A  Biztonságos  csak akkor támogatott, ha a  PDF-verzió  1.4-re vagy nagyobbra van beállítva. Archiválás (PDF/A) Ki * Be Archív változat A‑1a * A‑1b A‑2u Nagymértékben tömörített Ki * Be Biztonságos Ki * Be Kereshető Ki * Be Tartalom típusa N/A Szöveg Szöveg/fénykép * Fénykép Grafika A kimeneti eredmény javítása az eredeti dokumentum tartalomtípusa alapján. Tartalom forrása N/A Monokróm lézer Színes lézer * Tintasugaras Fénykép/film Magazin Újság Sajtótermék Egyéb A kimeneteli eredmény javítása az eredeti dokumentum tartalomforrása alapján. Színes N/A Fekete-fehér Szürkeárnyalatos Színes * Automatikus A nyomtató beállítása, hogy színesben vagy fekete-fehérben rögzítse a fájl tartalmát. Felbontás N/A 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi A beolvasott kép felbontásának beállítása. Sötétség N/A 1–9  (5*) A beolvasott kép sötétségének beállítása. Tájolás N/A Álló * Fekvő Az eredeti dokumentum tájolásának megadása. Eredeti méret N/A Vegyes méretek * Az eredeti dokumentum papírméretének beállítása. Oldalak N/A Ki * Rövid él Hosszú él Az eredeti dokumentum tájolásának meghatározása a dokumentum mindkét oldalának beolvasása esetén. Fájlnév N/A A beállítás felhasználó által meghatározott. A beolvasott kép fájlnevének beállítása. Speciális képalkotás Színegyensúly Ciánkék  (0*) Bíbor  (0*) Sárga  (0*) A ciánkék, bíbor és sárga színintenzitásának beállítása. Színkihagyás Színkihagyás  ( Nincs *) Alapértelmezett vörös szín küszöbérték  (128*) Alapértelmezett zöld szín küszöbérték  (128*) Alapértelmezett kék szín küszöbérték  (128*) Azt határozza meg, hogy a beolvasás során melyik színt kell elhagyni, illetve lehetőséget kínál a színre vonatkozó elhagyási beállítások módosítására. Au. színérzékelés Színérzékenység  (5*) Ter. érzékenység  (5*) A beolvasás bitmélysége  (1 bit*) Minimális beolvasási felbontás  (300 dpi*) Az automatikus színérzékelés beállításának megadása. JPEG-minőség A tartalomhoz legjobb * 5–95 A beolvasott kép JPEG-minőségének beállítása. Kontraszt A tartalomhoz legjobb * 0–5 A beolvasott kép kontrasztjának beállítása. Háttér eltávolítása Háttérérzékelés  ( Tartalomalapú *) Szint  (0*) Eltávolítja a háttérszínt vagy képzajt az eredeti dokumentumból. Tükörkép Ki * Be Tükörképet készít az eredeti dokumentumról. Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Speciális képalkotás Inverz kép Ki * Be Negatív képet készít az eredeti dokumentumról. Árnyék részletei -4 és 4 között  (0*) Az árnyék részleteinek beállítása a beolvasott képen. Beolvasás széltől szélig Ki * Be Az eredeti dokumentum beolvasása széltől szélig. Élesség 1–5  (3*) A beolvasott kép élességének beállítása. Hőmérséklet -4 és 4 között  (0*) Az eredeti dokumentum kékebb vagy vörösebb kimenetét hozza létre. Üres oldalak Üres oldal eltávolítása  ( Ne távolítsa el *) Üres oldal érzékelése  (5*) A beolvasások érzékenységét állítja be az üres oldalakhoz viszonyítva az eredeti dokumentumban. Rendszergazdai beállítások Szöveg mód alapértelmezett értéke 5–95  (75*) A beolvasott képeken szereplő szöveg minőségének beállítása. Szöveg/fénykép mód alapértelmezett értéke 5–95  (75*) A beolvasott képeken szereplő szöveg és fénykép minőségének beállítása. Fénykép mód alapértelmezett értéke 5–95  (50*) A beolvasott képen szereplő fénykép minőségének beállítása. Többoldalas TIFF használata Ki Be * Egyetlen TIFF-fájlban több TIFF-kép beolvasásának engedélyezése. TIFF-tömörítés JPEG LZW * A TIFF-fájlok tömörítési típusának meghatározása. Egyéni feladat beolvasása Ki * Be Úgy állítja be a nyomtatót, hogy az eredeti dokumentumok első készletét a megadott beállításokkal olvassa be, majd a következő készletet ugyanazokkal vagy más beállításokkal olvassa be. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Lapolvasási előnézet Ki * Be Az eredeti dokumentum beolvasási előnézetének megjelenítése. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Automatikus lapadagoló ferdeségének igazítása Ki Be * Úgy állítja be a nyomtatót, hogy kiigazítsa az automatikus lapadagolóból beolvasott dokumentumok képeinek ferdeségét. menü Flash-meghajtó beolvasása"},{"UUID":"39bd6c5b-1666-4f36-b84b-887b1da06c1b","title":"USB-meghajtó","link":"flash-drive-scan-topic.html","desc":"Nyomtatás flash-meghajtóról A Nyomtatás flash-meghajtóról","descFull":"Nyomtatás flash-meghajtóról A Nyomtatás flash-meghajtóról menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Példányszám 1–9999  (1*) A nyomtatási feladatban szereplő példányszám beállítása. Papírforrás [x].  tálca  (1*) Többcélú adagoló Kézi papíradagolás Manuális borítékadagolás Papírforrás beállítása a nyomtatási feladathoz. Színes Ki Be * Egy fájl színes nyomtatása flash-meghajtóról. Leválogatás Ki [1,1,1,2,2,2] Be [1, 2, 1, 2, 1, 2] * Ha ugyanarról az eredetiről több másolatot is nyomtat, akkor a nyomtató az egyes példányokat összerendezi. Oldalak Egyoldalas * Kétoldalas Meghatározhatja, hogy a nyomtatás a papír egyik vagy mindkét oldalára készüljön. kapcsozás Ki * 1 kapocs, bal felső sarok 2 kapocs, balra 1 kapocs, jobb felső sarok 2 kapocs, fent 1 kapocs, bal alsó sarok 2 kapocs, alul 1 kapocs, jobb alsó sarok 2 kapocs, jobb A kapcsok helyzetének beállítása az összes nyomtatási feladathoz. Ez a menü csak akkor jelenik meg, ha a kapcsozó kiadóegység telepítve van. Lyukasztás Ki * 2 lyuk 3 lyuk 4 lyuk A lyukasztási mód beállítása az összes nyomtatási feladathoz. Ez a menü csak akkor jelenik meg, ha van telepítve többpozíciós kapcsozó-lyukasztó kiadóegység. Oldalak eltolása Nincs * Példányok között Feladatok között Az egyes nyomtatási feladatok, vagy az azokból származó egyes példányok kimenetének eltolása. Ha a  Példányok  között beállítást választja, a rendszer a nyomtatási feladat minden példányát eltolja, ha a  Leválogatás  beállításnál a  Be [1,2,1,2,1,2]  értéket választotta. Ha a  Leválogatás  beállításnál a  Ki [1,1,1,2,2,2]  értéket választotta, akkor a rendszer készletenként tolja el az oldalakat (azaz az összes elsőként megjelölt oldalt, az összes másodikként megjelölt oldalt stb.). A  Feladatok között  lehetőség ugyanazt az eltolási helyzetet állítja be a teljes nyomtatási feladatra, függetlenül a kinyomtatott példányszámtól. Lapozási stílus Hosszú oldal * Rövid él Határozza meg, hogy kétoldalas nyomtatás esetén a papír melyik oldala legyen bekötve. Oldal/lap Ki * 2 oldal/lap 3 oldal/lap 4 oldal/lap 6 oldal/lap 9 oldal/lap 12 oldal/lap 16 oldal/lap Több egy oldalon lévő kép nyomtatása a papír egyik oldalára. Oldal/lap rendelés Vízszintes * Fordított vízszintes Fordított függőleges Függőleges Több, az oldalon lévő kép elrendezésének beállítása az  Oldal/lap  menü használata esetén. Oldal/oldal tájolás Auto * Fekvő Álló Több, az oldalon lévő kép tájolásának beállítása az  Oldal/lap  menü használata esetén. Oldal/lap szegélye Nincs * Halvány Oldalszegély nyomtatása az oldalon lévő képek köré az  Oldal/lap  menü használata esetén. Elválasztólapok Ki * Példányok között Feladatok között Oldalak között Üres elválasztólapok beillesztése a nyomtatás során. Elválasztólap forrása [x].  tálca  (1*) Többcélú adagoló Adja meg az elválasztó lap papírforrását. Üres oldalak Nincs nyomtatás * Nyomtatás Üres oldalak nyomtatása egy nyomtatási feladatban. menü Nyomtatás flash-meghajtóról"},{"UUID":"f93ee12b-8449-4885-a8b1-630b4bdf9ca0","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"Hálózati áttekintés Hálózati áttekintés, menüelemek","descFull":"Hálózati áttekintés Hálózati áttekintés, menüelemek és a leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Aktív adapter Auto * Szabványos hál. Vezeték nélküli A hálózati kapcsolat típusát határozza meg. A  Vezeték nélküli  opció kizárólag vezeték nélküli hálózathoz csatlakoztatott nyomtatóknál áll rendelkezésre. Hálózat állapota A beállítás csak olvasható információ. A nyomtatóhálózat kapcsolódási állapotának megjelenítése. A hálózati állapot megjelenítése a nyomtatón Ki Be * A hálózat állapotának megjelenítése a kijelzőn. Sebesség, kétoldalas A beállítás csak olvasható információ. Az éppen aktív hálózati kártya sebességét jeleníti meg. IPv4 A beállítás csak olvasható információ. IPv4-cím megjelenítése. Összes IPv6-cím A beállítás csak olvasható információ. Összes IPv6-cím megjelenítése. Nyomtatókiszolgáló visszaállítása Indítás A nyomtatóra irányuló aktív hálózati kapcsolatok visszaállítása. Ez a beállítás törli a hálózati konfiguráció összes beállítását. Hálózati feladat időkorlátja Ki Be * (90 másodperc) Beállíthatja azt az időt, ameddig a nyomtató várakozik, mielőtt törölné a hálózati nyomtatási feladatokat. Szalagcímlap Ki Be * Szalagcímlap nyomtatása. PC-re szkennelés porttartománya A beállítás felhasználó által meghatározott. Megadja a portokat letiltó tűzfal mögötti nyomtatók érvényes porttartományát. Hálózati kapcsolatok engedélyezése Ki Be * Engedélyezi a nyomtató hálózathoz való kapcsolódását. LLDP engedélyezése Ki * Be A hálózat állapotának megjelenítése a kezdőképernyőn. menü Hálózati áttekintés"},{"UUID":"1d148e9d-3134-43d7-b0f1-d590c267a6ab","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"Vezeték nélküli Ez a menü","descFull":"Vezeték nélküli Ez a menü csak vezeték nélküli hálózathoz csatlakoztatott nyomtatókon vagy vezeték nélküli hálózati adapterrel rendelkező nyomtatómodelleken érhető el.  A Vezeték nélküli menü elemei és azok leírása Menüelem Almenüelem Beállítások Leírás Beállítás a nyomtató kezelőpaneljén Hálózat kiválasztása [Az elérhető vezeték nélküli hálózatok listája] Adja meg a vezeték nélküli hálózatot, amihez a nyomtató csatlakozhat. Wi-Fi hálózat hozzáadása Hálózat neve Hálózati mód  ( Infrastruktúra *) Vezeték nélküli biztonságos mód  ( Letiltva *) Adja meg manuálisan a hálózat nevét és a hálózat típusát. Wi-Fi Protected Setup N/A Gombnyomásos módszer indítása PIN-módszer indítása Hozzon létre egy vezeték nélküli hálózatot, és aktiválja a hálózati biztonság beállítását. A  gombnyomásos módszer  indítása lehetővé teszi a nyomtató csatlakoztatását a vezeték nélküli hálózathoz, ha a nyomtatón és a hozzáférési ponton lévő (vezeték nélküli útválasztó) gombokat a megadott időn belül nyomja meg. A  PIN-kódos  módszer indítása lehetővé teszi a nyomtató csatlakozását a vezeték nélküli hálózathoz, ha a nyomtató PIN-kódját megadja a vezeték nélküli hozzáférési pont beállításainál. Hálózati mód N/A BSS-típus Infrastruktúra * Adja meg a hálózati üzemmódot. Kompatibilitás N/A 802.11b/g/n (2,4 GHz) * 802.11a/b/g/n/ac (2.4GHz/5GHz) 802.11a/n/ac (5GHz) Adja meg a Wi-Fi hálózat vezeték nélküli szabványát. A  802.11a/b/g/n/ac (2,4 GHz/5 GHz)  és  802.11a/n/ac (5 GHz)  csak a Wi-Fi opció telepítése után jelenik meg. Vezeték nélküli biztonságos mód N/A Letiltva * WPA2/WPA – Személyes WPA2 – Személyes WPA3/WPA – Személyes WPA3 – Személyes 802.1x– HATÓKÖR A nyomtató Wi-Fi eszközökre történő csatlakoztatásához állítsa be a biztonságos módot. WPA2/WPA – személyes N/A AES Vezeték nélküli biztonság engedélyezése Wi-Fi-védett hozzáféréssel (WPA). Ez a menüelem csak akkor jelenik meg, ha a  Vezeték nélküli biztonságos mód WPA2/WPA – személyes  módra van állítva. PSK beállítása N/A A beállítás felhasználó által meghatározott. Állítsa be a jelszót a biztonságos Wi-Fi-kapcsolathoz. WPA2 – személyes N/A AES Vezeték nélküli biztonság engedélyezése WPA2 beállítással. Ez a menüelem csak akkor jelenik meg, ha a  Vezeték nélküli biztonságos mód  beállítás a  WPA2 – személyes  lehetőségre van állítva. 802.1x titkosítási mód N/A WPA+ WPA2* A Wi-Fi-biztonság engedélyezése a 802.1x szabványon keresztül. Ez a menüelem csak akkor jelenik meg, ha a  Vezeték nélküli biztonságos mód  beállítás a  802.1x - RADIUS  (802.1x – Hatókör) lehetőségre van állítva. A  802.1x - RADIUS  szolgáltatást csak az Embedded Web Serveren keresztül lehet módosítani. IPv4 DHCP engedélyezése Be * Ki Engedélyezze és konfigurálja az IPv4-beállításokat a nyomtatón. Statikus IP-cím beállítása IP-cím Hálózati maszk Átjáró IPv6 IPv6 engedélyezése Be * Ki Engedélyezze és konfigurálja az IPv6-beállításokat a nyomtatón. DHCPv6 enged. Be Ki * Állapotmentes automatikus címkonfiguráció Be * Ki DNS-kiszolgálócím A beállítás felhasználó által meghatározott. Manuálisan kirendelt IPv6-cím A beállítás felhasználó által meghatározott. Manuálisan kirendelt IPv6-útválasztó A beállítás felhasználó által meghatározott. Cím előtagja A beállítás felhasználó által meghatározott. Összes IPv6-cím A beállítás felhasználó által meghatározott. Összes IPv6-útválasztócím A beállítás felhasználó által meghatározott. Hálózati cím N/A UAA LAA A hálózati címek megtekintése. PCL SmartSwitch N/A Ki Be * Beállíthatja, hogy a nyomtató az alapértelmezett nyomtatónyelvtől függetlenül átváltson-e PCL-emulációra, amikor egy nyomtatási feladathoz arra van szükség. Ha a  PCL SmartSwitch Ki  van kapcsolva, a nyomtató nem vizsgálja meg a bejövő adatokat, és a  Beállítás  menüben megadott alapértelmezett nyomtatónyelvet használja. PS SmartSwitch N/A Ki Be * Beállíthatja, hogy a nyomtató az alapértelmezett nyomtatónyelvtől függetlenül átváltson-e PS-emulációra, amikor egy nyomtatási feladathoz arra van szükség. Ha a  PCL SmartSwitch Ki  van kapcsolva, a nyomtató nem vizsgálja meg a bejövő adatokat, és a  Beállítás  menüben megadott alapértelmezett nyomtatónyelvet használja. Pufferhasználat N/A Be Ki * A nyomtatási feladatokat nyomtatás előtt ideiglenesen tárolja a tárolómeghajtón. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolóeszköz. Mac bináris PS N/A Auto * Be Ki Beállítja, hogy a nyomtató Macintosh rendszerbeli bináris PostScript emulációs nyomtatási feladatokat dolgozzon fel. A  Be  beállítás feldolgozza a nyers bináris PostScript emulációs nyomtatási feladatokat. A  Ki  beállítás normál protokollt használva szűri a nyomtatási feladatokat. menü Vezeték nélküli"},{"UUID":"7764f9e6-487c-4d3e-b9f6-5b57d9be9404","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"Wi-Fi Direct A Wi-Fi Direct","descFull":"Wi-Fi Direct A Wi-Fi Direct menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Wi‑Fi Direct engedélyezése Be Ki * Állítsa be a nyomtatót, hogy közvetlenül kapcsolódhasson a Wi-Fi-eszközökre. Wi-Fi Direct név A beállítás felhasználó által meghatározott. Adja meg a Wi-Fi Direct hálózat nevét. Wi-Fi Direct jelszó A beállítás felhasználó által meghatározott. A Wi-Fi-kapcsolat felhasználóinak hitelesítésére és ellenőrzésére szolgáló jelszó megadása. Jelszó megjelenítése a Beállítások oldalon Ki Be * A  Wi-Fi Direct jelszó  megjelenítése a  Hálózati beállítások oldalán . Preferált csatornaszám 1–11 Auto * Állítsa be a Wi-Fi-hálózat kívánt csatornáját. Csoporttulajdonos IP-címe A beállítás felhasználó által meghatározott. A csoporttulajdonos IP-címének megadása. A nyomógombkérések automatikus elfogadása Ki * Be A hálózati csatlakozási kérések automatikus elfogadása. Az ügyfelek automatikus elfogadása nem biztonságos. menü Wi-Fi Direct"},{"UUID":"bfa89f3c-7094-447a-b7b5-36dc898c7681","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"Mobilszolgáltatás-kezelő A Mobilszolgáltatás-kezelő menü elemei","descFull":"Mobilszolgáltatás-kezelő A Mobilszolgáltatás-kezelő menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. IPP nyomtatás engedélyezése Be * Ki Engedélyezi, hogy egy hálózati nyomtató az IPP (Internet Printing Protocol) használatával nyomtathasson. IPP faxolás engedélyezése Be * Ki Engedélyezi, hogy egy USB-nyomtató IPP használatával faxfeladatokat küldjön. IPP engedélyezése USB-n keresztül Be * Ki Engedélyezi, hogy egy USB-nyomtató IPP használatával feladatokat nyomtasson. Az IPP-t általánosan hálózati nyomtatókhoz tervezték. Beolvasás engedélyezése Be * Ki Engedélyezi, hogy egy hálózati nyomtató eSCL-protokollt használó nyomtatási feladatokat nyomtasson. Mopria észlelés engedélyezése Be * Ki Lehetővé teszi a mobileszközök számára a Mopria™ tanúsítvánnyal rendelkező nyomtatók felismerését. menü Mobilszolgáltatás-kezelő"},{"UUID":"2627e79e-bb62-43df-b2af-4f8bafd62019","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"Ethernet Az Ethernet menü elemei","descFull":"Ethernet Az Ethernet menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Hálózati sebesség N/A A beállítás csak olvasható információ. Az aktív hálózati adapter sebességét jeleníti meg. IPv4 DHCP engedélyezése Be * Ki Az IPv4 beállítások konfigurálása. A beállítások felhasználó által meghatározottak. Statikus IP-cím beállítása IP-cím Hálózati maszk Átjáró IPv6 IPv6 engedélyezése Be * Ki Az IPv6 beállítások konfigurálása. DHCPv6 enged. Ki * Be Állapotmentes automatikus címkonfiguráció Be * Ki DNS-kiszolgálócím A beállítás felhasználó által meghatározott. Manuálisan kirendelt IPv6-cím A beállítás felhasználó által meghatározott. Manuálisan kirendelt IPv6-útválasztó A beállítás felhasználó által meghatározott. Cím előtagja (64*) 0–128  (64*) Összes IPv6-cím A beállítás csak olvasható információ. Összes IPv6-útválasztócím A beállítás csak olvasható információ. Hálózati cím N/A UAA LAA A hálózati cím meghatározása. PCL SmartSwitch N/A Ki Be * Beállíthatja, hogy a nyomtató az alapértelmezett nyomtatónyelvtől függetlenül átváltson-e PCL-emulációra, amikor egy nyomtatási feladathoz arra van szükség. Ha ez a beállítás le van tiltva, akkor a nyomtató nem vizsgálja meg a bejövő adatokat, és a  Beállítás  menüben megadott alapértelmezett nyomtatónyelvet használja. PS SmartSwitch N/A Ki Be * Beállíthatja, hogy a nyomtató az alapértelmezett nyomtatónyelvtől függetlenül átváltson-e automatikusan a PostScript emulációra, amikor egy nyomtatási feladathoz arra van szükség. Ha ez a beállítás le van tiltva, akkor a nyomtató nem vizsgálja meg a bejövő adatokat, és a  Beállítás  menüben megadott alapértelmezett nyomtatónyelvet használja. Pufferhasználat N/A Ki * Be A feladatokat nyomtatás előtt ideiglenesen tárolja a tárolómeghajtón. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Mac bináris PS N/A Auto * Ki Be Beállítja, hogy a nyomtató Macintosh rendszerbeli bináris PostScript emulációs nyomtatási feladatokat dolgozzon fel. Az  Automatikus  beállítással a nyomtató Windows vagy Macintosh operációs rendszert futtató számítógépekről származó nyomtatási feladatokat dolgoz fel. A  Ki  beállítás normál protokollt használva szűri a PostScript emulációs nyomtatási feladatokat. Energiahatékony Ethernet N/A Be Ki Auto * Csökkenti az energiafelhasználást, amikor a nyomtató nem kap adatokat az Ethernet-hálózatból. menü Ethernet"},{"UUID":"96aebb01-0774-4b09-83d9-bb68656fb29a","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"TCP/IP Ez a menü csak","descFull":"TCP/IP Ez a menü csak a hálózati nyomtatók, illetve a nyomtatókiszolgálókhoz csatlakoztatott nyomtatók esetében jelenik meg. A TCP/IP menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Állomásnév beállítása A beállítás felhasználó által meghatározott. Itt állíthatja be az aktuális TCP/IP-állomásnevet. Tartománynév A beállítás felhasználó által meghatározott. Állítsa be a tartománynevet. DHCP/BOOTP engedélyezése az NTP-kiszolgáló frissítéséhez Be * Ki A nyomtató NTP-beállításai frissítésének engedélyezése DHCP (Dynamic Host Configuration Protocol) és BOOTstrap (BOOTP) kliensek számára. Zero Configuration-név A beállítás felhasználó által meghatározott. Szolgáltatásnév megadása a konfigurációmentes hálózathoz. Enable Auto IP (AutoIP engedélyezése) Ki Be * IP-cím automatikus hozzárendelése. DNS-kiszolgálócím A beállítás felhasználó által meghatározott. Az aktuális Domain Name System (DNS) kiszolgáló címének beállítása. Másodlagos DNS-kiszolgáló címe A beállítás felhasználó által meghatározott. A másodlagos DNS-kiszolgáló címének beállítása. Másodlagos DNS-kiszolgáló címe 2 Másodlagos DNS-kiszolgáló címe 3 Tartománykeresési sorrend A beállítás felhasználó által meghatározott. Egy tartománynévlista beállítása, amely leegyszerűsíti a keresést, ha a nyomtató és erőforrásai a hálózat különböző tartományaiban helyezkednek el. DDNS engedélyezése Ki * Be A Dynamic DNS beállításainak frissítése. DDNS TTL A beállítás felhasználó által meghatározott. A DDNS-beállítások megadása. Alapértelmezett TTL DDNS frissítési ideje mDNS engedélyezése Ki Be * A multicast DNS beállításainak frissítése. WINS-kiszolgálócím A beállítás felhasználó által meghatározott. Kiszolgáló címének beállítása a Windows Internet Name Service (WINS) szolgáltatáshoz. BOOTP engedélyezése Ki * Be A BOOTP engedélyezése a nyomtató IP-címének kiosztásához. Korlátozott kiszolgálólista A beállítás felhasználó által meghatározott. Azoknak az IP-címeknek a megadása, amelyek engedélyt kapnak a nyomtatóval folytatott kommunikációra TCP/IP-n keresztül. Tegyen vesszőt az egyes IP-címek közé. Legfeljebb 50 IP-címet adhat meg. Korlátozott kiszolgálólista beállításai Összes port blokkolása * Csak a nyomtatás blokkolása Csak a nyomtatás és a HTTP blokkolása Az IP-címek a listában nem szereplő hozzáférési lehetőségeinek megadása. MTU 256–1500 Ethernet  (1500*) A maximális átviteli egység (MTU) paraméter beállítása a TCP-kapcsolatokhoz. Nyomtató nyers portja 1–65535  (9100*) A hálózathoz csatlakoztatott nyomtatók nyers portszámának beállítása. Kimenőforgalom maximális sebessége Ki * Be A nyomtató maximális átviteli sebességének beállítása. Bekapcsolása esetén ehhez a beállításhoz a 100–1 000 000 kilobit/másodperc lehetőség tartozik. TLS-támogatás TLSv1.0 engedélyezése  ( Ki *) TLSv1.1 engedélyezése  ( Ki *) TLSv1.2 engedélyezése  ( Be *) A Transport Layer Security protokoll engedélyezése. SSL titkosítási lista A beállítás felhasználó által meghatározott. Adja meg az SSL vagy a TLS csatlakozókon használatos titkosítási algoritmusokat. TLSv1.3 SSL titkosítási lista menü TCP/IP"},{"UUID":"c9815b8f-4735-46d0-8673-08d5c0f84a5a","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"SNMP Ez a menü kizárólag","descFull":"SNMP Ez a menü kizárólag hálózati nyomtatókon, illetve nyomtatókiszolgálóra csatlakoztatott nyomtatókon érhető el. A SNMP menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. SNMP 1 és 2c verziók Engedélyezve Ki Be * Azt határozza meg, hogy a Simple Network Management Protocol (SNMP) 1 és 2c verziója telepítse-e a nyomtató illesztőprogramjait és alkalmazásait. SNMP-beállítás engedélyezése Ki Be * PPM MIB engedélyezése Ki Be * SNMP-közösség A beállítás felhasználó által meghatározott. SNMP 3. verzió Engedélyezve Ki Be * Engedélyezi, hogy az SNMP 3 verzió konfigurálja és frissítse-e a nyomtató biztonsági beállításait. Kontextus neve A beállítás felhasználó által meghatározott. Kontextus nevének megadása. Hitelesítő adatok olvasáshoz/íráshoz Felhasználónév Hitelesítési jelszó: Adatvédelmi jelszó: Az SNMP 3. verzió olvasási és írási hitelesítő adatai. Csak olvasási hitelesítő adatok beállítása Felhasználónév Hitelesítési jelszó: Adatvédelmi jelszó: Az SNMP 3. verzió csak olvasható hitelesítő adatai. Hitelesítési kivonat MD5 SHA1 * A alkalmazandó hitelesítési kivonat beállítása. Minimális hitelesítési szint Nincs hitelesítés, nincs adatvédelem Hitelesítés, nincs adatvédelem Hitelesítés, adatvédelem * Az alkalmazandó minimális hitelesítési szint beállítása. Adatvédelmi algoritmus DES AES‑128 * Az alkalmazandó adatvédelmi algoritmus beállítása. menü SNMP"},{"UUID":"e1c8f4ba-23a1-4046-835c-0dab5c22d73a","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"IPSec Ez a menü kizárólag","descFull":"IPSec Ez a menü kizárólag hálózati nyomtatókon, illetve nyomtatókiszolgálóra csatlakoztatott nyomtatókon érhető el. Az IPSec menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. IPSec engedélyezése Ki * Be Az Internet Protocol Security (IPSec) protokoll engedélyezése. Alapkonfiguráció Alapértelmezett * Kompatibilitás Biztonságos Az IPSec alapkonfigurációjának beállítása. Ez a menüelem csak akkor jelenik meg, ha az  IPSec engedélyezése  lehetőség a  Be  értékre van állítva. DH (Diffie‑Hellman) csoportos javaslat modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Az IPSec alapkonfigurációjának beállítása. Ez a menüelem csak akkor használható, ha az  Alapkonfiguráció  beállítás értéke  Kompatibilitás . Javasolt titkosítási módszer 3DES AES * Titkosítási módszer beállítása. Ez a menüelem csak akkor használható, ha az  Alapkonfiguráció  beállítás értéke  Kompatibilitás . Javasolt hitelesítési módszer SHA1 SHA256 * SHA512 Hitelesítési módszer beállítása. Ez a menüelem csak akkor használható, ha az  Alapkonfiguráció  beállítás értéke  Kompatibilitás . IKE SA élettartam (órában) 1 2 4 8 24 * Adja meg az IKE SA lejárati időtartamát. Ez a menüelem csak akkor jelenik meg, ha az  Alapkonfiguráció  beállítás értéke  Biztonságos . IPSec SA élettartam (órában) 1 2 4 8 24 * Adja meg az IPSec SA lejárati időtartamát. Ez a menüelem csak akkor jelenik meg, ha az  Alapkonfiguráció  beállítás értéke  Biztonságos . IPSec-eszköztanúsítvány alapértelmezett * Az IPSec-tanúsítvány beállítása. Ez a menüelem csak akkor jelenik meg, ha az  IPSec engedélyezése  lehetőség a  Be  értékre van állítva. Előmegosztott kulcs hitelesített kapcsolatai [x]  gazdagép A nyomtató hitelesített kapcsolatainak konfigurálása. Ezek a menüelemek csak akkor jelennek meg, ha az  IPSec engedélyezése  lehetőség a  Be  értékre van állítva. Tanúsítvány hitelesített kapcsolatai [X]  gazdagép címe[/alhálózat] menü IPSec"},{"UUID":"888ccf02-9f7b-4040-a274-dc3a7f22a778","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"802.1x 802.1x Ez a menü","descFull":"802.1x 802.1x Ez a menü kizárólag hálózati nyomtatókon, illetve nyomtatókiszolgálóra csatlakoztatott nyomtatókon érhető el. A 802.1x menü elemei és leírásuk Menüelem Almenüelemek Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Aktív N/A Ki * Be Engedélyezi, hogy a nyomtató olyan hálózatokhoz csatlakozzon, amelyek a hozzáférés engedélyezése előtt hitelesítést kérnek. 802.1x hitelesítés Eszköz bejelentkezési neve A beállítás felhasználó által meghatározott. Adja meg az egyedi bejelentkezési nevet. Eszköz bejelentkezési jelszava A beállítás felhasználó által meghatározott. Adja meg az egyedi jelszót. Kiszolgálói tanúsítvány hitelesítése Be * Ki Ha engedélyezi ezt a beállítást, a biztonsági tanúsítvány ellenőrzését kérheti a hitelesítési kiszolgálón. Eseménynapló bekapcsolása Be Ki * Engedélyezi a nyomtatónak a kapcsolati naplók rögzítését. 802.1x-eszköztanúsítvány alapértelmezett * Válassza ki a használni kívánt digitális tanúsítványt. Ha csak egy tanúsítvány van telepítve, akkor az  alapértelmezett  az egyetlen megjelenő lehetőség.  Hitelesítési mechanizmus EAP-MD5 Be * Ki Az EAP (Extensible Authentication Protocol) MD5 keretrendszer engedélyezése. EAP - MSCHAPv2 Be * Ki Az EAP Microsoft Challenge Handshake Authentication Protocol (MSCHAP) 2. verzió hitelesítési módszer engedélyezése. LEAP Be * Ki A LEAP (Lightweight Extensible Authentication Protocol), az MSCHAP módosított verziójának engedélyezése. PEAP Be * Ki A Protected Extensible Authentication Protocol (PEAP) engedélyezése; ez a módszer biztonságosabb hitelesítést biztosít a 802.11 WLAN-ok számára. A PEAP támogatja a 802.1x porthozzáférés-vezérlést. EAP-TLS Be * Ki Az EAP Transport Layer Security (TLS) protokoll engedélyezése, amelyben a kliens és a kiszolgáló digitális tanúsítványok segítségével hitelesíti egymást. EAP-TTLS Be * Ki Az EAP-alagutas Transport Layer Security (TLS) engedélyezése, amely az EAP_TLS-hez hasonló protokoll, azzal a különbséggel, hogy először csak a kiszolgáló rendelkezik tanúsítvánnyal, hogy hitelesítse magát a kliens felé. TTLS-hitelesítési módszer CHAP MSCHAP MSCHAPv2 * PAP Válassza ki, hogy melyik EAP TTLS-módszert kívánja használni az eszközéhez. menü 802.1x"},{"UUID":"8f5f7c84-6dac-45ee-9f22-4c525f691cbb","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"LPD-konfiguráció Ez a menü kizárólag","descFull":"LPD-konfiguráció Ez a menü kizárólag hálózati nyomtatókon, illetve nyomtatókiszolgálóra csatlakoztatott nyomtatókon érhető el. Az LPD-konfiguráció menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. LPD időtúllépés 0–65535 másodperc  (90*) Ezzel a beállítással megadhat egy időtúllépési értéket, így megakadályozhatja, hogy a Line Printer Daemon (LPD) kiszolgáló határozatlan ideig várjon a megakadt vagy hibás nyomtatási feladatokra. LPD szalagcím-lap Ki * Be Szalagcímlap nyomtatása az összes LPD-s nyomtatási feladat esetében. A szalagcímlap a nyomtatási feladat első oldala, amely a nyomtatási feladatok elválasztására, valamint a nyomtatási kérések küldőjének azonosítására szolgál. LPD lezárólap Ki * Be Lezárólap nyomtatása az összes LPD-s nyomtatási feladat esetében. A lezárólap a nyomtatási feladatok utolsó oldala. LPD kocsi vissza konverzió Ki * Be A kocsivissza-konverzió engedélyezése. A „kocsi vissza” művelet parancsot ad a nyomtatónak arra, hogy a kurzort az aktuális sor első pozíciójába állítsa. menü LPD-konfiguráció"},{"UUID":"3ec94aa0-babf-4bc2-be87-5f9a08378825","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"HTTP-/FTP-beállítások A HTTP/FTP beállítások menü","descFull":"HTTP-/FTP-beállítások A HTTP/FTP beállítások menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Proxy HTPP Proxy IP-cím A beállítás felhasználó által meghatározott. A HTTP-kiszolgáló beállításainak konfigurálása. HTTP alapértelmezett IP-port A beállítás felhasználó által meghatározott. A HTTP alapértelmezett IP-port-címének beállítása. A HTTP gyári alapértelmezett portja a 80. FTP Proxy IP-cím A beállítás felhasználó által meghatározott. Az FTP-beállítások konfigurálása. FTP alapértelmezett IP-port A beállítás felhasználó által meghatározott. Az FTP alapértelmezett IP-port-címének beállítása. A HTTP gyári alapértelmezett portja a 21. Hitelesítés Nincs Auto * Alap Digest NTLM Adja meg a hitelesítési adatokat. Felhasználónév A beállítás felhasználó által meghatározott. Adja meg az egyedi felhasználónevet. Jelszó A beállítás felhasználó által meghatározott. Adja meg az egyedi jelszót. Helyi tartományok A beállítás felhasználó által meghatározott. A HTTP- és az FTP-kiszolgálók tartománynevének megadása. Egyéb beállítások HTTP-kiszolgáló engedélyezése Be * Ki A nyomtató figyelésére és felügyeletére használható Embedded Web Server elérése. HTPPS engedélyezése Be * Ki A biztonságos hiperszöveg-átviteli protokoll (HTTPS) engedélyezése a nyomtatókiszolgáló felé irányuló és onnan származó adatátvitel titkosításához. HTTPS-kapcsolatok kényszerítése Be Ki * A nyomtató kényszerítése a HTTPS-kapcsolatok használatára. FTP/TFTP engedélyezése Be * Ki Fájlok küldése FTP/TFTP használatával. HTTPS-eszköztanúsítvány alapértelmezett * A nyomtatón használt HTTPS-eszköztanúsítvány megtekintése. HTTP/FTP kérések időtúllépése 1–299 másodperc  (30*) Azt az időtartamot határozza meg, amelynek elteltével a rendszer megszakítja a kapcsolódást a kiszolgálóhoz. HTTP/FTP kérések ismétlései 1–299 másodperc  (3*) Azt határozza meg, hogy a rendszer hányszor próbáljon meg csatlakozni a HTTP-/FTP-kiszolgálóhoz. menü HTTP-/FTP-beállítások"},{"UUID":"31949ffc-a964-45d5-b2f3-b26f7ec20a86","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"ThinPrint A ThinPrint menü elemei","descFull":"ThinPrint A ThinPrint menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. ThinPrint engedélyezése Ki * Be Nyomtatás ThinPrint használatával. Portszám 4000–4999  (4000*) A ThinPrint-kiszolgáló portszámának beállítása. Sávszélesség (bit/másodperc) 100–1000000  (0*) A ThinPrint-környezetben használandó adatátviteli sebesség beállítása. Csomagméret (kbyte) 0–64000  (0*) Az adatátviteli csomagok méretének beállítása. menü ThinPrint"},{"UUID":"c48a3211-6e59-440e-85e0-420e15e40a20","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"USB Az USB menü elemei","descFull":"USB Az USB menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. PCL SmartSwitch Ki Be * Beállítja, hogy a nyomtató átváltson-e PCL-emulációra, amikor egy USB-porton érkező nyomtatási feladatnak arra van szüksége, az alapértelmezett nyomtatónyelvtől függetlenül. Ha ez a beállítás le van tiltva, akkor a nyomtató nem vizsgálja meg a bejövő adatokat, és a  Beállítás  menüben megadott alapértelmezett nyomtatónyelvet használja. PS SmartSwitch Ki Be * Beállítja, hogy a nyomtató az alapértelmezett nyomtatónyelvtől függetlenül átváltson-e PostScript emulációra, amikor egy USB-porton érkező nyomtatási feladathoz arra van szükség. Ha ez a beállítás le van tiltva, akkor a nyomtató nem vizsgálja meg a bejövő adatokat, és a  Beállítás  menüben megadott alapértelmezett nyomtatónyelvet használja. Pufferhasználat Ki * Be A feladatokat nyomtatás előtt ideiglenesen tárolja a tárolómeghajtón. Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. Mac bináris PS Auto * Be Ki Beállítja, hogy a nyomtató Macintosh rendszerbeli bináris PostScript emulációs nyomtatási feladatokat dolgozzon fel. Az  Automatikus  beállítással a nyomtató Windows vagy Macintosh operációs rendszert futtató számítógépekről származó nyomtatási feladatokat dolgoz fel. A  Ki  beállítás normál protokollt használva szűri a PostScript emulációs nyomtatási feladatokat. USB-port engedélyezése Ki Be * Engedélyezi az elülső és a hátsó USB-meghajtóportokat. menü USB"},{"UUID":"acfced9a-63a9-426f-873d-e1931e0ce7fa","title":"Hálózat/portok","link":"network-overview-topic.html","desc":"Külső hálózati hozzáférés korlátozása A","descFull":"Külső hálózati hozzáférés korlátozása A Külső hálózati hozzáférés korlátozása menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Külső hálózati hozzáférés korlátozása Ki * Be Korlátozza a hozzáférést a hálózati oldalakhoz. Külső hálózati cím A beállítás felhasználó által meghatározott. Meghatározza a korlátozott hozzáférésű hálózati címeket. E-mail-cím az értesítéshez A beállítás felhasználó által meghatározott. Meghatároz egy e-mail-címet, amelyre a naplózott eseményekről értesítést küld. Pingelés gyakorisága 1–300  (10*) Meghatározza a hálózati lekérés időközeit másodpercben. Tárgy A beállítás felhasználó által meghatározott. Meghatározza az értesítő e-mail tárgyát és tartalmát. Üzenet menü Külső hálózati hozzáférés korlátozása"},{"UUID":"7ee6c815-0153-4352-8483-6c471d5e9e2a","title":"Bejelentkezési módszerek","link":"login-methods-subgroup.html","desc":"Engedélyek kezelése Az Engedélyek kezelése","descFull":"Engedélyek kezelése Az Engedélyek kezelése menü elemei és leírásuk Menüelem Beállítások Leírás Funkció elérése Címjegyzék elérése az alkalmazásokban Címjegyzék módosítása Parancsikonok kezelése Profilok létrehozása Könyvjelzők kezelése Nyomtatás flash-meghajtóról Flash meghajtó színes nyomtatása Flash-meghajtó beolvasása Másolás funkció Színes nyomtatás másolása Színkihagyás E-mail-funkció Fax funkció FTP funkció Felfüggesztett faxüzenetek feloldása Felfüggesztett feladatok elérése Profilok használata Feladatok megszakítása az eszközön Nyelv módosítása Internetes Nyomt. Prot. (IPP) Beolvasás indítása távolról Fekete-fehér nyomtatás Színes nyomtatás Hálózati mappa – Beolvasás Merevlemez – Nyomtatás Merevlemez – Színes nyomtatás Merevlemez – Beolvasás Adja meg a nyomtató azon funkcióit, amelyekhez a felhasználó hozzáférhet. Bizonyos menüpontok csak akkor jelennek meg, ha telepítve van egy tárolómeghajtó. Adminisztrációs menük Biztonság menü Hálózat/portok menü Papír menü Jelentések menü Funkciókonfigurációs menük Kellékanyagok menü Kiegészítő kártya menü SE menü Eszköz menü Adja meg a nyomtató azon menüit, amelyekhez a felhasználó hozzáférhet. Eszközkezelés Távoli kezelés Firmware-frissítések Alkalmazások konfigurálása Kezelőpanelzár Embedded Web Server kiszolgáló hozzáférés Minden beállítás importálása/exportálása Üzemen kívüli törlés Felhőalapú szolgáltatások – regisztráció Adja meg azokat az  eszközkezelési  funkciókat, amelyekhez a felhasználó hozzáférhet. Alkalmazások Új alkalmazások Diavetítés Háttérkép módosítása Képernyővédő Kártya másolása Beolvasási központ [x].  egyéni beolvasási központ A nyomtatóalkalmazásokhoz való hozzáférés szabályozása. menü Engedélyek kezelése"},{"UUID":"7d332b54-14a3-4d69-b547-6f783e504726","title":"Bejelentkezési módszerek","link":"login-methods-subgroup.html","desc":"Helyi fiókok A Helyi fiókok","descFull":"Helyi fiókok A Helyi fiókok menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Csoportok/engedélyek kezelése Csoport hozzáadása A beállítás felhasználó által meghatározott. Adja meg azokat a csoportokat, amelyek hozzáférhetnek a nyomtatófunkciókhoz, a felügyeleti menükhöz, a nyomtatókezelési beállításokhoz és az alkalmazásokhoz. Minden felhasználó Hozzáférés-vezérlők importálása Hozzáférésvezérlők importálása a nyomtatón regisztrált fiókokból. Felhasználó hozzáadása Felhasználónév/Jelszó Felhasználónév Jelszó PIN-kód A beállítás felhasználó által meghatározott. Adjon hozzá egy felhasználót, és adja meg a nyomtatóra való bejelentkezés módját. menü Helyi fiókok"},{"UUID":"0b66a4c6-031c-4110-a478-027c40118bb7","title":"Bejelentkezési módszerek","link":"login-methods-subgroup.html","desc":"Alapértelmezett bejelentkezési módok Ez a","descFull":"Alapértelmezett bejelentkezési módok Ez a menü csak akkor jelenik meg, ha a  Helyi fiókok  menü be van állítva. Az Alapértelmezett bejelentkezési módok menü elemei és leírásuk Menüelem Beállítások Leírás Kezelőpanel Felhasználónév/Jelszó Felhasználónév Jelszó PIN-kód Adja meg az alapértelmezett bejelentkezési módot a kezelőpanelhez való hozzáféréshez. Böngésző Felhasználónév/Jelszó Felhasználónév Jelszó PIN-kód Adja meg az alapértelmezett bejelentkezési módot a böngészőhöz való hozzáféréshez. menü Alapértelmezett bejelentkezési módok"},{"UUID":"1bb78b5a-9111-4b8c-8c0e-a0680e414809","title":"Biztonság","link":"login-methods-subgroup.html","desc":"USB-eszközök ütemezése Az USB-eszközök ütemezése","descFull":"USB-eszközök ütemezése Az USB-eszközök ütemezése menü elemei és leírásuk Menüelem Almenüelemek Beállítások Leírás Ütemezések Új ütemezés hozzáadása Ütemezés mentése Művelet Nap Idő Az elülső USB-porthoz való hozzáférés ütemezése. menü USB-eszközök ütemezése"},{"UUID":"efca81aa-fd16-44c3-947d-7006174ca8b2","title":"Biztonság","link":"login-methods-subgroup.html","desc":"Biztonsági ellenőrzési napló A Biztonsági","descFull":"Biztonsági ellenőrzési napló A Biztonsági ellenőrzési napló menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Ellenőrzés engedélyezése Ki * Be A nyomtató beállítása úgy, hogy az eseményeket a biztonságos ellenőrzési naplóban és a távoli rendszernaplóban rögzítse. Távoli rendszernapló engedélyezése Ki * Be A nyomtató beállítása úgy, hogy az ellenőrzési naplókat egy távoli kiszolgálóra küldje. Távoli rendszernapló-kiszolgáló A beállítás felhasználó által meghatározott. Adja meg a távoli rendszernapló-kiszolgálót. Távoli rendszernaplóport 1–65535  (514*) Adja meg azt a portot, amelyen keresztül a nyomtató a naplózott eseményeket egy távoli kiszolgálónak elküldi. Távoli rendszernaplózási módszer Normál UDP * Stunnel Azonosítsa a nyomtató által a naplózott események távoli kiszolgálóra történő továbbítására használt protokollt. Távoli rendszernaplózási szolgáltatás 0 – Kernelüzenetek 1 – Felhasználószintű üzenetek 2 – Levelezőrendszer 3 – Rendszerdémonok 4 – Biztonsági/hitelesítési üzenetek * 5 – A rendszernaplók által belsőleg generált üzenetek 6 – Soros nyomtató alrendszere 7 – Hálózati hírek alrendszere 8 – UUCP-alrendszer 9 – Óradémon 10 – Biztonsági/hitelesítési üzenetek 11 – FTP-démon 12 – NTP-alrendszer 13 – Megfigyelési napló 14 – Riasztási napló 15 – Óradémon 16 – Helyi használat 0 (helyi0) 17 – Helyi használat 1 (helyi1) 18 – Helyi használat 2 (helyi2) 19 – Helyi használat 3 (helyi3) 20 – Helyi használat 4 (helyi4) 21 – Helyi használat 5 (helyi5) 22 – Helyi használat 6 (helyi6) 23 – Helyi használat 7 (helyi7) A nyomtató által a naplóesemények távoli rendszernapló-kiszolgálóra történő küldésekor használt Létesítmény érték beállítása. Naplózandó események súlyossága 0 – Vészhelyzet 1 – Riasztás 2 – Kritikus 3 – Hiba 4 – Figyelmeztetés * 5 – Értesítés 6 – Tájékoztató jellegű 7 – Hibakeresés Adja meg az egyes események súlyossági értékét. Távoli rendszernapló által nem naplózott események Ki * Be A nyomtató beállítása a vonatkozó események küldésére. Rendszergazda e-mail-címe A beállítás felhasználó által meghatározott. Adja nyomtató rendszergazdájának e-mail-címét, aki értesítést kap bizonyos naplóeseményekről. Naplóból való törlésre vonatkozó e-mail-riasztás Ki * Be A nyomtató beállítása úgy, hogy minden naplótörlés esetén küldjön e-mailt a rendszergazdának. Napló megtelésére vonatkozó e-mail-riasztás Ki * Be A nyomtató beállítása, hogy e-mailt küldjön a rendszergazdának, ha a naplóbejegyzések csomagolása megtörtént. Művelet napló megtelése esetén Legrégebbi bejegyzések felülírása * Napló küldése e-mailben, majd az összes bejegyzés törlése Határozza meg, hogyan oldja meg a nyomtató a naplótárolási problémákat, amikor a napló megtölti a számára kijelölt memóriát. E-mail riasztás a azázalékos telítettségről Ki * Be A nyomtató beállítása úgy, hogy e-mailt küldjön a rendszergazdának, amikor a napló megtölti a számára kijelölt memóriát. Százalékos telítettségi riasztás szintje 1–99  (90*) Meghatározza, hogy a napló által elfoglalt terület meghaladja-e a teljes riasztási szint értékét, illetve megegyezik-e vele. Napló exportálására figyelmeztető e-mail-riasztás Ki * Be Értesítő e-mail küldése a rendszergazdának, ha a naplót valaki exportálja. Naplóbeállítások módosítására figyelmeztető e-mail-riasztás Ki * Be A nyomtató beállítása úgy, hogy e-mailt küldjön a rendszergazdának, ha az  Ellenőrzés engedélyezése  menü értéke megváltozik. Naplózási sor vége LF (\\n) * CR (\\r) CRLF (\\r\\n) Meghatározza, hogy a nyomtató hogyan kezeli a naplófájlban a sorvégeket, függően az operációs rendszertől, amiben a fájlt elemzik vagy megnézik. Exportált fájlok digitális aláírása Ki * Be A nyomtató beállítása az exportált biztonsági naplók automatikus aláírására. Napló törlése A beállítás felhasználó által meghatározott. Az összes ellenőrzési napló törlése. Napló exportálása Rendszernapló (RFC 5424) Rendszernapló (RFC 3164) CSV Naplók exportálása nyomtatóról vagy flash-meghajtóról. menü Biztonsági ellenőrzési napló"},{"UUID":"fc66e713-d913-42c4-a79a-91e2064b76b9","title":"Biztonság","link":"login-methods-subgroup.html","desc":"Bejelentkezési korlátozások A Bejelentkezési korlátozások","descFull":"Bejelentkezési korlátozások A Bejelentkezési korlátozások menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Sikertelen bejelentkezések 1–10  (3*) A felhasználók felfüggesztése előtt tehető sikertelen bejelentkezési kísérletek számát adja meg. Sikertelenség időkerete 1–60 perc  (5*) A felhasználók felfüggesztése előtt a sikertelen bejelentkezési kísérleteknek megengedett időtartamot. Felfüggesztés időtartama 1–60 perc  (5*) Adja meg bejelentkezés letiltásának idejét. Webes bejelentkezés időkorlátja 1–120 perc  (10*) Adja meg, hogy egy távoli felület, például egy weboldal mennyi ideig maradhat tétlen, mielőtt a felhasználót a rendszer automatikusan kijelentkezteti. menü Bejelentkezési korlátozások"},{"UUID":"7e428e30-41cf-46f7-8ab8-598d0fda01bf","title":"Biztonság","link":"login-methods-subgroup.html","desc":"Titkosított nyomtatás beállításai A Titkosított","descFull":"Titkosított nyomtatás beállításai A Titkosított nyomtatás beállításai menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Érvényt. PIN max. 2–10 Állítsa be az érvénytelen PIN-kód megadására vonatkozó korlátot. A limit elérésekor az adott felhasználónévhez tartozó nyomtatási feladatok törlődnek. Titkosított feladatok lejárata Ki * 1 óra 4 óra 24 óra 72 óra 1 hét Állítson be egy egyéni lejárati időt minden egyes típusú felfüggesztett feladathoz, mielőtt a nyomtató automatikusan törli azt a memóriából. A felfüggesztett feladatok típusai a következők:  Titkosított ,  Ismétlés ,  Megőrzés  és  Ellenőrzés . Ha a lejárat i idő beállítást módosítják, mialatt a titkosított nyomtatási feladatok a nyomtató memóriájában vagy merevlemezén vannak, akkor ezeknek a nyomtatási feladatoknak a lejárati ideje nem módosul az új alapértelmezett értékre. Ha a nyomtatót kikapcsolja, akkor a nyomtató memóriájában tárolt összes titkosított feladat törlődik. Feladatismétlés lejárata Ki * 1 óra 4 óra 24 óra 72 óra 1 hét Ismételni kívánt nyomtatási feladatok lejárati idejének beállítása. Feladatellenőrzés lejárata Ki * 1 óra 4 óra 24 óra 72 óra 1 hét Lejárati idő beállítása a feladat egyetlen példányban történő nyomtatásához annak érdekében, hogy ellenőrizni lehessen a minőséget a fennmaradó példányok nyomtatása előtt. Feladatmegőrzés lejárata Ki * 1 óra 4 óra 24 óra 72 óra 1 hét Lejárati idő beállítása azokhoz a feladatokhoz, amelyeket a nyomtatóban későbbi nyomtatáshoz tárolni szeretne. Minden feladat várakozzon Ki * Be Ezzel a funkcióval beállíthatja, hogy a nyomtató várakoztassa a nyomtatási feladatokat. Másolat megőrzése a dokumentumokról Ki * Be Beállítja, hogy a nyomtató az összes azonos fájlnevű dokumentumot megőrizze. menü Titkosított nyomtatás beállításai"},{"UUID":"a0482787-5056-4c0a-8bdd-73a55492dc23","title":"Biztonság","link":"login-methods-subgroup.html","desc":"Titkosítás A Titkosítás menü elemei","descFull":"Titkosítás A Titkosítás menü elemei és leírásuk Menüelem Beállítások Leírás Belső tárhely A beállítás csak olvasható információ. A belső tároló titkosítási állapotának megjelenítése. Merevlemez A beállítás csak olvasható információ. A merevlemez titkosítási állapotának megjelenítése. Ez a menüelem csak telepített merevlemez esetén jelenik meg. Intelligens tárolómeghajtó A beállítás csak olvasható információ. Az intelligens tárolómeghajtó (ISD) titkosítási állapotának megjelenítése. Ez a menü csak telepített ISD esetén jelenik meg. menü Titkosítás"},{"UUID":"cd028899-c500-4e59-a49d-a1059a3027b7","title":"Biztonság","link":"login-methods-subgroup.html","desc":"Ideiglenes adatfájlok törlése Az Ideiglenes","descFull":"Ideiglenes adatfájlok törlése Az Ideiglenes adatfájlok törlése menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Tárolás a belső memóriában Ki * Be A nyomtató beállítása úgy, hogy törölje a feladat összes adatát a memóriából a feladat befejezése után. Tárolás a merevlemezen 1 menetes törlés * 3 menetes törlés 7 menetes törl. Adja meg, hogy a nyomtató milyen módszerrel törölje a feladat összes adatát a merevlemezről a feladat befejezése után. Ez a menüelem csak akkor jelenik meg, ha a nyomtató merevlemeze telepítve van. menü Ideiglenes adatfájlok törlése"},{"UUID":"b1bdf496-93f5-4388-bb6f-f25a08994739","title":"Biztonság","link":"login-methods-subgroup.html","desc":"Megoldások: LDAP-beállítások A Megoldások: LDAP-beállítások","descFull":"Megoldások: LDAP-beállítások A Megoldások: LDAP-beállítások menü elemei és leírásuk Menüelem Beállítások Leírás LDAP-hivatkozások követése Ki * Be Bejelentkezett felhasználói fiók keresése a tartományban lévő különböző kiszolgálókban. LDAP-tanúsítvány ellenőrzése Igen Nem * LDAP-tanúsítványok ellenőrzésének engedélyezése. menü Megoldások: LDAP-beállítások"},{"UUID":"a8948cc8-e7c2-4b1b-9f99-1f7c6cd2288f","title":"Biztonság","link":"login-methods-subgroup.html","desc":"Egyebek Az Egyéb menü elemei","descFull":"Egyebek Az Egyéb menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Védett funkciók Megjelenítés * Elrejtés Megmutatja azokat a funkciókat, amelyeket a funkció-hozzáférési vezérlés (FAC) a felhasználó biztonsági engedélyétől függetlenül véd. Az  Elrejtés  csak azokat a FAC‑védett funkciókat jeleníti meg, amelyekhez a felhasználó hozzáfér. Nyomtatási engedély Ki * Be A felhasználónak be kell jelentkeznie a nyomtatás előtt. Alapértelmezett nyomtatási engedély bejelentkezési adatai Felhasználónév/jelszó * Felhasználónév Beállítja a  Nyomtatási engedély  alapértelmezett bejelentkezési adatait. Biztonsági visszaállító összekötő Vendéghozzáférés engedélyezése * Nincs hatása A felhasználói hozzáférést határozza meg a nyomtatóhoz. A  „Vendég” hozzáférés engedélyezése  mindenkinek hozzáférést biztosít a nyomtató összes funkciójához. A  Nincs hatása  letilthatja a hozzáférést a nyomtatóhoz abban az esetben, ha a szükséges biztonsági információk nem állnak rendelkezésre. Intelligens tárolómeghajtó használata a felhasználói adatok számára Ki Be * A felhasználói adatok tárolásának engedélyezése az intelligens tárolómeghajtón. Ez a menüelem telepített merevlemez esetén le van tiltva. Jelszó minimális hossza 0–32  (0*) Adja meg a belső fiókokhoz, például a  Jelszó  és a  Felhasználónév/jelszó  fiókokhoz használandó minimális jelszóhosszúságot. Jelszó/PIN-kód mutatásának engedélyezése Ki Be * A jelszó vagy a személyes azonosítószám megjelenítése. A nem felejtő szolgáltatási memória titkosításának engedélyezése Ki * Be Engedélyezi a készülék nem felejtő memóriájának titkosítását. Ez a beállítás akkor érhető el, ha a  Titkosítási szolgáltatás – nem felejtő memória  le van tiltva. menü Egyebek"},{"UUID":"bb26fe8b-cb0d-4430-85bc-1dfa1ddd2a6f","title":"Felhőszolgáltatások","link":"cloud-services-enrollment-topic.html","desc":"Felhőalapú szolgáltatások – regisztráció A","descFull":"Felhőalapú szolgáltatások – regisztráció A Felhőalapú szolgáltatások – Regisztráció menü elemei és leírásuk Menüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. További információ megtekintése A beállítás csak olvasható információ. A Lexmark Cloud Services használatára vonatkozó további információk megtekintése. Kommunikáció engedélyezése a Lexmark Cloud Services szolgáltatással Ki * Be Engedélyezze a kommunikációt a nyomtató és a Lexmark Cloud Services szolgáltatás között. Aktuális állapot megtekintése A beállítás csak olvasható információ. A nyomtató és a Lexmark Cloud Services közötti csatlakozási állapot megtekintése. menü Felhőalapú szolgáltatások – regisztráció"},{"UUID":"ec55e074-a9d1-48dd-9958-47b86c1c7548","title":"Jelentések","link":"menu-settings-page-topic.html","desc":"Menübeállítási oldal A  Menübeállítási","descFull":"Menübeállítási oldal A  Menübeállítási oldal  menü elemei és leírásuk Menüelem Leírás Menübeállítási oldal A nyomtató menüit felsoroló jelentés nyomtatása. menü Menübeállítási oldal"},{"UUID":"bc7e4d0a-eea5-4400-b686-47f15ad956d8","title":"Jelentések","link":"menu-settings-page-topic.html","desc":"Eszköz Az Eszköz menü elemei","descFull":"Eszköz Az Eszköz menü elemei és leírásuk Menüelem Leírás Készülékadatok A nyomtatóval kapcsolatos információkat tartalmazó jelentés nyomtatása. Készülékstatisztika Nyomtathat jelentést a kellékanyagok állapotáról, a papírszámról, a feladattal kapcsolatos információkról és egyebekről. Profilok lista A nyomtatóban tárolt profilok listájának nyomtatása. Készletjelentés A nyomtatási problémák diagnosztikai eszközének nyomtatása. A tartalom levágásának elkerülése érdekében nyomtassa a jelentést Letter vagy A4-es méretű papírra. menü Eszköz"},{"UUID":"24b3b477-154b-4ef3-8013-bdb029141bb2","title":"Jelentések","link":"menu-settings-page-topic.html","desc":"Nyomtatás A Nyomtatás menü elemei","descFull":"Nyomtatás A Nyomtatás menü elemei és leírásuk Menüelem Beállítások Leírás Betűtípusok nyomtatása PCL betűtípusok PS betűtípusok Minták nyomtatása és információk az egyes nyomtatónyelvekhez elérhető betűtípusokról. Nyomtatási bemutató Demó oldal A nyomtatási problémák diagnosztikai eszközének nyomtatása. A tartalom levágásának elkerülése érdekében nyomtassa a jelentést Letter vagy A4-es méretű papírra. Ez a menüelem csak akkor jelenik meg, ha a nyomtatóra telepítve van demó oldal. Könyvtár nyomtatása A beállítás felhasználó által meghatározott. Nyomtathat egy jelentést, amely megmutatja a flash-meghajtón vagy a nyomtató merevlemezén tárolt erőforrásokat. menü Nyomtatás"},{"UUID":"b9869b68-5340-46b5-b939-e74529520532","title":"Jelentések","link":"menu-settings-page-topic.html","desc":"Parancsikonok A Parancsikonok menü elemei","descFull":"Parancsikonok A Parancsikonok menü elemei és leírásuk Menüelem Leírás Összes parancsikon A nyomtatóban tárolt összes parancsikont tartalmazó lista nyomtatása. A  faxolási parancsikonok  csak  fax  beszerelése esetén jelennek meg. Faxolási parancsikonok Másolási parancsikonok E-mail-parancsikonok FTP-parancsikonok Hálózati mappa parancsikonok menü Parancsikonok"},{"UUID":"b57a7a22-4a4d-4c6d-bdca-591c18a0d5c1","title":"Jelentések","link":"menu-settings-page-topic.html","desc":"Fax Ez a menü csak","descFull":"Fax Ez a menü csak akkor jelenik meg, ha a fax konfigurálva van, és a  Feladatnapló engedélyezése  értéke  Be . A Fax menü elemei és leírásuk Menüelem Leírás Faxfeladatok naplója A legutóbb végrehajtott 200 faxolási feladatra vonatkozó jelentés nyomtatása. Faxhívási napló Kinyomtat egy, a legutóbbi 100 megkísérelt, fogadott vagy letiltott hívásra vonatkozó jelentést. menü Fax"},{"UUID":"61d0917b-a787-4fa2-9428-7ff709a65590","title":"Jelentések","link":"menu-settings-page-topic.html","desc":"Hálózat A Hálózat menü elemei","descFull":"Hálózat A Hálózat menü elemei és leírásuk Menüelem Leírás Hálózati beállítások oldala A konfigurált hálózatot, valamint a nyomtató vezeték nélküli beállításait tartalmazó oldal nyomtatása. Ez a menüelem csak a hálózati nyomtatók, illetve a nyomtatókiszolgálókhoz csatlakoztatott nyomtatók esetében jelenik meg. Wi‑Fi Direct segítségével csatlakozott ügyfelek A nyomtatóhoz WiFi Direct segítségével csatlakozott eszközöket tartalmazó oldal nyomtatása. Ez a menüelem csak akkor jelenik meg, ha a  Wi-Fi Direct engedélyezése  lehetőség a  Be  értékre van állítva. menü Hálózat"},{"UUID":"08300a6a-f2ef-4118-b07b-8b8958feb179","title":"Nyomtatómenük","link":"troubleshooting-menu-topic.html","desc":"Hibaelhárítás A Hibaelhárítás menü elemei","descFull":"Hibaelhárítás A Hibaelhárítás menü elemei és leírásuk Menüelem Leírás Tesztoldal nyomtatása A nyomtatási minőséggel kapcsolatos hibák azonosítására és kijavítására nyomtasson tesztoldalakat. A lapolvasó tisztítása Nyomtassa ki a lapolvasó tisztításával kapcsolatos utasításokat. menü Hibaelhárítás Tesztoldal nyomtatása Lapolvasó tisztítása"},{"UUID":"95277d79-58b9-4952-a989-419cc079df9c","title":"Nyomtatómenük","link":"forms-merge-topic.html","desc":"Forms Merge Ez a menüpont","descFull":"Forms Merge Ez a menüpont csak akkor jelenik meg, ha telepítve van egy tárolómeghajtó. A Forms Merge menü elemei és leírásuk Menüelem Almenüelem Beállítások Leírás Az érték melletti csillag (*) az alapértelmezett gyári beállításokat jelöli. Egyesítés mód N/A Nyomtatás * Adatrögzítés Letiltva A Forms Merge üzemmód meghatározása. Adatrögzítés helye N/A Flash * Azon hely megadása, ahová a rendszer továbbítja a rögzített adatokat. Ez a menüelem csak akkor jelenik meg, ha az  Egyesítés mód  beállítás  Adatrögzítés  lehetőségre van állítva. Nyomtatóport és szűrő beállítások Hálózati port Be * Ki Engedélyezi a Forms Merge számára a hálózati porton keresztül küldött adatok feldolgozását. Hálózati szűrő Letiltva * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF A hálózati szűrő meghatározása a nyomtatónak küldött adatok tekintetében. USB-port Be * Ki Engedélyezi a Forms Merge számára az USB porton keresztül küldött adatok feldolgozását. USB szűrő Letiltva * NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF Az USB-szűrő meghatározása a nyomtatónak küldött adatok tekintetében. Helyi port időkorlátja 1–100  (10*) A helyi portra küldött Forms Merge feladatok időkorlátjának meghatározása. Egyebek Összes űrlap nyomtatása Indítás Az intelligens tárolómeghajtón vagy merevlemezen tárolt összes űrlap kinyomtatása. Hibajelentés nyomtatása Be * Ki Engedélyezi egy hibajelentés kinyomtatását, amikor egy Forms Merge feladatnál hiba jelentkezik. menü Forms Merge"},{"UUID":"cbe317ff-1169-455f-8168-adb3bbb3c93f","title":"Nyomtatómenük","link":"printing-menu-settings-page-topic.html","desc":"Menübeállítási oldal  nyomtatása A","descFull":"Menübeállítási oldal  nyomtatása A kezelőpanelen navigáljon a  Beállítások Jelentések  menüpontra. Válassza ki a  Menübeállítási oldal  lehetőséget. nyomtatás Menübeállítási oldal Menübeállítási oldal nyomtatás nyomtató menüi"},{"UUID":"05983416-a819-49c5-b551-3bd79b953aa6","title":"Nyomtató szétválogató-opciói","link":"using-staple-finisher-topic.html","desc":"A kapcsozó kiadó használata Kapcsozás","descFull":"A kapcsozó kiadó használata Kapcsozás a nyomtató-illesztőprogramjával Útmutatás Windows-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd kattintson a  Tulajdonságok ,  Jellemzők ,  Beállítások  vagy  Beállítás  gombra. Kattintson a  Papír/utófeldolgozás  gombra, majd konfigurálja a  Papír  beállításokat. A  Kapocs  menüben válasszon ki egy beállítást. Kattintson az  OK , majd a  Nyomtatás  gombra. Macintosh-felhasználók számára Megnyitott dokumentum esetén válassza a  Fájl Nyomtatás  menüpontot. Itt kiválaszthatja a kívánt nyomtatót. A  Papírkiadási lehetőségek  menüből válassza a  Papírkiadási lehetőségek alkalmazása Nyomtatóbeállítások  menüpontot. Kattintson a  Tűzés  elemre, majd válasszon egy beállítást. Kattintson a  Nyomtatás  gombra. Kapcsozás a kezelőpanel használatával A kezelőpanelen válassza a  Nyomtatás  lehetőséget, majd válassza ki a nyomtatási feladat forrását. Válassza ki a dokumentumot. Válassza a  További beállítások , majd a  Papírkiadási lehetőségek  elemet. Válassza ki a  Kapocs  elemet, majd válasszon ki egy beállítást. Nyomtassa ki a dokumentumot. kapcsozó kiadó használat fűzés nyomtatott lapok fűzés másolt dokumentumok"},{"UUID":"7836c180-84e0-4ca5-9f30-23350882861f","title":"Nyomtató szétválogató-opciói","link":"using-staple-hole-punch-finisher-topic.html","desc":"A kapcsozó és lyukasztó kiadóegység","descFull":"A kapcsozó és lyukasztó kiadóegység használata A kapcsozó és lyukasztó kiadóegység használata A papír kapcsozása vagy lyukasztása a nyomtató-illesztőprogrammal Útmutatás Windows-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd kattintson a  Tulajdonságok ,  Jellemzők ,  Beállítások  vagy  Beállítás  gombra. Kattintson a  Papír/utófeldolgozás  gombra, majd konfigurálja a  Papír  beállításokat. A kívánt befejezéstől függően válassza ki a  Kapocs  vagy a  Lyukasztás  elemet. Mindkettő beállítását kiválaszthatja, ha a nyomtatott anyagokat kapcsozni és lyukasztani szeretné. Kattintson az  OK , majd a  Nyomtatás  gombra. Macintosh-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Itt kiválaszthatja a kívánt nyomtatót. A  Papírkiadási lehetőségek  menüből válassza a  Papírkiadási lehetőségek alkalmazása Nyomtatóbeállítások  menüpontot. Kattintson a  Kapocs  vagy  Lyukasztás  gombra, majd válasszon ki egy beállítást. Kattintson a  Nyomtatás  gombra. Papír kapcsozása vagy lyukasztása a kezelőpanel segítségével A kezelőpanelen válassza a  Nyomtatás  lehetőséget, majd válassza ki a nyomtatási feladat forrását. Válassza ki a dokumentumot. Válassza a  További beállítások , majd a  Papírkiadási lehetőségek  elemet. A kívánt befejezéstől függően válassza ki a  Kapocs  vagy a  Lyukasztás  elemet. Mindkettő beállítását kiválaszthatja, ha a nyomtatott anyagokat kapcsozni és lyukasztani szeretné. Nyomtassa ki a dokumentumot. kinyomtatott lapok tűzése lyukasztás nyomtatott lapokban kapcsozó és lyukasztó kiadóegység használat"},{"UUID":"014251d5-0c70-4f0e-a0b0-db2253fee4c2","title":"Nyomtató szétválogató-opciói","link":"using-offset-stacker-topic.html","desc":"A kötegelő rendezőtálca használata Kötegelő","descFull":"A kötegelő rendezőtálca használata Kötegelő rendezés a nyomtató-illesztőprogrammal Útmutatás Windows-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd kattintson a  Tulajdonságok ,  Jellemzők ,  Beállítások  vagy  Beállítás  gombra. Kattintson a  Papír/utófeldolgozás  gombra, majd konfigurálja a  Papír  beállításokat. Az  Eltolás  menüben válasszon ki egy beállítást. Kattintson az  OK , majd a  Nyomtatás  gombra. Macintosh-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Itt kiválaszthatja a kívánt nyomtatót. A  Papírkiadási lehetőségek  menüből válassza a  Papírkiadási lehetőségek alkalmazása Nyomtatóbeállítások  menüpontot. Kattintson az  Eltolás  elemre, majd válasszon egy beállítást. Kattintson a  Nyomtatás  gombra. Kötegelő rendezés a kezelőpanellel Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kép levágásának elkerülése érdekében győződjön meg arról, hogy az eredeti dokumentum és a kimeneti papír mérete megegyezik. A kezelőpanelen válassza ki a  Másolás  elemet, majd adja meg a példányszámot. Válassza a  További beállítások , majd az  Oldalak eltolása  lehetőséget. Kapcsolja be a menüt, majd válasszon ki egy beállítást. Nyomtassa ki a dokumentumot. kötegelő rendezőtálca használat kötegelés eltolása"},{"UUID":"8e056b6f-2707-4ab5-900e-7299350a2947","title":"Nyomtató szétválogató-opciói","link":"using-booklet-finisher-topic.html","desc":"A füzetkészítő egység használata Mielőtt","descFull":"A füzetkészítő egység használata Mielőtt füzetet készít, a papírt a rövid szélével a tálca jobb oldala felé fordítva helyezze be. Füzet létrehozása a nyomtató-illesztőprogrammal Útmutatás Windows-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd kattintson a  Tulajdonságok ,  Jellemzők ,  Beállítások  vagy  Beállítás  gombra. Válassza ki a  Füzet  lehetőséget. Kattintson a  Papír/utófeldolgozás  fülre, majd konfigurálja a papírbeállításokat. A  Hajtogatás  menüben válasszon ki egy beállítást. Kattintson az  OK , majd a  Nyomtatás  gombra. Macintosh-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Itt kiválaszthatja a kívánt nyomtatót. A  Papírkiadási lehetőségek  menüből válassza a  Papírkiadási lehetőségek alkalmazása Nyomtatóbeállítások  menüpontot. Válassza a  Füzet  lehetőséget, majd válasszon egy  hajtogatási  beállítást. Kattintson az  OK  gombra. Füzet létrehozása a kezelőpanel segítségével Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kép levágásának elkerülése érdekében győződjön meg arról, hogy az eredeti dokumentum és a kimeneti papír mérete megegyezik. A kezelőpanelen válassza a  Másolás  lehetőséget, majd konfigurálja a beállításokat. Válassza a  További beállítások , majd a  Füzetlétrehozása  lehetőséget. Engedélyezze a  Füzetkészítést , majd válasszon ki egy beállítást. Indítsa el a másolási műveletet. füzet létrehozása füzet létrehozása füzetkészítő egység használat"},{"UUID":"4b23cffc-fbe9-4bdb-b758-041721e89bb0","title":"Nyomtató szétválogató-opciói","link":"using-hptfu-topic.html","desc":"A hajtogatási lehetőséggel ellátott papírszállító","descFull":"A hajtogatási lehetőséggel ellátott papírszállító egység használata Papír hajtogatása a nyomtató-illesztőprogrammal Útmutatás Windows-felhasználók számára Megnyitott dokumentum esetén kattintson a  Fájl Nyomtatás  gombra. Válasszon ki egy nyomtatót, majd kattintson a  Tulajdonságok ,  Jellemzők ,  Beállítások  vagy  Beállítás  gombra. Kattintson a  Papír/utófeldolgozás  gombra, majd konfigurálja a Papír beállításokat. A  Hajtogatás  menüben válasszon ki egy beállítást. Kattintson az  OK , majd a  Nyomtatás  gombra. Macintosh-felhasználók számára Megnyitott dokumentum esetén válassza a  Fájl Nyomtatás  menüpontot. Itt kiválaszthatja a kívánt nyomtatót. A  Papírkiadási lehetőségek  menüből válassza a  Papírkiadási lehetőségek alkalmazása Nyomtatóbeállítások  menüpontot. Kattintson a  Hajtogatás  elemre, majd válasszon egy beállítást. Kattintson a  Nyomtatás  gombra. Papírhajtogatás a kezelőpanel segítségével Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. A kép levágásának elkerülése érdekében győződjön meg arról, hogy az eredeti dokumentum és a kimeneti papír mérete megegyezik. A kezelőpanelen válassza ki a  Másolás  elemet, majd adja meg a példányszámot. Válassza a  További beállítások , majd a  Papírkiadási lehetőségek  elemet. Válassza a  Hajtogatás  elemet, majd válasszon ki egy beállítást. Indítsa el a másolási műveletet. papírszállító egység hajtogatási lehetőséggel használat nyomtatott példányok hajtogatása másolt dokumentumok hajtogatása"},{"UUID":"cbcfb122-c493-4834-b5f1-0c392017a7e7","title":"A nyomtató karbantartása","link":"checking-supplies-status-topic.html","desc":"Az alkatrészek és kellékek állapotának","descFull":"Az alkatrészek és kellékek állapotának ellenőrzése Az alkatrészek és kellékek állapotának ellenőrzése A kezelőpanel jobb felső sarkában válassza a   lehetőséget. A nyomtató alkatrészei és kellékei állapotának megtekintése. A felhasználói beavatkozást igénylő értesítések ellenőrzéséhez kiválaszthatja a   lehetőséget is. ellenőrzés, kellékanyagok állapota kellékanyagok állapota ellenőrzés nyomtatóalkatrészek állapota ellenőrzés"},{"UUID":"3622de71-83ed-4bc7-ba80-4ea8c6e109e6","title":"A nyomtató karbantartása","link":"configuring-supply-notifications-topic.html","desc":"Kellékanyag-értesítések konfigurálása Kellékanyag-értesítések konfigurálása Nyisson","descFull":"Kellékanyag-értesítések konfigurálása Kellékanyag-értesítések konfigurálása Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Beállítások Eszköz Értesítések  elemre. Kattintson az  Egyéni kellékanyag-értesítések  lehetőségre. Válasszon ki értesítést az egyes kellékekhez. Alkalmazza a módosításokat. kellékanyagok értesítése konfigurálás kellékanyagok értesítésének konfigurálása"},{"UUID":"4040f2f3-245b-408e-9261-a7a97f9a4a7c","title":"A nyomtató karbantartása","link":"setting-up-email-alert-topic.html","desc":"E-mail-riasztások beállítása E-mail-riasztások beállítása Nyisson","descFull":"E-mail-riasztások beállítása E-mail-riasztások beállítása Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Beállítások Eszköz Értesítések  elemre. Kattintson az  E-mail riasztás beállítása  gombra, majd konfigurálja a beállításokat. Az SMTP-beállításokra vonatkozó bővebb információkért vegye fel a kapcsolatot az e-mail-szolgáltatóval. Alkalmazza a módosításokat. Kattintson az  E-mail listák és riasztások beállítása  elemre, és módosítsa a beállításokat. Alkalmazza a módosításokat. e-mail-riasztások beállítás e-mail-riasztások beállítása"},{"UUID":"7f415931-fc6a-473b-950d-a24519b5e334","title":"A nyomtató karbantartása","link":"generating-reports-and-logs-topic.html","desc":"Jelentések és naplók készítése Jelentések","descFull":"Jelentések és naplók készítése Jelentések és naplók készítése A kezelőpanelen navigáljon a  Beállítások Jelentések  menüpontra. Válassza ki a nyomtatni kívánt jelentést vagy naplót. Menübeállítási oldal  – A nyomtató aktuális beállításainak és konfigurációinak megjelenítése. Eszköz Eszközinformációk  – A nyomtatósorozatszám, a telepített megoldások és a fax megjelenítése. Eszközstatisztikák  – Megjeleníti a tápellátás állapotát, a kinyomtatott lapok számát és a nyomtatási feladatokra vonatkozó információkat. Profillista  – A nyomtatóban tárolt profilok vagy parancsikonok listájának megjelenítése. Készletjelentést  – Megjeleníti a nyomtató készletadatait, beleértve a sorozatszámot és a típus nevét. Nyomtatás Nyomtatási betűtípusok  – Az egyes nyomtatónyelveken elérhető betűtípusok megjelenítése. Bemutató nyomtatása  – Megjeleníti a firmware-ben, a flash-memóriában és a lemezen elérhető demó fájlokat. Nyomtatási könyvtár  – Megjeleníti a flash-meghajtón, merevlemezen vagy intelligens tárolómeghajtón (ISD) tárolt erőforrásokat. A jelentés csak akkor jelenik meg, ha flash-meghajtó, nyomtató-merevlemez vagy ISD van telepítve. Parancsikonok Minden parancsikon  – A nyomtatón tárolt összes parancsikon listájának megjelenítése. Faxolási parancsikonok  – A nyomtatón tárolt faxolási parancsikonok listájának megjelenítése. Másolási parancsikonok  – A nyomtatón tárolt másolási parancsikonok listájának megjelenítése. E-mail-parancsikonok  – A nyomtatón tárolt e-mail-parancsikonok listájának megjelenítése. FTP-parancsikonok  – A nyomtatón tárolt FTP- (File Transfer Protocol) parancsikonok listájának megjelenítése. Hálózati mappa parancsikonjai  – A nyomtatón tárolt hálózati mappa parancsikonjai listájának megjelenítése. Fax Faxfeladatok naplója  – Az utolsó 200 befejezett faxfeladatot tartalmazó lista. A jelentés csak akkor jelenik meg, ha a  Feladatnapló engedélyezése  engedélyezve van. Faxhívási napló  – A flash-meghajtón vagy tárolómeghajtón tárolt erőforrások megjelenítése. A jelentés csak akkor jelenik meg, ha telepítve van flash-meghajtó vagy tárolómeghajtó. Hálózat Hálózati beállítások oldala  – A nyomtató konfigurált hálózati és vezeték nélküli beállításainak megjelenítése. Ez a jelentés csak a hálózati nyomtatókon és a nyomtatókiszolgálókhoz csatlakoztatott nyomtatókon jelenik meg. Wi-Fi Directtel csatlakoztatott kliensek  – A Wi-Fi Direct segítségével a nyomtatóhoz csatlakoztatott eszközök listájának megjelenítése. Ez a jelentés csak akkor jelenik meg, ha a  Wi-Fi Direct engedélyezése Be  van kapcsolva. jelentések nyomtatása nyomtatási naplók jelentések és naplók megtekintése mért értékek, megtekintés nyomtatott lapok, megtekintés"},{"UUID":"9ad7b7f3-82e0-4b04-ac3e-fe8dddc7ed6a","title":"Alkatrészek és kellékek rendelése","link":"ordering-parts-and-supplies-group.html","desc":"Kellékanyagok rendeléséhez az Egyesült Államokban","descFull":"Kellékanyagok rendeléséhez az Egyesült Államokban lépjen kapcsolatba a Lexmarkkal a 1-800-539-6275 számon, ahol információkat kaphat az Önhöz közeli hivatalos Lexmark-viszonteladókról. Más országokban/térségekben keresse fel a  www.lexmark.com  oldalt, vagy lépjen kapcsolatba a nyomtatót értékesítő kereskedővel. Kellékanyagok rendeléséhez lépjen kapcsolatba a kereskedővel, akitől a nyomtatót beszerezte. A nyomtató kellékanyagainak élettartambecslése A4-es, sima papírra való nyomtatást tételez fel. Ha nem gondoskodik a nyomtató optimális teljesítményének megőrzéséről, vagy nem cseréli az alkatrészeket és kellékanyagokat, azzal kárt tehet a nyomtatóban. eredeti alkatrészek és kellékanyagok"},{"UUID":"55a53eb4-9deb-4c8c-bf09-956e5f3e048b","title":"Alkatrészek és kellékek rendelése","link":"ordering-parts-and-supplies-group.html","desc":"Eredeti Lexmark-alkatrészek és -kellékanyagok használata","descFull":"Eredeti Lexmark-alkatrészek és -kellékanyagok használata A Lexmark nyomtatót úgy tervezték, hogy a legjobban eredeti Lexmark alkatrészekkel és kellékanyagokkal működjön. Egyéb márkájú kellékanyag vagy alkatrész használata befolyásolhatja a nyomtató teljesítményét, megbízhatóságát vagy élettartamát, valamint képalkotó-alkatrészeit. Emellett a garancia érvényességét is befolyásolhatja. Nem vállalunk garanciát az egyéb márkájú alkatrészek és kellékanyagok használata által okozott kárra. A termék élettartama eredeti Lexmark alkatrészek és kellékanyagok használatához van megtervezve; ha egyéb márkájú alkatrészeket vagy kellékanyagokat használ, az váratlan eredményhez vezethet. A tervezett élettartama után használt képalkotó-összetevő károsíthatja a Lexmark nyomtatót vagy a hozzá kapcsolt alkatrészeket. A visszajuttatási program szerződési feltételekkel nem rendelkező kellékanyagok és alkatrészek visszaállíthatók és utángyárthatók. A gyártói garancia azonban nem vonatkozik a nem eredeti kellékanyagok vagy alkatrészek által okozott károkra. Ha megfelelő utángyártás nélküli kellékanyagra vagy alkatrészre állítja vissza a számlálót, az kárt okozhat a nyomtatóban. A kellékanyag- vagy alkatrészszámláló visszaállítása után előfordulhat, hogy a nyomtató a visszaállított elem hiányára utaló hibát jelez. eredeti Lexmark-alkatrészek és -kellékanyagok használata eredeti Lexmark-alkatrészek és -kellékanyagok"},{"UUID":"2b74a6fc-3752-4928-9e06-afc32f90a451","title":"Alkatrészek és kellékek rendelése","link":"ordering-parts-and-supplies-group.html","desc":"Tonerkazetta rendelése Tonerkazetta rendelése A","descFull":"Tonerkazetta rendelése Tonerkazetta rendelése A becsült oldalkapacitás meghatározása az ISO/IEC 19798 szabványon alapul. Ha hosszabb ideig nagyon alacsony a nyomtatás lefedettsége, az negatívan befolyásolhatja a tényleges kapacitást. Festékkazetták rendeléséhez lépjen kapcsolatba a kereskedővel, akitől a nyomtatót beszerezte. Visszajuttatási programban részt vevő tonerkazetták Lexmark CX833, CX961, CX962, CX963 Elem Egyesült Államok, Kanada, Ausztrália és Új-Zéland Európai Unió, Európai Gazdasági Térség, Izland, Liechtenstein, Norvégia, Svájc Ázsiai és csendes-óceáni térség egyéb részei Latin-Amerika, Puerto Rico és Mexikó Európa többi része, Közel-Kelet, Afrika, Közép-Kelet-Európa, Független Államok Közössége Az egyes régiók országaira vonatkozó további információkért látogasson el a  www.lexmark.com/regions  weboldalra. Cián 77L10C0 77L20C0 77L30C0 77L40C0 77L50C0 Bíbor 77L10M0 77L20M0 77L30M0 77L40M0 77L50M0 Sárga 77L10Y0 77L20Y0 77L30Y0 77L40Y0 77L50Y0 Fekete 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 Nagy kapacitású, visszajuttatási programban részt vevő tonerkazetták Lexmark CX833 Elem Egyesült Államok, Kanada, Ausztrália és Új-Zéland Európai Unió, Európai Gazdasági Térség, Izland, Liechtenstein, Norvégia, Svájc Ázsiai és csendes-óceáni térség egyéb részei Latin-Amerika, Puerto Rico és Mexikó Európa többi része, Közel-Kelet, Afrika, Közép-Kelet-Európa, Független Államok Közössége Az egyes régiók országaira vonatkozó további információkért látogasson el a  www.lexmark.com/regions  weboldalra. Cián 79L10K0 79L20K0 79L30K0 79L40K0 79L50K0 Bíbor 79L1HM0 79L2HM0 79L3HM0 79L4HM0 79L5HM0 Sárga 79L1HY0 79L2HY0 79L3HY0 79L4HY0 79L5HY0 Fekete 79L1HK0 79L2HK0 79L3HK0 79L4HK0 79L5HK0 Lexmark CX961, CX962, CX963 Elem Egyesült Államok, Kanada, Ausztrália és Új-Zéland Európai Unió, Európai Gazdasági Térség, Izland, Liechtenstein, Norvégia, Svájc Ázsiai és csendes-óceáni térség egyéb részei Latin-Amerika, Puerto Rico és Mexikó Európa többi része, Közel-Kelet, Afrika, Közép-Kelet-Európa, Független Államok Közössége Az egyes régiók országaira vonatkozó további információkért látogasson el a  www.lexmark.com/regions  weboldalra. Cián 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 Bíbor 77L1HM0 77L2HM0 77L3HM0 77L4HM0 77L5HM0 Sárga 77L1HY0 77L2HY0 77L3HY0 77L4HY0 77L5HY0 Fekete 77L1HK0 77L2HK0 77L3HK0 77L4HK0 77L5HK0 Lexmark XC8355 Elem Egyesült Államok, Kanada, Ausztrália, Új-Zéland Európa egyéb részei, Közel-Kelet és Afrika Az egyes régiók országaira vonatkozó további információkért látogasson el a  www.lexmark.com/regions  weboldalra. Cián 24B7574 24B7582 Bíbor 24B7575 24B7583 Sárga 24B7576 24B7584 Fekete 24B7577 24B7585 Lexmark XC9635, XC9645, XC9655 Elem Egyesült Államok, Kanada, Ausztrália és Új-Zéland Európa egyéb részei, Közel-Kelet és Afrika Az egyes régiók országaira vonatkozó további információkért látogasson el a  www.lexmark.com/regions  weboldalra. Cián 24B7570 24B7578 Bíbor 24B7571 24B7579 Sárga 24B7572 24B7580 Fekete 24B7573 24B7581 Nagy kapacitású hagyományos tonerkazetták Lexmark CX833 Elem Világszerte Az egyes régiók országaira vonatkozó további információkért látogasson el a  www.lexmark.com/regions  weboldalra. Cián 77L0H20 Bíbor 77L0H30 Sárga 77L0H40 Fekete 77L0H10 Lexmark CX961, CX962, CX963 Elem Világszerte Az egyes régiók országaira vonatkozó további információkért látogasson el a  www.lexmark.com/regions  weboldalra. Cián 79L0H20 Bíbor 79L0H30 Sárga 79L0H40 Fekete 79L0H10 kellékanyagok rendelése festékkazetta festékkazetta rendelés"},{"UUID":"7bfcfec0-184d-4cc6-ac37-4642843a2788","title":"Alkatrészek és kellékek rendelése","link":"ordering-parts-and-supplies-group.html","desc":"Fekete képalkotó egység rendelése Fekete","descFull":"Fekete képalkotó egység rendelése Fekete képalkotó egység rendelése A fekete képalkotó egység megrendeléséhez lépjen kapcsolatba a nyomtató értékesítőjével. Fekete képalkotó egység és a cikkszámai Elem Cikkszám A visszajuttatási programban részt vevő fekete képalkotó egység 77L0ZK0 Fekete képalkotó egység 77L0Z10 fekete képalkotó egység rendelés kellékanyagok rendelése fekete képalkotó egység"},{"UUID":"60a91b0e-ef35-4b17-b019-7734c10aa86e","title":"Alkatrészek és kellékek rendelése","link":"ordering-parts-and-supplies-group.html","desc":"Színes képalkotó készlet rendelése Ha","descFull":"Színes képalkotó készlet rendelése Ha színes képalkotó készletet szeretne rendelni, forduljon ahhoz az üzlethez, ahol a nyomtatót megvásárolta. Elem Cikkszám Visszajuttatási programban részt vevő színes képalkotó készlet 77L0ZV0 Hagyományos színes képalkotó készlet 77L0Z50 színes képalkotó készlet rendelés kellékanyagok rendelése színes képalkotó készlet"},{"UUID":"5ed99ad9-f759-4e89-ba9f-95aae6820e98","title":"Alkatrészek és kellékek rendelése","link":"ordering-parts-and-supplies-group.html","desc":"A hulladékfesték-tartály megrendelése A hulladékfesték-tartály","descFull":"A hulladékfesték-tartály megrendelése A hulladékfesték-tartály megrendelése Hulladékfesték-tartály rendeléséhez lépjen kapcsolatba a nyomtató értékesítőjével. Hulladékfesték-tartály cikkszáma Elem Cikkszám Hulladékfesték-tartály 77L0W00 kellékanyagok rendelése hulladékfesték-tartály hulladékfesték-tartály rendelés"},{"UUID":"b96a84da-5782-4347-a273-5803ded55ba1","title":"Alkatrészek és kellékek rendelése","link":"ordering-parts-and-supplies-group.html","desc":"Tűzőkazetta rendelése Tűzőkazetta rendeléséhez lépjen","descFull":"Tűzőkazetta rendelése Tűzőkazetta rendeléséhez lépjen kapcsolatba a kereskedővel, akitől a nyomtatót beszerezte. Tűzőkazetta és cikkszám Elem Cikkszám 1  Csak a füzetkészítő egységhez elérhető. 2  Csak a füzetkészítő egységhez, a kapcsozó kiadóhoz és a kapcsozó-lyukasztó kiadóegységhez elérhető. Tűzőkazetta (4 db) 1 20L7500 Tűzőkazetta (3 db) 2 25A0013 tűzőkazetta rendelés kellékanyagok rendelése tűzőkazetta"},{"UUID":"8e73ca34-7757-48e8-81f2-6cf8c2216d75","title":"Alkatrészek és kellékek rendelése","link":"ordering-parts-and-supplies-group.html","desc":"Karbantartási készlet rendelése Karbantartási készlet","descFull":"Karbantartási készlet rendelése Karbantartási készlet rendelése Karbantartási készletet a nyomtató értékesítőjétől rendelhet. A nyomtató feszültségének megfelelő karbantartó készletet válasszon. Bizonyos papírtípusok használata esetén a karbantartási készletet gyakrabban kell cserélni. A karbantartó készlet egy beégető egységet és behúzógörgő-gumikat tartalmaz. Ezek szükség szerint külön is megrendelhetők és cserélhetők. Ajánlott karbantartó készletek és alkatrészszámok Elem Cikkszám A karbantartó készlet cseréjét csak az arra felhatalmazott szervizszakember végezheti el. Forduljon szolgáltatójához. 100 V Visszajuttatási programban részt vevő beégetőegység karbantartó készlete, 02-es típus 41X5654 100–120 V Visszajuttatási programban részt vevő beégetőegység karbantartó készlete, 00-s típus 41X5655 220–240 V Visszajuttatási programban részt vevő beégetőegység karbantartó készlete, 01-es típus 41X5656 100 V Hagyományos beégetőegység karbantartó készlete, 12-es típus 41X6053 110-120 V Hagyományos beégetőegység karbantartó készlete, 10-es típus 41X6051 220-240 V Hagyományos beégetőegység karbantartó készlete, 11-es típus 41X6052 kellékanyagok rendelése beégetőegység karbantartó készlete beégetőegység karbantartó készlete rendelés"},{"UUID":"60399705-99b5-4c4b-867b-58acb070e06b","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"Tonerkazetta cseréje Tonerkazetta cseréje Nyissa","descFull":"Tonerkazetta cseréje Tonerkazetta cseréje Nyissa ki az elülső ajtót.  Vegye ki a használt tonerkazettát. Csomagolja ki az új tonerkazettát. Tegye be az új tonerkazettát úgy, hogy  bepattanjon  a helyére. Csukja be az ajtót. festékkazetta csere kellékanyagok cseréje festékkazetta"},{"UUID":"9535541d-5c74-482c-ba28-d7e157c1bace","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A fekete képalkotó egység cseréje","descFull":"A fekete képalkotó egység cseréje Nyissa ki az elülső ajtót. Távolítsa el a tonerkazettákat. Vegye ki a hulladékfesték-tartályt. A festék kiömlésének elkerülése érdekében a tartályt függőleges helyzetben tárolja. Távolítsa el a képalkotó készletet. Ne tegye ki közvetlen fény hatásának a képalkotó készletet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a fényvezető dobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. A képalkotó készletet tiszta, sík felületre és függőleges helyzetbe helyezze, hogy elkerülje a fényvezető dob megkarcolását vagy sérülését.  Oldja ki a használt fekete képalkotó egységet. Távolítsa el a használt, fekete képalkotó egységet. Csomagolja ki az új, fekete képalkotó egységet. Helyezze be az új fekete képalkotó egységet. Rögzítse az új fekete képalkotó egységet a helyére. Úgy helyezze be a képalkotó készletet, hogy az teljesen beüljön a helyére. Tegye be a hulladékfesték-tartályt úgy, hogy  bepattanjon  a helyére. Óvatosan húzza ki a nyomtatófejtörlőket, majd tisztítsa meg a nyomtatófej lencséit. A nyomtatófej lencséinek tisztításával kapcsolatos további információkért lásd:  . Helyezze be a tonerkazettákat. Csukja be az ajtót. fekete képalkotó egység csere kellékanyagok cseréje fekete képalkotó egység"},{"UUID":"ce74e4b1-85cc-4cc0-a9df-46e35f06414a","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A színes képalkotó készlet cseréje","descFull":"A színes képalkotó készlet cseréje Nyissa ki az elülső ajtót. Távolítsa el a tonerkazettákat. Vegye ki a hulladékfesték-tartályt. A festék kiömlésének elkerülése érdekében a tartályt függőleges helyzetben tárolja. Távolítsa el a használt képalkotó készletet. A képalkotó készletet tiszta, sík felületre és függőleges helyzetbe helyezze, hogy elkerülje a fényvezető dob megkarcolását vagy sérülését.  Oldja ki a fekete képalkotó egységet. Távolítsa el a fekete képalkotó egységet. Ne dobja ki a fekete képalkotó egységet. Ezt az új képalkotó készletre kell szerelni. Csomagolja ki az új képalkotó készletet. A képalkotó készlet a képalkotó kosarat és a ciánkék, bíborszín, illetve sárga előhívó egységeket tartalmazza. Ne tegye ki közvetlen fény hatásának a képalkotó készletet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a fényvezető dobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet az új képalkotó készletbe. Rögzítse a fekete képalkotó egységet a helyén. Úgy helyezze be az új képalkotó készletet, hogy az teljesen beüljön a helyére. Tegye be a hulladékfesték-tartályt úgy, hogy  bepattanjon  a helyére. Óvatosan húzza ki a nyomtatófejtörlőket, majd tisztítsa meg a nyomtatófej lencséit. A nyomtatófej lencséinek tisztításával kapcsolatos további információkért lásd:  . Helyezze be a tonerkazettákat. Csukja be az ajtót. színes képalkotó készlet csere kellékanyagok cseréje színes képalkotó készlet"},{"UUID":"d119e4f8-1aae-43b6-bcb4-f76836221cc0","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A hulladékfesték-tartály cseréje A hulladékfesték-tartály","descFull":"A hulladékfesték-tartály cseréje A hulladékfesték-tartály cseréje Nyissa ki az elülső ajtót. Távolítsa el a használt hulladékfesték-tartályt. A festék kiömlésének elkerülése érdekében a tartályt függőleges helyzetben tárolja. Csomagolja ki az új hulladékfesték-tartályt. Helyezze be az új hulladékfesték-tartályt úgy, hogy a helyére  kattanjon , majd csukja be az ajtót. kellékanyagok cseréje hulladékfesték-tartály hulladékfesték-tartály csere"},{"UUID":"8f585277-99c6-4e19-b0f8-b2471b44a66a","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"Beégető cseréje Beégető cseréje Kapcsolja","descFull":"Beégető cseréje Beégető cseréje Kapcsolja ki a nyomtatót. Húzza ki a tápkábelt a konnektorból, majd a nyomtatóból. Nyissa ki a B ajtót. Előfordulhat, hogy a nyomtató belseje forró. Az égési sérülések elkerülése érdekében várja meg, amíg a forró felületek kihűlnek. Oldja ki, majd távolítsa el a használt beégetőegységet. Csomagolja ki az új beégetőegységet. Tegye be az új beégetőegységet úgy, hogy  bepattanjon  a helyére, majd rögzítse. Csukja be a B ajtót. Csatlakoztassa a tápkábel egyik végét a nyomtatóhoz, majd ezután a másik végét a konnektorhoz. A tűzveszély és az áramütés elkerülése érdekében a tápkábelt közvetlenül egy, a készülékhez közeli, könnyen hozzáférhető, megfelelő besorolású és megfelelően földelt konnektorba csatlakoztassa. Kapcsolja be a nyomtatót. beégetőegység csere alkatrészek cseréje beégetőegység"},{"UUID":"7a91f002-0bd5-461a-8ff0-c6ce9ca7d1e3","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A tálca mozgatható részének cseréje","descFull":"A tálca mozgatható részének cseréje A tálca mozgatható részének cseréje Húzza ki a tálca használt mozgatható részét. Csomagolja ki a tálca új mozgatható részét. Helyezze be a tálca új mozgatható részét. tálca mozgatható része csere alkatrészek cseréje tálca mozgatható része"},{"UUID":"10663cc0-7e7f-4ba5-a273-ba9d373fee7d","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A külön megvásárolható 550 lapos","descFull":"A külön megvásárolható 550 lapos tálca papírvezetőinek cseréje A külön megvásárolható 550 lapos tálca papírvezetőinek cseréje Húzza ki a tálcát. Távolítsa el a használt papírvezetőket. Csomagolja ki az új papírvezetőket. Helyezze be az új papírvezetőket, amíg azok a helyükre nem  kattannak . Szerelje fel a tálcát. papírvezetők csere alkatrészek cseréje papírvezetők"},{"UUID":"577cb6e1-7d50-4d26-9236-ec3fc6cba8db","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A külön megvásárolható 550 lapos","descFull":"A külön megvásárolható 550 lapos tálca fedelének cseréje A külön megvásárolható 550 lapos tálca fedelének cseréje Távolítsa el a használt tálcafedelet. Csomagolja ki az új tálcafedelet. Helyezze be az új tálcafedelet, amíg az a helyére nem kattan. alkatrészek cseréje tálcafedél tálcafedél csere 550 lapos tálca fedele"},{"UUID":"96a0b61b-ca59-48a0-9033-57cb118b54d5","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A füzetkészítő egység felső rekeszbővítőjének","descFull":"A füzetkészítő egység felső rekeszbővítőjének cseréje Távolítsa el a használt felső rekeszbővítőt. Csomagolja ki az új felső rekeszbővítőt. Helyezze be ki az új felső rekeszbővítőt. alkatrészek cseréje füzetkészítő egység felső rekeszbővítője füzetkészítő egység felső rekeszbővítője csere"},{"UUID":"34058da9-2e33-431a-a5f7-a1938e65acb9","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"Lyukasztódoboz cseréje A telepített kiadóegységtől","descFull":"Lyukasztódoboz cseréje A telepített kiadóegységtől függően a lyukasztódoboz megjelenése változhat. Nyissa ki a kiadóegység ajtaját. Távolítsa el a használt lyukasztódobozt. Csomagolja ki az új lyukasztódobozt. Helyezze be az új lyukasztódobozt. Csukja be a szétválogató ajtaját. alkatrészek cseréje lyukasztódoboz lyukasztódoboz csere"},{"UUID":"906a6dbe-2015-42a8-be96-0e949df85e5b","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A normál rekesz cseréje A","descFull":"A normál rekesz cseréje A normál rekesz cseréje Távolítsa el a használt normál rekeszt. Csomagolja ki az új normál rekeszt. Csatlakoztassa az új normál rekeszt. alkatrészek cseréje normál tároló normál tároló csere"},{"UUID":"2a8d1371-8dfe-4cbe-9777-b656b02fe3a5","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A ventilátorfedél cseréje Távolítsa el","descFull":"A ventilátorfedél cseréje Távolítsa el a használt ventilátorfedelet. Csomagolja ki az új fedelet. Helyezze be az új fedelet, amíg az a helyére nem  kattan . alkatrészek cseréje ventilátorfedél ventilátorfedél csere"},{"UUID":"19d18caa-4f7e-4565-95a7-0ef7c30d9fa1","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A jobb oldali fedél cseréje","descFull":"A jobb oldali fedél cseréje Távolítsa el a használt jobb oldali fedelet. Csomagolja ki az új fedelet. Helyezze be az új fedelet, amíg az a helyére nem  kattan . alkatrészek cseréje jobb oldali fedél jobb oldali fedél csere"},{"UUID":"24e148a0-6310-43f5-9f90-b96310575286","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"Az üvegtisztító eszköz cseréje Nyissa","descFull":"Az üvegtisztító eszköz cseréje Nyissa fel a lapolvasó fedelét. Távolítsa el a használt üvegtisztító eszközt. Csomagolja ki az új üvegtisztítót. Helyezze be az új üvegtisztítót. Csukja be a lapolvasó fedelét. alkatrészek cseréje üvegtisztító eszköz üvegtisztító eszköz csere"},{"UUID":"83ef4728-5948-4fda-8bfb-1cc3c74a272d","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A papírszállító egység csatlakozófedelének cseréje","descFull":"A papírszállító egység csatlakozófedelének cseréje A papírszállító egység csatlakozófedelének cseréje Vegye ki a normál rekeszt. Távolítsa el a papírszállító egység használt csatlakozófedelét. Csomagolja ki az új csatlakozófedelet. Helyezze fel az új csatlakozófedelet, amíg az a helyére nem  kattan . Csatlakoztassa a normál rekeszt. alkatrészek cseréje papírszállító egység csatlakozófedele papírszállító egység csatlakozófedele csere"},{"UUID":"00c5a7fa-65ed-46b6-8030-707d1734692d","title":"Tűzőkazetta-egység cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A tűzőkazetta cseréje a kapcsozó","descFull":"A tűzőkazetta cseréje a kapcsozó kiadóban Fogja meg az F fogantyút, majd csúsztassa balra a kapcsozó kiadót. Vegye ki a tűzőkazetta tartóját. Vegye ki az üres tűzőkazettát. Tegye be az új tűzőkazettát úgy, hogy  bepattanjon  a helyére. Nyomással  pattintsa be  a helyére a tűzőkazetta tartóját. Csúsztassa a kapcsozó kiadót jobbra. kellékanyagok cseréje tűzőkazetta tűzőkazetta csere"},{"UUID":"d3ad19c4-778b-4ebc-897c-31b06c9de3e5","title":"Tűzőkazetta-egység cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A kapcsozó-lyukasztó kiadóegység tűzőkazettájának cseréje","descFull":"A kapcsozó-lyukasztó kiadóegység tűzőkazettájának cseréje Nyissa ki a H ajtót. Húzza ki a zöld fogantyút, majd vegye ki a tűzőkazetta-tartót. Vegye ki az üres tűzőkazettát. Bontsa ki az új tűzőkazettát. Tegye be az új tűzőkazettát úgy, hogy  bepattanjon  a helyére. Nyomással  pattintsa be  a helyére a tűzőkazetta tartóját. H ajtó bezárása. kellékanyagok cseréje tűzőkazetta tűzőkazetta csere"},{"UUID":"73a1ebdc-451d-4750-9f3b-826227d69cb2","title":"Tűzőkazetta-egység cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A tűzőkazetta cseréje a füzetkészítő","descFull":"A tűzőkazetta cseréje a füzetkészítő egységben Nyissa ki a H ajtót. Húzza ki a zöld fogantyút, majd vegye ki a tűzőkazetta-tartót. Vegye ki az üres tűzőkazettát. Bontsa ki az új tűzőkazettát. Tegye be az új tűzőkazettát úgy, hogy  bepattanjon  a helyére. Nyomással  pattintsa be  a helyére a tűzőkazetta tartóját. H ajtó bezárása. kellékanyagok cseréje tűzőkazetta tűzőkazetta csere"},{"UUID":"9b48fa9a-520f-42c5-93ca-4fb704986d1b","title":"Tűzőkazetta-egység cseréje","link":"replacing-toner-cartridge-topic.html","desc":"A tűzőkazetta-tartók cseréje a füzetkészítő","descFull":"A tűzőkazetta-tartók cseréje a füzetkészítő egységben Nyissa ki a kiadóegység ajtaját. Húzza ki a füzetkészítő egységet, majd távolítsa el az elhasznált tűzőkazetta-tartókat. Csomagolja ki az új tűzőkazetta-tartókat. Helyezze be az új tűzőkazetta-tartókat. Helyezze be a füzetkészítő egységet, majd csukja be a kiadóegység ajtaját. alkatrészek cseréje tűzőkazetta-tartó tűzőkazetta-tartó csere"},{"UUID":"b19fa37e-48fa-4e1d-b0ae-e47a5c7b5143","title":"Alkatrészek és kellékanyagok cseréje","link":"replacing-toner-cartridge-topic.html","desc":"Kellékanyag-használati számlálók visszaállítása Kellékanyag-használati számlálók","descFull":"Kellékanyag-használati számlálók visszaállítása Kellékanyag-használati számlálók visszaállítása A kezelőpanelről navigáljon a  Beállítások Eszköz Karbantartás Konfigurációs menü Kellékhasználat és -számlálók . Válassza ki a visszaállítani kívánt számlálót. A visszajuttatási program szerződési feltételekkel nem rendelkező kellékanyagok és alkatrészek visszaállíthatók és utángyárthatók. A gyártói garancia azonban nem vonatkozik a nem eredeti kellékanyagok vagy alkatrészek által okozott károkra. A kellékanyag vagy alkatrész számlálóinak a megfelelő utángyártás nélküli visszaállítása károsíthatja a nyomtatót. A kellékanyag vagy alkatrész számlálójának visszaállítása után a nyomtató hibaüzenetet jeleníthet meg, amely jelzi a visszaállított elem jelenlétét. A használati és visszajuttatási program szerződési feltételekkel nem rendelkező kellékanyagok és alkatrészek visszaállíthatók és utángyárthatók. A gyártói garancia azonban nem vonatkozik a nem eredeti kellékanyagok vagy alkatrészek által okozott károkra. A kellékanyag vagy alkatrész számlálóinak a megfelelő utángyártás nélküli visszaállítása károsíthatja a nyomtatót. A kellékanyag vagy alkatrész számlálójának visszaállítása után a nyomtató hibaüzenetet jeleníthet meg, amely jelzi a visszaállított elem jelenlétét. kellékanyag-használati számlálók alaphelyzetbe állítás kellékanyag-használati számlálók alaphelyzetbe állítása"},{"UUID":"379fe73c-2317-42a9-a55a-aa755d53ce00","title":"A nyomtató alkatrészeinek tisztítása","link":"cleaning-printer-topic.html","desc":"A nyomtató tisztítása A nyomtató","descFull":"A nyomtató tisztítása A nyomtató tisztítása A nyomtató külsejének tisztításakor az áramütés veszélyének elkerülése érdekében először húzza ki a tápkábelt a fali aljzatból, majd húzzon ki minden kábelt a nyomtatóból. Néhány havonta végezze el ezt a feladatot. A helytelen kezelésből adódó károkra a nyomtató jótállása nem terjed ki. Kapcsolja ki a nyomtatót, majd húzza ki a tápkábelt a csatlakozóaljzatból. Vegye ki a papírt a normál rekeszből és a többcélú adagolóból. Egy puha kefe vagy porszívó segítségével távolítsa el a nyomtató körüli port, szöszöket és papírdarabokat.   Törölje le a nyomtató külsejét nedves, puha, szöszmentes kendővel. Ne használjon háztartási tisztítószereket vagy mosószereket, mert azok kárt tehetnek a nyomtató külsejében. Ügyeljen, hogy a tisztítás után a nyomtató összes része száraz legyen. Csatlakoztassa a tápkábelt a fali konnektorhoz, majd kapcsolja be a nyomtatót. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. nyomtató tisztítása nyomtató, tisztítás"},{"UUID":"34d3158d-2436-4ca4-9ec0-8a12f316c4d1","title":"A nyomtató alkatrészeinek tisztítása","link":"cleaning-printer-topic.html","desc":"Az érintőképernyő tisztítása Az érintőképernyő","descFull":"Az érintőképernyő tisztítása Az érintőképernyő tisztítása A nyomtató külsejének tisztításakor az áramütés veszélyének elkerülése érdekében először húzza ki a tápkábelt a csatlakozóaljzatból, majd húzzon ki minden kábelt a nyomtatóból. Kapcsolja ki a nyomtatót, majd húzza ki a tápkábelt a csatlakozóaljzatból. Egy puha, nedves, szöszmentes ruhaanyaggal törölje le az érintőkijelzőt. Ne használjon háztartási tisztítószert vagy mosószert, mert ezek kárt tehetnek az érintőkijelzőben. Tisztítás után ellenőrizze, hogy az érintőkijelző száraz-e. Csatlakoztassa a tápkábelt a fali konnektorhoz, majd kapcsolja be a nyomtatót. A tűzveszély és az áramütés elkerülése érdekében a tápkábelt közvetlenül egy, a készülékhez közeli, könnyen hozzáférhető, megfelelő besorolású és megfelelően földelt konnektorba csatlakoztassa. érintőképernyő, tisztítás érintőképernyő tisztítása"},{"UUID":"6f7b846f-dcf8-4c65-8ce5-bf23d8068824","title":"A nyomtató alkatrészeinek tisztítása","link":"cleaning-printer-topic.html","desc":"Lapolvasó tisztítása Nyissa fel a","descFull":"Lapolvasó tisztítása Nyissa fel a lapolvasó fedelét. Távolítsa el az üvegtisztító eszközt. Nyissa ki az A1 ajtót. Az eszközzel törölje le az ADF üvegét. Zárja be az A1 ajtót. Egy puha, nedves, szöszmentes ruhaanyaggal törölje le a következő területeket: Az automatikus lapadagoló üvegének beolvasólapja Lapolvasó üveg beolvasólapja Lapolvasó üveglapja Az eszközzel törölje le az ADF üvegét. Helyezze vissza az eszközt a helyére. Csukja be a lapolvasó fedelét. lapolvasó tisztítás nyomtatási minőség lapolvasó tisztítása lapolvasó tisztítása"},{"UUID":"b8bdd097-c085-4fc3-9f9a-53b931889981","title":"A nyomtató alkatrészeinek tisztítása","link":"cleaning-printer-topic.html","desc":"A nyomtatófejlencsék tisztítása Nyissa ki","descFull":"A nyomtatófejlencsék tisztítása Nyissa ki az elülső ajtót. Távolítsa el a tonerkazettákat. Óvatosan húzza ki a törlőt, amíg meg nem áll. A törlő nem válik le a nyomtatóról. Nyomja vissza a törlőt a nyomtatófejbe, amíg meg nem áll. Ismétlés  3. lépés  és  4. lépés  háromszor minden egyes nyomtatófejhez. Helyezze be a tonerkazettákat. Csukja be az elülső ajtót. nyomtatófej lencsék tisztítás a nyomtatófej lencséjének megtisztítása"},{"UUID":"a4c182bc-b854-44f2-83f9-644c8f7cad3b","title":"A nyomtató alkatrészeinek tisztítása","link":"cleaning-printer-topic.html","desc":"A lyukasztódoboz kiürítése A telepített","descFull":"A lyukasztódoboz kiürítése A telepített kiadóegységtől függően a lyukasztódoboz megjelenése változhat. Nyissa ki a kiadóegység ajtaját. Vegye ki, és ürítse ki a lyukasztódobozt. Helyezze be a lyukasztódobozt. Csukja be a szétválogató ajtaját. lyukasztódoboz ürítés lyukasztódoboz kiürítése"},{"UUID":"2a8a37d0-bd7d-41f2-8b75-f9b83722b371","title":"Energia- és papírtakarékosság","link":"configuring-power-save-mode-settings-topic.html","desc":"Energiatakarékos üzemmód beállításainak módosítása Energiatakarékos","descFull":"Energiatakarékos üzemmód beállításainak módosítása Energiatakarékos üzemmód beállításainak módosítása alvó üzemmód A kezelőpanelen navigáljon a  Beállítások Eszköz Energiagazdálkodás Időkorlátok Alvó üzemmód  menüpontra. Állítsa be, hogy a nyomtató mennyi ideig maradjon készenléti állapotban, mielőtt  Alvó üzemmódba  lép. Hibernálási üzemmód A kezelőpanelen navigáljon a  Beállítások Eszköz Energiagazdálkodás Időkorlátok Hibernációs időkorlát  menüpontra. Állítsa be, hogy a nyomtató mennyi ideig maradjon készenléti állapotban, mielőtt Hibernált üzemmódba lép. A  Hibernálási idő  működtetéséhez állítsa be a  Hibernálási idő kapcsolat esetén  elemet  Hibernált  értékre. Az Embedded Web Server le van tiltva, amikor a nyomtató hibernált üzemmódban van. alvó üzemmód konfigurálás Hibernálási üzemmód konfigurálás energiatakarékos üzemmódok konfigurálás"},{"UUID":"047851e5-8cea-48f5-9d34-70889ec0aa8e","title":"Energia- és papírtakarékosság","link":"configuring-power-save-mode-settings-topic.html","desc":"A kijelző fényerejének beállítása A","descFull":"A kijelző fényerejének beállítása A kijelző fényerejének beállítása A kezelőpanelen navigáljon a  Beállítások Eszköz Beállítások  menüpontra. A  Kijelző fényereje  menüben módosítsa a beállítást. kijelző fényereje beállítás fényerő módosítása"},{"UUID":"80338aa0-7e17-471d-9c12-00b8a7c06fac","title":"Energia- és papírtakarékosság","link":"configuring-power-save-mode-settings-topic.html","desc":"Kellékanyagok megőrzése Nyomtatás a papír","descFull":"Kellékanyagok megőrzése Nyomtatás a papír mindkét oldalára. A kétoldalas nyomtatás az alapértelmezett beállítás a nyomtatón. Több oldal nyomtatása egyetlen lapra. A nyomtatás előtt az előnézet funkció használatával tekintheti meg, hogyan fog mutatni a kész nyomtatás. Nyomtasson egy példányt a dokumentumból és ellenőrizze tartalmának és formátumának helyességét. kellékanyagok megőrzése takarékoskodás, kellékanyagokkal"},{"UUID":"af77b162-cb4b-4ef0-95b3-91847914f699","title":"A nyomtató karbantartása","link":"moving-printer-topic.html","desc":"A nyomtató áthelyezése más helyre","descFull":"A nyomtató áthelyezése más helyre A nyomtató áthelyezése más helyre Ha a nyomtató nehezebb mint 20 kg (44 font), a biztonságos megemeléséhez legalább két ember szükséges. A tűzveszély és az áramütés elkerülése érdekében csak a termékhez kapott vagy a gyártó által hitelesített tápkábelt használja. A nyomtató mozgatásakor tartsa be az alábbi útmutatásokat a személyi sérülések és a nyomtató károsodásának elkerülése érdekében: Ellenőrizze, hogy az összes ajtó és tálca zárva legyen. Kapcsolja ki a nyomtatót, és húzza ki a tápkábelt a konnektorból. Húzzon ki a nyomtatóból minden vezetéket és kábelt. Ha a nyomtatóhoz padlón álló, külön megvásárolható tálcák vagy kimeneti egységek csatlakoznak, a nyomtató mozgatása előtt csatlakoztassa le azokat. Ha a nyomtatóhoz görgős talp tartozik, tolja át a készüléket óvatosan az új helyére. Legyen óvatos, amikor küszöbökön vagy padlórepedéseken halad keresztül! Ha a nyomtató nem rendelkezik görgős talppal, de külön megvásárolható tálcák vagy kimeneti egységek csatlakoznak hozzá, vegye le a kimeneti egységeket, majd emelje le a nyomtatót a tálcákról. Ne próbálja egyszerre megemelni a nyomtatót és a többi egységet. A nyomtatót mindig a rajta található fogantyúk használatával emelje fel. A nyomtató mozgatására használt kocsinak elegendő rakfelülettel kell rendelkeznie a nyomtató teljes alapterületéhez. A hardveres kiegészítők mozgatására használt kocsinak elegendő rakfelülettel kell rendelkeznie a kiegészítők teljes méretéhez. Tartsa a nyomtatót függőlegesen. Óvakodjon az rázkódással járó mozgástól. Ügyeljen rá, hogy az ujja ne kerüljön a nyomtató alá, amikor lerakja. Ügyeljen rá, hogy elég szabad hely maradjon a nyomtató körül. A helytelen áthelyezésből adódó károkra a nyomtató jótállása nem terjed ki. nyomtató áthelyezése"},{"UUID":"6c911299-9a72-4846-a310-f564a08e9524","title":"Problémák elhárítása","link":"print-quality-problems-topic.html","desc":"Nyomtatási minőséggel kapcsolatos problémák Keresse","descFull":"Nyomtatási minőséggel kapcsolatos problémák Keresse meg az Ön által tapasztalt nyomtatási hibát illusztráló képet, majd kattintson az alatta lévő hivatkozásra a megoldás megtekintéséhez."},{"UUID":"6669a5f6-2a6b-49b4-aa5d-735c813b0e36","title":"Problémák elhárítása","link":"printer-error-codes-topic.html","desc":"A nyomtató hibakódjai Hibakódok és","descFull":"A nyomtató hibakódjai Hibakódok és megoldásuk Hibakódok A hibaüzenet Megoldás 2.01 Kellékanyag szükséges. Válassza a  Feladat törlése  elemet, és rendelje meg a szükséges kellékanyagot. További információkért lásd:  . 3.01 A normál kimeneti rekesz megtelt. Vegye ki a papírt a rekeszből, majd válassza a  Folytatás  lehetőséget. 3.02, 3.03, 3.04 Távolítsa el a papírt a(z) [x]. rekeszből. Vegye ki a papírt a rekeszből, majd válassza a  Folytatás  lehetőséget. 7.13, 7.23, 7.33,7.43 Helyezze be az [x]. tálcát. Illessze be a megadott tálcát. 8.01 Csukja be az elülső ajtót. Csak akkor nyissa ki az elülső ajtót, ha karbantartást végez. 8.02, 8.03, 8.04, 8.05, 8.08, 8.10, 8.11 Csukja be az ajtót: [x]. Csak akkor nyissa ki a jelzett ajtót, ha karbantartást végez. 8.06 Illessze vissza az 1500 lapos fiókot. Győződjön meg róla, hogy a tálca megfelelően rögzül a nyomtatóhoz. 8.07 Helyezze vissza a kapcsozó kiadót. Győződjön meg róla, hogy a kiadóegység megfelelően rögzül a nyomtatóhoz. 8.08 Csukja be a papírszállító egység F fedelét. Csak akkor nyissa ki a fedelet, ha karbantartást végez. 8.09 Csukja be a papírszállító egység G fedelét. 9 A nyomtató újraindult. Lehet, hogy az utolsó feladat nincs befejezve. Válassza a  Folytatás  gombot az üzenet törléséhez és a nyomtatás folytatásához. 11.11, 11.21, 11.31, 11.41, 11.51, 11.81, 11.91 <forrás/> feltöltése ezzel: <típus/>, <méret/>. Töltse fel a jelzett tálcát papírral. További információkért lásd:  . 11.12, 11.22, 11.32, 11.42, 11.82, 11.92 <Forrás/> feltöltése ezzel: <típus/>, <méret/>, <tájolás/>. 12.11, 12.21, 12.31, 12.41, 12.51, 12.91 <forrás/> módosítása erre: <típus/>, <méret/>. Húzza ki a megadott tálcát, vegye ki a papírt, majd töltsön be megfelelő típusú és méretű papírt. További információkért lásd:  . 12.12, 12.22, 12.32, 12.4212.92 <Forrás/> módosítása erre: <típus/>, <méret/>, <tájolás/>. 31.00 A lyukasztódoboz hiányzik vagy megtelt. Nyissa ki a H ajtót. Vegye ki a lyukasztódobozt. Ha a lyukasztódoboz megtelt, ürítse ki. Helyezze be a lyukasztódobozt. H ajtó bezárása. 31.35, 31.35A, 31.35B Helyezze vissza a hiányzó vagy nem reagáló hulladékfesték-tartályt. Nyissa ki az elülső ajtót. Vegye ki a hulladékfesték-tartályt. A festék kiömlésének elkerülése érdekében a tartályt függőleges helyzetben tárolja. Helyezze be a hulladékfesték-tartályt. Csukja be az elülső ajtót. 31.40z, 31.41z, 31.42z, 31.43z Helyezze vissza a hiányzó vagy nem reagáló [szín] tonerkazettát. Nyissa ki az elülső ajtót. Vegye ki a kazettát. Helyezze be a kazettát. Csukja be az elülső ajtót. 31.60z Helyezze vissza a hiányzó vagy nem reagáló fekete képalkotó egységet. Nyissa ki az elülső ajtót. Távolítsa el a tonerkazettákat. Vegye ki a hulladékfesték-tartályt. A festék kiömlésének elkerülése érdekében a tartályt függőleges helyzetben tárolja. Távolítsa el a képalkotó készletet. Ne tegye ki közvetlen fény hatásának a képalkotó készletet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a fényvezető dobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Nyissa ki, majd vegye ki a fekete képalkotó egységet. Helyezze be a fekete képalkotó egységet, majd rögzítse a helyén. Úgy helyezze be a képalkotó készletet, hogy az teljesen beüljön a helyére. Helyezze be a hulladékfesték-tartályt. Helyezze be a tonerkazettákat. Csukja be az elülső ajtót. 31.64z Helyezze vissza a hiányzó, kihúzott vagy nem reagáló színes képalkotó készletet. Nyissa ki az elülső ajtót. Távolítsa el a tonerkazettákat. Vegye ki a hulladékfesték-tartályt. A festék kiömlésének elkerülése érdekében a tartályt függőleges helyzetben tárolja. Távolítsa el a képalkotó készletet. Ne tegye ki közvetlen fény hatásának a képalkotó készletet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a fényvezető dobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Úgy helyezze be a képalkotó készletet, hogy az teljesen beüljön a helyére. Helyezze be a hulladékfesték-tartályt. Helyezze be a tonerkazettákat. Csukja be az elülső ajtót. 31.80z Hiányzó vagy nem válaszoló beégető egység újratelepítése. Nyissa ki a B ajtót. Előfordulhat, hogy a nyomtató belseje forró. Az égési sérülések elkerülése érdekében várja meg, amíg a forró felületek kihűlnek. Oldja ki, majd vegye ki a beégetőegységet. Helyezze be a beégetőegységet, majd rögzítse a helyére. Csukja be a B ajtót. 32.40z, 32.41z, 32.42z, 32.43z Cserélje ki a nem támogatott [szín] tonerkazettát. További információkért lásd:  . 32.60z Cserélje ki a nem támogatott fekete képalkotó egységet. További információkért lásd:  . 32.65z Cserélje ki a nem támogatott színes képalkotó készletet. További információkért lásd:  . 33.40z, 33.41z, 33.42z, 33.43z Újratöltött hagyományos [szín] kazetta További információkért lásd:  . 33.60z Nem eredeti fekete képalkotó egység. Lásd a Használati útmutatót. További információkért lásd:  . 33.64z Nem eredeti színes képalkotó készlet. Lásd a Használati útmutatót. 34.00 Túl rövid papír. Állítsa be a papírméretet a tálcába betöltött papírnak megfelelően. A kezelőpanelen navigáljon a  Beállítások Papír Tálca Konfiguráció Papírméret/típus  menüpontra. 34.10, 34.20, 34.30, 34.40, 34.50 Ellenőrizze a következőt: [forrás], állítsa be a papírvezetőket és a tájolást. Húzza ki a megadott tálcát, majd győződjön meg arról, hogy a papír megfelelően van-e betöltve. További információkért lásd:  . 34.90 Ellenőrizze a többcélú adagolót, állítsa be a papírvezetőket és a tájolást. Ellenőrizze, hogy a papír helyesen van-e betöltve. További információkért lásd:  . 37.1 Nincs elegendő memória a feladat leválogatásához. Próbálja meg az alábbiak valamelyikét: Ha szeretné kinyomtatni a munka tárolt részét és elkezdeni a nyomtatási feladat maradék részének leválogatását, akkor válassza a  Folytatás  lehetőséget. Szakítsa meg az aktuális nyomtatási feladatot. 37.3 Nincs elég memória, egyes felfüggesztett feladatok törlődtek. Válassza a  Folytatás  gombot az üzenet törléséhez és a nyomtatás folytatásához. 38.1 Memória megtelt. Próbálja meg a következők valamelyikét: Válassza a  Folytatás  lehetőséget az üzenet törléséhez és a nyomtatás folytatásához. Szakítsa meg az aktuális nyomtatási feladatot. Telepítsen további nyomtatómemóriát. Csökkentse a nyomtatási feladatban lévő lapok számát. 39.1 Összetett oldal, előfordulhat, hogy néhány adat nincs kinyomtatva. Próbálja meg a következők valamelyikét: Válassza a  Folytatás  lehetőséget az üzenet törléséhez és a nyomtatás folytatásához. Szakítsa meg az aktuális nyomtatási feladatot. Telepítsen további nyomtatómemóriát. Csökkentse a nyomtatási feladat összetettségét és méretét, mielőtt ismét nyomtatásba küldené. Csökkentse a nyomtatási feladatban lévő lapok számát. Csökkentse a letöltött betűtípusok számát és méretét. Törölje a felesleges betűtípusokat vagy makrókat a nyomtatási feladatból. Csökkentse a nyomtatási feladatban lévő grafikák számát. 42.yyC, 42.yyK, 42.yyM, 42.yyY Cserélje ki a [szín] tonerkazettát, a nyomtató régiója nem egyezik. További információkért lásd:  . 43.40Y, 43.41Y, 43.42Y, 43.43Y Helyezze vissza a [szín] tonerkazettát. Nyissa ki az elülső ajtót. Vegye ki a kazettát. Helyezze be a kazettát. Csukja be az elülső ajtót. 43.40Z, 43.41Z, 43.42Z, 43.43Z Cserélje ki a [szín] tonerkazettát. További információkért lásd:  . 50 A PPDS-betűtípus hibája. Telepítse a nyomtatási feladatban megjelölt PPDS-betűtípust, majd válassza a  Folytatás  lehetőséget, hogy a nyomtató megkeresse a helyettesítő betűtípust. 51 Hibás flash-memória észlelhető. Próbálja meg a következők valamelyikét: Cserélje ki a flash-memóriát. Válassza a  Folytatás  gombot az üzenet törléséhez és a nyomtatás folytatásához. Szakítsa meg az aktuális nyomtatási feladatot. 52 Nincs elég szabad hely a flash-memóriában az erőforrások számára. Próbálja meg a következők valamelyikét: Válassza a  Folytatás  gombot az üzenet törléséhez és a nyomtatás folytatásához. Törölje a flash-memórián tárolt betűtípusokat, makrókat és egyéb adatokat. Szereljen be egy tárolómeghajtót. A flash-memórián előzőleg nem tárolt, letöltött betűtípusok és makrók törölve lesznek. 58.4 Hibás a kimeneti opció konfigurációja. Kapcsolja ki a nyomtatót, majd helyezze be a megfelelő rekeszt vagy kiadóegységet. 61 Távolítsa el a hibás lemezt. Cserélje ki a hibás tárolómeghajtót. 62 Lemez megtelt. Próbálja meg a következők valamelyikét: Válassza a  Folytatás  gombot az üzenet törléséhez és a nyomtatás folytatásához. A tárolómeghajtón tárolt betűtípusok, makrók és egyéb adatok törlése. Szereljen be egy tárolómeghajtót. 63 Formázza a lemezt. A formázás mostantól minden adatot töröl a tárolómeghajtóról. A lemez formázásához tegye az alábbiakat: A kezelőpanelről navigáljon a  Beállítások Eszköz Karbantartás Üzemen kívüli törlés . Válassza a  Minden információ letisztítása a merevlemezről  elemet, majd válassza a  TÖRLÉS  elemet. 71.01 A Faxállomásnév nincs beállítva. Lépjen kapcsolatba a rendszergazdával. További információkért lásd:  . 71.02 A Faxállomásszám nincs beállítva. Lépjen kapcsolatba a rendszergazdával. 71.03 Nem kapcsolódik analóg telefonvonal a modemhez, fax kikapcsolva. Ellenőrizze a csatlakozást és a vonalat, hogy van-e jel. További információkért lásd:  . 71.04 Az analóg telefonvezeték nem a megfelelő porthoz van csatlakoztatva. Húzza ki a telefonvezetéket, majd csatlakoztassa a LINE porthoz. 71.06 Nem lehet csatlakozni a HTTPS faxkiszolgálóhoz. Megszakadt a kapcsolat a HTTPS faxkiszolgálóval. Ellenőrizze a nyomtató internetkapcsolatát. 71.07 A nyomtató nincs regisztrálva a HTTPS faxkiszolgálóhoz. Ellenőrizze, hogy a nyomtatót hozzáadták-e az eszközlistához a HTTPS faxkiszolgáló portálon. Forduljon a rendszergazdához. 71.11 Faxpartíció. A faxpartíció nem működik. Forduljon a rendszergazdához. 71.12 A memória megtelt, nem nyomtathatók faxok. Válassza az  Összes nyomtatása  lehetőséget, hogy kinyomtassa az összes elmentett faxot. 71.13 Memória megtelt. Nem lehet faxot küldeni. Próbálja meg az alábbiak valamelyikét: Folytassa a műveletet, és próbálja meg ismét elküldeni a faxot. Olvassa be az eredeti dokumentumot oldalanként, tárcsázza a faxszámot, majd olvassa be a dokumentumot. 71.4 A nyomtatón kijelzett idő nem megfelelő. Nyomtató idejének konfigurálása. A kezelőpanelen navigáljon a  Beállítások Eszköz Beállítások Dátum és idő Konfigurálás  menüpontra. 72.01 Az e-mail SMTP-kiszolgáló nincs beállítva. Lépjen kapcsolatba a rendszergazdával.  Próbálja meg az alábbiak valamelyikét: Állítsa be az e-mail-funkciót. További információkért lásd:  . Tiltsa le a hibaüzenetet. További információkért lásd:  . 72.02 A Web Link-kiszolgáló nincs beállítva. Lépjen kapcsolatba a rendszergazdával. Lépjen kapcsolatba a rendszergazdával. 72.04 A faxkiszolgáló címzettformátuma nincs beállítva. Lépjen kapcsolatba a rendszergazdával. Próbálja meg az alábbiak valamelyikét:  Konfigurálja a  Címzett formátuma  beállítást. A kezelőpanelen navigáljon a  Beállítások Fax Faxkiszolgáló beállítása Általános faxbeállítások  menüpontra. Lépjen kapcsolatba a rendszergazdával. 75.01 Secure Element biztonsági chip észlelve. Tegye az alábbiak valamelyikét: Használja a telepített Secure Element biztonsági chipet. A nyomtató törli az összes meglévő tanúsítványt, és törölheti és újraformázhatja a tárolómeghajtót is. Kapcsolja ki a nyomtatót, majd vegye ki a Secure Element biztonsági chipet. 75.02 nem sikerült felismerni a Secure Element biztonsági chipet. 75.03 Hiba a Secure Element biztonsági chippel való kommunikációban.  Tegye az alábbiak valamelyikét: Ne használja tovább a Secure Element biztonsági chipet. A nyomtató törli az összes meglévő tanúsítványt, és törölheti és újraformázhatja a tárolómeghajtót is. Kapcsolja ki a nyomtatót, vegye ki, majd helyezze be a Secure Element biztonsági chipet. 75.11 A Secure Element biztonsági chip frissítése sikertelen. Tegye az alábbiak valamelyikét: Próbálja meg újra a frissítést. Törölje a frissítést. A nyomtató törölheti az összes meglévő tanúsítványt és a tárolómeghajtó tartalmát. 75.12 A Secure Element biztonsági chip frissítése nem teljes. Tegye az alábbiak valamelyikét: Indítsa újra a nyomtatót. Várjon 10 másodpercet a frissítés befejezéséhez. Törölje a frissítést. A nyomtató törölheti az összes meglévő tanúsítványt és a tárolómeghajtó tartalmát. 80.01, 80.09 A karbantartó készlet szintje közepesen alacsony. Az üzenet törléséhez válassza a  Folytatás  lehetőséget. 80.11, 80.19 A karbantartó készlet szintje alacsony. 80.21, 80.29 A karbantartó készlet szintje nagyon alacsony. 80.31 A nyomtatás folytatásához cserélje ki a karbantartó készletet. További információkért lásd:  . 80.31 Cserélje ki a karbantartó készletet, ha az túllépte a javasolt élettartamot. 81.11 Az 1500 lapos tálca görgőkészletének szintje alacsony. Az üzenet törléséhez válassza a  Folytatás  lehetőséget. 81.31 Cserélje ki az 1500 lapos fiók görgőkészletét; túllépte az ajánlott élettartamot . További információkért, forduljon a következőhöz:  ügyféltámogatás . 82.00, 82.02, 82.09 A hulladékfesték-tartály majdnem megtelt. További információkért lásd:  . 82.3, 82.32, 82.33, 82.39 Cserélje ki a hulladékfesték-tartályt. 83.1y Átviteli modul kimerül. Az üzenet törléséhez válassza a  Folytatás  lehetőséget. 83.3y Cserélje ki a átviteli modult; túllépte az ajánlott élettartamot. További információkért, forduljon a következőhöz:  ügyféltámogatás . 83.4y Cserélje ki a átviteli modult. 83.20 Tűzőkazetta kifogyóban. Az üzenet törléséhez válassza a  Folytatás  lehetőséget. 83.20 A belső S2 kapcsok szintje alacsony. 83.20 A külső S2 kapcsok szintje alacsony. 83.30 A tűzőkazetta üres vagy hiányzik. Próbálja meg az alábbiak valamelyikét: Távolítsa el, majd helyezze vissza a tűzőkazettát. Cserélje ki a tűzőkazettát. További információért lásd:   vagy  . 83.30 Az S1 tűzőkazetta üres vagy hiányzik. Próbálja meg az alábbiak valamelyikét: Távolítsa el, majd helyezze vissza a tűzőkazettát. Cserélje ki a tűzőkazettát. További információkért lásd:  . 83.30 A belső S2 tűzőkazetta üres vagy hiányzik. Próbálja meg az alábbiak valamelyikét: Távolítsa el, majd helyezze vissza a tűzőkazettát. Cserélje ki a tűzőkazettát. További információkért lásd:  . 83.30 A külső S2 tűzőkazetta üres vagy hiányzik. 84.01K, 84.03K, 84.09K Fekete képalkotó egység szintje közepesen alacsony. Az üzenet törléséhez válassza a  Folytatás  lehetőséget. 84.11K, 84.13K, 84.19K Fekete képalkotó egység szintje alacsony. 84.21C, 84.03C, 84.09C Fekete képalkotó egység szintje nagyon alacsony. 84.01C, 84.03C, 84.09C Színes képalkotó készlet szintje közepesen alacsony. 84.11C, 84.13C, 84.19C Színes képalkotó készlet szintje alacsony. 84.21C, 84.23C, 84.29C Színes képalkotó készlet szintje nagyon alacsony. 84.31, 84.33 Cserélje ki a fekete képalkotó egységet, ha az túllépte a javasolt élettartamot. További információkért lásd:  . 84.31, 84.33 Cserélje ki a színes képalkotó készletet, ha az túllépte a javasolt élettartamot. További információkért lásd:  . 84.41, 84.43, 84.48 A nyomtatás folytatásához cserélje ki a fekete képalkotó egységet. További információkért lásd:  . 84.41, 84.43, 84.48 A nyomtatás folytatásához cserélje ki a színes képalkotó készletet. További információkért lásd:  . 86.23 Hamarosan lapolvasó-karbantartásra lesz szükség. Az üzenet törléséhez válassza a  Folytatás  lehetőséget. 86.33 Cserélje ki az ADF készletet, ha az túllépte a javasolt élettartamot. További információkért, forduljon a következőhöz:  ügyféltámogatás . 88.00[x], 88.07[x], 88.08[x], 88.09[x] a [szín] tonerkazetta szintje közepesen alacsony. Az üzenet törléséhez válassza a  Folytatás  lehetőséget. 88.10[x], 88.17[x], 88.18[x], 88.19[x] a [szín] tonerkazetta szintje alacsony. 88.20[x], 88.27[x], 88.28[x], 88.29[x] a [szín] tonerkazetta szintje nagyon alacsony. 88.30[x], 88.37[x], 88.38[x] Cserélje ki a [szín] tonerkazettát, <NUM/> becsült oldal maradt. További információkért lásd:  . 88.30[x], 88.37[x], 88.38[x] Cserélje ki a [szín] tonerkazettát. 88.40[x], 88.47[x], 88.48[x] Cserélje ki a [szín] tonerkazettát, 0 oldal maradt. 88.40[x], 88.47[x], 88.48[x] Cserélje ki a [szín] tonerkazettát. 200.03, 200.05, 200.12, 200.13, 200.14, 200.15, 200.22, 200.23, 200.24, 200.25, 200.26, 200.32, 200.33, 200.34, 200.35, 200.36, 200.42, 200.43, 200.44, 200.45, 200.46, 200.52, 200.53, 200.54, 200.55, 200.56, 200.91, 201.91, 202.02, 202.03, 202.04, 202.05, 202.12, 202.13, 202.14, 202.15, 202.22, 202.23, 202.24, 202.25, 202.32, 202.33, 202.34, 202.35, 202.42, 202.43, 202.44, 202.45, 202.52, 202.53, 202.54, 202.55, 202.91, 202.93, 202.95, 231.03, 231.05, 231.13, 231.15, 231.23, 231.25, 231.33, 231.35, 231.43, 231.45, 231.53, 231.55, 231.91, 232.03, 232.05, 232.13, 232.15, 232.23, 232.25, 232.33, 232.35, 232.43, 232.45, 232.53, 232.55, 232.93, 232.94, 232.95, 240.05, 240.25, 240.35, 240.45, 240.55, 240.91, 240.95, 241.12, 241.14, 241.15, 241.91 Papírelakadás itt: [LOCATION/]. További információkért lásd:  . 240.06 Papírelakadás itt: [LOCATION/]. További információkért lásd:  . 241.16, 241.82, 241.83, 241.84, 661.13, 661.84 Papírbetöltési hiba itt: [LOCATION/]. Nyissa ki az 1. tálcát. Távolítsa el, majd állítsa be újra a papírköteget. Ha szükséges, igazítsa meg a papírvezetőket. Töltse be újra az 1. tálcát. Csukja be az 1. tálcát. 242.23, 242.25, 242.35, 242.45, 242.55, 242.91 Papírelakadás itt: [LOCATION/]. További információkért lásd:  . 242.33, 242.43, 243.33, 243.35, 243.36, 243.43, 243.35, 243.45, 243.45, 243.55, 243.91, 244.43, 244.45, 244.91 Papírelakadás itt: [LOCATION/]. További információkért lásd az alábbiakat valamelyikét: 243.43, 243.53, 244.43, 244.45, 244.46, 244.91, 245.53, 245.56, 245.55, 245.91, 602.59, 664.43, 665.53 Papírelakadás itt: [LOCATION/]. További információkért lásd:  . 28X.13K, 28X.93K, 28X.15K, 28X.95K, 281.16K, 281.96K, 680.20K, 680.40K Az összes eredeti dokumentum kicserélése a feladat újraindításakor. Próbálja meg az alábbiak valamelyikét: Indítsa újra a feladatot. Törölje a feladatot. 28X.13Q, 28X.93Q, 28X.15Q, 28X.95Q, 281.16Q, 281.96Q, 680.20Q Helyezze vissza az elakadt eredetiket, ha folytatja a feladatot. Próbálja meg a következők egyikét: Beolvasás a lapolvasó üveglapjáról. Beolvasás az automatikus lapadagolóból. Feladat befejezése további beolvasás nélkül. Törölje a feladatot. 280.06 Töltse be újra az eredeti példányokat az automatikus lapadagolóba, és indítsa újra a feladatot. 280.06, 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 281.11, 281.15, 281.16, 281.91, 281.95, 281.96, 282.11, 282.13, 282.15, 282.91, 282.93, 282.95, 283.11, 283.13, 283.91, 283.15, 283.93, 284.11, 284.13, 284.15, 284.91, 284.93, 284.95, 295.01 Lapolvasó elakadása. További információkért lásd:  . 291.06 Zárja le a síkágy fedelét és töltse be az eredeti dokumentumot a feladat újraindításakor. Tegye a következők egyikét: Beolvasás a lapolvasó üveglapjáról. Beolvasás az automatikus lapadagolóból. Feladat befejezése további beolvasás nélkül. Törölje a feladatot. 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 444.66, 450.21, 450.23, 450.25, 450.98, 450.99, 451.21, 451.23, 451.25, 452.66, 453.21, 453.23, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 460.66, 461.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 472.66, 477.66, 480.66, 483.66, 486.29, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 Papírelakadás itt: [LOCATION/]. További információkért lásd:  . 400.11, 400.13, 400.15, 401.11, 401.13, 401.15, 404.19, 438.11, 438.21, 442.66, 444.66, 445.66, 450.21, 450.23, 450.25, 451.21, 451.23, 451.25, 451.98, 451.99, 452.66, 453.21, 453.23, 453.25, 454.21, 454.23, 454.25, 457.21, 457.23, 457.25, 459.66, 460.66, 461.66, 462.66, 463.66, 464.66, 465.66, 466.66, 467.66, 468.66, 469.66, 470.66, 472.66, 473.66, 476.66, 477.66, 480.66, 483.66, 486.29, 490.66, 491.21, 491.25, 491.66, 493.21, 494.21, 492.66, 494.66, 495.66, 496.66, 497.66, 504.11, 504.15, 505.11, 505.15, 514.19, 698.29 Papírelakadás itt: [LOCATION/]. További információkért lásd:  . 420.11, 420.13, 420.15, 420.99, 421.56, 422.56, 423.56, 424.56, 425.13, 425.15, 425.11, 426.11, 426.15, 428.56A, 428.56B, 431.56, 435.56, 438.11, 439.19, 461.56, 698.19 Papírelakadás itt: [LOCATION/]. További információkért lásd:  . 438.11, 500.11, 500.13, 500.15, 500.99, 502.11, 502.13, 502.15, 504.11, 504.13, 504.15, 505.13, 506.11, 506.13, 506.15, 507.11, 507.13, 507.15,  508.56, 509.56, 510.56, 511.56, 512.56, 513.56, 514.19, 698.19, 698.29 Papírelakadás itt: [LOCATION/]. További információkért lásd:  . 602.29, 662.23 Papírbetöltési hiba a 2. tálcában. További információkért lásd:  . 602.39, 663.33 Papírbetöltési hiba a 3. tálcában. További információkért lásd az alábbiakat valamelyikét: 602.49, 664.43 Papírbetöltési hiba a 4. tálcában. További információkért lásd:  . a nyomtató hibakódjai hibakódok nyomtatóüzenetek hibaüzenetek"},{"UUID":"3be0a377-62bf-427f-9c48-2bc6fa1f81cb","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Üres vagy fehér oldalak A","descFull":"Üres vagy fehér oldalak A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: Győződjön meg róla, hogy minden csomagolóanyagot eltávolított a képalkotó készletről, a képalkotó egységről és a tonerkazettákról. Ellenőrizze, hogy a nyomtató eredeti, támogatott Lexmark-tonerkazettát használ-e. Ellenőrizze, hogy a nyomtató eredeti, támogatott tonerkazettát használ-e. Ha a kazetta nem támogatott, helyezzen be egy támogatott kazettát. Győződjön meg arról, hogy a képalkotó készlet és a fekete képalkotó egység megfelelően van-e beszerelve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma fehér lapok nyomtatás minőségével kapcsolatos probléma üres oldalak üres oldalak fehér lapok"},{"UUID":"91a34657-e56c-4487-92eb-bf3b846f36bf","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Sötét nyomat A probléma megoldása","descFull":"Sötét nyomat A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: A kezelőpanelen navigáljon a  Beállítások Nyomtatás Minőség Speciális képalkotás  menüpontra, majd válassza a  Színbeállítás  lehetőséget. A festék sötétségét az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen csökkentheti. A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Nyomtatás Minőség Festék sötétsége  menüponthoz. A papír típusát az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítások megfeleljenek a tálcába töltött papírnak.  A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Ellenőrizze, hogy a tálcába töltött papír felülete nem túl durva-e. Töltsön be papírt egy bontatlan csomagból. A papír magas páratartalom esetén megszívja magát nedvességgel. Tárolja a papírt az eredeti csomagolásban, amíg nem használja fel. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma sötét nyomtatás sötét nyomtatás"},{"UUID":"417d5ce9-c1c2-4dbd-9de2-83f183fb7484","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Szellemképek A probléma megoldása előtt","descFull":"Szellemképek A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: Töltse fel a tálcát a megfelelő típusú és súlyú papírral. A papír típusát az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítások megfeleljenek a tálcába töltött papírnak.  A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. A kezelőpanelen navigáljon a  Beállítások Nyomtatás Minőség Speciális képalkotás  menüpontra, majd válassza a  Színbeállítás  lehetőséget. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma szellemképek szellemképek"},{"UUID":"04f0ea38-9f0d-4a74-84a8-cf53c9550227","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Szürke vagy színes háttér A","descFull":"Szürke vagy színes háttér A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: Az operációs rendszertől függően növelje a festékmennyiséget a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelről. A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Nyomtatás Minőség Festék sötétsége  menüponthoz. A kezelőpanelen navigáljon a  Beállítások Nyomtatás Minőség Speciális képalkotás  menüpontra, majd válassza a  Színbeállítás  lehetőséget. Győződjön meg arról, hogy a képalkotó készlet és a fekete képalkotó egység megfelelően van-e beszerelve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma szürke vagy színes háttér szürke háttér nyomaton színes háttér nyomaton"},{"UUID":"6ce19d02-033a-4147-96d2-f21c59714a80","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Helytelen margók Próbálja meg a","descFull":"Helytelen margók Próbálja meg a következők valamelyikét: Állítsa a tálcában lévő papírvezetőket a betöltött papírnak megfelelő pozícióba. A papír méretét az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítás megfeleljen a betöltött papírnak.  A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma helytelen margók helytelen margók"},{"UUID":"7717a485-ac9a-4d34-8c44-2417585fd349","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Túl világos nyomat A probléma","descFull":"Túl világos nyomat A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: Győződjön meg róla, hogy minden csomagolóanyagot eltávolított a képalkotó készletről, a képalkotó egységről és a tonerkazettákról. A kezelőpanelen navigáljon a  Beállítások Nyomtatás Minőség Speciális képalkotás  menüpontra, majd válassza a  Színbeállítás  lehetőséget. Az operációs rendszertől függően növelje a festékmennyiséget a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelről.  A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Nyomtatás Minőség Festék sötétsége  menüponthoz. A kezelőpanelen navigáljon a  Beállítások Nyomtatás Minőség  menüpontra, majd kapcsolja ki a  Színmegtakarító  funkciót. A papír típusát az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítás megfeleljen a betöltött papírnak.  A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Ellenőrizze, hogy a tálcába töltött papír felülete nem túl durva-e. Töltsön be papírt egy bontatlan csomagból. A papír magas páratartalom esetén megszívja magát nedvességgel. Tárolja a papírt az eredeti csomagolásban, amíg nem használja fel. Győződjön meg arról, hogy a képalkotó készlet és a fekete képalkotó egység megfelelően van-e beszerelve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma túl világos nyomat túl világos nyomat"},{"UUID":"b2aa95c3-8e06-4275-8a57-32d18294c152","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Hiányzó színek A probléma megoldása","descFull":"Hiányzó színek A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: Győződjön meg róla, hogy minden csomagolóanyagot eltávolított a képalkotó készletről, a képalkotó egységről és a tonerkazettákról. Vegye ki a hiányzó színű előhívó egységet. Távolítsa el a képalkotó készletet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Vegye ki, majd helyezze vissza a hiányzó szín előhívó egységét. Helyezze be a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma hiányzó színek hiányzó színek"},{"UUID":"5a56f864-96d0-4453-a72e-1b6d1ae9090c","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Tarka és pöttyös nyomat Tarka","descFull":"Tarka és pöttyös nyomat Tarka és pöttyös nyomat A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: Ellenőrizze, nem szennyezte-e be a nyomtatót a kiszivárgott festék. Győződjön meg róla, hogy a papírméret és a papírtípus beállításai megfelelnek a betöltött papírnak. A kezelőpanelről kiindulva lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  elemre. Ellenőrizze, hogy a tálcába töltött papír felülete nem túl durva-e. A papírméretet és papírtípust az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítások megfeleljenek a tálcába töltött papírnak. Töltsön be papírt egy bontatlan csomagból. A papír magas páratartalom esetén megszívja magát nedvességgel. Tárolja a papírt az eredeti csomagolásban, amíg nem használja fel. Győződjön meg arról, hogy a képalkotó készlet és a fekete képalkotó egység megfelelően van-e beszerelve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma tarka és pöttyös nyomat tarka és pöttyös nyomat pöttyök a kinyomtatott oldalon"},{"UUID":"e66f1850-4afc-4117-9a09-9ff01dcaac6f","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Görbe vagy ferde nyomat A","descFull":"Görbe vagy ferde nyomat A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: Töltsön be papírt egy bontatlan csomagból. Nyissa ki a tálcát, majd vegye ki a papírt. Töltsön be papírt egy bontatlan csomagból. A papír magas páratartalom esetén megszívja magát nedvességgel. Tárolja a papírt az eredeti csomagolásban, amíg nem használja fel. Állítsa a tálcában lévő papírvezetőket a betöltött papírnak megfelelő pozícióba. Győződjön meg arról, hogy támogatott papírra nyomtat. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma eltorzult nyomat nyomtatás minőségével kapcsolatos probléma görbe nyomat görbe nyomat eltorzult nyomat"},{"UUID":"b5ffba7a-231d-4b1a-8a38-9021fc6205c6","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Egyszínű vagy fekete képek A","descFull":"Egyszínű vagy fekete képek A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma egyszínű vagy fekete képek egyszínű fekete képek"},{"UUID":"e0c811d1-16bb-4ca8-9d0e-6bdc995ac181","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Levágott szöveg vagy kép A","descFull":"Levágott szöveg vagy kép A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: Győződjön meg róla, hogy minden csomagolóanyagot eltávolított a képalkotó készletről, a képalkotó egységről és a tonerkazettákról. Állítsa a tálcában lévő papírvezetőket a betöltött papírnak megfelelő pozícióba. A papír méretét az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítások megfeleljenek a tálcába töltött papírnak.  A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Győződjön meg arról, hogy a képalkotó készlet és a fekete képalkotó egység megfelelően van-e beszerelve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma levágott szöveg vagy kép szöveg levágása a nyomaton képeket levágni a nyomtatásban"},{"UUID":"0b3b872b-fc6d-4777-bc0b-feaf409e5723","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Könnyen ledörzsölődik a festék A","descFull":"Könnyen ledörzsölődik a festék A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a  Beállítások Hibaelhárítás  Tesztoldal nyomtatása  menüpontra. Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg az alábbiak valamelyikét: Győződjön meg róla, hogy a nyomtató tápkábele megfelelően méretezett és megfelelően földelt elektromos konnektorba van dugva. A papír típusát az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítás megfeleljen a betöltött papírnak. Állítsa be a papírtípust a kezelőpanelen. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma könnyen ledörzsölődik a festék könnyen ledörzsölődik a festék"},{"UUID":"efab968d-0e93-40d1-a7b3-6a01fbe4b19d","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Egyenetlen nyomtatási eloszlás A probléma","descFull":"Egyenetlen nyomtatási eloszlás A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a következő lehetőségre:  Beállítások Hibaelhárítás Tesztoldal nyomtatása . Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: Nyissa ki a B ajtót, majd győződjön meg arról, hogy a második továbbítógörgő a helyén van-e rögzítve. Győződjön meg arról, hogy a képalkotó készlet és a fekete képalkotó egység megfelelően van-e beszerelve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma egyenetlen nyomtatási eloszlás egyenetlen nyomtatási eloszlás"},{"UUID":"224750b8-d6f6-4b08-ab86-7ed45a875a58","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Vízszintes sötét vonalak A probléma","descFull":"Vízszintes sötét vonalak A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a következő lehetőségre:  Beállítások Hibaelhárítás Tesztoldal nyomtatása . Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Ha továbbra is vízszintes sötét vonalak jelennek meg a nyomatokon, lásd:  . Próbálja meg a következők valamelyikét: A papír típusát az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítás megfeleljen a betöltött papírnak. A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Ellenőrizze, hogy a tálcába töltött papír felülete nem túl durva-e. Töltsön be papírt egy bontatlan csomagból. A papír magas páratartalom esetén megszívja magát nedvességgel. Tárolja a papírt az eredeti csomagolásban, amíg nem használja fel. Győződjön meg arról, hogy a képalkotó készlet és a fekete képalkotó egység megfelelően van-e beszerelve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma vízszintes sötét vonalak vízszintes sötét vonalak"},{"UUID":"4f14fa41-087e-4420-b41d-a2cb797989fc","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Függőleges sötét vonalak A probléma","descFull":"Függőleges sötét vonalak A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a következő lehetőségre:  Beállítások Hibaelhárítás Tesztoldal nyomtatása . Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: A papír típusát az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítások megfeleljenek a tálcába töltött papírnak. A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Ellenőrizze, hogy a tálcába töltött papír felülete nem túl durva-e. Töltsön be papírt egy bontatlan csomagból. A papír magas páratartalom esetén megszívja magát nedvességgel. Tárolja a papírt az eredeti csomagolásban, amíg nem használja fel. Győződjön meg arról, hogy a képalkotó készlet és a fekete képalkotó egység megfelelően van-e beszerelve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma függőleges sötét vonalak jelennek meg a nyomatokon függőleges sötét vonalak a nyomatokon"},{"UUID":"e5944dee-bd2d-40c3-a24b-d9a8636a7206","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Vízszintes fehér vonalak A probléma","descFull":"Vízszintes fehér vonalak A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a következő lehetőségre:  Beállítások Hibaelhárítás Tesztoldal nyomtatása . Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Ha továbbra is vízszintes fehér vonalak jelennek meg a nyomatokon, lásd:  . Próbálja meg a következők valamelyikét: A papír típusát az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítások megfeleljenek a tálcába töltött papírnak. A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Töltse be a megadott papírforrásba az ajánlott típusú papírt. Győződjön meg arról, hogy a képalkotó készlet és a fekete képalkotó egység megfelelően van-e beszerelve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki közvetlen fény hatásának a fényvezető dobot. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a fényvezetődobokhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma vízszintes fehér vonalak vízszintes fehér vonalak"},{"UUID":"868eeb02-8cf9-4669-bbe1-dbccf693b141","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Függőleges fehér vonalak A probléma","descFull":"Függőleges fehér vonalak A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a következő lehetőségre:  Beállítások Hibaelhárítás Tesztoldal nyomtatása . Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Próbálja meg a következők valamelyikét: A papír típusát az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítások megfeleljenek a tálcába töltött papírnak. A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Ellenőrizze, hogy az ajánlott típusú papírt használja-e. Ügyeljen arra, hogy a megadott papírforrást az ajánlott papírtípussal töltse be. Győződjön meg arról, hogy a képalkotó készlet és a fekete képalkotó egység megfelelően van-e beszerelve. Vegye ki a képalkotó készletet, majd vegye ki a fekete képalkotó egységet. Ne tegye ki 10 percnél hosszabb ideig tartó közvetlen fényhatásnak a képalkotó készletet és a fekete képalkotó egységet. A hosszabb ideig tartó közvetlen napsugárzás nyomtatási minőségbeli problémákat okozhat. Ne érjen a képalkotó készlet és a fekete képalkotó egység alatt található fényvezetődobhoz. Ha hozzáér, azzal később romolhat a nyomtatási feladatok minősége. Helyezze be a fekete képalkotó egységet, majd a képalkotó készletet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma függőleges fehér vonalak függőleges fehér vonalak"},{"UUID":"d7900ad9-d2b6-40cc-9b9a-0cd9225871bd","title":"Gyenge a nyomtatási minőség","link":"solving-printing-problems.html","desc":"Ismétlődő hibák A probléma megoldása","descFull":"Ismétlődő hibák A probléma megoldása előtt nyomtasson tesztoldalakat. A kezelőpanelen navigáljon a következő lehetőségre:  Beállítások Hibaelhárítás Tesztoldal nyomtatása . Használja az 1. tálcát a mintaoldalak nyomtatásához, és győződjön meg róla, hogy a papír álló tájolásban van behelyezve. Állapítsa meg, hány színen találhatók hibák. Mérje meg az érintett színes oldalon az ismétlődő hibák közötti távolságot. A Karbantartási hibavonalzó segítségével mérje meg az ismétlődő hibák közötti távolságot az érintett szín oldalán. Cserélje ki azt az egységet vagy alkatrészt, amely megfelel az érintett szín oldalán mért értékeknek. Színes képalkotó készlet vagy fekete képalkotó egység 94,5 mm (3,72 hüvelyk) 19,9 mm (1,18 ”) 23,2 mm (0,19 ”) Előhívó egység 43,6 mm (1,72 ”) 45,0 mm (1,77 ”) Beégetőegység 95 mm (3,74 ”) 110 mm (4,33 ”) Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma ismétlődő nyomtatási hibák ismétlődő nyomtatási hibák"},{"UUID":"17b43ad2-5eec-4bb2-9a5a-83d60e007536","title":"Nyomtatási problémák","link":"solving-printing-problems.html","desc":"A nyomtató nem nyomtatja ki","descFull":"A nyomtató nem nyomtatja ki a nyomtatási feladatokat Próbálja meg a következők valamelyikét: Nyissa meg a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelt a nyomtatni kívánt dokumentumból, majd ellenőrizze, hogy a helyes nyomtatót választotta-e ki. Ellenőrizze, hogy a nyomtató be van-e kapcsolva, majd oldja meg a kijelzőn megjelenő hibaüzeneteket. Ellenőrizze, hogy a portok működnek-e, és a kábelek megfelelően csatlakoznak-e a számítógéphez és a nyomtatóhoz. További információ a nyomtatóhoz mellékelt beállítási útmutatóban található. Kapcsolja ki a nyomtatót, várjon körülbelül 10 másodpercet, majd kapcsolja vissza. Távolítsa el, majd telepítse újra a nyomtató-illesztőprogramot. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatási hiba a nyomtató nem nyomtatja ki a nyomtatási feladatokat nyomtatási feladatok nem nyomtatódnak ki a nyomtató nem nyomtatja ki a nyomtatási feladatokat"},{"UUID":"1ff259cc-cd6e-49c0-a119-ff66745f3fc9","title":"Nyomtatási problémák","link":"solving-printing-problems.html","desc":"Titkosított és felfüggesztett dokumentumok nem","descFull":"Titkosított és felfüggesztett dokumentumok nem nyomtatódnak ki Próbálja meg a következők valamelyikét: Ellenőrizze a kezelőpanelen, hogy a dokumentumok megjelennek-e a  Felfüggesztett feladatok  listájában. Ha a dokumentumok nem szerepelnek a listában, nyomtassa ki őket a Nyomtatás és várakozás lehetőség használatával. A nyomtatási feladatban előforduló esetleges formázási hibákkal vagy érvénytelen adatokkal kapcsolatos problémák megoldása. Törölje a nyomtatási feladatot, majd küldje el újra. PDF fájlok esetében hozzon létre egy új fájlt, majd nyomtassa ki a dokumentumokat. Internetről történő nyomtatás esetén a nyomtató a több feladatcímet másolatként olvashatja be. Windows-felhasználók esetében győződjön meg róla, hogy a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelben bejelölte a  Másolat megőrzése a dokumentumokról  lehetőséget. Macintosh-felhasználók esetében nevezze el az egyes feladatokat másképpen. Nyomtatómemória felszabadításához töröljön néhány felfüggesztett feladatot. Telepítsen további nyomtatómemóriát. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma bizalmas és felfüggesztett feladatok nem nyomtatódnak ki titkosított dokumentumok nem nyomtatódnak ki felfüggesztett dokumentumok nem nyomtatódnak ki"},{"UUID":"2a804c15-8433-4caf-bdfe-431171f1344e","title":"Nyomtatási problémák","link":"solving-printing-problems.html","desc":"A feladat nyomtatása rossz tálcából","descFull":"A feladat nyomtatása rossz tálcából vagy rossz papírra történik Próbálja meg a következők valamelyikét: Győződjön meg róla, hogy a megfelelő papírra nyomtat. A papírméretet és papírtípust az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítások megfeleljenek a betöltött papírnak. A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Ellenőrizze, hogy a tálcák össze vannak-e kapcsolva. További információkért lásd:  . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatási hiba rossz tálcából történő nyomtatás nyomtatási hiba nem megfelelő papírra történő feladatnyomtatás rossz tálcából történő nyomtatás nem megfelelő papírra történő feladatnyomtatás"},{"UUID":"99b8e1e9-49ad-4091-9ddc-250b620bedb2","title":"Nyomtatási problémák","link":"solving-printing-problems.html","desc":"Lassú nyomtatás Próbálja meg a","descFull":"Lassú nyomtatás Próbálja meg a következők valamelyikét: Ellenőrizze, hogy a nyomtatókábel biztonságosan csatlakozik-e a nyomtatóhoz, a számítógéphez, a nyomtatókiszolgálóhoz, az opcióhoz vagy az egyéb hálózati eszközhöz. Győződjön meg arról, hogy a nyomtató nincs  Csendes üzemmódban . A kezelőpanelen navigáljon a  Beállítások Eszköz Karbantartás Konfigurációs menü Eszközműveletek Csendes üzemmód  menüpontra. Adja meg a nyomtatni kívánt dokumentum felbontását. Az operációs rendszertől függően lépjen a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelre. Állítsa a felbontást  4800 CQ  értékre. A beállítás kezelőpanelen is módosítható. Lépjen a  Beállítások Nyomtatás Minőség Nyomtatási felbontás  menüpontba. A papír típusát az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. A beállítás kezelőpanelen is módosítható. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Nehezebb papírra lassabb a nyomtatás. A Letter, A4 és Legal papíroknál keskenyebb papírokra sokkal lassabban történhet a nyomtatás. Győződjön meg arról, hogy a nyomtató Textúra és Tömeg beállításai megegyeznek a betöltött papír adataival. A kezelőpanelen navigáljon a  Beállítások Papír Hordozókonfiguráció Hordozótípusok  menüpontra.  A durva papírtextúrákra és a nehezebb papírokra lassabban történhet a nyomtatás. Törölje a felfüggesztett feladatokat. Ellenőrizze, hogy a nyomtató nem melegedett-e túl. Hosszabb nyomtatási feladat után hagyja a nyomtatót hűlni. Vegye figyelembe a nyomtató számára ajánlott környezeti hőmérsékletet. További információkért lásd:  . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatási hiba lassú nyomtatás lassú nyomtatás"},{"UUID":"603db147-9a85-4817-8765-df1817df8c20","title":"Problémák elhárítása","link":"trb-printer-not-responding-topic.html","desc":"A nyomtató nem válaszol Próbálja","descFull":"A nyomtató nem válaszol Próbálja meg a következők valamelyikét: Ellenőrizze, hogy a tápkábel csatlakoztatva van-e a csatlakozóaljzathoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Ellenőrizze, hogy a konnektort sem kapcsolóval, sem megszakítóval nem kapcsolták-e ki. Ellenőrizze, hogy be van-e kapcsolva a nyomtató. Győződjön meg róla, hogy a nyomtató nincs alvó vagy hibernált üzemmódban. Győződjön meg róla, hogy a nyomtatót és a számítógépet összekötő kábelek a megfelelő portokhoz csatlakoznak. Kapcsolja ki a nyomtatót, szerelje be a hardverkiegészítőket, majd kapcsolja be a nyomtatót. További tudnivalók a kiegészítő dokumentációjában találhatók. Telepítse a megfelelő nyomtató-illesztőprogramot. Kapcsolja ki a nyomtatót, várjon körülbelül 10 másodpercet, majd kapcsolja vissza. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatási hiba nyomtató nem válaszol nyomtató nem válaszol"},{"UUID":"8a3ec21a-a4f4-4a4e-a40a-d8e402fd4156","title":"Problémák elhárítása","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Nem lehet olvasni a flash-meghajtót","descFull":"Nem lehet olvasni a flash-meghajtót Próbálja meg a következők valamelyikét: Győződjön meg róla, hogy a nyomtató nincs elfoglalva több feladat feldolgozásával. Győződjön meg róla, hogy a flash-meghajtó az elülső USB-portba van behelyezve. A flash-meghajtó nem működik, ha a hátsó USB-porthoz van csatlakoztatva. Győződjön meg róla, hogy a flash-meghajtó támogatott. További információkért lásd:  . Távolítsa el, majd helyezze vissza a flash-meghajtót. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nem lehet olvasni a flash-meghajtót nyomtatási hiba nem lehet olvasni a flash-meghajtót"},{"UUID":"08e76103-6fcd-433c-8424-b6d9d9794fcc","title":"Problémák elhárítása","link":"enabling-usb-port-topic.html","desc":"Az USB-port engedélyezése A kezelőpanelen","descFull":"Az USB-port engedélyezése A kezelőpanelen navigáljon a  Beállítások Hálózat/portok USB  menüpontra. Válassza az  USB-port engedélyezése  lehetőséget. USB-port engedélyezés USB port engedélyezése USB port beállítása"},{"UUID":"172f02f3-4dc7-4d9c-86ea-8790ffa3f979","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadások elkerülése Töltse be a","descFull":"Papírelakadások elkerülése Töltse be a papírt megfelelően Ügyeljen, hogy a papír egyenletesen feküdjön a tálcában. A papír helyes és helytelen betöltése Helyes papírbetöltés Helytelen papírbetöltés Ne töltse fel és ne távolítsa el a tálcákat nyomtatás közben. Ne töltsön be túl sok papírt. Ügyeljen arra, a köteg magassága ne haladja meg a maximális papírmennyiséget mutató jelet. Ne csúsztasson papírt a tálcába. A papírt az ábrán látható módon töltse be. Ügyeljen arra, hogy a papírvezetők helyesen helyezkedjenek el, és ne nyomódjanak neki szorosan a papírnak vagy borítékoknak. A papír behelyezése után határozott mozdulattal helyezze vissza a tálcát a nyomtatóba. Használjon javasolt papírfajtát Csak ajánlott papírtípusokat és nyomathordozókat használjon. Ne töltsön be gyűrött, szamárfüles, nedves, behajtott vagy hullámos papírt. Mielőtt behelyezné a papírt, hajlítsa meg, pörgesse át, és igazítsa össze a köteget. Ne használjon vágott vagy kézzel tépett papírt. Ne tegyen különböző papírméreteket, -súlyokat és -típusokat egy tálcába. Ügyeljen, hogy helyesen legyen megadva a papír mérete és típusa a nyomtató kezelőpanelén. A papírt tárolja a gyártó előírásai szerint. papírelakadás elkerülés elakadások, papír elkerülés papírelakadások elkerülése"},{"UUID":"1eafffc8-81e9-434f-952a-5979a2efe052","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Elakadás helyének azonosítása Ha az","descFull":"Elakadás helyének azonosítása Ha az  Elakadássegéd  funkció beállítása  Be , akkor a nyomtató egy elakadt oldal eltávolítását követően az üres vagy részleges nyomatot tartalmazó oldalakat a normál tárolóba továbbítja. Ellenőrizze, hogy a kinyomtatott oldalak között nincsenek-e üres oldalak. Ha az  Elakadás-elhárítás  beállítása  Be  vagy  Auto , akkor a nyomtató újból kinyomtatja az elakadt oldalakat. Elakadás helye Elakadás helye 1 B ajtó 2 Többcélú adagoló 3 Normál tálca 4 Normál rekesz 5 Automatikus lapadagoló 6 Kapcsozó kiadó 7 Kiegészítő 550 lapos tálca 8 2 x 550 lapos tálca 9 1500 lapos tálca 10 Kapcsozó-lyukasztó kiadóegység 11 Papírszállító egység hajtogatási lehetőséggel 12 2000 lapos kettős bemeneti egység 13 Füzetkészítő egység papírelakadás keresés elakadás helye azonosítás"},{"UUID":"6274bcad-d8e9-40c4-81cf-0e57c138fe31","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a normál tálcában Papírelakadás","descFull":"Papírelakadás a normál tálcában Papírelakadás a normál tálcában Húzza ki a normál tálcát. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Szerelje fel a tálcát. elakadás megszüntetése normál tálcában papírelakadás megszüntetése normál tálcában papírelakadás a normál tálcában"},{"UUID":"42c949aa-dd17-44a0-af78-2b8ad2b46701","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a külön megvásárolható 550","descFull":"Papírelakadás a külön megvásárolható 550 lapos tálcában Nyissa ki a D ajtót. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be az ajtót. Húzza ki a külön megvásárolható 550 lapos tálcát. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Szerelje fel a tálcát. elakadás megszüntetése a 550 lapos tálcában papírelakadás megszüntetése a 550 lapos tálcában papírelakadás az 550 lapos tálcában"},{"UUID":"f26fe3c1-c737-4a61-adbe-f3377488457a","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás az automatikus lapadagolóban Papírelakadás","descFull":"Papírelakadás az automatikus lapadagolóban Papírelakadás az A ajtónál Nyissa ki az A ajtót. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be az A ajtót. Papírelakadás az A1 ajtóban Nyissa fel a lapolvasó fedelét. Nyomja le a zöld rögzítőt az A1 ajtó kinyitásához. Fordítsa el jobbra az A1 ajtó melletti zöld gombot, majd távolítsa el az elakadt papírt. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be az A1 ajtót, majd csukja le a lapolvasó fedelét. Papírelakadás az automatikus lapadagoló rekeszben Távolítson el minden papírt az automatikus lapadagoló rekeszből. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. elakadás megszüntetése az automatikus lapadagolóban papírelakadás az automatikus lapadagolóban papírelakadás megszüntetése az automatikus lapadagolóban"},{"UUID":"a0e4469d-bb74-41fb-a7ff-47dabe30b325","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a többcélú adagolóban Távolítsa","descFull":"Papírelakadás a többcélú adagolóban Távolítsa el a papírt a többcélú adagolóból. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. elakadás megszüntetése többcélú adagolóban papírelakadás megszüntetése többcélú adagolóban Papírelakadás a többcélú adagolóban"},{"UUID":"27362cae-f90a-40bf-a0ca-8350e0581d7b","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a 2 x 550","descFull":"Papírelakadás a 2 x 550 lapos tálcában Nyissa ki az E ajtót. Távolítsa el az E ajtó mögött elakadt papírt. Ügyeljen arra, hogy minden papírdarabot eltávolítson. E ajtót bezárni Húzza ki a 3. tálcát. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Helyezze be a 3. tálcát. Ismétlés  4. lépés  –  6. lépés  a 4. tálcához. elakadás megszüntetése 2 x 550 lapos tálca papírelakadás megszüntetése 2 x 550 lapos tálca papírelakadás 2 x 550 lapos tálca"},{"UUID":"c4680cf7-0ba7-4cc6-bb84-b6444d90a040","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a 2000 lapos kettős","descFull":"Papírelakadás a 2000 lapos kettős bemeneti egységben Nyissa ki az E ajtót. Távolítsa el az E ajtó mögött elakadt papírt. Ügyeljen arra, hogy minden papírdarabot eltávolítson. E ajtót bezárni elakadás megszüntetése a 2000 lapos kettős bemeneti egységben papírelakadás megszüntetése a 2000 lapos kettős bemeneti egységben papírelakadás a 2000 lapos fiókban"},{"UUID":"ffa7147f-71ed-4635-87b0-fa454eea7a35","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás az 1500 lapos fiókban","descFull":"Papírelakadás az 1500 lapos fiókban Nyissa ki a K ajtót. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be a K ajtót. Fogja meg a J fogantyút, majd csúsztassa a fiókot jobbra. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csúsztassa vissza a helyére a tálcát. elakadás megszüntetése 1500 lapos fiókban papírelakadás megszüntetése 1500 lapos fiókban papírelakadás 1500 lapos fiókban"},{"UUID":"56bde149-4f93-4c62-a6d5-992376f9b141","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a B ajtónál Nyissa","descFull":"Papírelakadás a B ajtónál Nyissa ki a B ajtót. Előfordulhat, hogy a nyomtató belseje forró. Az égési sérülések elkerülése érdekében várja meg, amíg a forró felületek kihűlnek. Mielőtt a nyomtató belső részébe nyúlna, érintse meg a nyomtató valamelyik fém alkatrészét, így elkerülhetők az elektrosztatikus kisülések okozta károk. Távolítsa el az elakadt papírt a következő helyek mindegyikénél: Ügyeljen arra, hogy minden papírdarabot eltávolítson. A beégetőegység felett A beégetőegységben A beégetőegység alatt A normál rekesz kimeneti görgője alatt A kétoldalas egységben Csukja be a B ajtót. papírelakadás a B ajtónál papírelakadás a beégetőegységben papírelakadás a kétoldalas egységben elakadás megszüntetése a beégetőegységben elakadás megszüntetése kétoldalas egységben papírelakadás megszüntetése a beégetőegységben papírelakadás megszüntetése kétoldalas egységben"},{"UUID":"1de64b01-09f6-437a-a23a-ff45cf5c5db3","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a normál rekeszben Távolítsa","descFull":"Papírelakadás a normál rekeszben Távolítsa el minden papírt a normál rekeszből. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. elakadás megszüntetése normál rekesz papírelakadás megszüntetése normál rekeszben papírelakadás a normál rekeszben"},{"UUID":"4918e470-aec6-45e3-b076-6df338ddf93c","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a kapcsozó kiadó tárolójában","descFull":"Papírelakadás a kapcsozó kiadó tárolójában Távolítsa el az elakadt papírt a kapcsozó kiadó rekeszéből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Fogja meg az F fogantyút, majd csúsztassa balra a kapcsozó kiadót. Nyissa ki az R1 ajtót, majd forgassa el az R2 gombot az óramutató járásával megegyező irányba. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Zárja be az R1 ajtót. Távolítsa el a normál rekesz kimeneti görgőjénél elakadt papírt. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csúsztassa vissza a kapcsozó kiadót a helyére. elakadás megszüntetése a kapcsozó kiadóban papírelakadás megszüntetése a kapcsozó kiadóban papírelakadás a kapcsozó kiadóban"},{"UUID":"f3dc59aa-dcff-43a6-aa98-d8501c70797c","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a hajtogatási lehetőséggel ellátott","descFull":"Papírelakadás a hajtogatási lehetőséggel ellátott papírszállító egységben Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Nyissa ki az F ajtót. Emelje fel az N4 fogantyút. Emelje fel az N5 fogantyút. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Zárja be az N5 fogantyút, majd zárja be az N4 fogantyút. Nyomja le az N1 fogantyút. Fordítsa az N2 gombot az óramutató járásával ellentétes irányba. Távolítsa el az elakadt papírlapot. A nyomtató sérülésének elkerülése érdekében az elakadt papír eltávolítása előtt távolítson el minden kiegészítőt a kezéről. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Helyezze vissza az N1 fogantyút a helyére. Csukja be az F ajtót. elakadás megszüntetése hajtogatási lehetőséggel ellátott papírszállító egységben papírelakadás megszüntetése hajtogatási lehetőséggel ellátott papírszállító egységben papírelakadás hajtogatási lehetőséggel ellátott papírszállító egységben"},{"UUID":"66bebb24-b8a8-4605-af1c-fb73e5dcdc2d","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a kapcsozó-lyukasztó kiadóegységben Ha","descFull":"Papírelakadás a kapcsozó-lyukasztó kiadóegységben Ha a nyomtató papírszállító egységgel van konfigurálva, akkor tegye a következőket: Távolítsa el az elakadt papírt a 1. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. A hiányzó oldalak elkerülése érdekében ne távolítsa el a kapcsozáshoz használt papírösszegyűjtő rekeszben lévő nyomtatott oldalakat. Távolítsa el az elakadt papírt a kiadóegység normál rekeszéből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Távolítsa el az elakadt papírt a 2. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Nyissa ki a papírszállító egység G fedelét, majd távolítsa el az elakadt papírt. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be a papírszállító egység G fedelét. Nyissa ki az I ajtót, nyissa ki az R1 ajtót, majd távolítsa el az elakadt papírt. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be az R1 ajtót, majd az I ajtót. Nyissa ki a papírszállító egység F fedelét. Nyissa ki a H ajtót. Emelje fel az R4 fogantyút. Fordítsa az R3 gombot az óramutató járásával ellentétes irányba, majd távolítsa el az elakadt papírt az 1. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Fordítsa el az R2 gombot az óramutató járásával ellentétes irányba, majd távolítsa el az elakadt papírt a papírszállító egység F fedeléből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be a papírszállító egység F fedelét. Helyezze vissza az R4 fogantyút az eredeti helyzetébe. H ajtó bezárása. Ha a nyomtatója hajtogatási lehetőséggel ellátott papírszállító egységgel van konfigurálva, akkor tegye a következőket: Távolítsa el az elakadt papírt a 1. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. A hiányzó oldalak elkerülése érdekében ne távolítsa el a kapcsozáshoz használt papírösszegyűjtő rekeszben lévő nyomtatott oldalakat. Távolítsa el az elakadt papírt a kiadóegység normál rekeszéből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Távolítsa el az elakadt papírt a 2. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Nyissa ki az F ajtót. Nyissa ki az N4-es ajtót. Nyissa ki az N5 ajtót. Nyissa ki a H ajtót. Emelje fel az R4 fogantyút. Fordítsa az R3 gombot az óramutató járásával ellentétes irányba, majd távolítsa el az elakadt papírt az 1. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Fordítsa az R2 gombot az óramutató járásával ellentétes irányba, majd távolítsa el az elakadt papírt az N4 és N5 ajtók között. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Nyissa ki a B ajtót. Előfordulhat, hogy a nyomtató belseje forró. Az égési sérülések elkerülése érdekében várja meg, amíg a forró felületek kihűlnek. Mielőtt a nyomtató belső részébe nyúlna, érintse meg a nyomtató valamelyik fém alkatrészét, így elkerülhetők az elektrosztatikus kisülések okozta károk. Távolítsa el az elakadt papírt normál rekesz kimeneti görgője alól. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be a B ajtót. Nyomja le az N1 fogantyút. Fordítsa az N2 gombot az óramutató járásával ellentétes irányba. Távolítsa el az elakadt papírlapot. A nyomtató sérülésének elkerülése érdekében az elakadt papír eltávolítása előtt távolítson el minden kiegészítőt a kezéről. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Helyezze vissza az N1 fogantyút a helyére. Zárja be az N5 fogantyút, majd zárja be az N4 fogantyút. Csukja be az F ajtót. Helyezze vissza az R4 fogantyút az eredeti helyzetébe. H ajtó bezárása. elakadás megszüntetése a kapcsozó-lyukasztó kiadóegységben papírelakadás megszüntetése a kapcsozó-lyukasztó kiadóegységben papírelakadás a kapcsozó-lyukasztó kiadóegységben"},{"UUID":"9463dd4b-df8c-43d2-b4ad-be2f3284eacb","title":"Elakadások megszüntetése","link":"clearing-jams.html","desc":"Papírelakadás a füzetkészítő egységben Ha","descFull":"Papírelakadás a füzetkészítő egységben Ha a nyomtató papírszállító egységgel van konfigurálva, akkor tegye a következőket: Távolítsa el az elakadt papírt a kiadóegység normál rekeszéből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Távolítsa el az elakadt papírt a 1. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Távolítsa el az elakadt papírt a 1. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. A hiányzó oldalak elkerülése érdekében ne távolítsa el a kapcsozáshoz használt papírösszegyűjtő rekeszben lévő nyomtatott oldalakat. Távolítsa el az elakadt papírt a 3. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Nyissa ki a papírszállító egység G fedelét, majd távolítsa el az elakadt papírt. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be a papírszállító egység G fedelét. Nyissa ki a papírszállító egység F fedelét. Nyissa ki a H ajtót. Mozgassa az R3 fogantyút jobbra, majd távolítsa el az elakadt papírt. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Mozgassa az R1 fogantyút balra, fordítsa el az R2 gombot az óramutató járásával ellentétes irányba, majd távolítsa el az elakadt papírt. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Fordítsa az R5 gombot az óramutató járásával ellentétes irányba, majd távolítsa el az elakadt papírt a kiadóegység normál rekeszéből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Emelje fel az R4 fogantyút, fordítsa el az R2 gombot az óramutató járásával megegyező irányba, majd távolítsa el az elakadt papírt. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be a papírszállító egység F fedelét. Helyezze vissza az R1, R3 és R4 fogantyút eredeti helyzetébe. H ajtó bezárása. Ha a nyomtatója hajtogatási lehetőséggel ellátott papírszállító egységgel van konfigurálva, akkor tegye a következőket: Távolítsa el az elakadt papírt a kiadóegység normál rekeszéből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Távolítsa el az elakadt papírt a 1. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Távolítsa el az elakadt papírt a 1. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. A hiányzó oldalak elkerülése érdekében ne távolítsa el a kapcsozáshoz használt papírösszegyűjtő rekeszben lévő nyomtatott oldalakat. Távolítsa el az elakadt papírt a 3. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Nyissa ki az F ajtót. Nyissa ki a H ajtót. Nyissa ki az N4-es ajtót. Nyissa ki az N5 ajtót. Emelje fel az R4 fogantyút. Fordítsa el az R2 gombot az óramutató járásával megegyező irányba, majd távolítsa el az elakadt papírt az R4 fogantyúban. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Mozgassa az R1 fogantyút balra, fordítsa el az R2 gombot az óramutató járásával ellentétes irányba, majd távolítsa el az elakadt papírt az N4 és N5 ajtó között. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Nyissa ki a B ajtót. Előfordulhat, hogy a nyomtató belseje forró. Az égési sérülések elkerülése érdekében várja meg, amíg a forró felületek kihűlnek. Mielőtt a nyomtató belső részébe nyúlna, érintse meg a nyomtató valamelyik fém alkatrészét, így elkerülhetők az elektrosztatikus kisülések okozta károk. Távolítsa el az elakadt papírt normál rekesz kimeneti görgője alól. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Csukja be a B ajtót. Nyomja le az N1 fogantyút. Fordítsa az N2 gombot az óramutató járásával ellentétes irányba. Távolítsa el az elakadt papírlapot. A nyomtató sérülésének elkerülése érdekében az elakadt papír eltávolítása előtt távolítson el minden kiegészítőt a kezéről. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Helyezze vissza az N1 fogantyút a helyére. Csukja be az N5 ajtót, majd az N4 ajtót. Csukja be az F ajtót. Helyezze vissza az R1 és R4 fogantyút eredeti helyzetébe. H ajtó bezárása. Papírelakadás a füzetkészítő egységben Távolítsa el az elakadt papírt a 2. rekeszből. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Nyissa ki a H ajtót. Fordítsa el az R6, R11 és R10 gombot az óramutató járásával megegyező irányba. Húzza ki a füzetkészítő egységet. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Forgassa az R9 gombot az óramutató járásával ellentétes irányba, amíg meg nem áll. Nyissa ki az R8 ajtót. Távolítsa el az elakadt papírlapot. Ügyeljen arra, hogy minden papírdarabot eltávolítson. Zárja be az R8 ajtót. Tegye vissza a füzetkészítőt a füzetkészítő egységbe. H ajtó bezárása. elakadás megszüntetése a füzetkészítő egységben papírelakadás megszüntetése a füzetkészítő egységben papírelakadás a füzetkészítő egységben"},{"UUID":"bc68e0c8-aabe-44cc-afbc-1a597b00d0ac","title":"Hálózatikapcsolat-hibák","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Az Embedded Web Servert nem","descFull":"Az Embedded Web Servert nem lehet megnyitni Az Embedded Web Servert nem lehet megnyitni Próbálja meg a következők valamelyikét: Győződjön meg róla, hogy a nyomtató be van kapcsolva. Ügyeljen, hogy helyes legyen a nyomtató IP-címe. Tekintse meg az IP-címet a kezelőpanelen. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ügyeljen arra, hogy támogatott böngésző legyen telepítve. 11-es verziójú vagy újabb Internet Explorer Microsoft Edge 6-os verziójú vagy újabb Safari Google Chrome  32-es vagy újabb verzió 24-as verziójú vagy újabb Mozilla Firefox Ellenőrizze, hogy működik-e a hálózati kapcsolat. Ha a kapcsolat nem működik, forduljon a rendszergazdához. Ügyeljen, hogy megfelelőek legyenek a nyomtató és a nyomtatókiszolgáló kábelcsatlakozásai. További tudnivalók a nyomtatókiszolgáló dokumentációjában találhatók. Ellenőrizze, hogy le vannak-e tiltva a webes proxykiszolgálók. Ha a kiszolgálók le vannak tiltva, forduljon a rendszergazdához. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . az Embedded Web Servert nem lehet megnyitni hibaelhárítás az Embedded Web Servert nem lehet megnyitni"},{"UUID":"7d6dc5d3-2a25-41b5-8059-88c5ded49a7c","title":"Hálózatikapcsolat-hibák","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"A nyomtató nem csatlakoztatható a","descFull":"A nyomtató nem csatlakoztatható a Wi-Fi hálózathoz A nyomtató nem csatlakoztatható a Wi-Fi hálózathoz Próbálja meg a következők valamelyikét: A kezelőpanelen navigáljon a  Beállítások Hálózat/portok Hálózati áttekintés Aktív adapter  menüpontra, majd válassza az  Automatikus  lehetőséget. Győződjön meg róla, hogy a számítógép a megfelelő Wi-Fi hálózathoz csatlakozik. További információkért lásd:  . Egyes útválasztókon előfordulhat, hogy az alapértelmezett Wi-Fi név közös. Ellenőrizze, hogy a megfelelő hálózati jelszót adta-e meg. Ellenőrizze a jelszóban használt szóközöket, számokat és nagybetűket. Győződjön meg róla, hogy a megfelelő vezeték nélküli biztonsági mód van kiválasztva. A kezelőpanelen navigáljon a  Beállítások Hálózat/portok Vezeték nélküli Vezeték nélküli biztonsági mód  menüpontba. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . a nyomtató nem csatlakoztatható a Wi-Fi-hez hibaelhárítás a nyomtató nem csatlakoztatható a Wi-Fi-hez"},{"UUID":"f6ff097a-8fcb-4f70-9f68-f6415a4076d9","title":"Hardveropciókkal kapcsolatos problémák","link":"trb-cannot-detect-internal-option-topic.html","desc":"Nem található belső kiegészítő Nem","descFull":"Nem található belső kiegészítő Nem található belső kiegészítő Próbálja meg a következők valamelyikét: Kapcsolja ki a nyomtatót, várjon körülbelül 10 másodpercet, majd kapcsolja vissza. Nyomtassa ki a  menübeállítási oldalt , és ellenőrizze, hogy a belső kiegészítő megjelenik-e a Telepített funkciók listában. A kezelőpanelen navigáljon a  Beállítások Jelentések Menübeállítási oldal  menüpontra. Ellenőrizze, hogy a belső kiegészítő megfelelően van-e a vezérlőkártyára szerelve. Kapcsolja ki a nyomtatót, majd húzza ki a tápkábelt a csatlakozóaljzatból. Győződjön meg arról, hogy a belső kiegészítő a vezérlőkártya megfelelő csatlakozójába van helyezve. Csatlakoztassa a tápkábelt a fali konnektorhoz, majd kapcsolja be a nyomtatót. A tűzveszély és az áramütés elkerülése érdekében a tápkábelt közvetlenül egy, a készülékhez közeli, könnyen hozzáférhető, megfelelő besorolású és megfelelően földelt konnektorba csatlakoztassa. Ellenőrizze, hogy a belső kiegészítő elérhető-e a nyomtató-illesztőprogramban. Szükség esetén kézzel adja hozzá a belső kiegészítőt a nyomtató-illesztőprogramban, hogy az elérhető legyen a nyomtatási feladatokhoz. További információkért lásd:  . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . hardveropciókkal kapcsolatos problémák nem található belső kiegészítő belső kiegészítő nem észlelhető nem található belső kiegészítő"},{"UUID":"c8a2cac4-e93e-4ac7-83ec-fa63e7e09cba","title":"Hardveropciókkal kapcsolatos problémák","link":"trb-cannot-detect-internal-option-topic.html","desc":"A belső megoldások portjának működése","descFull":"A belső megoldások portjának működése nem megfelelő A belső megoldások portjának működése nem megfelelő Próbálja meg a következők valamelyikét: Nyomtassa ki a  Menübeállítási oldalt , és ellenőrizze, hogy a belső megoldások portja (ISP) megjelenik-e a Telepített funkciók listában. A kezelőpanelen navigáljon a  Beállítások Jelentések Menübeállítási oldal  menüpontra. Távolítsa el, majd telepítse újra az ISP-t. További információkért lásd:  . Ellenőrizze a kábelt és az ISP csatlakozását. Használja a megfelelő kábelt, majd ellenőrizze, hogy megfelelően csatlakozik-e az ISP-hez. Ellenőrizze, hogy az ISP-megoldás interfészkábele biztonságosan csatlakozik-e a vezérlőkártyán lévő foglalathoz. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . hibaelhárítás belső megoldásport nyomtatási beállítások problémája belső megoldásport a belső megoldások portjának működése nem megfelelő"},{"UUID":"adc24b28-516e-4086-beaa-04e6f3fae325","title":"Hardveropciókkal kapcsolatos problémák","link":"trb-cannot-detect-internal-option-topic.html","desc":"A párhuzamos vagy soros illesztőkártya","descFull":"A párhuzamos vagy soros illesztőkártya működése nem megfelelő A párhuzamos vagy soros illesztőkártya működése nem megfelelő Próbálja meg a következők valamelyikét: Nyomtassa ki a  Menübeállítási oldalt , és ellenőrizze, hogy a párhuzamos vagy soros illesztőkártya megjelenik-e a Telepített funkciók listában. A kezelőpanelen navigáljon a  Beállítások Jelentések Menübeállítási oldal  menüpontra. Szerelje ki, majd szerelje vissza a párhuzamos vagy soros illesztőkártyát. További információkért lásd:  . Ellenőrizze a kábel és a párhuzamos vagy soros illesztőkártya közötti kapcsolatot. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatási beállítások problémája párhuzamos interfészkártya nyomtatási beállítások problémája soros interfészkártya hibaelhárítás párhuzamos interfészkártya hibaelhárítás soros interfészkártya"},{"UUID":"6612dba9-3ea0-4dbf-996f-21bc3df37b0d","title":"Hardveropciókkal kapcsolatos problémák","link":"trb-cannot-detect-internal-option-topic.html","desc":"Hibás flash-memória észlelve Hibás flash-memória","descFull":"Hibás flash-memória észlelve Hibás flash-memória észlelve Próbálja meg a következők valamelyikét: Cserélje ki a hibás flash-memóriát. Válassza a  Folytatás  gombot az üzenet figyelmen kívül hagyásához és a nyomtatás folytatásához. Szakítsa meg az aktuális nyomtatási feladatot. nyomtatóüzenetek hibás flash-memória észlelhető hibás flash-memória hibaelhárítás hibás flash-memória"},{"UUID":"39a6cbe6-959a-49ee-b32d-987284f3e822","title":"Hardveropciókkal kapcsolatos problémák","link":"trb-cannot-detect-internal-option-topic.html","desc":"Nincs elég szabad hely a","descFull":"Nincs elég szabad hely a flash-memóriában az erőforrások számára Nincs elég szabad hely a flash-memóriában az erőforrások számára Próbálja meg a következők valamelyikét: Válassza a  Folytatás  gombot az üzenet törléséhez és a nyomtatás folytatásához. Törölje a flash-memórián tárolt betűtípusokat, makrókat és egyéb adatokat. Szereljen be egy tárolómeghajtót. A flash-memórián előzőleg nem tárolt, letöltött betűtípusok és makrók törölve lesznek. nyomtatóüzenetek Nincs elég szabad hely a flash-memóriában az erőforrások számára Nincs elég szabad hely a flash-memóriában az erőforrások számára"},{"UUID":"1d011675-bb8d-45c5-b030-25877961410d","title":"Kellékanyagokkal kapcsolatos problémák","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Cserélje ki a tonerkazettát –","descFull":"Cserélje ki a tonerkazettát – nem megfelelő régió A probléma kijavításához vásároljon megfelelő tonerkazettát, amelynek régiója megegyezik a nyomtató régiójával, vagy válasszon nemzetközi tonerkazettát. A hibaüzenetben a 42-es szám után látható első számjegy jelzi a nyomtató régióját. A hibaüzenetben a 42-es szám után látható második számjegy jelzi a tonerkazetta régióját. Helyezze be a megfelelő tonerkazettát. Nyomtató- és tonerkazetta-régiók Régió Számkód Nemzetközi, vagy nem értelmezhető régió 0 Észak-Amerika (Egyesült Államok, Kanada) 1 Európai Gazdasági Térség, Nyugat-Európa, Észak-Európa, Svájc 2 Ázsia csendes-óceáni területei 3 Latin-Amerika 4 Európa egyéb részei, Közel-Kelet, Afrika 5 Ausztrália, Új-Zéland 6 Érvénytelen régió 9 A nyomtató és a tonerkazetta területi beállításainak megállapításához nyomtassa ki a  Nyomtatásminőségi tesztoldalakat . A kezelőpanelen navigáljon a következő lehetőségre:  Beállítások Hibaelhárítás Tesztoldal nyomtatása . nyomtatóüzenetek Cserélje ki a tonerkazettát – nem megfelelő régió Cserélje ki a tonerkazettát – nem megfelelő régió kazetta, nyomtató régió eltérés"},{"UUID":"b9b03991-8fcd-43a1-8d77-1aed4bfe5423","title":"Kellékanyagokkal kapcsolatos problémák","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Újratöltött hagyományos [szín] kazetta A","descFull":"Újratöltött hagyományos [szín] kazetta A nyomtató olyan Lexmark hagyományos tonerkazettát észlelt, amelyet a Lexmarkon kívüli fél nem eredeti festékkel töltött újra. A nyomtató olyan kazettát észlelt, amelyet a nyomtató gyártójától eltérő fél nem eredeti festékkel töltött újra. A folytatáshoz válassza az  OK  lehetőséget. A nyomtató minden alkatrészének élettartamjelzőjét úgy tervezték, hogy a Lexmark kellékanyagokkal és alkatrészekkel működjön, és kiszámíthatatlan eredményeket adhat, ha a Lexmark nyomtatójában olyan kellékanyagokat vagy alkatrészeket használ, amelyeket nem a Lexmark gyártott újra. A nyomtató minden alkatrészének élettartamjelzőjét úgy tervezték, hogy a gyártói kellékanyagokkal és alkatrészekkel működjön, és kiszámíthatatlan eredményeket adhat, ha a nyomtatójában olyan kellékanyagokat vagy alkatrészeket használ, amelyeket nem a nyomtató gyártója gyártott újra. További információkért lásd a nyomtató korlátozott jótállási nyilatkozatát. nyomtatóüzenetek újratöltött hagyományos kazetta nem eredeti festék harmadik féltől származó áruk"},{"UUID":"2d71b70b-b243-49d0-9674-9293e29539e9","title":"Kellékanyagokkal kapcsolatos problémák","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Nem Lexmark márkájú kellékanyagok Nem","descFull":"Nem Lexmark márkájú kellékanyagok Nem Dell márkájú kellékanyagok Nem nyomtatógyártó által gyártott kellékanyagok A nyomtató nem a Lexmark által gyártott kellékanyag vagy alkatrész beszerelését észlelte. A nyomtató nem a Dell által gyártott kellékanyag vagy alkatrész beszerelését észlelte. A nyomtató ismeretlen kellékanyag vagy alkatrész beszerelését észlelte. A Lexmark nyomtatót úgy tervezték, hogy a Lexmark eredeti kellékanyagaival és alkatrészeivel működjön a legjobban. Egyéb márkájú kellékanyag vagy alkatrész használata befolyásolhatja a nyomtató teljesítményét, megbízhatóságát vagy élettartamát, valamint képalkotó-alkatrészeit. A Dell nyomtatót úgy tervezték, hogy a Dell eredeti kellékanyagaival és alkatrészeivel működjön a legjobban. Egyéb márkájú kellékanyag vagy alkatrész használata befolyásolhatja a nyomtató teljesítményét, megbízhatóságát vagy élettartamát, valamint képalkotó-alkatrészeit. A nyomtatót úgy tervezték, hogy a nyomtató gyártója által készített eredeti kellékanyagokkal és alkatrészekkel működjön a legjobban. Egyéb márkájú kellékanyag vagy alkatrész használata befolyásolhatja a nyomtató teljesítményét, megbízhatóságát vagy élettartamát, valamint képalkotó-alkatrészeit. A termék élettartamának becslése a Lexmark eredeti kellékanyagainak és alkatrészeinek használatán alapul. Egyéb márkájú kellékanyagok vagy alkatrészek használata váratlan eredményhez vezethet. A képalkotó alkatrész tervezett élettartamot meghaladó használata károsíthatja a Lexmark nyomtatót vagy a kapcsolódó alkatrészeket. A termék élettartamának becslése a Dell eredeti kellékanyagainak és alkatrészeinek használatán alapul. Egyéb márkájú kellékanyagok vagy alkatrészek használata váratlan eredményhez vezethet. A képalkotó alkatrész tervezett élettartamot meghaladó használata károsíthatja a Dell nyomtatót vagy a kapcsolódó alkatrészeket. A termék élettartamának becslése a nyomtató gyártója által előállított kellékanyagok és alkatrészek használatán alapul. Egyéb márkájú kellékanyagok vagy alkatrészek használata váratlan eredményhez vezethet. A képalkotó alkatrész tervezett élettartamot meghaladó használata károsíthatja a nyomtatót vagy a kapcsolódó alkatrészeket.  Egyéb márkájú kellékanyag vagy alkatrész használata befolyásolhatja a garancia érvényességét. Az egyéb márkájú kellékanyagok vagy alkatrészek használata által okozott kárra nem vállalunk garanciát. Ezen kockázatok részben és egészben való elfogadásához és a nyomtatóhoz nem eredeti kellékanyagok vagy alkatrészek használatának folytatásához érintse meg és tartsa lenyomva 15 másodpercig a kijelzőn lévő hibaüzenetet. Amikor megjelenik egy megerősítő párbeszédpanel, érintse meg a  Folytatás  gombot. Ha nem szeretné felvállalni ezeket a kockázatokat, akkor távolítsa el a nyomtatóból az egyéb márkájú kellékanyagot vagy alkatrészt, majd szereljen be egy eredeti, Lexmark által gyártottat. További információért lásd:  . Ha nem szeretné felvállalni ezeket a kockázatokat, akkor távolítsa el a nyomtatóból az egyéb márkájú kellékanyagot vagy alkatrészt, majd szereljen be egy eredeti, Dell által gyártottat. Ha nem szeretné felvállalni ezeket a kockázatokat, akkor távolítsa el a nyomtatóból az egyéb márkájú kellékanyagot vagy alkatrészt, és helyezzen be a nyomtató gyártója által gyártott eredetit. Ha a nyomtató a hibaüzenet törlése után sem nyomtat, állítsa vissza a kellékanyag-használati számlálót. A kezelőpanelről navigáljon a  Beállítások Eszköz Karbantartás Konfigurációs menü Kellékhasználat és -számlálók . Jelölje ki a visszaállítani kívánt alkatrészeket és kellékanyagokat, majd válassza a  Start  elemet. Olvassa el a „Vigyázat!” üzenetet, majd válassza a  Folytatás  elemet. Két ujjával érintse meg a kijelzőt 15 másodpercig az üzenet törléséhez. Ha nem tudja visszaállítani a kellékanyag-használat számlálóit, vigye vissza a kellékanyagot a vásárlás helyére. nyomtatóüzenetek Nem Lexmark kellékanyag Nem Lexmark kellékanyag nyomtatóüzenetek Nem Dell kellékanyag Nem Dell kellékanyag nyomtatóüzenetek Nem nyomtatógyártó által gyártott kellékanyag Nem nyomtatógyártó által gyártott kellékanyag alaphelyzetbe állítás kellékanyag-használati számlálók kellékanyag-használati számlálók alaphelyzetbe állítás kellékanyag-használati számlálók visszaállítása"},{"UUID":"a527ee0c-3145-4737-b575-2e3379b51844","title":"Papíradagolási problémák","link":"trb-paper-curl-topic.html","desc":"Gyűrött papír Próbálja meg a","descFull":"Gyűrött papír Próbálja meg a következők valamelyikét: Állítsa a tálcában lévő vezetőket a betöltött papírnak megfelelő pozícióba. A papír típusát az operációs rendszertől függően a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelen adhatja meg. Ügyeljen arra, hogy a beállítás megfeleljen a betöltött papírnak. A beállítások a nyomtató kezelőpaneljéről is módosíthatók. Lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  menüponthoz. Vegye ki a papírt, fordítsa meg, majd töltse be újra a papírt. Töltsön be papírt egy bontatlan csomagból. A papír magas páratartalom esetén megszívja magát nedvességgel. Tárolja a papírt az eredeti csomagolásban, amíg nem használja fel. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatás minőségével kapcsolatos probléma papírmeghajlás papírmeghajlás"},{"UUID":"13d041f2-2c51-4692-8791-3e4f2db13cd9","title":"Papíradagolási problémák","link":"trb-paper-curl-topic.html","desc":"Boríték összetapad nyomtatás közben Próbálja","descFull":"Boríték összetapad nyomtatás közben Próbálja meg a következők valamelyikét: Használjon száraz helyen tárolt borítékot. Ha nagy nedvességtartalmú borítékokra nyomtat, a ragasztós fülek összetapadhatnak. Ügyeljen rá, hogy a papírtípus beállítása  Boríték  legyen. A kezelőpanelről kiindulva lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  elemre. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . papíradagolási probléma boríték összetapad nyomtatás közben boríték összetapad nyomtatás közben"},{"UUID":"696cf8d0-df88-43a0-972c-9a3a162d2ac7","title":"Papíradagolási problémák","link":"trb-paper-curl-topic.html","desc":"Nem működik a leválogatás Próbálja","descFull":"Nem működik a leválogatás Próbálja meg a következők valamelyikét: A kezelőpanelen navigáljon a  Beállítások Nyomtatás Elrendezés Leválogatás  menüpontra, majd válassza a  Be [1,2,1,2,1,2]  lehetőséget. A nyomtatandó dokumentumból nyissa meg a Nyomtatási beállítások vagy a Nyomtatás párbeszédpanelt, majd válassza a  Leválogatás  lehetőséget. Csökkentse a kinyomtatandó oldalak számát. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . papíradagolási probléma nem működik a leválogatás nem működik a leválogatás"},{"UUID":"12eb8f67-e432-4f98-bd93-59c3fdfcce1e","title":"Papíradagolási problémák","link":"trb-paper-curl-topic.html","desc":"A tálcaösszekapcsolás nem működik Próbálja","descFull":"A tálcaösszekapcsolás nem működik Próbálja meg a következők valamelyikét: Győződjön meg arról, hogy a kapcsolt tálcák papírmérete, tájolása és papírtípusa azonos. Ügyeljen arra, hogy a papírvezetők megfelelően legyenek beállítva. Az összekapcsolt tálcákba betöltött papír paramétereivel megegyező papírméretet és -típust állítson be. A kezelőpanelről kiindulva lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  elemre. Ügyeljen rá, hogy a  Tálca-összekapcsolás Automatikus  beállításra legyen állítva. További információkért lásd:  . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  ügyféltámogatás . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . papíradagolási probléma a tálca-összekapcsolás nem működik a tálca-összekapcsolás nem működik"},{"UUID":"d3e674cf-0560-4554-9335-e491b170f14a","title":"Papíradagolási problémák","link":"trb-paper-curl-topic.html","desc":"A papír gyakran elakad Próbálja","descFull":"A papír gyakran elakad Próbálja meg a következők valamelyikét: Ellenőrizze, hogy helyesen van-e betöltve a papír. Ügyeljen arra, hogy a papírvezetők megfelelően legyenek beállítva. Ügyeljen arra, a köteg magassága ne haladja meg a maximális papírmennyiséget mutató jelet. Ügyeljen arra, hogy az ajánlott papírméretre és papírtípusra nyomtasson. Állítsa be a megfelelő papírméretet és papírtípust. A kezelőpanelről kiindulva lépjen a  Beállítások Papír Tálcakonfiguráció Papírméret/-típus  elemre. Töltsön be papírt egy bontatlan csomagból. A papír magas páratartalom esetén megszívja magát nedvességgel. Tárolja a papírt az eredeti csomagolásban, amíg nem használja fel. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . papíradagolási probléma a papír gyakran elakad a papír gyakran elakad"},{"UUID":"9e53fb1f-6738-4ccf-befd-703bc4729e8c","title":"Papíradagolási problémák","link":"trb-paper-curl-topic.html","desc":"Az elakadt lapokat a nyomtató","descFull":"Az elakadt lapokat a nyomtató nem nyomtatja ki újra A kezelőpanelen navigáljon a  Beállítások Eszköz Értesítések Elakadáselhárítás  menüpontra. Az  Elakadáselhárítás  menüben válassza a  Be  vagy az  Automatikus  lehetőséget. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nyomtatási probléma az elakadt lapokat a nyomtató nem nyomtatja ki újra az elakadt lapokat a nyomtató nem nyomtatja ki újra"},{"UUID":"cbf4cb86-992a-47a8-992d-ea60db6f396d","title":"E-mail-küldési problémák","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"„Az SMTP-kiszolgáló nincs beállítva” hiba","descFull":"„Az SMTP-kiszolgáló nincs beállítva” hiba letiltása A kezelőpanelen navigáljon a  Beállítások E-mail E-mail beállítása  menüpontra. „Az SMTP-kiszolgáló nincs beállítva” hiba letiltása  lehetőséget állítsa  Be  értékre. A hiba ismételt előfordulásának elkerülése érdekében végezzen el a következő feladatok közül egyet vagy többet: Frissítse a nyomtató firmware-ét. További információkért lásd a „A firmware frissítése” című részt. Az e-mail SMTP-beállításainak konfigurálása. További információkért lásd:  . „Az SMTP-kiszolgáló nincs beállítva” hiba letiltás hibaelhárítás „Az SMTP-kiszolgáló nincs beállítva” hiba „Az SMTP-kiszolgáló nincs beállítva” hiba letiltása"},{"UUID":"8af7e952-2f66-4659-ab67-a1a2f805f4b8","title":"E-mail-küldési problémák","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Nem tud e-maileket küldeni Próbáljon","descFull":"Nem tud e-maileket küldeni Próbáljon ki még egyet a következők közül: Ellenőrizze, hogy az e-mail SMTP-beállításai megfelelően vannak-e konfigurálva. További információkért lásd:  . Ellenőrizze, hogy a nyomtató csatlakozik-e egy hálózathoz, és hogy a hálózat csatlakozik-e az internethez. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . e-mail-probléma nem tud e-maileket küldeni nem tud e-maileket küldeni"},{"UUID":"5f943cb8-18b7-446c-8c9c-f4ab922790bd","title":"Faxolási problémák","link":"trb-caller-id-not-shown-topic.html","desc":"Nem jelenik meg a hívófél-azonosító","descFull":"Nem jelenik meg a hívófél-azonosító Nem jelenik meg a hívófél-azonosító Ezek az utasítások csak a faxkártyával felszerelt nyomtatókra vonatkoznak. A kezelőpanelen navigáljon a  Beállítások Fax Faxbeállítás Faxfogadási beállítások Rendszergazdai beállítások  menüpontra. Állítsa a  Hívóazonosító engedélyezése  beállítást  Be  értékre. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . faxprobléma hívó azonosítója nem jelenik meg hívó azonosítója nem jelenik meg"},{"UUID":"096902e3-bd61-45db-a479-0fdaa82d80e5","title":"Faxolási problémák","link":"trb-caller-id-not-shown-topic.html","desc":"Nem lehet faxot küldeni vagy","descFull":"Nem lehet faxot küldeni vagy fogadni analóg fax használatakor Nem lehet faxot küldeni vagy fogadni analóg fax használatakor Próbálja meg a következők valamelyikét: Hárítsa el a kijelzőn megjelenő esetleges hibaüzeneteket. Győződjön meg arról, hogy a telefon, a kézibeszélő vagy az üzenetrögzítő kábelcsatlakozásai biztonságosan csatlakoznak. Ellenőrizze a tárcsahangot. Hívja fel a faxszámot a helyes működése ellenőrzéséhez. Ha az On Hook Dial alkalmazást használja, akkor csavarja fel a hangerőt a tárcsahang ellenőrzéséhez. Ellenőrizze a fali telefonaljzatot. Csatlakoztassa az analóg telefont közvetlenül a fali aljzathoz. Várja meg, hogy hallható legyen a tárcsahang. Ha nem hall tárcsahangot, használjon másik telefonkábelt. Ha ezután sem hall tárcsahangot, csatlakoztassa az analóg telefont egy másik fali aljzathoz. Ha hall tárcsahangot, akkor csatlakoztassa a nyomtatót abba a fali aljzatba. Ellenőrizze, hogy a nyomtató csatlakozik-e analóg telefonszolgáltatáshoz vagy megfelelő digitális csatlakozóhoz. Ha integrált szolgáltatású digitális hálózati (Integrated Services Digital Network, ISDN) telefonszolgáltatást használ, csatlakoztassa a készüléket egy ISDN termináladapter analóg telefonportjához. További információért forduljon ISDN-szolgáltatójához. Ha DSL telefont használ, csatlakozzon olyan DSL szűrőhöz vagy útválasztóhoz, amely lehetővé teszi az analóg használatot. További információért forduljon DSL-szolgáltatójához. Ha alközpontos (private branch exchange, PBX) telefonszolgáltatást használ, ügyeljen arra, hogy az alközponton analóg porthoz csatlakoztassa a készüléket. Ha az alközpont nem rendelkezik analóg aljzattal, javasoljuk, hogy a faxkészülékhez helyezzen üzembe egy analóg telefonvonalat. Ideiglenesen válassza le az egyéb berendezéseket, és kapcsolja ki az egyéb telefonszolgáltatásokat. Válassza le a nyomtató és a telefonvonal közötti egyéb berendezéseket (például üzenetrögzítőket, számítógépeket, modemeket vagy telefonvonali frekvenciaosztókat). Tiltsa le a hívásvárakoztatást és a hangpostát. További információért forduljon a telefonszolgáltatóhoz. Szkennelje be az eredeti dokumentumot oldalanként. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . faxprobléma nem lehet faxot küldeni vagy fogadni analóg fax használatakor nem lehet faxot küldeni vagy fogadni analóg fax használatakor"},{"UUID":"29ff705b-d55d-4161-9844-07981e272b80","title":"Faxolási problémák","link":"trb-caller-id-not-shown-topic.html","desc":"Faxot küldeni lehet, de fogadni","descFull":"Faxot küldeni lehet, de fogadni nem analóg fax használatakor Faxot küldeni lehet, de fogadni nem analóg fax használatakor Próbálja meg a következők valamelyikét: Tegye az eredeti dokumentumot az automatikus lapadagoló tálcájába vagy a lapolvasó üveglapjára. Állítsa be helyesen a parancsikonnevet. Ellenőrizze, hogy korábban beállított-e gyorstárcsázó számot a tárcsázni kívánt számhoz. Manuálisan tárcsázza a kívánt számot. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . faxprobléma nem lehet faxot küldeni analóg fax használatakor nem lehet faxot küldeni analóg fax használatakor"},{"UUID":"91ae771a-8f95-4e3a-95ff-82fa84b1948e","title":"Faxolási problémák","link":"trb-caller-id-not-shown-topic.html","desc":"Faxot küldeni lehet, de fogadni","descFull":"Faxot küldeni lehet, de fogadni nem analóg fax használatakor Faxot küldeni lehet, de fogadni nem analóg fax használatakor Próbálja meg a következők valamelyikét: Ellenőrizze, hogy a papírforrás nem üres-e. Ellenőrizze a kicsengések számához tartozó beállítást. A kezelőpanelen válassza a  Beállítások Fax Fax beállítása Faxfogadási beállítások Csengések a válaszig  lehetőséget. Ha a nyomtató üres oldalakat nyomtat, lásd a következőt:  . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . faxprobléma faxot küldeni lehet, de fogadni nem analóg fax használatakor nem lehet faxot fogadni analóg fax használatakor"},{"UUID":"7b8bb44c-fec5-4ae7-83cb-666f103d862e","title":"Faxolási problémák","link":"trb-caller-id-not-shown-topic.html","desc":"Sikertelen etherFAX-beállítás Sikertelen etherFAX-beállítás Próbálja","descFull":"Sikertelen etherFAX-beállítás Sikertelen etherFAX-beállítás Próbálja meg a következők valamelyikét: Ellenőrizze a nyomtató csatlakozását. A kezelőpanelen navigáljon a  Beállítások Jelentések Hálózat Hálózati beállítások oldala  menüpontra. Ellenőrizze a hálózat állapotát a nyomtatott oldalon. Ellenőrizze, hogy a nyomtató csatlakozik-e egy hálózathoz, és hogy a hálózat csatlakozik-e az internethez. Győződjön meg arról, hogy az etherFAX megfelelően van beállítva. További információkért lásd:  . Ha a probléma továbbra is fennáll, akkor látogasson el a  https://www.etherfax.net/lexmark  weboldalra. faxprobléma sikertelen etherFAX-beállítás sikertelen etherFAX-beállítás"},{"UUID":"b5246e20-cca7-463a-b01d-02b590a0ec2d","title":"Faxolási problémák","link":"trb-caller-id-not-shown-topic.html","desc":"Nem lehet faxot küldeni vagy","descFull":"Nem lehet faxot küldeni vagy fogadni az etherFAX használatával Nem lehet faxot küldeni vagy fogadni az etherFAX használatával Próbálja meg a következők valamelyikét: Ellenőrizze, hogy a nyomtató csatlakozik-e egy hálózathoz, és hogy a hálózat csatlakozik-e az internethez. Győződjön meg arról, hogy az etherFAX megfelelően van beállítva. További információkért lásd:  . Ossza fel a nagy dokumentumokat kisebb méretű fájlokra. Ha a probléma továbbra is fennáll, akkor látogasson el a  https://www.etherfax.net/lexmark  weboldalra. faxprobléma nem lehet faxot küldeni vagy fogadni az etherFAX használatával nem lehet faxot küldeni vagy fogadni az etherFAX használatával"},{"UUID":"64767e54-efb2-4946-ae69-b80a0328486d","title":"Faxolási problémák","link":"trb-caller-id-not-shown-topic.html","desc":"Gyenge faxnyomtatási minőség Gyenge faxnyomtatási","descFull":"Gyenge faxnyomtatási minőség Gyenge faxnyomtatási minőség Próbálja meg a következők valamelyikét: Javítsa ki a nyomtatási minőséggel kapcsolatos hibákat. Nyomtassa ki a  Nyomtatásiminőségi tesztoldalakat . A kezelőpanelen navigáljon a következő lehetőségre:  Beállítások Hibaelhárítás Tesztoldal nyomtatása . Javítsa ki a nyomtatási minőséggel kapcsolatos hibákat. További információkért lásd:  . Ha analóg faxot használ, növelje a bejövő faxok átviteli sebességét. A kezelőpanelen navigáljon a  Beállítások Fax Faxbeállítás  Faxfogadási beállítások Rendszergazdai beállítások  menüpontra. A  Max. sebesség  menüben válasszon ki egy alacsonyabb átviteli sebességet. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . faxprobléma gyenge nyomtatási minőség gyenge faxnyomtatási minőség"},{"UUID":"45905057-c6ac-46e5-9e55-cf392b4d5232","title":"Faxolási problémák","link":"trb-caller-id-not-shown-topic.html","desc":"Hiányzó információk a fax fedőlapján","descFull":"Hiányzó információk a fax fedőlapján Hiányzó információk a fax fedőlapján Kapcsolja ki a nyomtatót, várjon körülbelül 10 másodpercet, majd kapcsolja vissza. Küldje el vagy kérje le a faxot. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . faxprobléma hiányzó információk a faxfedőlapon hiányzó információk a faxfedőlapon"},{"UUID":"fad9f524-6e1e-4b67-9c3f-42da7d79bdb9","title":"Faxolási problémák","link":"trb-caller-id-not-shown-topic.html","desc":"Nem lehet elküldeni a fax","descFull":"Nem lehet elküldeni a fax fedőlapját a számítógépről Nem lehet elküldeni a fax fedőlapját a számítógépről Próbálja meg a következők valamelyikét: Győződjön meg róla, hogy a nyomtató-illesztőprogram frissítve van. További információért látogasson el a  www.lexmark.com/downloads  weboldalra. Győződjön meg róla, hogy a nyomtató-illesztőprogram frissítve van. További információért fáradjon el oda, ahol a nyomtatót vásárolta. Győződjön meg róla, hogy a nyomtató-illesztőprogram frissítve van, majd küldje el a faxot. További információkért, forduljon a következőhöz:  a kereskedőjével . Szüntesse meg a  Beállítások kijelzése minden faxolás előtt  bejelölését. Nyissa meg a  Nyomtatás  párbeszédpanelt úgy, hogy közben meg van nyitva a faxolni kívánt dokumentum. Válassza ki a nyomtatót, majd kattintson a  Tulajdonságok ,  Jellemzők ,  Beállítások  vagy  Beállítás  gombra. Kattintson a  Fax  elemre, majd törölje a  Mindig mutassa a beállításokat a fax elküldése előtt  beállítást. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . faxprobléma nem tud faxfedőlapot küldeni a számítógépről nem tud faxfedőlapot küldeni a számítógépről"},{"UUID":"d4977aa6-11bf-4006-bbe8-cb9e73d21fc7","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nem lehetséges a beolvasás számítógépre","descFull":"Nem lehetséges a beolvasás számítógépre Próbálja meg a következők valamelyikét: Hajtson végre egy másolási feladatot. Ha a feladat sikertelen volt, kapcsolja ki a nyomtatót, várjon körülbelül 10 másodpercet, majd kapcsolja vissza. Ellenőrizze a nyomtató csatlakozását. Nyomtassa ki a  Hálózati beállítások oldalát . A kezelőpanelen navigáljon a  Beállítások Jelentések Hálózat  menüpontra, majd válassza a  Hálózat beállítások oldala  menüpontot. Ellenőrizze az oldal első szakaszát, és győződjön meg arról, hogy az állapot értéke a csatlakoztatva. Győződjön meg róla, hogy a nyomtató és a számítógép ugyanahhoz a hálózathoz csatlakozik. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . beolvasási probléma nem lehetséges a beolvasás számítógépre nem lehetséges a beolvasás számítógépre"},{"UUID":"3e5ab24e-811f-419b-a23f-4346f8715b11","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nem lehetséges a beolvasás hálózati","descFull":"Nem lehetséges a beolvasás hálózati mappába Próbálja meg a következők valamelyikét: Hozzon létre egy hálózati mappára mutató parancsikon, majd olvasson be egy dokumentumot a parancsikon segítségével. További információkért lásd:  . Ellenőrizze, hogy a hálózati mappa elérési útvonala és formátuma megfelelő-e. Például  : // kiszolgáló_állomásnév /mappanév/útvonal , ahol a  kiszolgáló_állomásnév  teljes tartománynév (FQDN) vagy IP-cím. Ellenőrizze, hogy rendelkezik-e írási jogosultsággal a hálózati mappához. Frissítse a hálózati mappa parancsikonját. Nyisson meg egy webböngészőt, és írja be a nyomtató IP-címét a címmezőbe. Tekintse meg a nyomtató IP-címét a nyomtató főképernyőjén. Az IP-cím számok négyelemű, pontokkal elválasztott halmaza, például 123.123.123.123. Ha proxykiszolgálót használ, átmenetileg tiltsa le azt a weboldal megfelelő betöltése érdekében. Kattintson a  Parancsikonok  elemre, majd válasszon ki egy parancsikont. Több parancsikontípus esetén válassza a  Hálózati mappa  lehetőséget. Írja be a hálózati mappa elérési útvonalát az Elérési útvonal megosztása mezőbe. Például  \\\\kiszolgáló_állomásnév\\mappanév\\útvonal . A megosztás elérési útvonalának beírásakor mindig használjon előre dőlő perjelet. A  Hitelesítés  menüben válassza ki a hitelesítés típusát. Ha a  Hitelesítés beállítása  „ Hozzárendelt felhasználónév és jelszó használata ”, akkor a Felhasználónév és a Jelszó mezőkben adja meg hitelesítési adatait. Kattintson a  Mentés  gombra. Győződjön meg róla, hogy a nyomtató és a hálózati mappa ugyanahhoz a hálózathoz csatlakozik. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . nem lehetséges a beolvasás hálózati mappába beolvasási probléma nem lehetséges a beolvasás hálózati mappába"},{"UUID":"a48d5f7b-5463-42f5-a3f5-dab1c44ccdb5","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"A dokumentum vagy fénykép részleges","descFull":"A dokumentum vagy fénykép részleges másolása Próbálja meg a következők valamelyikét: Ügyeljen arra, hogy a dokumentum vagy fénykép a színével lefelé legyen betöltve, a lapolvasó üveglapjának bal felső sarkához. Állítsa be a papírméretet a tálcába betöltött papírnak megfelelően. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . másolási probléma dokumentumok részleges másolása másolási probléma fényképek részleges másolása dokumentum vagy fénykép részleges másolása beolvasási probléma dokumentumok részleges másolása beolvasási probléma fényképek részleges másolása"},{"UUID":"8ffeb7a9-6d1a-4670-9378-8c1d3dc1615d","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"Gyenge másolási minőség Próbálja meg","descFull":"Gyenge másolási minőség Próbálja meg a következők valamelyikét: Tisztítsa meg a lapolvasó üveglapját és az automatikus lapadagoló üvegét nedves, puha, szöszmentes ronggyal. Ha a nyomtatója második automatikus lapadagoló üveggel is rendelkezik az automatikus lapadagolón belül, azt az üveget is tisztítsa meg. További információkért lásd:  . Ügyeljen arra, hogy a dokumentum vagy fénykép a színével lefelé legyen betöltve, a lapolvasó üveglapjának bal felső sarkához. Ellenőrizze az eredeti dokumentum vagy fénykép minőségét, és ennek megfelelően állítsa be a beolvasás minőségi beállításait. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . másolási probléma gyenge másolási minőség gyenge másolási minőség beolvasási probléma gyenge másolási minőség gyenge beolvasási minőség"},{"UUID":"2b0751eb-a68c-48d7-9b36-778339dfac95","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"Függőleges sötét csíkok, amikor az","descFull":"Függőleges sötét csíkok, amikor az automatikus lapadagolóból olvas be Emelje fel a lapolvasó fedelét, majd vegye ki az üvegtisztító szerszámot. Törölje le az automatikus lapadagoló üvegét és a lapolvasó üveglapját is. Nyissa ki az A1 ajtót, majd tisztítsa meg az automatikus lapadagoló üvegét. Helyezze vissza a szerszámot a helyére. Csukja be a lapolvasó fedelét. A lapolvasó tisztításával kapcsolatos további információkért lásd:  . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . beolvasási probléma függőleges sötét csíkok a beolvasott oldalakon, amikor az automatikus lapadagolóból olvas be függőleges sötét csíkok a beolvasott oldalakon, amikor az automatikus lapadagolóból olvas be beolvasás minőségével kapcsolatos problémák"},{"UUID":"1daf1588-16f4-4b0f-9bad-d004beab57bc","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"Recés kép vagy szöveg az","descFull":"Recés kép vagy szöveg az automatikus lapadagolóból való beolvasáskor Recés kép vagy szöveg az automatikus lapadagolóból való beolvasáskor Töltsön 50 tiszta, normál papírlapot az automatikus lapadagolóba. A normál papír segít megtisztítani az automatikus lapadagoló adagológörgőit a portól és a rajtuk lévő egyéb anyagoktól. A kezelőpanelen húzza jobbra az ujját a kezelőközpont eléréséhez, és válassza a   lehetőséget. Tegyen be egy eredeti dokumentumot az automatikus lapadagolóba. Olvassa be a dokumentumot. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . beolvasási probléma recés kép beolvasási probléma recés szöveg hibaelhárítás recés a kép az automatikus lapadagolóból való beolvasáskor hibaelhárítás recés a szöveg az automatikus lapadagolóból való beolvasáskor recés a kép az automatikus lapadagolóból való beolvasáskor recés a szöveg az automatikus lapadagolóból való beolvasáskor"},{"UUID":"f0453973-7606-4a9e-88fa-6b34796adce9","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"A beolvasási feladat nem sikerült","descFull":"A beolvasási feladat nem sikerült A beolvasási feladat nem sikerült Próbálja meg a következők valamelyikét: Ügyeljen, hogy az Ethernet- vagy az USB-kábel biztonságosan csatlakozzon a számítógéphez és a nyomtatóhoz. Ellenőrizze a beolvasni kívánt fájlt, és győződjön meg róla, hogy: A fájl neve még nem szerepel a célmappában. A beolvasni kívánt dokumentum vagy fénykép nincs megnyitva egy másik alkalmazásban. Ügyeljen, hogy az  Időbélyeg hozzáfűzése  vagy a  Meglévő fájl felülírása  négyzet be legyen jelölve a célhely konfigurációs beállításai között. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . beolvasási probléma a beolvasási feladat nem sikerült a beolvasási feladat nem sikerült hibaelhárítás a beolvasási feladat nem sikerült"},{"UUID":"70632419-06b9-4132-9dd5-83834f37f67c","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nem lehet lecsukni a lapolvasót","descFull":"Nem lehet lecsukni a lapolvasót Nem lehet lecsukni a lapolvasót Távolítsa el a lapolvasó fedelét nyitva tartó akadályokat. Zárja be a lapolvasót. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . beolvasási probléma nem lehet lecsukni a lapolvasót nem lehet lecsukni a lapolvasót"},{"UUID":"2f27f636-e71e-44b2-8b2f-d0363155a5cb","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"A beolvasás sokáig tart, vagy","descFull":"A beolvasás sokáig tart, vagy lefagy tőle a számítógép A beolvasás sokáig tart, vagy lefagy tőle a számítógép Zárja be a beolvasást zavaró összes alkalmazást. Olvassa be a dokumentumot újból. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . beolvasási probléma a beolvasás túl sokáig tart beolvasási probléma a beolvasás lefagyasztja a számítógépet a beolvasás sokáig tart, vagy lefagy tőle a számítógép"},{"UUID":"2ac7e136-da14-476c-8926-d5a899a5233d","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"A lapolvasó nem válaszol A","descFull":"A lapolvasó nem válaszol A lapolvasó nem válaszol Próbálja meg a következők valamelyikét: Ellenőrizze, hogy a tápkábel megfelelően csatlakoztatva van-e a nyomtatóhoz és a csatlakozóaljzathoz. A tűz és áramütés kockázatának elkerülése érdekében csatlakoztassa a tápkábelt közvetlenül egy megfelelő teljesítményt biztosító, gondosan földelt, a készülék közelében levő és könnyen hozzáférhető csatlakozóaljzathoz. Ellenőrizze, hogy a nyomtató be van-e kapcsolva, majd oldja meg a kijelzőn megjelenő hibaüzeneteket. Kapcsolja ki a nyomtatót, várjon körülbelül 10 másodpercet, majd kapcsolja vissza. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . másolási probléma a lapolvasó nem válaszol beolvasási probléma a lapolvasó nem válaszol a lapolvasó nem válaszol"},{"UUID":"77d8985c-41bb-46b8-ba3e-8e4845b9916f","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"A lapolvasó-regisztráció beállítása A lapolvasó-regisztráció","descFull":"A lapolvasó-regisztráció beállítása A lapolvasó-regisztráció beállítása A kezelőpanelen navigáljon a  Beállítások Eszköz Karbantartás Konfigurációs menü Lapolvasó konfigurációja Lapolvasó kézi regisztrálása  menüpontra. A  Nyomtatási gyorsteszt  menüben válassza az  Indítás  lehetőséget. Helyezze a tesztoldalt a lapolvasó üveglapjára, majd válassza a  Síkágy-regisztráció  lehetőséget. A  Másolási gyorsteszt  menüben válassza az  Indítás  lehetőséget. Hasonlítsa össze a tesztoldalt az eredeti dokumentummal. Ha a tesztoldal margói eltérnek az eredeti dokumentumétól, módosítsa a  Bal margó  és  Felső margó  értékét. Ismételje meg a  . és  . lépéseket addig, amíg a  Másolási gyorsteszt  oldal margói meg nem egyeznek az eredeti dokumentum margóival. beállítás lapolvasó regisztrálása"},{"UUID":"05fe7781-395a-4c1b-ae14-f3dbce58640a","title":"Beolvasási problémák","link":"trb-cannot-scan-to-computer-topic.html","desc":"Automatikus lapadagoló regisztrációjának módosítása A","descFull":"Automatikus lapadagoló regisztrációjának módosítása A kezelőpanelen navigáljon a  Beállítások Eszköz Karbantartás Konfigurációs menü Lapolvasó konfigurációja Lapolvasó kézi regisztrálása  menüpontra. A  Nyomtatási gyorsteszt  menüben válassza az  Indítás  lehetőséget. Helyezze a tesztoldalt az automatikus lapadagoló tálcájára. Válassza az  Automatikus lapadagoló elülső regisztrálása  vagy az  Automatikus lapadagoló hátsó regisztrálása  elemet. Az  automatikus lapadagoló elülső regisztrálásához  a tesztoldalt színével felfelé, rövid oldalával előre helyezze az automatikus lapadagolóba. Az  automatikus lapadagoló hátsó regisztrálásához  a tesztoldalt színével lefelé, rövid oldalával előre helyezze az automatikus lapadagolóba. A  Másolási gyorsteszt  menüben válassza az  Indítás  lehetőséget. Hasonlítsa össze a tesztoldalt az eredeti dokumentummal. Ha a tesztoldal margói eltérnek az eredeti dokumentumtól, akkor módosítsa a  Vízszintes beállítás  és a  Felső margó  értékeit. Ismételje meg a  . és  . lépéseket addig, amíg a  Másolási gyorsteszt  oldal margói meg nem egyeznek az eredeti dokumentum margóival. ADF regisztrálása beállítás automatikus lapadagoló regisztrációjának módosítása"},{"UUID":"60b01989-975f-436b-8cb2-c5ce52456659","title":"A színminőséggel kapcsolatos problémák","link":"modifying-colors-in-printed-output-topic.html","desc":"A kinyomtatott anyagon látható színek","descFull":"A kinyomtatott anyagon látható színek módosítása A kezelőpanelen navigáljon a  Beállítások Nyomtatás Minőség Speciális képalkotás Színkorrekció  menüpontra. A  Színkorrekció  menüben válassza a  Manuális  lehetőséget. A  Színkorrekció – tartalom  menüben válassza ki a megfelelő színkonverziós beállítást. A Kézi szín menü objektumtípusai és a hozzájuk tartozó színátalakító táblázatok Objektumtípus Színátalakító táblázatok RGB kép RGB szöveg RGB grafika Élénk : világosabb, telítettebb színeket eredményez. Minden beérkező színformátumhoz használható. sRGB-kijelző : a számítógép-monitoron megjelenített színekhez hasonló kimenetet eredményez. A fekete festék használata fényképek nyomtatására van optimalizálva. Kijelző – valódi fekete : a számítógép-monitoron megjelenített színekhez hasonló kimenetet eredményez. Ez a beállítás csak fekete festéket használ a semleges szürke minden árnyalatának megjelenítéséhez. Élénk sRGB : megnövelt színtelítettséget eredményez az  sRGB-kijelző  színjavításához. A fekete festék használata reklámgrafikák nyomtatására van optimalizálva. Ki CMYK kép CMYK szöveg CMYK grafika USA CMYK : az SWOP-színskála megközelítésére alkalmaz színjavítást. Európai CMYK : az Euroscale-színskála megközelítésére alkalmaz színjavítást. Élénk CMYK : megnöveli az  USA CMYK  színjavító beállítás színtelítettségét. Ki színkimenet módosítása manuális színkorrekció színkorrekció"},{"UUID":"c7746580-4f35-4c41-a5ef-2bcb3b834a30","title":"A színminőséggel kapcsolatos problémák","link":"modifying-colors-in-printed-output-topic.html","desc":"GYIK a színes nyomtatásról Mi","descFull":"GYIK a színes nyomtatásról Mi az az RGB-szín? Az alapszín az egyes színeket a létrehozásukhoz szükséges piros, zöld és kék szín mennyiségének megadásával határozza meg. A piros (red), a zöld (green) és a kék (blue) színt többféle mennyiségben lehet adagolni, ami így széles, a természetben megfigyelhető színekből álló színskálát eredményez. A számítógép-képernyők, a lapolvasók és a digitális fényképezőgépek ezzel a módszerrel jelenítik meg a színeket. Mi az a CMYK-szín? A kevert szín az egyes színeket a létrehozásukhoz szükséges ciánkék, bíbor, sárga és fekete szín mennyiségének megadásával határozza meg. A CMXK-tintát vagy -festéket többféle mennyiségben lehet kinyomtatni, ami így széles, a természetben megfigyelhető színekből álló színskálát eredményez. A nyomdagépek, tintasugaras és színes lézernyomtatók így keverik ki a színeket.  Hogyan adja meg a rendszer a nyomtatni kívánt dokumentum színeit? A szoftverek a dokumentumok színét RGB- vagy CMYK-színkombinációk használatával adják meg és módosítják. További információt a szoftverhez tartozó súgótémakörökben olvashat. Honnan ismeri fel a nyomtató, hogy milyen színt kell kinyomtatnia? Amikor kinyomtat egy dokumentumot, a nyomtató megkapja az egyes objektumok típus- és színadatainak leírását. Az információt ezután színkonverziós táblázatokon vezeti keresztül a rendszer. A színeket a kívánt szín létrehozásához szükséges mennyiségű CMYK-festékekre képezi le a rendszer. Az objektumadatok a színátalakító táblázatok alkalmazásának módját határozzák meg. Például lehetséges, hogy a szövegekhez egyféle színátalakító táblázatot használjon, a fényképek nyomtatásához pedig egy másikat. Mit jelent a kézi színjavítás? Ha a kézi színjavítás funkció be van kapcsolva, a nyomtató a felhasználó által kiválasztott színátalakító táblázatokat használja az objektumok feldolgozása során. A Kézi színjavítás beállításainak értéke a nyomtatandó objektum típusától (szöveg, grafika, kép) függ. Attól is függ, hogy az objektum színei hogyan vannak megadva a szoftverben (RGB- vagy CMYK-színkombináció). Más színátalakító táblázat kézi alkalmazásához lásd:  . Ha a szoftver a színeket nem RGB- vagy CMYK-színkombinációként határozza meg, a kézi színjavításnak nincs értelme. Akkor sem hatékony megoldás, ha a színbeállítást a szoftveralkalmazás vagy a számítógép operációs rendszere vezérli. A legtöbb helyzetben, ha a színkorrekciót automatikusra állítja, a dokumentumoknál előáll a kívánt szín. Hogyan lehet egy adott színt (pl. egy vállalati emblémát) harmonizálni? A  Minőség  menüben kilenc  Színminták  készlet található. Ezek a készletek az Embedded Web Server  Színminták  oldaláról is elérhetők. Bármelyik színmintakészletet választja is ki, a nyomtató színes mezők százait tartalmazó oldalak nyomtatásába kezd. A kiválasztott színtáblázattól függően az egyes mezőkben CMYK- vagy RGB-színkombinációk találhatók. Az egyes mezők megfigyelt színe a mezőn feltüntetett CMYK- vagy RGB-színek átadásával jön létre. A  Színminták  készletek megvizsgálásával meghatározhatja, hogy melyik mező színe hasonlít leginkább a kívánt színre. A mező címkéjén lévő színkombináció felhasználható az objektum színének módosítására egy szoftverprogramban. További információt a szoftverhez tartozó súgótémakörökben olvashat. Az adott objektum kiválasztott színátalakító táblázatának alkalmazásához kézi színjavításra lehet szükség. Egy adott színeltéréssel kapcsolatos probléma megoldásához szükséges  Színminták  készlet kiválasztása az alábbiaktól függ: A  Színkorrekció  aktuális beállítása ( Automatikus ,  Kikapcsolva ,  Kézi ) A nyomtatandó objektum típusa (szöveg, grafika vagy kép) Az objektum színeinek meghatározási módja a szoftverben (RGB- vagy CMYK-színek) Ha a szoftver nem ad meg színeket RGB- vagy CMYK-színekkel, akkor a  Színminták  oldalak nem hasznosak. Előfordulhat, hogy az RGB- vagy a CMYK-színeknek a szoftverben megadott kombinációját egyes szoftverek állítják be a színkezelőn keresztül. Ezekben az esetekben a kinyomtatott szín nem feltétlenül egyezik meg tökéletesen a  Színminták  oldalakon láthatóval. színminőséggel kapcsolatos probléma GYIK a színes nyomtatásról színes nyomtatás színkorrekció színminták"},{"UUID":"091e0d60-e47a-4d26-87cd-26fe4aab7dfa","title":"A színminőséggel kapcsolatos problémák","link":"modifying-colors-in-printed-output-topic.html","desc":"A nyomat színesnek látszik A","descFull":"A nyomat színesnek látszik A nyomat színesnek látszik Próbálja meg a következők valamelyikét: A kezelőpanelen navigáljon a  Beállítások Nyomtatás Minőség Speciális képalkotás  menüpontra, majd válassza a  Színbeállítás  lehetőséget. A kezelőpanelen navigáljon a  Beállítások Nyomtatás Minőség Speciális képalkotás  menüpontra, válassza a  Színegyensúly  lehetőséget, és állítsa be a beállításokat. Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  az ügyféltámogatással . Ha a probléma nem szűnne meg, akkor lépjen kapcsolatba  a kereskedőjével . színminőséggel kapcsolatos probléma a nyomat színesnek látszik a nyomat színesnek látszik hibaelhárítás a nyomat színesnek látszik"},{"UUID":"65b452c0-3fc7-4187-98be-1bad6f4bb37c","title":"Problémák elhárítása","link":"trb-contacting-customer-support-topic.html","desc":"Kapcsolatba lépés az ügyféltámogatással Kapcsolatba","descFull":"Kapcsolatba lépés az ügyféltámogatással Kapcsolatba lépés az ügyféltámogatással Mielőtt felvenné a kapcsolatot az ügyféltámogatással, gyűjtse össze a következő információkat: A probléma A hibaüzenet A nyomtató modellje és sorozatszáma Látogasson el a  https://support.lexmark.com  weboldalra e-mailes vagy chat alapú támogatásért, illetve a kézikönyvek, dokumentációk, illesztőprogramok és más letöltések eléréséért. Telefonos műszaki támogatás is elérhető. Az Egyesült Államokban vagy Kanadában hívja az 1-800-539-6275 számot. Más országok vagy régiók esetében látogasson el a  nemzetközi támogatási elérhetőségek könyvtára  oldalra. Keresse fel azt a helyet, ahol a nyomtatót vásárolta. kapcsolatba lépés az ügyfélszolgálattal az ügyféltámogatással"},{"UUID":"e68ad83a-a731-4660-b141-c99205d83283","title":"Problémák elhárítása","link":"troubleshooting-chapter.html","desc":"Kapcsolatfelvétel a márkakereskedőjével Mielőtt felvenné","descFull":"Kapcsolatfelvétel a márkakereskedőjével Mielőtt felvenné a kapcsolatot a márkakereskedőjével, gyűjtse össze a következő információkat: A probléma A hibaüzenet A nyomtató típusa és sorozatszáma kapcsolatfelvétel a márkakereskedővel nyomtató-márkakereskedő"},{"UUID":"79716ade-af05-4896-9ed7-8d2efa1652e4","title":"Problémák elhárítása","link":"troubleshooting-chapter.html","desc":"Kapcsolatba lépés a műszaki ügyfélszolgálattal","descFull":"Kapcsolatba lépés a műszaki ügyfélszolgálattal Amikor felhívja a terméktámogatást, írja le a problémát, a nyomtató kijelzőjén lévő üzenetet és az elvégzett hibaelhárítási lépéseket. Nézze meg az első felső fedél belsejében vagy a nyomtató hátulján lévő címkét, és jegyezze fel a következőket: A nyomtatómodell A szervizcímke száma vagy az expressz szervizkód További információkért látogasson el a  www.dell.com/support/printers  weboldalra. hibaelhárítás a műszaki terméktámogatás hívása a műszaki terméktámogatás hívása"},{"UUID":"239005c0-6633-4d12-865e-f1c34931b0a3","title":"Újrahasznosítás és hulladékkezelés","link":"recycling-lexmark-products-topic.html","desc":"Lexmark termékek újrahasznosítása Lexmark termékek","descFull":"Lexmark termékek újrahasznosítása Lexmark termékek újrahasznosítása Látogasson el a  www.lexmark.com/recycle  címre. Válassza ki az országot vagy régiót. Válasszon ki egy újrahasznosítási programot. újrahasznosított termékek"},{"UUID":"ac6e594a-a856-414e-b206-a9106ee113b6","title":"Újrahasznosítás és hulladékkezelés","link":"recycling-lexmark-packaging-topic.html","desc":"Lexmark csomagolás újrahasznosítása Lexmark csomagolás","descFull":"Lexmark csomagolás újrahasznosítása Lexmark csomagolás újrahasznosítása A Lexmark folyamatosan arra törekszik, hogy minél kevesebb csomagolóanyagot használjon. A kevesebb csomagolóanyag azt jelenti, hogy a Lexmark nyomtatókat a lehető leghatékonyabb és legkörnyezetbarátabb módon szállítjuk, és gondoskodunk arról, ahogy minél kevesebb legyen a kidobott csomagolóanyag. Az ilyen hatékonyságnövelő törekvések révén kevesebb üvegházgáz kerül a légkörbe, miközben mérsékeltebb az energia- és természeteserőforrás-felhasználás. A Lexmark emellett egyes országokban és régiókban a csomagolóanyagok összetevőinek újrahasznosítását is kínálja. További információért látogasson el a  www.lexmark.com/recycle  weboldalra. A Lexmark kartondobozok 100%-ban újrahasznosíthatók ott, ahol léteznek hullámpapírt újrahasznosító létesítmények. Előfordulhat, hogy ilyen létesítmények nincsenek az Ön területén. A Lexmark csomagolásaiban használt puha anyagok újrahasznosíthatók ott, ahol találhatók ilyen jellegű újrahasznosító létesítmények. Előfordulhat, hogy ilyen létesítmények nincsenek az Ön területén.  Amikor visszaküld egy kazettát a Lexmarknak, újrahasználhatja a kazetta eredeti dobozát. A Lexmark ezt követően újrahasznosítja a dobozt. termék-újrahasznosítás csomagolóanyag"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFPs"}},[_vm._v("\n    CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFPs\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_hu","title":"Biztons&aacute;gi inform&aacute;ci&oacute;k"}},[_vm._v("\n    Biztonsági információk\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Konvenci&oacute;k"}},[_vm._v("\n     Konvenciók\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e43","title":"Term&eacute;knyilatkozatok"}},[_vm._v("\n     Terméknyilatkozatok\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_hu","title":"Inform&aacute;ci&oacute;k a nyomtat&oacute;r&oacute;l"}},[_vm._v("\n    Információk a nyomtatóról\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e221"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_hu","title":"Tov&aacute;bbi inform&aacute;ci&oacute;k a nyomtat&oacute;r&oacute;l"}},[_vm._v("\n     További információk a nyomtatóról\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_hu","title":"A nyomtat&oacute; sorozatsz&aacute;m&aacute;nak megtal&aacute;l&aacute;sa"}},[_vm._v("\n     A nyomtató sorozatszámának megtalálása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_hu","title":"Nyomtat&oacute;konfigur&aacute;ci&oacute;k"}},[_vm._v("\n     Nyomtatókonfigurációk\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_hu","title":"A kezelőpanel haszn&aacute;lata"}},[_vm._v("\n     A kezelőpanel használata\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#using-home-screen_hu","title":"Kezdőoldal ikonjai"}},[_vm._v("\n     Kezdőoldal ikonjai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"colors-of-indicator-light-topic.html#colors-of-indicator-light_hu","title":"A jelzőf&eacute;ny sz&iacute;nei"}},[_vm._v("\n     A jelzőfény színei\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_hu","title":"Az automatikus lapadagol&oacute; &eacute;s a lapolvas&oacute; &uuml;veglapj&aacute;nak haszn&aacute;lata"}},[_vm._v("\n     Az automatikus lapadagoló és a lapolvasó üveglapjának használata\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_hu","title":"Biztons&aacute;gi ny&iacute;l&aacute;s poz&iacute;ci&oacute;ja"}},[_vm._v("\n     Biztonsági nyílás pozíciója\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-guidelines-topic.html#d0e769","title":"Pap&iacute;r kiv&aacute;laszt&aacute;sa"}},[_vm._v("\n     Papír kiválasztása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-applications-topic.html#d0e10635","title":"Tov&aacute;bbi nyomtat&oacute;funkci&oacute;k &eacute;s t&aacute;mogat&aacute;s"}},[_vm._v("\n     További nyomtatófunkciók és támogatás\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_hu","title":"Be&aacute;ll&iacute;t&aacute;s, telep&iacute;t&eacute;s &eacute;s konfigur&aacute;l&aacute;s"}},[_vm._v("\n    Beállítás, telepítés és konfigurálás\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10762"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_hu","title":"A nyomtat&oacute; hely&eacute;nek kiv&aacute;laszt&aacute;sa"}},[_vm._v("\n     A nyomtató helyének kiválasztása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-ports-topic.html#printer-ports_hu","title":"Nyomtat&oacute;portok"}},[_vm._v("\n     Nyomtatóportok\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-scan-center-topic.html#d0e10961","title":"Alkalmaz&aacute;sok &eacute;s megold&aacute;sok konfigur&aacute;l&aacute;sa"}},[_vm._v("\n     Alkalmazások és megoldások konfigurálása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e11138","title":"A kiseg&iacute;tő funkci&oacute;k telep&iacute;t&eacute;se &eacute;s haszn&aacute;lata"}},[_vm._v("\n     A kisegítő funkciók telepítése és használata\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e11443","title":"Nyomtat&oacute; be&aacute;ll&iacute;t&aacute;sa faxol&aacute;sra"}},[_vm._v("\n     Nyomtató beállítása faxolásra\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-group.html#loading-trays-group_hu","title":"Pap&iacute;r &eacute;s speci&aacute;lis adathordoz&oacute; bet&ouml;lt&eacute;se"}},[_vm._v("\n     Papír és speciális adathordozó betöltése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e12239","title":"Szoftver, illesztőprogramok &eacute;s firmware telep&iacute;t&eacute;se, illetve friss&iacute;t&eacute;se"}},[_vm._v("\n     Szoftver, illesztőprogramok és firmware telepítése, illetve frissítése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-optional-550-sheet-tray-topic.html#d0e12565","title":"Hardverkieg&eacute;sz&iacute;tők telep&iacute;t&eacute;se"}},[_vm._v("\n     Hardverkiegészítők telepítése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"connecting-printer-to-wireless-network-topic.html#d0e14096","title":"H&aacute;l&oacute;zati haszn&aacute;lat"}},[_vm._v("\n     Hálózati használat\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_hu","title":"A nyomtat&oacute; biztons&aacute;ga"}},[_vm._v("\n    A nyomtató biztonsága\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14448"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_hu","title":"Nyomtat&oacute;mem&oacute;ria t&ouml;rl&eacute;se"}},[_vm._v("\n     Nyomtatómemória törlése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_hu","title":"Nyomtat&oacute; t&aacute;rol&oacute;meghajt&oacute;j&aacute;nak t&ouml;rl&eacute;se"}},[_vm._v("\n     Nyomtató tárolómeghajtójának törlése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_hu","title":"Gy&aacute;ri alap&eacute;rtelmezett &eacute;rt&eacute;kek vissza&aacute;ll&iacute;t&aacute;sa"}},[_vm._v("\n     Gyári alapértelmezett értékek visszaállítása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_hu","title":"T&ouml;r&ouml;lhetős&eacute;gi nyilatkozat"}},[_vm._v("\n     Törölhetőségi nyilatkozat\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_hu","title":"Nyomtat&aacute;s"}},[_vm._v("\n    Nyomtatás\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14640"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-topic.html#printing-from-computer_hu","title":"Nyomtat&aacute;s a sz&aacute;m&iacute;t&oacute;g&eacute;pről"}},[_vm._v("\n     Nyomtatás a számítógépről\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14691","title":"Nyomtat&aacute;s mobileszk&ouml;zről"}},[_vm._v("\n     Nyomtatás mobileszközről\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_hu","title":"Nyomtat&aacute;s flash-meghajt&oacute;r&oacute;l"}},[_vm._v("\n     Nyomtatás flash-meghajtóról\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_hu","title":"Titkos&iacute;tott feladatok konfigur&aacute;l&aacute;sa"}},[_vm._v("\n     Titkosított feladatok konfigurálása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_hu","title":"Bizalmas &eacute;s m&aacute;s t&iacute;pus&uacute; f&uuml;ggő feladatok nyomtat&aacute;sa"}},[_vm._v("\n     Bizalmas és más típusú függő feladatok nyomtatása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-topic.html#printing-font-sample-list_hu","title":"Betűt&iacute;pusmint&aacute;k list&aacute;j&aacute;nak nyomtat&aacute;sa"}},[_vm._v("\n     Betűtípusminták listájának nyomtatása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-topic.html#printing-directory-list_hu","title":"K&ouml;nyvt&aacute;rlista nyomtat&aacute;sa"}},[_vm._v("\n     Könyvtárlista nyomtatása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_hu","title":"Elv&aacute;laszt&oacute; lapok elhelyez&eacute;se nyomtat&aacute;si feladatokban"}},[_vm._v("\n     Elválasztó lapok elhelyezése nyomtatási feladatokban\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_hu","title":"Nyomtat&aacute;si feladat t&ouml;rl&eacute;se"}},[_vm._v("\n     Nyomtatási feladat törlése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_hu","title":"A fest&eacute;kmennyis&eacute;g be&aacute;ll&iacute;t&aacute;sa"}},[_vm._v("\n     A festékmennyiség beállítása\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_hu","title":"M&aacute;sol&aacute;s"}},[_vm._v("\n    Másolás\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15186"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_hu","title":"M&aacute;solatok k&eacute;sz&iacute;t&eacute;se"}},[_vm._v("\n     Másolatok készítése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_hu","title":"F&eacute;nyk&eacute;pek m&aacute;sol&aacute;sa"}},[_vm._v("\n     Fényképek másolása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-letterhead-topic.html#copying-on-letterhead_hu","title":"M&aacute;sol&aacute;s fejl&eacute;ces pap&iacute;rra"}},[_vm._v("\n     Másolás fejléces papírra\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_hu","title":"M&aacute;sol&aacute;s a pap&iacute;r mindk&eacute;t oldal&aacute;ra"}},[_vm._v("\n     Másolás a papír mindkét oldalára\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_hu","title":"A m&aacute;solatok kicsiny&iacute;t&eacute;se &eacute;s nagy&iacute;t&aacute;sa"}},[_vm._v("\n     A másolatok kicsinyítése és nagyítása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_hu","title":"P&eacute;ld&aacute;nyok lev&aacute;logat&aacute;sa"}},[_vm._v("\n     Példányok leválogatása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_hu","title":"Elv&aacute;laszt&oacute;lapok m&aacute;solatok k&ouml;z&eacute; helyez&eacute;se"}},[_vm._v("\n     Elválasztólapok másolatok közé helyezése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_hu","title":"T&ouml;bb oldal m&aacute;sol&aacute;sa egyetlen lapra"}},[_vm._v("\n     Több oldal másolása egyetlen lapra\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_hu","title":"K&aacute;rty&aacute;k m&aacute;sol&aacute;sa"}},[_vm._v("\n     Kártyák másolása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_hu","title":"M&aacute;sol&aacute;si parancsikon l&eacute;trehoz&aacute;sa"}},[_vm._v("\n     Másolási parancsikon létrehozása\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_hu","title":"E-mail"}},[_vm._v("\n    E-mail\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15459"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-settings-topic.html#configuring-smtp-settings_hu","title":"A SMTP-be&aacute;ll&iacute;t&aacute;sok konfigur&aacute;l&aacute;sa"}},[_vm._v("\n     A SMTP-beállítások konfigurálása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_hu","title":"E-mail k&uuml;ld&eacute;se"}},[_vm._v("\n     E-mail küldése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_hu","title":"E-mail parancsikon l&eacute;trehoz&aacute;sa"}},[_vm._v("\n     E-mail parancsikon létrehozása\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_hu","title":"Fax"}},[_vm._v("\n    Fax\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e16908"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_hu","title":"Faxk&uuml;ld&eacute;s"}},[_vm._v("\n     Faxküldés\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_hu","title":"Fax &uuml;temez&eacute;se"}},[_vm._v("\n     Fax ütemezése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_hu","title":"Faxel&eacute;r&eacute;si c&eacute;lhely parancsikon l&eacute;trehoz&aacute;sa"}},[_vm._v("\n     Faxelérési célhely parancsikon létrehozása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_hu","title":"A fax felbont&aacute;s&aacute;nak m&oacute;dos&iacute;t&aacute;sa"}},[_vm._v("\n     A fax felbontásának módosítása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_hu","title":"Fax s&ouml;t&eacute;ts&eacute;g&eacute;nek m&oacute;dos&iacute;t&aacute;sa"}},[_vm._v("\n     Fax sötétségének módosítása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_hu","title":"Faxnapl&oacute; nyomtat&aacute;sa"}},[_vm._v("\n     Faxnapló nyomtatása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_hu","title":"K&eacute;retlen faxok blokkol&aacute;sa"}},[_vm._v("\n     Kéretlen faxok blokkolása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_hu","title":"Faxok felf&uuml;ggeszt&eacute;se"}},[_vm._v("\n     Faxok felfüggesztése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_hu","title":"Fax tov&aacute;bb&iacute;t&aacute;sa"}},[_vm._v("\n     Fax továbbítása\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_hu","title":"Beolvas&aacute;s"}},[_vm._v("\n    Beolvasás\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17204"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_hu","title":"Beolvas&aacute;s sz&aacute;m&iacute;t&oacute;g&eacute;pre"}},[_vm._v("\n     Beolvasás számítógépre\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_hu","title":"Beolvas&aacute;s FTP-kiszolg&aacute;l&oacute;ra"}},[_vm._v("\n     Beolvasás FTP-kiszolgálóra\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_hu","title":"FTP-parancsikon l&eacute;trehoz&aacute;sa"}},[_vm._v("\n     FTP-parancsikon létrehozása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-network-folder-topic.html#scanning-to-network-folder_hu","title":"Beolvas&aacute;s h&aacute;l&oacute;zati mapp&aacute;ba"}},[_vm._v("\n     Beolvasás hálózati mappába\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-network-folder-destination-topic.html#configuring-network-folder-destination_hu","title":"H&aacute;l&oacute;zati c&eacute;lmappa be&aacute;ll&iacute;t&aacute;sa"}},[_vm._v("\n     Hálózati célmappa beállítása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_hu","title":"H&aacute;l&oacute;zati mappa hivatkoz&aacute;s&aacute;nak hozz&aacute;ad&aacute;sa"}},[_vm._v("\n     Hálózati mappa hivatkozásának hozzáadása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_hu","title":"Beolvas&aacute;s flash-meghajt&oacute;ra"}},[_vm._v("\n     Beolvasás flash-meghajtóra\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printer-menus-chapter.html#printer-menus-chapter_hu","title":"Nyomtat&oacute;men&uuml;k"}},[_vm._v("\n    Nyomtatómenük\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17493"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-topic.html#menu-map_hu","title":"Men&uuml;t&eacute;rk&eacute;p"}},[_vm._v("\n     Menütérkép\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e17807","title":"Eszk&ouml;z"}},[_vm._v("\n     Eszköz\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e20041","title":"Nyomtat&aacute;s"}},[_vm._v("\n     Nyomtatás\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e21323","title":"Pap&iacute;r"}},[_vm._v("\n     Papír\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e21655","title":"M&aacute;sol&aacute;s"}},[_vm._v("\n     Másolás\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e22214","title":"Fax"}},[_vm._v("\n     Fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e24081","title":"E-mail"}},[_vm._v("\n     E-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e25178","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e25884","title":"USB-meghajt&oacute;"}},[_vm._v("\n     USB-meghajtó\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e26730","title":"H&aacute;l&oacute;zat/portok"}},[_vm._v("\n     Hálózat/portok\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e28881","title":"Biztons&aacute;g"}},[_vm._v("\n     Biztonság\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e29978","title":"Felhőszolg&aacute;ltat&aacute;sok"}},[_vm._v("\n     Felhőszolgáltatások\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e30035","title":"Jelent&eacute;sek"}},[_vm._v("\n     Jelentések\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_hu","title":"Hibaelh&aacute;r&iacute;t&aacute;s"}},[_c('strong',[_vm._v("\n      Hibaelhárítás\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forms-merge-topic.html#forms-merge_hu","title":"Forms Merge"}},[_c('strong',[_vm._v("\n      Forms Merge\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_hu","title":"Men&uuml;be&aacute;ll&iacute;t&aacute;si oldal nyomtat&aacute;sa"}},[_c('strong',[_vm._v("\n      Menübeállítási oldal\n     ")]),_vm._v("\n     nyomtatása\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_hu","title":"Nyomtat&oacute; sz&eacute;tv&aacute;logat&oacute;-opci&oacute;i"}},[_vm._v("\n    Nyomtató szétválogató-opciói\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30518"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-finisher-topic.html#using-staple-finisher_hu","title":"A kapcsoz&oacute; kiad&oacute; haszn&aacute;lata"}},[_vm._v("\n     A kapcsozó kiadó használata\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_hu","title":"A kapcsoz&oacute; &eacute;s lyukaszt&oacute; kiad&oacute;egys&eacute;g haszn&aacute;lata"}},[_vm._v("\n     A kapcsozó és lyukasztó kiadóegység használata\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacker-topic.html#using-offset-stacker_hu","title":"A k&ouml;tegelő rendezőt&aacute;lca haszn&aacute;lata"}},[_vm._v("\n     A kötegelő rendezőtálca használata\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-booklet-finisher-topic.html#using-booklet-finisher_hu","title":"A f&uuml;zetk&eacute;sz&iacute;tő egys&eacute;g haszn&aacute;lata"}},[_vm._v("\n     A füzetkészítő egység használata\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-hptfu-topic.html#using-hptfu_hu","title":"A hajtogat&aacute;si lehetős&eacute;ggel ell&aacute;tott pap&iacute;rsz&aacute;ll&iacute;t&oacute; egys&eacute;g haszn&aacute;lata"}},[_vm._v("\n     A hajtogatási lehetőséggel ellátott papírszállító egység használata\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_hu","title":"A nyomtat&oacute; karbantart&aacute;sa"}},[_vm._v("\n    A nyomtató karbantartása\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30928"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-supplies-status-topic.html#checking-supplies-status_hu","title":"Az alkatr&eacute;szek &eacute;s kell&eacute;kek &aacute;llapot&aacute;nak ellenőrz&eacute;se"}},[_vm._v("\n     Az alkatrészek és kellékek állapotának ellenőrzése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_hu","title":"Kell&eacute;kanyag-&eacute;rtes&iacute;t&eacute;sek konfigur&aacute;l&aacute;sa"}},[_vm._v("\n     Kellékanyag-értesítések konfigurálása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-email-alert-topic.html#setting-up-email-alert_hu","title":"E-mail-riaszt&aacute;sok be&aacute;ll&iacute;t&aacute;sa"}},[_vm._v("\n     E-mail-riasztások beállítása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"generating-reports-and-logs-topic.html#generating-reports-and-logs_hu","title":"Jelent&eacute;sek &eacute;s napl&oacute;k k&eacute;sz&iacute;t&eacute;se"}},[_vm._v("\n     Jelentések és naplók készítése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_hu","title":"Alkatr&eacute;szek &eacute;s kell&eacute;kek rendel&eacute;se"}},[_vm._v("\n     Alkatrészek és kellékek rendelése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e31783","title":"Alkatr&eacute;szek &eacute;s kell&eacute;kanyagok cser&eacute;je"}},[_vm._v("\n     Alkatrészek és kellékanyagok cseréje\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e32407","title":"A nyomtat&oacute; alkatr&eacute;szeinek tiszt&iacute;t&aacute;sa"}},[_vm._v("\n     A nyomtató alkatrészeinek tisztítása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e32571","title":"Energia- &eacute;s pap&iacute;rtakar&eacute;koss&aacute;g"}},[_vm._v("\n     Energia- és papírtakarékosság\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_hu","title":"A nyomtat&oacute; &aacute;thelyez&eacute;se m&aacute;s helyre"}},[_vm._v("\n     A nyomtató áthelyezése más helyre\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_hu","title":"Probl&eacute;m&aacute;k elh&aacute;r&iacute;t&aacute;sa"}},[_vm._v("\n    Problémák elhárítása\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32709"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-topic.html#print-quality-problems_hu","title":"Nyomtat&aacute;si minős&eacute;ggel kapcsolatos probl&eacute;m&aacute;k"}},[_vm._v("\n     Nyomtatási minőséggel kapcsolatos problémák\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_hu","title":"A nyomtat&oacute; hibak&oacute;djai"}},[_vm._v("\n     A nyomtató hibakódjai\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_hu","title":"Nyomtat&aacute;si probl&eacute;m&aacute;k"}},[_vm._v("\n     Nyomtatási problémák\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_hu","title":"A nyomtat&oacute; nem v&aacute;laszol"}},[_vm._v("\n     A nyomtató nem válaszol\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_hu","title":"Nem lehet olvasni a flash-meghajt&oacute;t"}},[_vm._v("\n     Nem lehet olvasni a flash-meghajtót\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_hu","title":"Az USB-port enged&eacute;lyez&eacute;se"}},[_vm._v("\n     Az USB-port engedélyezése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_hu","title":"Elakad&aacute;sok megsz&uuml;ntet&eacute;se"}},[_vm._v("\n     Elakadások megszüntetése\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e36133","title":"H&aacute;l&oacute;zatikapcsolat-hib&aacute;k"}},[_vm._v("\n     Hálózatikapcsolat-hibák\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e36226","title":"Hardveropci&oacute;kkal kapcsolatos probl&eacute;m&aacute;k"}},[_vm._v("\n     Hardveropciókkal kapcsolatos problémák\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e36399","title":"Kell&eacute;kanyagokkal kapcsolatos probl&eacute;m&aacute;k"}},[_vm._v("\n     Kellékanyagokkal kapcsolatos problémák\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-paper-curl-topic.html#d0e36547","title":"Pap&iacute;radagol&aacute;si probl&eacute;m&aacute;k"}},[_vm._v("\n     Papíradagolási problémák\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e36741","title":"E-mail-k&uuml;ld&eacute;si probl&eacute;m&aacute;k"}},[_vm._v("\n     E-mail-küldési problémák\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e36796","title":"Faxol&aacute;si probl&eacute;m&aacute;k"}},[_vm._v("\n     Faxolási problémák\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e37118","title":"Beolvas&aacute;si probl&eacute;m&aacute;k"}},[_vm._v("\n     Beolvasási problémák\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"modifying-colors-in-printed-output-topic.html#d0e37536","title":"A sz&iacute;nminős&eacute;ggel kapcsolatos probl&eacute;m&aacute;k"}},[_vm._v("\n     A színminőséggel kapcsolatos problémák\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_hu","title":"Kapcsolatba l&eacute;p&eacute;s az &uuml;gyf&eacute;lt&aacute;mogat&aacute;ssal"}},[_vm._v("\n     Kapcsolatba lépés az ügyféltámogatással\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_hu","title":"&Uacute;jrahasznos&iacute;t&aacute;s &eacute;s hullad&eacute;kkezel&eacute;s"}},[_vm._v("\n    Újrahasznosítás és hulladékkezelés\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37762"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_hu","title":"Lexmark term&eacute;kek &uacute;jrahasznos&iacute;t&aacute;sa"}},[_vm._v("\n     Lexmark termékek újrahasznosítása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_hu","title":"Lexmark csomagol&aacute;s &uacute;jrahasznos&iacute;t&aacute;sa"}},[_vm._v("\n     Lexmark csomagolás újrahasznosítása\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_hu","title":"&Eacute;rtes&iacute;t&eacute;sek"}},[_vm._v("\n    Értesítések\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37798"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37801","title":"Term&eacute;kinform&aacute;ci&oacute;k"}},[_vm._v("\n     Termékinformációk\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37818","title":"Edition notice"}},[_vm._v("\n     Edition notice\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_hu","title":"V&eacute;djegyek"}},[_vm._v("\n     Védjegyek\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_hu","title":"Licencnyilatkozat"}},[_vm._v("\n     Licencnyilatkozat\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_hu","title":"Zajkibocs&aacute;t&aacute;si szintek"}},[_vm._v("\n     Zajkibocsátási szintek\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_hu","title":"Az elektromos &eacute;s elektronikus term&eacute;kekből keletkező hullad&eacute;kokra vonatkoz&oacute; (WEEE) direkt&iacute;va"}},[_vm._v("\n     Az elektromos és elektronikus termékekből keletkező hulladékokra vonatkozó (WEEE) direktíva\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37924","title":"&Uacute;jrat&ouml;lthető l&iacute;tium-ion elem"}},[_vm._v("\n     Újratölthető lítium-ion elem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#eu-battery-directive-2023-1542_hu","title":"(EU) 2023/1542 rendelet"}},[_vm._v("\n     (EU) 2023/1542 rendelet\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37962","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_hu","title":"A term&eacute;k kidob&aacute;sa"}},[_vm._v("\n     A termék kidobása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_hu","title":"A Lexmark fest&eacute;kkazett&aacute;k visszajuttat&aacute;sa &uacute;jb&oacute;li felhaszn&aacute;l&aacute;sra vagy &uacute;jrahasznos&iacute;t&aacute;sra"}},[_vm._v("\n     A Lexmark festékkazetták visszajuttatása újbóli felhasználásra vagy újrahasznosításra\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_hu","title":"Statikus &eacute;rz&eacute;kenys&eacute;ggel kapcsolatos figyelmeztet&eacute;s"}},[_vm._v("\n     Statikus érzékenységgel kapcsolatos figyelmeztetés\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_hu","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_hu","title":"Hőm&eacute;rs&eacute;kletadatok"}},[_vm._v("\n     Hőmérsékletadatok\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_hu","title":"Megjegyz&eacute;s a l&eacute;zerrel kapcsolatban"}},[_vm._v("\n     Megjegyzés a lézerrel kapcsolatban\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_hu","title":"Power consumption"}},[_vm._v("\n     Power consumption\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38223","title":"A vezet&eacute;k n&eacute;lk&uuml;li term&eacute;kekre vonatkoz&oacute; szab&aacute;lyok"}},[_vm._v("\n     A vezeték nélküli termékekre vonatkozó szabályok\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_hu","title":"Megjegyz&eacute;s a modul&aacute;ris &ouml;sszetevőkről"}},[_vm._v("\n     Megjegyzés a moduláris összetevőkről\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_hu","title":"A r&aacute;di&oacute;frekvenci&aacute;s sug&aacute;rz&aacute;s hat&aacute;sa"}},[_vm._v("\n     A rádiófrekvenciás sugárzás hatása\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38248","title":"Az Eur&oacute;pai K&ouml;z&ouml;ss&eacute;g (EK) elő&iacute;r&aacute;sainak val&oacute; megfelel&eacute;s"}},[_vm._v("\n     Az Európai Közösség (EK) előírásainak való megfelelés\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-a_hu","title":"Az Eur&oacute;pai K&ouml;z&ouml;ss&eacute;g (EK) elő&iacute;r&aacute;sainak val&oacute; megfelel&eacute;s"}},[_vm._v("\n     Az Európai Közösség (EK) előírásainak való megfelelés\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_hu","title":"R&aacute;di&oacute;interferenci&aacute;val kapcsolatos tudnival&oacute;k"}},[_vm._v("\n     Rádióinterferenciával kapcsolatos tudnivalók\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js